const langs = {
    gb: {
        _name: 'English',
        autoCloseModal: {
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            updateOrder: 'Update Order',
        },
        balanceModal: {
            balance: 'Balance',
            credit: 'Credit',
            equity: 'Equity',
            practice: 'PRACTICE',
            real: 'REAL',
            account: 'ACCOUNT',
            invested: 'Invested',
            profit: 'Profit',
            loss: 'Loss',
            margin: 'Margin',
            marginLevel: 'Margin Level',
            marginFree: 'Free Margin'
        },
        header: {
            cfd: 'CFD',
            platform: 'Platform',
            deposit: 'Deposit',
            myAccount: 'My account'
        },
        sideMenu: {
            marketWatch: 'Market Watch',
            activeOrders: 'Active Orders',
            tradingHistory: 'Trading History',
            economicCalendar: 'Economic Calendar',
            marketNews: 'Market News'
        },
        closePositionModal: {
            closeOrder: 'Close Position',
            areYouSure: 'Are you sure to close the position',
            buy: 'Buy',
            sell: 'Sell',
            yes: 'Yes',
            no: 'No',
        },
        chart: {
            addNewChart: 'Add New Chart',
        },
        symbolsModal: {
            watchlist: 'Watchlist',
            asset: 'Asset',
            price: 'Price',
            changePct: 'Change 24h'
        },
        pendingModal: {
            pending: 'Pending',
            assetPrice: 'Asset Price',
            current: 'Current',
            revert: 'Revert to Market Price',
            automatically: 'Position will be opened automatically when the price reaches this level'
        },
        orderMenu: {
            volume: 'Volume',
            lots: 'lots',
            units: 'units',
            currency: 'currency',
            contractSize: 'Contract size',
            position: 'Position',
            margin: 'Margin',
            freeMargin: 'Free Margin',
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            pending: 'Pending',
            market: 'Market',
            leverage: 'Leverage',
            spread: 'Spread',
            notSet: 'Not set',
            at: 'at',
            buy: 'buy',
            sell: 'sell',
        },
        footer: {
            supportBanner: 'EVERY DAY, AROUND THE CLOCK',
            currentTime: 'CURRENT TIME',
            liveChat: 'Live Chat'
        },
        statusBar: {
            balance: 'Balance',
            credit: 'Credit',
            equity: 'Equity',
            margin: 'Margin',
            marginLevel: 'Margin level',
            freeMargin: 'Free Margin',
            pnl: 'PnL',
            profitTotal: 'Lifetime PnL'
        },
        accountModal: {
            dateRegistered: 'Date Registered',
            userId: 'User ID',
            dashboard: 'Dashboard',
            personalData: 'Personal Data',
            deposit: 'Deposit',
            withdrawFunds: 'Withdraw Funds',
            savings: 'Savings',
            settings: 'Settings',
            logout: 'Logout'
        },
        depositModal: {
            BT_INVOICE: 'Enter amount and generate invoice',
            BT_TITLE: 'Our banking details',
            BT_ACCOUNT: 'Account',
            BT_BANK_NAME: 'Bank Name',
            BT_BENEFICIARY: 'Beneficiary',
            BT_ADDRESS: 'Beneficiary Address',
            BT_SWIFT: 'Swift',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Bank Reference Code',
            BT_INN: 'INN',
            BT_KPP: 'Correspondent account',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: 'Amount',
            TOKEN_SUBTOTAL: 'Subtotal',
            TOKEN_TOTAL: 'Total',
            TOKEN_DESCRIPTION: 'Description',
            TOKEN_PAYMENT_DETAILS: 'Payment Details',
            PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
            makeDeposit: 'Make a Deposit',
            practiceAccount: 'Practice Account',
            realAccount: 'Real Account',
            noWithdrawals: 'No Withdrawals',
            easyWithdrawals: 'Easy Withdrawals',
            allAssets: 'All assets available',
            fullFledged: 'Full-ledged platform',
            fillUpTo: 'Fill Up To',
            freeReplenishment: 'Free replenishment',
            topUp: 'Top Up Your Account',
            minimumAmount: 'Minimum amount',
            canSwitch: 'You can switch between your accounts at any moment'
        },
        gridsModal: {
            chartGrids: 'CHART GRIDS',
            chart1: '1 chart',
            chart2: '2 charts',
            chart3: '3 charts',
            chart4: '4 charts',
        },
        noConnectionModal: {
            connectionLost: 'Connection with the server is lost',
            retryNow: 'Retry Now',
        },
        loginModal: {
            loginToTradeRoom: 'Login To Traderoom',
            email: 'Email address',
            emailAndId: 'Email address / ID number',
            enterEmail: 'Enter your email',
            twoFactor: '2FA Code (if enabled)',
            twoFactorAuth: 'Two-factor authentication',
            password: 'Password',
            yourPassword: 'Your password',
            signIn: 'Sign In',
            dontHaveAccount: 'Don’t have an account?',
            restore: 'Restore',
            fullName: 'Full Name',
            havePromo: 'I have a promo-code',
            promo: 'Promo code',
            login: 'Login',
            haveAccount: 'Already have an account?',
            hide: 'Hide',
            goTo: 'Back to'
        },
        newPasswordModal: {
            setNewPassword: 'Set New Password',
            newPassword: 'New password',
            confirmNewPassword: 'Confirm new password',
            setButton: 'Set'
        },
        registerModal: {
            createNewAccount: 'Create A New Account',
            email: 'Email address',
            firstName: 'First Name',
            lastName: 'Last Name',
            country: 'Country',
            phone: 'Phone',
            password: 'Password',
            createAccount: 'Create Account',
            currency: 'Currency'
        },
        forgotPasswordModal: {
            forgotPassword: 'Forgot Password?',
            submitEmail: 'Please submit an email used for registration, check your inbox and follow the instructions provided',
            submit: 'Submit'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            deposit: 'Deposit',
            withdrawal: 'Withdrawal',
            depositApproved: 'Deposit has been approved',
            depositDeclined: 'Deposit has been declined',
            withdrawalApproved: 'Withdrawal has been approved',
            withdrawalDeclined: 'Withdrawal has been declined',
            withdrawalCancelled: 'Withdrawal has been cancelled',
            orderRejected: 'Order Rejected',
            insufficientMargin: 'Your pending order could not be opened: not enough free margin',
            marginCall: 'Margin Call',
            marginCallText: 'Please make a deposit to meet margin requirements',
        },
        markets: {
            forex: 'Forex',
            stocks: 'Stocks',
            commodities: 'Commodities',
            indices: 'Indices',
            crypto: 'Crypto',
            metals: 'Metals',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            buy: 'BUY',
            profitCalculator: 'Profit Calculator',
            sell: 'SELL',
            volume: 'Volume',
            entryPrice: 'Entry Price',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            maxPosition: 'Max Position',
            calculate: 'Calculate',
            calculationsFor: 'Calculations for',
            leverage: 'Leverage',
            requiredMargin: 'Required Margin',
            profitFromTP: 'Profit from TP',
            lossFromSL: 'Loss from SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Deposit successful',
            text: 'Your deposit has been processed successfully!',
        },
        depositFailModal: {
            title: 'Deposit failed',
            text: 'Your deposit has not been processed.',
        },
        widgetMarketWatch: {
            marketWatch: 'Market Watch',
            search: 'Search...',
        },
        widgetOrders: {
            commission: 'Commission',
            volume: 'Volume',
            margin: 'Margin',
            active: 'Active',
            pending: 'Pending',
            activeOrders: 'Active Orders',
            portfolio: 'Portfolio',
            allPositions: 'All Positions',
            noPositionsLine1: 'You have no open',
            noPositionsLine2: 'positions yet',
            show: 'Show',
            more: 'more',
            less: 'less',
            purchaseTime: 'Purchase Time',
            closePosition: 'Close Position',
            priceOpen: 'Purchase Price',
            priceSl: 'Stop Loss Price',
            priceTp: 'Take Profit Price',
            type: 'Position Direction',
            pnl: 'Profit/Loss',
            cancelOrder: 'Cancel Order',
            orderType: 'Order Type',
            cancelled: 'Cancelled',
            tradingHistory: 'Trading History',
            noHistoryLine1: 'You don\'t have any',
            noHistoryLine2: 'closed deals yet',
            sortByTime: 'Sort by time',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Economic Calendar'
        },
        widgetMarketNews: {
            marketNews: 'Market News'
        },
        ordersPane: {
            ordersActive: 'Active Orders',
            ordersHistory: 'Orders History',
            id: 'ID',
            symbol: 'Symbol',
            type: 'Type',
            volume: 'Volume',
            openPrice: 'Open Price',
            openTime: 'Open Time',
            closePrice: 'Close Price',
            closeTime: 'Close Time',
            sl: 'SL',
            tp: 'TP',
            price: 'Price',
            pnl: 'PnL',
            actions: 'Actions',
            edit: 'Edit',
            close: 'Close',
            commission: 'Commission',
            swap: 'Swap',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short'
        },
        assetInfoModal: {
            assetInfo: 'Asset Info',
            tradingConditions: 'Trading Conditions',
            information: 'Information',
            bid: 'Bid',
            ask: 'Ask',
            sessionChange: 'Session Change',
            tradeNow: 'Trade Now',
            opens: 'Opens',
            closes: 'Closes',
            at: 'at',
            open247: 'Open 24/7',
            today: 'today',
            tomorrow: 'tomorrow',
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            contractSpecification: 'Contract Specification',
            symbol: 'Symbol',
            name: 'Name',
            market: 'Market',
            baseCurrency: 'Base Currency',
            digits: 'Digits',
            lotSize: 'Lot Size',
            lotStep: 'Lot Step',
            minVolume: 'Min Volume',
            maxVolume: 'Max Volume',
            leverage: 'Leverage',
            commission: 'Commission',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short',
            schedule: 'Schedule',
            weekday: 'Weekday',
            tradingTime: 'Trading Time',
            closed: 'closed',
            sell: 'Sell',
            buy: 'Buy',
            low: 'Low',
            high: 'High',
            oneHourChange: '1 hour change',
            oneDayChange: '1 day change',
            oneWeekChange: '1 week change',
            oneMonthChange: '1 month change',
            threeMonthsChange: '3 months change',
            oneYearChange: '1 year change',
            loading: 'Loading...',
        },
        fullScreen: {
            startTrading: 'Start Trading',
            deposit: 'Deposit',
            dashboard: 'Dashboard',
            personalInfo: 'Personal Info',
            withdrawal: 'Withdrawal',
            verification: 'Verification',
            accounts: 'Accounts',
            liveChat: 'Live Chat',
            savings: 'Savings',
            settings: 'Settings',
            logOut: 'Log Out',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            addressReceipt: 'Please wait for the address to load',
            makeDeposit: 'MAKE A DEPOSIT',
            instant: 'Instant',
            minutes: 'minutes',
            hours: 'hours',
            days: 'days',
            amount: 'Amount',
            continue: 'Continue',
            qrCode: 'QR CODE',
            depositAddress: 'DEPOSIT ADDRESS',
            addWalletAddress: 'The wallet for this method is not set up. Please contact your agent or customer support.',
            copy: 'Copy',
            last: 'LAST',
            deposits: 'DEPOSITS',
            time: 'Time',
            currency: 'Currency',
            status: 'Status',
            info: 'Info',
            name: 'Cardholder\'s name',
            address: 'Address',
            DOB: 'DOB',
            bankName: 'Bank name',
            additionalInfo: 'To deposit more to your account, please contact your account manager directly',
            additionalInfoOnlyBTCpsp: 'To open other payment methods please provide KYC or contact your account manager',
            sofortPspMessage: 'Our finance team will contact you to help you make a deposit'
        },
        fullScreenCcExt: {
            pleaseWait: 'Please wait. Connecting to payment service provider...',
            cardPayment: 'Card payment',
            inOrder: 'In order to send the amount',
            pleaseProvide: 'please provide card details:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Total Taxes',
            totalBalance: 'Total Balance',
            totalPnl: 'Total PNL',
            profitableOrders: 'Profitable Orders',
            roi: 'ROI',
            activityLog: 'Activity Log',
            loginFromIp: 'Login from IP',
            tradingResults: 'Trading Results',
            week: 'Week',
            month: 'Month',
            year: 'Year',
            successRate: 'Success rate',
            closedWithProfit: 'Closed With Profit',
            closedWithLoss: 'Closed With Loss',
            account: 'Account',
            balance: 'Balance',
            leverage: 'Leverage',
            credit: 'Credit',
            tradeNow: 'Trade Now',
            usingCurrentRate: 'using current exchange rate',
            totalDeposits: 'Total Deposits'
        },
        fullScreenPersonal: {
            personalDetails: 'Personal Details',
            profilePhoto: 'Profile Photo',
            firstName: 'First Name',
            country: 'Country',
            lastName: 'Last Name',
            address: 'Address',
            email: 'E-mail',
            phone: 'Phone number',
            saveChanges: 'Save Changes',
        },
        fullScreenAvatar: {
            dropFile: 'Drop a file on the circle above to upload',
            notAllowed: 'It is not allowed to publish',
            notAllowedLine1: 'Photos of an explicitly sexual or pornographic nature',
            notAllowedLine2: 'Images aimed at inciting ethnic or racial hatred or aggression',
            notAllowedLine3: 'Photos involving persons under 18 years of age',
            notAllowedLine4: 'Third-party copyright protected photos',
            notAllowedLine5: 'Images larger than 5 MB and in a format other than JPG, GIF or PNG',
            requirements: 'Your face must be clearly visible on the photo. All photos and videos uploaded by you must comply with these requirements, otherwise they can be removed.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Withdrawal',
            requestNewWithdrawal: 'REQUEST A NEW WITHDRAWAL',
            amount: 'Amount',
            currentBalance: 'Your current account balance is',
            withdrawAll: 'Withdraw all',
            requestWithdrawal: 'Request Withdrawal',
            last: 'LAST',
            withdrawalRequests: 'WITHDRAWAL REQUESTS',
            time: 'Time',
            currency: 'Currency',
            info: 'Info',
            status: 'Status',
            bank: 'Bank',
            bitcoin: 'Bitcoin',
            card: 'Card',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Withdrawal Details',
            address: 'Wallet Address',
            bankAccount: 'Account Number',
            bankHolder: 'Account Holder Name',
            bankIban: 'IBAN',
            bankSwift: 'Bank SWIFT code',
            sortCode: 'Sort Code',
            ifscCode: 'IFSC Code',
            bankCode: "Bank Code (BSB)",
            bankName: 'Bank Name',
            bankBranch: 'Bank Branch',
            cardNumber: 'Card Number',
            cardHolder: 'Card Holder Name',
            incorrectAmountByFreeMargin: 'The amount is incorrect you can withdraw the amount of free margin',
            closeOrders: 'before close all orders'
        },
        fullScreenVerification: {
            dragAndDrop: 'drag and drop the document to this area',
            documentsList: 'LIST OF UPLOADED DOCUMENTS',
            document: 'Document',
            timeUploaded: 'Time Uploaded',
            timeProcessed: 'Time Processed',
            status: 'Status',
            types: ['Proof of Id', 'Proof of Residence', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back', 'Selfie','Other'],
            types2: ['Proof of Id (ID CARD, PASSPORT, DRIVER LICENCE)', 'Proof of Residence (Utility bill or Bank statement)', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back (ID CARD BACK, DRIVER LICENCE BACK)', 'Selfie','Other'],
            upload: 'Upload',
            isConfirmed: 'is confirmed',
            uploadAnotherDocument: 'Upload another document',
            isUnderReview: 'is under review',
            questionnaire: 'Questionnaire',
            sendAnswers: 'Send Answers',
            progressBarOf: 'of',
            progressBarText: 'of your documents have been uploaded and confirmed'
        },
        fullScreenAccounts: {
            manageAccounts: 'Transfer funds between your accounts',
            transferFrom: 'From account',
            transferTo: 'To account',
            amount: 'Amount',
            makeTransfer: 'Make Transfer',
            yourAccounts: 'Your Accounts',
            account: 'Account',
            currency: 'Currency',
            balance: 'Balance',
            credit: 'Credit',
            makeActive: 'Make Active',
            active: 'Active'
        },
        fullScreenSupport: {
            chatOff: 'Chat will be available on working days',
            sendMessage: 'Send Message',
            responseTime: 'Average response time: 1-24h',
        },
        fullScreenSavings: {
            pct_0: 'Flexible',
            pct_30: 'Locked 1 Month',
            pct_90: 'Locked 1 Quarter',
            pct_180: 'Locked 6 Months',
            pct_365: 'Locked 1 Year',
            pct_730: 'Locked 2 Year',
            savings: 'Savings',
            detailedInformation: 'Detailed Information',
            pleaseSelect: 'Please select a currency and a period',
            openSavings: 'Open Savings',
            currentTime: 'Current Time',
            releaseTime: 'Release Time',
            currencyChosen: 'Currency Chosen',
            periodChosen: 'Period Chosen',
            yourRate: 'Your Rate',
            yourAnnualRate: 'Your Annual Rate',
            yourEarnings: 'Your earnings',
            accountFrom: 'Account to transfer funds from',
            enterAmount: 'Enter Amount',
            in: 'In',
            openAndInvest: 'Open Savings Account and invest',
            investment: 'Investment',
            period: 'Period',
            daysTotal: 'Days total',
            finalEarnings: 'Final earnings',
            created: 'Created',
            daysElapsed: 'Days Elapsed',
            days: 'days',
            earnings: 'Earnings',
            fundsReleasedIn: 'Funds Released In',
            claim: 'Claim',
        },
        fullScreenSettings: {
            updatePassword: 'UPDATE PASSWORD',
            currentPassword: 'Current Password',
            newPassword: 'New Password',
            changePassword: 'Change Password',
            activationForGoogle: 'Activation code for Google Authenticator',
            activateAndEnter: 'Activate Authenticator and enter a generated code in field below',
            qrCode: 'QR Code',
            activateProtection: 'Activate 2FA Protection',
            protectionActive: '2FA protection is active',
            twoFactorCode: '2FA Code',
            disableProtection: 'Disable 2FA Protection',
            language: 'Language',
            dashboardCurrency: 'Dashboard Currency',
            confirmNewPassword: 'Confirm new password',
        },
        fullScreenReferrals: {
            yourLink: 'YOUR REFERRAL LINK',
            referredFriends: 'REFERRED FRIENDS',
            id: 'ID',
            name: 'Name',
            registered: 'Register',
            level: 'Level',
            payout: 'Payout',
            lastPayouts: 'LAST REFERRAL PAYOUTS',
            time: 'Time',
            amount: 'Amount',
            currency: 'Currency',
            info: 'Info'
        },
        months: {
            Jan: 'Jan',
            Feb: 'Feb',
            Mar: 'Mar',
            Apr: 'Apr',
            May: 'May',
            Jun: 'Jun',
            Jul: 'Jul',
            Aug: 'Aug',
            Sep: 'Sep',
            Oct: 'Oct',
            Nov: 'Nov',
            Dec: 'Dec'
        },
        orderTypes: ['Buy', 'Sell', 'Buy Limit', 'Sell Limit', 'Buy Stop', 'Sell Stop'],
        statuses: ['Pending', 'Approved', 'Declined', 'Processing','Under Review','In Process','Cancelled'],
        errors: {
            INVALID_FIELDS: 'Please check that the data you have entered is correct',
            NOT_FOUND: 'Request error',
            FORBIDDEN: 'Access denied. Please re-login',
            SERVER_ERROR: 'Action failed. Please try again later',
            INVALID_ACCOUNT: 'Session expired. Please re-login',
            INVALID_EMAIL: 'Invalid e-mail address',
            INVALID_PHONE: 'Invalid phone number',
            INVALID_COUNTRY: 'Invalid country',
            INVALID_LOGIN: 'Invalid login credentials',
            USER_BLOCKED: 'Account is blocked. Please contact support',
            USER_REGISTERED: 'User with entered e-mail or phone number is already registered',
            INVALID_USER: 'User is not found',
            REJECTED: 'Operation is not allowed due to platform restrictions',
            INVALID_OLD_PASSWORD: 'Old password is invalid',
            INVALID_SYMBOL: 'Invalid trading symbol',
            INVALID_SYMBOL_PRECISION: 'Invalid symbol precision',
            INVALID_FRAME: 'Invalid chart frame',
            INVALID_CURRENCY: 'Invalid currency',
            INVALID_PRODUCT: 'Invalid account trading type',
            INSUFFICIENT_FUNDS: 'Insufficient funds',
            INVALID_WITHDRAWAL: 'Withdrawal is not found',
            INVALID_DEPOSIT: 'This deposit can no longer be cancelled - it was not found or has already been processed',
            INVALID_STATUS: 'Invalid status',
            INVALID_FILE: 'Invalid file extension or file is too large',
            INVALID_DOCUMENT: 'Document is not found',
            INVALID_NAME: 'Invalid name',
            INVALID_LOT_SIZE: 'Invalid lot size',
            INVALID_LOT_STEP: 'Invalid lot step',
            INVALID_MIN_VOLUME: 'Invalid minimal volume',
            INVALID_MAX_VOLUME: 'Invalid maximal volume',
            INVALID_GROUP: 'Invalid group',
            INVALID_SPREAD: 'Invalid spread',
            REQUEST_TIMEOUT: 'Request timed out. Please try again later',
            INVALID_TYPE: 'Invalid order type',
            INVALID_VOLUME: 'Invalid order volume',
            INVALID_SL: 'Invalid stop loss value',
            INVALID_TP: 'Invalid take profit value',
            INVALID_PRICE: 'Invalid order price',
            INVALID_EXPIRATION: 'Invalid order expiration',
            NOT_ENOUGH_MARGIN: 'Not enough margin',
            INVALID_ORDER: 'Order is not found',
            MARKET_CLOSED: 'Trading is not available. Please try again',
            INVALID_BALANCE_TYPE: 'Invalid type of balance operation',
            INVALID_HASH: 'Invalid hash',
            HASH_EXPIRED: 'Your password reset link is expired. Please request a new one',
            INVALID_CODE: 'Invalid 2FA code',
            CHAT_DISABLED: 'Access to the support chat has been closed',
            WITHDRAWAL_NOT_ALLOWED: 'Access to the withdrawals has been closed',
            TRADING_DISABLED: 'Trading is disabled for current account',
            PENDING_DEPOSITS_LIMIT: 'Deposits limit exceeded',
            CLOSE_OPEN_ORDERS: 'Please close your open orders',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Only one pending withdrawal allowed',
            LOCAL_DEPOSIT_ONLY_REAL: 'Deposit is available only for real account',
            LOCAL_DEPOSIT_POSITIVE: 'Amount of deposit must be more than 0',
            LOCAL_INVALID_CARD_NUMBER: 'Invalid card number',
            LOCAL_INVALID_CARD_EXPIRATION: 'Invalid card expiration',
            LOCAL_INVALID_CVC: 'Invalid CVV/CVC code',
            LOCAL_PASSWORDS_NOT_MATCH: 'Passwords do not match, please re-enter',
            LOCAL_NO_TRADING_ACCOUNTS: 'You do not have trading accounts available. Please contact the support',
            LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
            LOCAL_MIN_WITHDRAWAL: 'Minimum withdrawal amount is $',
            LOCAL_INVALID_FILE_TYPE: 'File format not supported. Please attach only JPG, PNG or PDF',
            LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',
            FLOOD_REJECTED: 'You are sending messages too often. Please try again later',
            REGISTRATIONS_BLOCKED: "Thank you for your inquiry, One of our representatives will be in touch with you as soon as possible",
        },
        countries: {
            AF: 'Afghanistan',
            AX: 'Aland Islands',
            AL: 'Albania',
            DZ: 'Algeria',
            AS: 'American Samoa',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarctica',
            AG: 'Antigua And Barbuda',
            AR: 'Argentina',
            AM: 'Armenia',
            AW: 'Aruba',
            AU: 'Australia',
            AT: 'Austria',
            AZ: 'Azerbaijan',
            BS: 'Bahamas',
            BH: 'Bahrain',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BY: 'Belarus',
            BE: 'Belgium',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivia',
            BA: 'Bosnia And Herzegovina',
            BW: 'Botswana',
            BV: 'Bouvet Island',
            BR: 'Brazil',
            IO: 'British Indian Ocean Territory',
            BN: 'Brunei Darussalam',
            BG: 'Bulgaria',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambodia',
            CM: 'Cameroon',
            CA: 'Canada',
            CV: 'Cape Verde',
            KY: 'Cayman Islands',
            CF: 'Central African Republic',
            TD: 'Chad',
            CL: 'Chile',
            CN: 'China',
            CX: 'Christmas Island',
            CC: 'Cocos (Keeling) Islands',
            CO: 'Colombia',
            KM: 'Comoros',
            CG: 'Congo',
            CD: 'Congo, Democratic Republic',
            CK: 'Cook Islands',
            CR: 'Costa Rica',
            CI: 'Cote D\'Ivoire',
            HR: 'Croatia',
            CU: 'Cuba',
            CY: 'Cyprus',
            CZ: 'Czech Republic',
            DK: 'Denmark',
            DJ: 'Djibouti',
            DM: 'Dominica',
            DO: 'Dominican Republic',
            EC: 'Ecuador',
            EG: 'Egypt',
            SV: 'El Salvador',
            GQ: 'Equatorial Guinea',
            ER: 'Eritrea',
            EE: 'Estonia',
            ET: 'Ethiopia',
            FK: 'Falkland Islands (Malvinas)',
            FO: 'Faroe Islands',
            FJ: 'Fiji',
            FI: 'Finland',
            FR: 'France',
            GF: 'French Guiana',
            PF: 'French Polynesia',
            TF: 'French Southern Territories',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgia',
            DE: 'Germany',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Greece',
            GL: 'Greenland',
            GD: 'Grenada',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HM: 'Heard Island & Mcdonald Islands',
            VA: 'Holy See (Vatican City State)',
            HN: 'Honduras',
            HK: 'Hong Kong',
            HU: 'Hungary',
            IS: 'Iceland',
            IN: 'India',
            ID: 'Indonesia',
            IR: 'Iran',
            IQ: 'Iraq',
            IE: 'Ireland',
            IM: 'Isle Of Man',
            IL: 'Israel',
            IT: 'Italy',
            JM: 'Jamaica',
            JP: 'Japan',
            JE: 'Jersey',
            JO: 'Jordan',
            KZ: 'Kazakhstan',
            KE: 'Kenya',
            KI: 'Kiribati',
            KR: 'Korea',
            KW: 'Kuwait',
            KG: 'Kyrgyzstan',
            LA: 'Lao People\'s Democratic Republic',
            LV: 'Latvia',
            LB: 'Lebanon',
            LS: 'Lesotho',
            LR: 'Liberia',
            LY: 'Libyan Arab Jamahiriya',
            LI: 'Liechtenstein',
            LT: 'Lithuania',
            LU: 'Luxembourg',
            MO: 'Macao',
            MK: 'Macedonia',
            MG: 'Madagascar',
            MW: 'Malawi',
            MY: 'Malaysia',
            MV: 'Maldives',
            ML: 'Mali',
            MT: 'Malta',
            MH: 'Marshall Islands',
            MQ: 'Martinique',
            MR: 'Mauritania',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Mexico',
            FM: 'Micronesia',
            MD: 'Moldova',
            MC: 'Monaco',
            MN: 'Mongolia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MA: 'Morocco',
            MZ: 'Mozambique',
            MM: 'Myanmar',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NL: 'Netherlands',
            AN: 'Netherlands Antilles',
            NC: 'New Caledonia',
            NZ: 'New Zealand',
            NI: 'Nicaragua',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            NF: 'Norfolk Island',
            MP: 'Northern Mariana Islands',
            NO: 'Norway',
            OM: 'Oman',
            PK: 'Pakistan',
            PW: 'Palau',
            PS: 'Palestinian Territory, Occupied',
            PA: 'Panama',
            PG: 'Papua New Guinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PH: 'Philippines',
            PN: 'Pitcairn',
            PL: 'Poland',
            PT: 'Portugal',
            PR: 'Puerto Rico',
            QA: 'Qatar',
            RE: 'Reunion',
            RO: 'Romania',
            RU: 'Russia',
            RW: 'Rwanda',
            BL: 'Saint Barthelemy',
            SH: 'Saint Helena',
            KN: 'Saint Kitts And Nevis',
            LC: 'Saint Lucia',
            MF: 'Saint Martin',
            PM: 'Saint Pierre And Miquelon',
            VC: 'Saint Vincent And Grenadines',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Sao Tome And Principe',
            SA: 'Saudi Arabia',
            SN: 'Senegal',
            RS: 'Serbia',
            SC: 'Seychelles',
            SL: 'Sierra Leone',
            SG: 'Singapore',
            SK: 'Slovakia',
            SI: 'Slovenia',
            SB: 'Solomon Islands',
            SO: 'Somalia',
            ZA: 'South Africa',
            GS: 'South Georgia And Sandwich Isl.',
            ES: 'Spain',
            LK: 'Sri Lanka',
            SD: 'Sudan',
            SR: 'Suriname',
            SJ: 'Svalbard And Jan Mayen',
            SZ: 'Swaziland',
            SE: 'Sweden',
            CH: 'Switzerland',
            SY: 'Syrian Arab Republic',
            TW: 'Taiwan',
            TJ: 'Tajikistan',
            TZ: 'Tanzania',
            TH: 'Thailand',
            TL: 'Timor-Leste',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad And Tobago',
            TN: 'Tunisia',
            TR: 'Turkey',
            TM: 'Turkmenistan',
            TC: 'Turks And Caicos Islands',
            TV: 'Tuvalu',
            UG: 'Uganda',
            UA: 'Ukraine',
            AE: 'United Arab Emirates',
            GB: 'United Kingdom',
            US: 'United States',
            UM: 'United States Outlying Islands',
            UY: 'Uruguay',
            UZ: 'Uzbekistan',
            VU: 'Vanuatu',
            VE: 'Venezuela',
            VN: 'Viet Nam',
            VG: 'Virgin Islands, British',
            VI: 'Virgin Islands, U.S.',
            WF: 'Wallis And Futuna',
            EH: 'Western Sahara',
            YE: 'Yemen',
            ZM: 'Zambia',
            ZW: 'Zimbabwe'
        },
    },
    ru: {
        _name: 'Русский',
        autoCloseModal: {
            takeProfitStopLoss: 'Тейк Профит и Стоп Лосс',
            takeProfit: 'Тейк Профит',
            stopLoss: 'Стоп Лосс',
            updateOrder: 'Изменить ордер',
        },
        balanceModal: {
            balance: 'Баланс',
            credit: 'Кредит',
            equity: 'Средства',
            practice: 'Пробный',
            real: 'Реальный',
            account: 'Счет',
            invested: 'Вложено',
            profit: 'Прибыль',
            loss: 'Убыток',
            margin: 'Маржа',
            marginLevel: 'Уровень маржи',
            marginFree: 'Свободная маржа'
        },
        header: {
            cfd: 'CFD',
            platform: 'Platform',
            deposit: 'Депозит',
            myAccount: 'Мой аккаунт'
        },
        sideMenu: {
            marketWatch: 'обзор Рынков',
            activeOrders: 'открытые ордера',
            tradingHistory: 'история Торговли',
            economicCalendar: 'экономический Календарь',
            marketNews: 'Новости рынков'
        },
        closePositionModal: {
            closeOrder: 'Закрыть позицию',
            areYouSure: 'Вы уверены, что хотите закрыть позицию',
            buy: 'Купить',
            sell: 'Продать',
            yes: 'Да',
            no: 'Нет',
        },
        chart: {
            addNewChart: 'Добавить график',
        },
        symbolsModal: {
            watchlist: 'Избранное',
            asset: 'Инструмент',
            price: 'Цена',
            changePct: 'Изменения 24ч'
        },
        pendingModal: {
            pending: 'Цена', // <- NB
            assetPrice: 'Цена инструмента',
            current: 'Текущая',
            revert: 'Вернуть к рыночной',
            automatically: 'Позиция будет открыта автоматически при достижении указанного уровня'
        },
        orderMenu: {
            volume: 'Объем',
            lots: 'лоты',
            units: 'юниты',
            currency: 'валюта',
            contractSize: 'Размер контракта',
            position: 'Позиция',
            margin: 'Маржа',
            freeMargin: 'Свободная маржа',
            takeProfitStopLoss: 'Тейк Профит и Стоп Лосс',
            pending: 'Цена',
            market: 'Рынок',
            leverage: 'Плечо',
            spread: 'Спрэд',
            notSet: 'Не задано',
            at: 'по',
            buy: 'купить',
            sell: 'продать',
        },
        footer: {
            supportBanner: 'КАЖДЫЙ ДЕНЬ, 24/7',
            currentTime: 'ТЕКУЩЕЕ ВРЕМЯ',
            liveChat: 'Поддержка'
        },
        statusBar: {
            balance: 'Баланс',
            credit: 'Кредит',
            equity: 'Средства',
            margin: 'Маржа',
            marginLevel: 'Уровень маржи',
            freeMargin: 'Свободная маржа',
            pnl: 'Прибыль/Убыток',
            profitTotal: 'Прибыль всего'
        },
        accountModal: {
            dateRegistered: 'Дата Регистрации',
            userId: 'ID Пользователя',
            dashboard: 'Панель пользователя',
            personalData: 'Личные Данные',
            deposit: 'Депозит',
            withdrawFunds: 'Вывод Средств',
            savings: 'Накопительные Счета',
            settings: 'Настройки',
            logout: 'Выйти'
        },
        depositModal: {
            BT_INVOICE: 'Введите сумму и сформируйте счет',
            BT_TITLE: 'Ваши платежные реквизиты',
            PENDING_DEPOSITS_LIMIT: 'Лимит депозитов',
            BT_ACCOUNT: 'Счет получателя',
            BT_BANK_NAME: 'Наименование банка получателя',
            BT_BENEFICIARY: 'Получатель',
            BT_ADDRESS: 'Счет получателя',
            BT_SWIFT: 'БИК Банка получателя',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Банковский референсный код',
            BT_INN: 'ИНН',
            BT_KPP: 'КПП',
            BT_CORRESPONDING: 'Корреспондентский счёт',
            TOKEN_AMOUNT: 'Сумма',
            TOKEN_SUBTOTAL: 'Промежуточный итог',
            TOKEN_TOTAL: 'Всего',
            TOKEN_DESCRIPTION: 'Описание',
            TOKEN_PAYMENT_DETAILS: 'Платежные реквизиты',
            makeDeposit: 'Внести Депозит',
            practiceAccount: 'Учебнй Счет',
            realAccount: 'Реальный Счет',
            noWithdrawals: 'Нет вывода средств',
            easyWithdrawals: 'Легкий вывод средств',
            allAssets: 'Доступны все инструменты',
            fullFledged: 'Полнофункциональная платформа',
            fillUpTo: 'Пополнить до',
            freeReplenishment: 'Бесплатное Пополнение',
            topUp: 'Пополните Ваш Счет',
            minimumAmount: 'Минимальная Сумма',
            canSwitch: 'Вы можете переключиться между счетами в любое время'
        },
        gridsModal: {
            chartGrids: 'СЕТКА ГРАФИКОВ',
            chart1: '1 график',
            chart2: '2 графика',
            chart3: '3 графика',
            chart4: '4 графика',
        },
        noConnectionModal: {
            connectionLost: 'Соединение с сервером потеряно',
            retryNow: 'Попробовать еще',
        },
        loginModal: {
            loginToTradeRoom: 'Авторизация',
            email: 'Электронная Почта',
            emailAndId: 'Электронная Почта / ID Номер',
            enterEmail: 'Введите почту',
            twoFactor: 'Код 2FA (если активна)',
            twoFactorAuth: 'Двухфакторная аутентификация',
            password: 'Пароль',
            yourPassword: 'Ваш пароль',
            signIn: 'Войти',
            dontHaveAccount: 'У вас нет аккаунта?',
            restore: 'Восстановить',
            fullName: 'Полное имя',
            havePromo: 'У меня есть промо код',
            promo: 'Промо код',
            login: 'Вход в систему',
            haveAccount: 'Уже есть аккаунт?',
            hide: 'Скрыть',
            goTo: 'Вернуться назад'
        },
        newPasswordModal: {
            setNewPassword: 'Установить новый пароль',
            newPassword: 'Новый пароль',
            confirmNewPassword: 'Подтвердите новый пароль',
            setButton: 'Установить'
        },
        registerModal: {
            createNewAccount: 'Создать Новый Счет',
            email: 'Электронная Почта',
            firstName: 'Имя',
            lastName: 'Фамилия',
            country: 'Страна',
            phone: 'Телефон',
            password: 'Пароль',
            createAccount: 'Создать Счет',
            currency: 'Валюта'
        },
        forgotPasswordModal: {
            forgotPassword: 'Забыли Пароль?',
            submitEmail: 'Пожалуйста, введите имейл, указанный при регистрации, проверьте свой ящик и следуйте инструкциям, полученным в письме',
            submit: 'Отправить'
        },
        notifications: {
            error: 'Ошибка',
            success: 'Успешно',
            deposit: 'Депозит',
            withdrawal: 'Вывод',
            depositApproved: 'Депозит одобрен',
            depositDeclined: 'Депозит отклонен',
            withdrawalApproved: 'Вывод средств одобрен',
            withdrawalDeclined: 'Вывод средств отклонен',
            withdrawalCancelled: 'Вывод средств был отменен',
            orderRejected: 'Ордер отклонен',
            insufficientMargin: 'Отложенный ордер не удалось открыть: недостаточно свободной маржи',
            marginCall: 'Маржин-колл',
            marginCallText: 'Пополните счет для выполнения требований по марже'
        },
        markets: {
            forex: 'Форекс',
            stocks: 'Акции',
            commodities: 'Сырье',
            indices: 'Индексы',
            crypto: 'Криптовалюта',
            metals: 'Металлы',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            profitCalculator: 'Калькулятор прибыли',
            buy: 'ПОКУПКА',
            sell: 'ПРОДАЖА',
            volume: 'Объем',
            entryPrice: 'Цена Входа',
            takeProfit: 'Тейк Профит',
            stopLoss: 'Стоп Лосс',
            maxPosition: 'Макс. Позиция',
            calculate: 'Рассчитать',
            calculationsFor: 'Рассчет для',
            leverage: 'Плечо',
            requiredMargin: 'Требуемая Маржа',
            profitFromTP: 'Прибыль от ТП',
            lossFromSL: 'Убыток от СЛ',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Deposit successful',
            text: 'Your deposit has been processed successfully!',
        },
        depositFailModal: {
            title: 'Deposit failed',
            text: 'Your deposit has not been processed.',
        },
        widgetMarketWatch: {
            marketWatch: 'Обзор Рынков',
            search: 'Поиск...',
        },
        widgetOrders: {
            commission: 'Комиссия',
            volume: 'Объем',
            margin: 'Маржа',
            active: 'Открытые',
            pending: 'В Ожидании',
            activeOrders: 'Открытые ордера',
            portfolio: 'Портфолио',
            allPositions: 'Все Позиции',
            noPositionsLine1: 'У вас ещё нет',
            noPositionsLine2: 'открытых позиций',
            show: 'Показать',
            more: 'больше',
            less: 'меньше',
            purchaseTime: 'Открыт',
            closePosition: 'Закрыть',
            priceOpen: 'Цена открытия',
            priceSl: 'Цена Стоп Лосс',
            priceTp: 'Цена Тейк Профит',
            type: 'Направление позиции',
            pnl: 'Прибыль/Убыток',
            cancelOrder: 'Отменить Ордер',
            orderType: 'Тип Ордера',
            cancelled: 'Отменено',
            tradingHistory: 'Торговая История',
            noHistoryLine1: 'У вас ещё нет',
            noHistoryLine2: 'закрытых позиций',
            sortByTime: 'Сортировать по времени',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Экономический Календарь'
        },
        widgetMarketNews: {
            marketNews: 'Новости Рынков'
        },
        ordersPane: {
            ordersActive: 'Активные ордеры',
            ordersHistory: 'История Ордеров',
            id: 'ID',
            symbol: 'Символ',
            type: 'Тип',
            volume: 'Объем',
            openPrice: 'Цена открытия',
            openTime: 'Время открытия',
            closePrice: 'Цена закрытия',
            closeTime: 'Время закрытия',
            sl: 'СЛ',
            tp: 'ТП',
            price: 'Цена',
            pnl: 'ПиУ',
            actions: 'Действия',
            edit: 'Править',
            close: 'Закрыть',
            commission: 'Комиссия',
            swap: 'Своп',
            swapLong: 'Своп Лонг',
            swapShort: 'Своп Шорт'
        },
        assetInfoModal: {
            assetInfo: 'Информация об Инструменте',
            tradingConditions: 'Торговые Условия',
            information: 'Информация',
            bid: 'Покупка',
            ask: 'Продажа',
            sessionChange: 'Изменение за сессию',
            tradeNow: 'Торговать',
            opens: 'Открывается',
            closes: 'Закрывается',
            at: 'в',
            open247: 'Открыто круглосуточно',
            today: 'сегодня',
            tomorrow: 'завтра',
            sunday: 'Воскресенье',
            monday: 'Понедельник',
            tuesday: 'Вторник',
            wednesday: 'Среда',
            thursday: 'Четверг',
            friday: 'Пятница',
            saturday: 'Суббота',
            contractSpecification: 'Спецификация контракта',
            symbol: 'Символ',
            name: 'Наименование',
            market: 'Рынок',
            baseCurrency: 'Базовая Валюта',
            digits: 'Точность',
            lotSize: 'Размер лота',
            lotStep: 'Шаг лота',
            minVolume: 'Мин Объем',
            maxVolume: 'Макс Объем',
            leverage: 'Плечо',
            commission: 'Комиссия',
            swapLong: 'Своп Лонг',
            swapShort: 'Своп Шорт',
            schedule: 'Расписание',
            weekday: 'День Недели',
            tradingTime: 'Время Торгов',
            closed: 'закрыто',
            sell: 'Продавать',
            buy: 'Покупать',
            low: 'Мин',
            high: 'Макс',
            oneHourChange: 'Изменение 1 час',
            oneDayChange: 'Изменение 1 день',
            oneWeekChange: 'Изменение 1 неделя',
            oneMonthChange: 'Изменение 1 месяц',
            threeMonthsChange: 'Изменение 3 месяца',
            oneYearChange: 'Изменение 1 год',
            loading: 'Загрузка...',
        },
        fullScreen: {
            startTrading: 'К Торговле',
            deposit: 'Депозит',
            dashboard: 'Панель Управления',
            personalInfo: 'Личные Данные',
            withdrawal: 'Вывод Средств',
            verification: 'Верификация',
            accounts: 'Счета',
            liveChat: 'Поддержка',
            savings: 'Накопительные Счета',
            settings: 'Настройки',
            logOut: 'Выход',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            name: 'Cardholder\'s name',
            address: 'Address',
            DOB: 'DOB',
            bankName: 'Bank name',
            additionalInfo: 'Чтобы пополнить свой счет, пожалуйста, свяжитесь напрямую с вашим менеджером',
            additionalInfoOnlyBTCpsp: 'Чтобы открыть другие способы оплаты, пожалуйста, предоставьте KYC или свяжитесь с вашим менеджером',
            sofortPspMessage: 'Наша финансовая команда свяжется с вами, чтобы помочь вам внести депозит',
            addWalletAddress: 'Кошелек для данного метода не установлен. Пожалуйста, обратитсь к Вашему агенту или в службу поддержки.',
            addressReceipt: 'Пожалуйста, подождите, получаем текущий адрес',
            makeDeposit: 'ВНЕСТИ ДЕПОЗИТ',
            instant: 'Моментально',
            minutes: 'минут',
            hours: 'часов',
            days: 'дней',
            amount: 'Сумма',
            continue: 'Продолжить',
            qrCode: 'QR код',
            depositAddress: 'АДРЕС КОШЕЛЬКА',
            copy: 'Копировать',
            last: 'ПОСЛЕДНИЕ',
            deposits: 'ДЕПОЗИТОВ',
            time: 'Время',
            currency: 'Валюта',
            status: 'Статус',
            info: 'Инфо',
        },
        fullScreenCcExt: {
            pleaseWait: 'Пожалуйста, подождите. Идет соединение с сервисом приема платежей...',
            cardPayment: 'Оплата картоу',
            inOrder: 'Чтобы отправить сумму',
            pleaseProvide: 'пожалуйста предоставьте данные карты:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Всего налогов',
            totalBalance: 'Итоговый Баланс',
            totalPnl: 'Прибыль / Убыток',
            profitableOrders: 'Прибыльные Ордеры',
            roi: 'ROI',
            activityLog: 'Лог Активности',
            loginFromIp: 'Вход с IP',
            tradingResults: 'Результаты Торговли',
            week: 'неделя',
            month: 'Месяц',
            year: 'Год',
            successRate: 'Успешные сделки',
            closedWithProfit: 'Закрыто с прибылью',
            closedWithLoss: 'Закрыто в убыток',
            account: 'Счет',
            balance: 'Баланс',
            leverage: 'Плечо',
            credit: 'Кредит',
            tradeNow: 'Торговать',
            usingCurrentRate: 'по текущей выбранной валюте',
            totalDeposits: 'Всего депозитов'
        },
        fullScreenPersonal: {
            personalDetails: 'Персональные Данные',
            profilePhoto: 'Фото Пользователя',
            firstName: 'Имя',
            country: 'Страна',
            lastName: 'Фамилия',
            address: 'Адрес',
            email: 'Электронная почта',
            phone: 'Номер телефона',
            saveChanges: 'Сохранить Изменения'
        },
        fullScreenAvatar: {
            dropFile: 'Для загрузки перетащите файл на круг выше',
            notAllowed: 'Не разрешается размещать',
            notAllowedLine1: 'Эротические и порнографические фотографии',
            notAllowedLine2: 'Изображения, разжигающие этническую или расовую ненависть или агрессию',
            notAllowedLine3: 'Фотографии с детьми до 18 лет',
            notAllowedLine4: 'Фотографии, защищенные авторским правом',
            notAllowedLine5: 'Фотографии размером более 5 Мб и в формате, отличном от JPG, GIF или PNG',
            requirements: 'На фото должно быть четко видно Ваше лицо. Все загруженные фотографии должны соответсвовать критериям, описанным выше. В противном случае они будут принудительно удалены.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Вывод Средств',
            requestNewWithdrawal: 'ЗАПРОСИТЬ ВЫВОД СРЕДСТВ',
            amount: 'Сумма',
            currentBalance: 'Ваш текущий баланс',
            withdrawAll: 'Вывести все',
            requestWithdrawal: 'Запросить Вывод',
            last: 'ПОСЛЕДНИЕ',
            withdrawalRequests: 'ВЫВОД СРЕДСТВ',
            time: 'Время',
            currency: 'Валюта',
            info: 'Инфо',
            status: 'Статус',
            bank: 'Банк',
            bitcoin: 'Биткоин',
            card: 'Карта',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Детали Вывода Средств',
            address: 'Адрес Кошелька',
            bankAccount: 'Номер Счета',
            bankHolder: 'Имя Владельца Счета',
            bankIban: 'IBAN',
            bankSwift: 'SWIFT код',
            sortCode: 'Код Сортировки',
            ifscCode: 'IFSC код',
            bankCode: "Банковский код (BSB)",
            bankName: 'Название Банка',
            bankBranch: 'Филиал Банка',
            cardNumber: 'Номер Карты',
            cardHolder: 'Имя Владельца Карты',
            incorrectAmountByFreeMargin: 'The amount is incorrect you can withdraw the amount of free margin',
            closeOrders: 'before close all orders'
        },
        fullScreenVerification: {
            dragAndDrop: 'для загрузки перетащите документ в эту область',
            documentsList: 'СПИСОК ЗАГРУЖЕННЫХ ДОКУМЕНТОВ',
            document: 'Документ',
            timeUploaded: 'Загружен',
            timeProcessed: 'Обработан',
            status: 'Статус',
            types: ['Подтверждeние Личности', 'Подтверждeние Адреса', 'Карта - Лицевая Сторона', 'Карта - Обратная Сторона', 'Подтверждeние Личности - Обратная Сторона', 'Селфи','Other'],
            types2: ['Proof of Id (ID CARD, PASSPORT, DRIVER LICENCE)', 'Proof of Residence (Utility bill or Bank statement)', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back (ID CARD BACK, DRIVER LICENCE BACK)', 'Selfie','Other'],
            upload: 'Загрузить',
            isConfirmed: 'одобрено',
            uploadAnotherDocument: 'Загрузите другой документ',
            isUnderReview: 'находится в обработке',
            questionnaire: 'Опросник',
            sendAnswers: 'Отправить Ответы',
            progressBarOf: 'из',
            progressBarText: 'ваших документов были загружены и подтверждены'
        },
        fullScreenAccounts: {
            manageAccounts: 'Перевод средств между счетами',
            transferFrom: 'Со счета',
            transferTo: 'На счет',
            amount: 'Сумма',
            makeTransfer: 'Перевести Средства',
            yourAccounts: 'Ваши Счета',
            account: 'Счет',
            currency: 'Валюта',
            balance: 'Баланс',
            credit: 'Кредит',
            makeActive: 'Сделать Активным',
            active: 'Активен'
        },
        fullScreenSupport: {
            chatOff: 'Чат будет доступен в рабочие часы',
            sendMessage: 'Отправить сообщение',
            responseTime: 'Среднее время ответа: 1-24 часа',
        },
        fullScreenSavings: {
            pct_0: 'Гибкий',
            pct_30: 'Фиксированный 1 Месяц',
            pct_90: 'Фиксированный 1 Квартал',
            pct_180: 'Фиксированный 6 Месяцев',
            pct_365: 'Фиксированный 1 Год',
            pct_730: 'Фиксированный 2 Года',
            savings: 'Накопительные счета',
            detailedInformation: 'Подробная Информация',
            pleaseSelect: 'Пожалуйста, выберите валюту и период',
            openSavings: 'Открытые накопительные счета',
            currentTime: 'Текущее время',
            releaseTime: 'Время закрытия счета',
            currencyChosen: 'Выбранная валюта',
            periodChosen: 'Выбранный период',
            yourRate: 'Ваша ставка',
            yourAnnualRate: 'Ваша годовая ставка',
            yourEarnings: 'Ваш доход',
            accountFrom: 'Счет, с которого произвести трансфер',
            enterAmount: 'Введите сумму',
            in: 'в',
            openAndInvest: 'Открыть накопительный счет и вложить',
            investment: 'Вложение',
            period: 'Период',
            daysTotal: 'Дней всего',
            finalEarnings: 'Итоговый доход',
            created: 'Создано',
            daysElapsed: 'Дней прошло',
            days: 'дней',
            earnings: 'Доход',
            fundsReleasedIn: 'До закрытия',
            claim: 'Забрать',
        },
        fullScreenSettings: {
            updatePassword: 'ОБНОВИТЬ ПАРОЛЬ',
            currentPassword: 'Текущий Пароль',
            newPassword: 'Новый Пароль',
            changePassword: 'Изменить Пароль',
            activationForGoogle: 'Код активации для Google Authenticator',
            activateAndEnter: 'Активируйте Authenticator и введите сгенерированный код в поле ниже',
            qrCode: 'QR код',
            activateProtection: 'Активировать Двухфакторную Защиту',
            protectionActive: 'ДВУХФАКТОРНАЯ ЗАЩИТА АКТИВНА',
            twoFactorCode: 'Код Верификации',
            disableProtection: 'Отключить Двухфакторную Защиту',
            language: 'Язык',
            dashboardCurrency: 'Валюта для панели управления',
            confirmNewPassword: 'Подтвердите новый пароль',
        },
        fullScreenReferrals: {
            yourLink: 'ВАША ССЫЛКА ДЛЯ ПРИВЛЕЧЕНИЯ',
            referredFriends: 'ПРИВЛЕЧЕННЫЕ ДРУЗЬЯ',
            id: 'ID',
            name: 'Имя',
            registered: 'Зарегистрироваться',
            level: 'Уровень',
            payout: 'Выплата',
            lastPayouts: 'ПОСЛЕДНИЕ ВЫПЛАТЫ',
            time: 'Время',
            amount: 'Сумма',
            currency: 'Валюта',
            info: 'Комментарий'
        },
        months: {
            Jan: 'Янв',
            Feb: 'Фев',
            Mar: 'Мар',
            Apr: 'Апр',
            May: 'Май',
            Jun: 'Июн',
            Jul: 'Июл',
            Aug: 'Авг',
            Sep: 'Сен',
            Oct: 'Окт',
            Nov: 'Ноя',
            Dec: 'Дек'
        },
        orderTypes: ['Покупка', 'Продажа', 'Лимитный Покупка', 'Лимитный Продажа', 'Стоп Покупка', 'Стоп Продажа'],
        statuses: ['Новый', 'Одобрен', 'Отклонен', 'В Обработке','На рассмотрении','In Process','Отменено'],
        errors: {
            INVALID_FIELDS: 'Пожалуйста, проверьте правильность введенных вами данных',
            NOT_FOUND: 'Ошибка запроса',
            FORBIDDEN: 'Доступ запрещен. Пожалуйста, авторизуйтесь заново',
            SERVER_ERROR: 'Действие не удалось. Пожалуйста, попробуйте позже',
            INVALID_ACCOUNT: 'Сессия истекла. Пожалуйста, авторизуйтесь заново',
            INVALID_EMAIL: 'Неверная электронная почта',
            INVALID_PHONE: 'Неверный номер телефона',
            INVALID_COUNTRY: 'Неверная страна',
            INVALID_LOGIN: 'Неверные данные авторизации',
            USER_BLOCKED: 'Аккаунт заблокирован. Пожалуйста, свяжитесь со службой поддержки',
            USER_REGISTERED: 'Пользователь с такими электронной почтой или номером телефона уже зарегистрирован',
            INVALID_USER: 'Пользователь не найден',
            REJECTED: 'Операция запрещена согласно настройкам платформы',
            INVALID_OLD_PASSWORD: 'Текущий пароль неверен',
            INVALID_SYMBOL: 'Неверный торговый инструмент',
            INVALID_SYMBOL_PRECISION: 'Неверная точность после запятой',
            INVALID_FRAME: 'Неверный период',
            INVALID_CURRENCY: 'Неверная валюта',
            INVALID_PRODUCT: 'Неверный тип счета',
            INSUFFICIENT_FUNDS: 'Недостаточно денег. Пожалуйста, внесите депозит',
            INVALID_WITHDRAWAL: 'Запрос на вывод средств не найден',
            INVALID_DEPOSIT: 'Этот депозит нельзя отменить: он не найден или уже обработан',
            INVALID_STATUS: 'Неверный статус',
            INVALID_FILE: 'Неверный тип файла или файл слишком большой',
            INVALID_DOCUMENT: 'Документ не найден',
            INVALID_NAME: 'Неверное имя',
            INVALID_LOT_SIZE: 'Неверный размер лота',
            INVALID_LOT_STEP: 'Неверный шаг лота',
            INVALID_MIN_VOLUME: 'Неверный минимальный объем',
            INVALID_MAX_VOLUME: 'Неверный максимальный объем',
            INVALID_GROUP: 'Неверная группа',
            INVALID_SPREAD: 'Неверный спред',
            REQUEST_TIMEOUT: 'Время ожидания запроса истекло. Пожалуйста, попробуйте еще раз',
            INVALID_TYPE: 'Неверный тип ордера',
            INVALID_VOLUME: 'Неверный объем ордера',
            INVALID_SL: 'Неверный стоп лосс',
            INVALID_TP: 'Неверный тейк профит',
            INVALID_PRICE: 'Неверная цена ордера',
            INVALID_EXPIRATION: 'Неверное время экспирации',
            NOT_ENOUGH_MARGIN: 'Недостаточно маржи',
            INVALID_ORDER: 'Ордер не найден',
            MARKET_CLOSED: 'Торговля недоступна, рынок закрыт',
            INVALID_BALANCE_TYPE: 'Неверный тип балансовой операции',
            INVALID_HASH: 'Неверный хеш',
            HASH_EXPIRED: 'Ваша ссылка на сброс пароля истекла. Пожалуйста, запросите новую',
            INVALID_CODE: 'Неверный код 2FA',
            CHAT_DISABLED: 'Доступ к чату поддержки был закрыт',
            WITHDRAWAL_NOT_ALLOWED: 'Доступ к выводу средств был закрыт',
            TRADING_DISABLED: 'Торговля отключена для этого счета',
            PENDING_DEPOSITS_LIMIT: 'Превышен лимит депозитов',
            CLOSE_OPEN_ORDERS: 'Пожалуйста, закройте открытые ордера',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Возможно только одно неподтвержденное снятие средств',
            LOCAL_DEPOSIT_ONLY_REAL: 'Пополнение возможно только для реального аккаунта',
            LOCAL_DEPOSIT_POSITIVE: 'Сумма депозита должна быть больше 0',
            LOCAL_INVALID_CARD_NUMBER: 'Неверный номер карты',
            LOCAL_INVALID_CARD_EXPIRATION: 'Неверная дата истечения срока действия',
            LOCAL_INVALID_CVC: 'Неверный код CVV/CVC',
            LOCAL_PASSWORDS_NOT_MATCH: 'Пароли не сопадают, пожалуйста, введите снова',
            LOCAL_NO_TRADING_ACCOUNTS: 'У вас нет торговых счетов. Пожалуйста, свяжитесь со службой поддержки',
            LOCAL_MIN_DEPOSIT: 'Минмальная сумма пополнения - $',
            LOCAL_MIN_WITHDRAWAL: 'Минимальная сумма снятия - $',
            LOCAL_INVALID_FILE_TYPE: 'Неподдерживаемый формат файла. Пожалуйста, приложите файл JPG, PNG или PDF',
            LOCAL_MIN_STAKING: 'Минимальная сумма для выбранной валюты ',
            FLOOD_REJECTED: 'Вы отправляете сообщения слишком часто. Пожалуйста, повторите попытку позже',
            REGISTRATIONS_BLOCKED: "Спасибо за ваш запрос, один из наших представителей свяжется с вами как можно скорее",
        },
        countries: {
            AF: 'Афганистан',
            AX: 'Аландские острова',
            AL: 'Албания',
            DZ: 'Алжир',
            AS: 'Американское Самоа',
            AD: 'Андорра',
            AO: 'Ангола',
            AI: 'Ангилья',
            AQ: 'Антарктида',
            AG: 'Антигуа и Барбуда',
            AR: 'Аргентина',
            AM: 'Армения',
            AW: 'Аруба',
            AU: 'Австралия',
            AT: 'Австрия',
            AZ: 'Азербайджан',
            BS: 'Багамские Острова',
            BH: 'Бахрейн',
            BD: 'Бангладеш',
            BB: 'Барбадос',
            BY: 'Белоруссия',
            BE: 'Бельгия',
            BZ: 'Белиз',
            BJ: 'Бенин',
            BM: 'Бермудские Острова',
            BT: 'Бутан',
            BO: 'Боливия',
            BA: 'Босния и Герцеговина',
            BW: 'Ботсвана',
            BV: 'Остров Буве',
            BR: 'Бразилия',
            IO: 'Британская территория в Индийском океане',
            BN: 'Бруней',
            BG: 'Болгария',
            BF: 'Буркина-Фасо',
            BI: 'Бурунди',
            KH: 'Камбоджа',
            CM: 'Камерун',
            CA: 'Канада',
            CV: 'Кабо-Верде',
            KY: 'Острова Кайман',
            CF: 'ЦАР',
            TD: 'Чад',
            CL: 'Чили',
            CN: 'Китай',
            CX: 'Остров Рождества',
            CC: 'Кокосовые острова',
            CO: 'Колумбия',
            KM: 'Коморы',
            CG: 'Конго',
            CD: 'Демократическая Республика Конго',
            CK: 'Острова Кука',
            CR: 'Коста-Рика',
            CI: 'Кот-д’Ивуар',
            HR: 'Хорватия',
            CU: 'Куба',
            CY: 'Кипр',
            CZ: 'Чехия',
            DK: 'Дания',
            DJ: 'Джибути',
            DM: 'Доминика',
            DO: 'Доминиканская Республика',
            EC: 'Эквадор',
            EG: 'Египет',
            SV: 'Сальвадор',
            GQ: 'Экваториальная Гвинея',
            ER: 'Эритрея',
            EE: 'Эстония',
            ET: 'Эфиопия',
            FK: 'Фолклендские острова',
            FO: 'Фарерские острова',
            FJ: 'Фиджи',
            FI: 'Финляндия',
            FR: 'Франция',
            GF: 'Гвиана',
            PF: 'Французская Полинезия',
            TF: 'Французские Южные и Антарктические территории',
            GA: 'Габон',
            GM: 'Гамбия',
            GE: 'Грузия',
            DE: 'Германия',
            GH: 'Гана',
            GI: 'Гибралтар',
            GR: 'Греция',
            GL: 'Гренландия',
            GD: 'Гренада',
            GP: 'Гваделупа',
            GU: 'Гуам',
            GT: 'Гватемала',
            GG: 'Гернси',
            GN: 'Гвинея',
            GW: 'Гвинея-Бисау',
            GY: 'Гайана',
            HT: 'Гаити',
            HM: 'Остров Херд и острова Макдональд',
            VA: 'Ватикан',
            HN: 'Гондурас',
            HK: 'Гонк Конг',
            HU: 'Венгрия',
            IS: 'исландия',
            IN: 'Индия',
            ID: 'Индонезия',
            IR: 'Иран',
            IQ: 'Ирак',
            IE: 'Ирландия',
            IM: 'Остров Мэн',
            IL: 'Израиль',
            IT: 'Италия',
            JM: 'Ямайка',
            JP: 'Япония',
            JE: 'Джерси',
            JO: 'Иордания',
            KZ: 'Казахстан',
            KE: 'Кения',
            KI: 'Кирибати',
            KR: 'Корея',
            KW: 'Кувейт',
            KG: 'Киргизия',
            LA: 'Лаос',
            LV: 'Латвия',
            LB: 'Ливан',
            LS: 'Лесото',
            LR: 'Либерия',
            LY: 'Ливия',
            LI: 'Лихтенштейн',
            LT: 'Литва',
            LU: 'Люксембург',
            MO: 'Макао',
            MK: 'Македония',
            MG: 'Мадагаскар',
            MW: 'Малави',
            MY: 'Малайзия',
            MV: 'Мальдивы',
            ML: 'Мали',
            MT: 'Мальта',
            MH: 'Маршалловы Острова',
            MQ: 'Мартиника',
            MR: 'Мавритания',
            MU: 'Маврикий',
            YT: 'Майотта',
            MX: 'Мексика',
            FM: 'Микронезия',
            MD: 'Молдова',
            MC: 'Монако',
            MN: 'Монголия',
            ME: 'Черногория',
            MS: 'Монтсеррат',
            MA: 'Марокко',
            MZ: 'Мозамбик',
            MM: 'Мьянма',
            NA: 'Намибия',
            NR: 'Науру',
            NP: 'Непал',
            NL: 'Нидерланды',
            AN: 'Нидерландские Антильские острова',
            NC: 'Новая Каледония',
            NZ: 'Новая Зеландия',
            NI: 'Никарагуа',
            NE: 'Нигер',
            NG: 'Нигерия',
            NU: 'Ниуэ',
            NF: 'Норфолк',
            MP: 'Северные Марианские острова',
            NO: 'Норвегия',
            OM: 'Оман',
            PK: 'Пакистан',
            PW: 'Палау',
            PS: 'Палестинские Территории',
            PA: 'Панама',
            PG: 'Папуа — НоваяГвинея',
            PY: 'Парагвай',
            PE: 'Перу',
            PH: 'Филиппины',
            PN: 'Острова Питкэрн',
            PL: 'Польша',
            PT: 'Португалия',
            PR: 'Пуэрто-Рико',
            QA: 'Катар',
            RE: 'Реюньон',
            RO: 'Румыния',
            RU: 'Россия',
            RW: 'Руанда',
            BL: 'Сен-Бартелеми',
            SH: 'Остров Святой Елены',
            KN: 'Сент-Китс и Невис',
            LC: 'Сент-Люсия',
            MF: 'Сен-Мартен',
            PM: 'Сен-Пьер и Микелон',
            VC: 'Сент-Винсент и Гренадины',
            WS: 'Самоа',
            SM: 'Сан Марино',
            ST: 'Сан-Томе и Принсипи',
            SA: 'Саудовская Арабия',
            SN: 'Сенегал',
            RS: 'Сербия',
            SC: 'Сейшелы',
            SL: 'Сьерра-Леоне',
            SG: 'Сингапур',
            SK: 'Словакия',
            SI: 'Словения',
            SB: 'Соломоновы Острова',
            SO: 'Сомали',
            ZA: 'ЮАР',
            GS: 'Южная Георгия и Южные Сандвичевы Острова',
            ES: 'Испания',
            LK: 'Шри-Ланка',
            SD: 'Судан',
            SR: 'Суринам',
            SJ: 'Шпицберген и Ян-Майен',
            SZ: 'Эсватини',
            SE: 'Швеция',
            CH: 'Швейцария',
            SY: 'Сирия',
            TW: 'тайвань',
            TJ: 'Таджикистан',
            TZ: 'Танзания',
            TH: 'Тайланд',
            TL: 'Восточный Тимор',
            TG: 'Того',
            TK: 'Токелау',
            TO: 'Тонга',
            TT: 'Тринидад и Тобаго',
            TN: 'Тунис',
            TR: 'Турция',
            TM: 'Туркменистан',
            TC: 'Тёркс и Кайкос',
            TV: 'Тувалу',
            UG: 'Уганда',
            UA: 'Украина',
            AE: 'ОАЭ',
            GB: 'Великобритания',
            US: 'США',
            UM: 'Внешние малые острова США',
            UY: 'Уругвай',
            UZ: 'Узбекистан',
            VU: 'Вануату',
            VE: 'Венесуэла',
            VN: 'Вьетнам',
            VG: 'Виргинские Острова',
            VI: 'Виргинские Острова (США)',
            WF: 'Уоллис и Футуна',
            EH: 'Западная Сахара',
            YE: 'Йемен',
            ZM: 'Замбия',
            ZW: 'Зимбабве'
        },
    },
    pl: {
        _name: 'Polski',
        autoCloseModal: {
            takeProfitStopLoss: 'Odbierz zysk i zatrzymaj strate',
            takeProfit: ' Odbierz zysk',
            stopLoss: ' Zatrzymaj strate',
            updateOrder: ' Zaktualizuj zamówienie'
        },
        balanceModal: {
            balance: 'Saldo',
            credit: ' Kredyt',
            equity: ' Kapital',
            practice: ' PRAKTYKA',
            real: ' REALNY',
            account: ' KONTO',
            invested: ' Zainwestowany',
            profit: ' Zysk',
            loss: ' Strata',
            margin: ' Margines',
            marginLevel: 'Poziom marginesu',
            marginFree: 'Wolny margines'
        },
        header: {
            cfd: 'CFD',
            platform: ' Platforma',
            deposit: ' Depozyt',
            myAccount: 'Moje konto'
        },
        sideMenu: {
            marketWatch: 'Obserwacja rynku',
            activeOrders: 'Aktywne zamówienia',
            tradingHistory: 'Historia handlu',
            economicCalendar: 'Kalendarz ekonomiczny',
            marketNews: 'Wiadomosci rynkowe'
        },
        closePositionModal: {
            closeOrder: 'Zamknij pozycje',
            areYouSure: 'Czy na pewno zamkniesz pozycje',
            buy: 'Kupic',
            sell: 'Sprzedac',
            yes: 'Tak',
            no: 'Nie',
        },
        chart: {
            addNewChart: 'Dodaj nowy wykres',
        },
        symbolsModal: {
            watchlist: 'Lista obserwowanych',
            asset: 'Aktywa',
            price: 'Cena',
            changePct: 'Wymiana 24h'
        },
        pendingModal: {
            pending: 'W oczekiwaniu',
            assetPrice: 'Cena aktywów',
            current: ' Aktualny',
            revert: 'Powrót do ceny rynkowej',
            automatically: 'Pozycja zostanie otwarta automatycznie, gdy cena osiegnie ten poziom'
        },
        orderMenu: {
            volume: 'Pojemnosc',
            lots: 'partii',
            units: ' jednostki',
            currency: 'waluta',
            contractSize: 'Wielkosc kontraktu',
            position: 'Pozycja',
            margin: 'Margines',
            freeMargin: 'Wolny margines',
            takeProfitStopLoss: 'Odbierz zysk i zatrzymaj strate',
            pending: 'W oczekiwaniu',
            market: 'Rynek',
            leverage: 'Dźwignia',
            spread: 'Spread',
            notSet: 'Nie ustawiony',
            at: 'w',
            buy: 'kupić',
            sell: 'sprzedać',
        },
        footer: {
            supportBanner: 'KAZDEGO DNIA PRZEZ CALE DOBE',
            currentTime: 'OBECNY CZAS',
            liveChat: 'Czat na zywo'
        },
        statusBar: {
            balance: 'Saldo',
            credit: 'Kredyt',
            equity: 'Kapital',
            margin: 'Margines',
            marginLevel: 'Poziom marginesu',
            freeMargin: 'Wolny margines',
            pnl: 'PnL',
            profitTotal: 'Lifetime PnL'
        },
        accountModal: {
            dateRegistered: 'Data rejestracji',
            userId: 'Identyfikator uzytkownika',
            dashboard: 'Dashboard',
            personalData: 'Dane osobiste',
            deposit: 'Depozyt',
            withdrawFunds: 'Wypłatę srodków',
            savings: 'Oszczednosci',
            settings: 'Ustawienia',
            logout: 'Wyloguj sie'
        },
        depositModal: {
            BT_INVOICE: 'Enter amount and generate invoice',
            BT_TITLE: 'Our banking details',
            PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
            BT_ACCOUNT: 'Account',
            BT_BANK_NAME: 'Bank Name',
            BT_BENEFICIARY: 'Beneficiary',
            BT_ADDRESS: 'Beneficiary Address',
            BT_SWIFT: 'Swift',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Kod referencyjny banku',
            BT_INN: 'INN',
            BT_KPP: 'Correspondent account',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: 'Amount',
            TOKEN_SUBTOTAL: 'Subtotal',
            TOKEN_TOTAL: 'Total',
            TOKEN_DESCRIPTION: 'Description',
            TOKEN_PAYMENT_DETAILS: 'Payment Details',
            makeDeposit: 'Zlozyc depozyt',
            practiceAccount: 'Konto treningowe',
            realAccount: 'Prawdziwe konto',
            noWithdrawals: 'Brak wyplat',
            easyWithdrawals: 'latwe wyplaty',
            allAssets: 'Wszystkie aktywy dostepne',
            fullFledged: 'Pelnoprawna platforma',
            fillUpTo: 'Wypelnij do',
            freeReplenishment: 'Bezplatne uzupelnianie',
            topUp: 'Doladuj swoje konto',
            minimumAmount: 'Stawka minimalna',
            canSwitch: 'Mozesz przelaczac sie miedzy swoimi kontami w dowolnym momencie'
        },
        gridsModal: {
            chartGrids: 'SIATKI WYKRESÓW',
            chart1: '1 wykres',
            chart2: '2 wykres',
            chart3: '3 wykres',
            chart4: '4 wykres',
        },
        noConnectionModal: {
            connectionLost: 'Polaczenie z serwerem zostalo utracone',
            retryNow: 'Spróbuj teraz',
        },
        loginModal: {
            loginToTradeRoom: 'Zaloguj sie do Traderoom',
            email: 'Adres e-mail',
            emailAndId: 'Adres e-mail / Numer identyfikacyjny',
            enterEmail: 'Wpisz swój e-mail',
            twoFactor: 'Kod 2FA (jesli jest wlaczony)',
            twoFactorAuth: 'Uwierzytelnianie dwuskladnikowe',
            password: 'Haslo',
            yourPassword: 'Twoje haslo',
            signIn: 'Zaloguj sie',
            dontHaveAccount: 'Don’t have an account?',
            restore: 'Restore',
            fullName: 'Full Name',
            havePromo: 'I have a promo-code',
            promo: 'Promo code',
            login: 'Login',
            haveAccount: 'Already have an account?',
            hide: 'Hide',
            goTo: 'Back to'
        },
        newPasswordModal: {
            setNewPassword: 'Ustaw nowe haslo',
            newPassword: 'Nasza zalety',
            confirmNewPassword: 'Potwierdź nowe hasło',
            setButton: 'Ustaw'
        },
        registerModal: {
            createNewAccount: 'Utwórz nowe konto',
            email: 'Adres e-mail',
            firstName: 'Imie',
            lastName: 'Nazwisko',
            country: 'Kraj',
            phone: 'Telefon',
            password: 'Haslo',
            createAccount: 'Utwórz konto',
            currency: 'Waluta'
        },
        forgotPasswordModal: {
            forgotPassword: 'Nie pamietam hasla?',
            submitEmail: 'Prosimy o podanie e-maila uzytego do rejestracji, sprawdzenie skrzynki odbiorczej i postepowanie zgodnie z podanymi instrukcjami.',
            submit: 'Przeslij'
        },
        notifications: {
            error: 'Blad',
            success: 'Sukces',
            deposit: 'Depozyt',
            withdrawal: 'Wycofanie',
            depositApproved: 'Depozyt zostal zatwierdzony',
            depositDeclined: 'Depozyt zostal odrzucony',
            withdrawalApproved: 'Wycofanie zatwierdzone',
            withdrawalDeclined: 'Odmówiono wyplaty',
            withdrawalCancelled: 'Wypłata została anulowana',
            orderRejected: 'Zlecenie odrzucone',
            insufficientMargin: 'Nie można otworzyć zlecenia oczekującego: niewystarczający wolny margines',
            marginCall: 'Margin Call',
            marginCallText: 'Prosimy o wpłatę, aby uzupełnić wymagany margines'
        },
        markets: {
            forex: 'Forex',
            stocks: 'Akcje',
            commodities: 'Towary',
            indices: 'Wskazniki',
            crypto: 'Kryptowaluta',
            metals: 'Metale',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            buy: 'BUY',
            profitCalculator: 'Profit Calculator',
            sell: 'SELL',
            volume: 'Volume',
            entryPrice: 'Entry Price',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            maxPosition: 'Max Position',
            calculate: 'Calculate',
            calculationsFor: 'Calculations for',
            leverage: 'Leverage',
            requiredMargin: 'Required Margin',
            profitFromTP: 'Profit from TP',
            lossFromSL: 'Loss from SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Deposit successful',
            text: 'Your deposit has been processed successfully!',
        },
        depositFailModal: {
            title: 'Deposit failed',
            text: 'Your deposit has not been processed.',
        },
        widgetMarketWatch: {
            marketWatch: 'Obserwacja rynku',
            search: 'Szukac  ...',
        },
        widgetOrders: {
            commission: 'Commission',
            volume: 'Tom',
            margin: 'Marza',
            active: 'Aktywny',
            pending: 'W trakcie realizacji',
            activeOrders: 'Zamówienia aktywne',
            portfolio: 'Portfolio',
            allPositions: 'Wszystkie stanowiska',
            noPositionsLine1: 'Nie masz otwartego',
            noPositionsLine2: 'jeszcze stanowiska',
            show: 'Pokaz',
            more: 'wiecej',
            less: 'mniej',
            purchaseTime: 'Czas zakupu',
            closePosition: 'Pozycja zamkniecia',
            priceOpen: 'Cena zakupu',
            priceSl: 'Cena Stop Loss',
            priceTp: 'Cena Take Profit',
            type: 'Pozycja Kierunek',
            pnl: 'Zysk/Strata',
            cancelOrder: 'Anuluj zamówienie',
            orderType: 'Typ zamówienia',
            cancelled: 'Anulowane',
            tradingHistory: 'Historia handlu',
            noHistoryLine1: 'Nie masz zadnych',
            noHistoryLine2: 'jeszcze zamkniete transakcje',
            sortByTime: 'Sortuj według czasu',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Kalendarz ekonomiczny'
        },
        widgetMarketNews: {
            marketNews: 'Wiadomosci rynkowe'
        },
        ordersPane: {
            ordersActive: 'Zamówienia Aktywne',
            ordersHistory: 'Historia zamówien',
            id: 'ID',
            symbol: 'Symbol',
            type: 'Typ',
            volume: 'Tom',
            openPrice: 'Cena wywolawcza',
            openTime: 'Czas otwarty',
            closePrice: 'Zamknij cene',
            closeTime: 'Czas zamkniecia',
            sl: 'SL',
            tp: 'TP',
            price: 'Cena',
            pnl: 'PnL',
            actions: 'Dzialania',
            edit: 'Edytować',
            close: 'Zamknać',
            commission: 'Commission',
            swap: 'Swap',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short'
        },
        assetInfoModal: {
            assetInfo: 'Asset Info',
            tradingConditions: 'Trading Conditions',
            information: 'Information',
            bid: 'Bid',
            ask: 'Ask',
            sessionChange: 'Session Change',
            tradeNow: 'Trade Now',
            opens: 'Opens',
            closes: 'Closes',
            at: 'at',
            open247: 'Open 24/7',
            today: 'today',
            tomorrow: 'tomorrow',
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            contractSpecification: 'Contract Specification',
            symbol: 'Symbol',
            name: 'Name',
            market: 'Market',
            baseCurrency: 'Base Currency',
            digits: 'Digits',
            lotSize: 'Lot Size',
            lotStep: 'Lot Step',
            minVolume: 'Min Volume',
            maxVolume: 'Max Volume',
            leverage: 'Leverage',
            commission: 'Commission',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short',
            schedule: 'Schedule',
            weekday: 'Weekday',
            tradingTime: 'Trading Time',
            closed: 'closed',
            sell: 'Sell',
            buy: 'Buy',
            low: 'Low',
            high: 'High',
            oneHourChange: '1 hour change',
            oneDayChange: '1 day change',
            oneWeekChange: '1 week change',
            oneMonthChange: '1 month change',
            threeMonthsChange: '3 months change',
            oneYearChange: '1 year change',
            loading: 'Loading...',
        },
        months: {
            Jan: 'Styczen',
            Feb: 'Luty',
            Mar: 'Marzec',
            Apr: 'Kwiecien',
            May: 'Maj',
            Jun: 'Czerwiec',
            Jul: 'Lipiec',
            Aug: 'Sierpien',
            Sep: 'Wrzesien',
            Oct: 'Pazdziernik',
            Nov: 'Listopad',
            Dec: 'Grudzien'
        },
        fullScreen: {
            startTrading: 'Rozpocznij Handel',
            deposit: 'Dokonaj wplaty',
            dashboard: 'Pulpit',
            personalInfo: 'Aktualizacja danych osobowych',
            withdrawal: 'Wypłata środków',
            verification: 'Weryfikacja tożsamości',
            accounts: 'Zarządzaj kontami',
            liveChat: 'Czat na żywo',
            savings: 'Lokaty',
            settings: 'Ustawienia platformy',
            logOut: 'Wyloguj się',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            name: 'Cardholder\'s name',
            address: 'Address',
            DOB: 'DOB',
            bankName: 'Bank name',
            additionalInfo: 'Aby wpłacić więcej na swoje konto, skontaktuj się bezpośrednio z swoim menedżerem konta',
            additionalInfoOnlyBTCpsp: 'Aby otworzyć inne metody płatności, proszę dostarczyć KYC lub skontaktować się z menedżerem konta',
            sofortPspMessage: 'Nasz zespół finansowy skontaktuje się z Tobą, aby pomóc Ci dokonać wpłaty',
            addWalletAddress: 'Wallet for this deposit method is not set. Please contact your agent or support team.',
            addressReceipt: 'Please wait for the address to load',
            makeDeposit: 'DOKONAJ WPLATY DEPOZYTU',
            instant: 'Natychmiast',
            minutes: 'minuty',
            hours: 'godziny',
            days: 'dni',
            amount: 'Kwota',
            continue: 'Kontynuuj',
            qrCode: 'KOD QR',
            depositAddress: 'ADRES DEPOZYTOWY',
            copy: 'Kopia',
            last: 'OSTATNI',
            deposits: 'DEPOZYTY',
            time: 'Czas',
            currency: 'Waluta',
            status: 'Status',
            info: 'Informacje',
        },
        fullScreenCcExt: {
            pleaseWait: 'Prosze czekac. Polaczenie z dostawca uslug platniczych...',
            cardPayment: 'Platnosc karta',
            inOrder: 'W celu wyslania kwoty',
            pleaseProvide: 'Prosze podac dane karty:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Total Taxes',
            totalBalance: 'Całkowite Saldo',
            totalPnl: 'Całkowity PNL',
            profitableOrders: 'Zyskowne pozycję',
            roi: 'ROI',
            activityLog: 'Lista Aktywności',
            loginFromIp: 'Login from IP',
            tradingResults: 'Trading Results',
            week: 'Tydzień',
            month: 'Miesiąc',
            year: 'Rok',
            successRate: 'Wskaźnik Sukcesu',
            closedWithProfit: 'Zamknięte z Zyskiem',
            closedWithLoss: 'Zamknięte ze stratą',
            account: 'Konto',
            balance: 'Saldo',
            leverage: 'Dźwignia',
            credit: 'Kredyt',
            tradeNow: 'Rozpocznij Handel',
            usingCurrentRate: 'using current exchange rate',
            totalDeposits: 'Total Deposits'
        },
        fullScreenPersonal: {
            personalDetails: 'Dane osobowe',
            profilePhoto: 'Zdjecie profilowe',
            firstName: 'Imię',
            country: 'Kraj',
            lastName: 'Nazwisko',
            address: 'Adres',
            email: 'E-mail',
            phone: 'Numer telefonu',
            saveChanges: 'Zapisac zmiany'
        },
        fullScreenAvatar: {
            dropFile: 'Wrzuc plik na okrag powyzej, aby go przeslac',
            notAllowed: 'Niedozwolone jest publikowanie',
            notAllowedLine1: 'Zdjecia o charakterze jednoznacznie seksualnym lub pornograficznym',
            notAllowedLine2: 'Obrazy majace na celu podzeganie do nienawisci lub agresji na tle etnicznym lub rasowym',
            notAllowedLine3: 'Zdjecia z udzialem osób ponizej 18 roku zycia',
            notAllowedLine4: 'Zdjecia chronione prawami autorskimi osób trzecich',
            notAllowedLine5: 'Obrazy wieksze niz 5 MB i w formacie innym niz JPG, GIF lub PNG',
            requirements: 'Twoja twarz musi byc wyraznie widoczna na zdjeciu. Wszystkie zdjecia i filmy zamieszczane przez Ciebie musza spelniac te wymagania, w przeciwnym razie moga zostac usuniete.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Withdrawal',
            requestNewWithdrawal: 'WNIOSEK O NOWA WYPŁATĘ',
            amount: 'Kwota',
            currentBalance: 'Stan Twojego rachunku biezacego wynosi',
            withdrawAll: 'Wycofac wszystkie',
            requestWithdrawal: 'Wypłać',
            last: 'OSTATNI',
            withdrawalRequests: 'Historia',
            time: 'Czas',
            currency: 'WALUTA',
            info: 'Informacje',
            status: 'Status',
            bank: 'Bank',
            bitcoin: 'Bitcoin',
            card: 'Karta',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Szczególy wypłaty',
            address: 'Adres portfela',
            bankAccount: 'Numer konta',
            bankHolder: 'Nazwa posiadacza konta',
            bankIban: 'IBAN',
            bankSwift: 'Kod SWIFT banku',
            sortCode: 'Kod sortowania',
            ifscCode: 'Kod IFSC',
            bankCode: "Kod banku (BSB)",
            bankName: 'Nazwa Banku',
            bankBranch: 'Oddział Banku',
            cardNumber: 'Numer karty',
            cardHolder: 'Nazwa posiadacza karty',
            incorrectAmountByFreeMargin: 'The amount is incorrect you can withdraw the amount of free margin',
            closeOrders: 'before close all orders'
        },
        fullScreenVerification: {
            dragAndDrop: 'przeciagnij i upuść dokument na ten obszar',
            documentsList: 'LISTA PRZESLANYCH DOKUMENTÓW',
            document: 'Dokument',
            timeUploaded: 'Wyslano',
            timeProcessed: 'Zweryfikowano',
            status: 'Status',
            types: ['Przód dowodu', 'Dokument potwierdzający adres zamieszkania', 'Przód karty kredytowej', 'Tył karty kredytowej', 'Tył dowodu', 'Selfie','Other'],
            types2: ['Proof of Id (ID CARD, PASSPORT, DRIVER LICENCE)', 'Proof of Residence (Utility bill or Bank statement)', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back (ID CARD BACK, DRIVER LICENCE BACK)', 'Selfie','Other'],
            upload: 'Wyślij',
            isConfirmed: 'jest potwierdzony',
            uploadAnotherDocument: 'Wyślij inny dokument',
            isUnderReview: 'jest w trakcie przegladu',
            questionnaire: 'Kwestionariusz',
            sendAnswers: 'Wyslij odpowiedzi',
            progressBarOf: 'z',
            progressBarText: 'twoich dokumentów zostały wgrane i potwierdzone'
        },
        fullScreenAccounts: {
            manageAccounts: 'Przelewaj srodki pomiedzy swoimi kontami',
            transferFrom: 'Z konta',
            transferTo: 'Na konto',
            amount: 'Kwota',
            makeTransfer: 'Dokonaj transferu',
            yourAccounts: 'Twoje konta',
            account: 'Konto',
            currency: 'Waluta',
            balance: 'Saldo',
            credit: 'Kredyt',
            makeActive: 'Uczyn aktywnym',
            active: 'Aktywny'
        },
        fullScreenSupport: {
            chatOff: 'Chat will be available on working days',
            sendMessage: 'Napisz wiadomość...',
            responseTime: 'Średni czas odpowiedzi: 1-24 godz.',
        },
        fullScreenSavings: {
            pct_0: 'Dynamiczna',
            pct_30: 'Terminowa miesiąc',
            pct_90: 'Terminowa kwartał',
            pct_180: 'Terminowa 6 miesięcy',
            pct_365: 'Terminowa rok',
            pct_730: 'Terminowa 2 rok',
            savings: 'Oszczednosci',
            detailedInformation: 'Szczególowe informacje',
            pleaseSelect: 'Prosze wybrac walute i okres',
            openSavings: 'Oszczednosci otwarte',
            currentTime: 'Aktualny czas',
            releaseTime: 'Czas wydania',
            currencyChosen: 'Wybrana waluta',
            periodChosen: 'Wybrany okres',
            yourRate: 'Twoja stawka',
            yourAnnualRate: 'Twój roczny wskaźnik',
            yourEarnings: 'Twoje zarobki',
            accountFrom: 'Z konta',
            enterAmount: 'Wprowadz kwote',
            in: 'W',
            openAndInvest: 'Otwórz konto oszczednosciowe i inwestuj',
            investment: 'Lokata',
            period: 'Okres',
            daysTotal: 'Dni',
            finalEarnings: 'Potencjialny zysk',
            created: 'Utworzony',
            daysElapsed: 'Dni, które uplynely',
            days: 'dni',
            earnings: 'Zarobki',
            fundsReleasedIn: 'Odbłokowane za',
            claim: 'Roszczenie',
        },
        fullScreenSettings: {
            updatePassword: 'AKTUALIZACJA HASLA',
            currentPassword: 'Aktualne haslo',
            newPassword: 'Nowe hasło',
            changePassword: 'Zmiana hasła',
            activationForGoogle: 'Kod aktywacyjny dla Google Authenticator',
            activateAndEnter: 'Aktywuj kod uwierzytelniający i wprowadź wygenerowany kod w polu poniżej',
            qrCode: 'Kod QR',
            activateProtection: 'Aktywuj ochrone 2FA',
            protectionActive: 'Ochrona 2FA jest aktywna',
            twoFactorCode: 'Kod 2FA',
            disableProtection: 'Wylacz ochrone 2FA',
            language: 'Jezyk',
            dashboardCurrency: 'Dashboard Currency',
            confirmNewPassword: 'Potwierdź nowe hasło',
        },
        fullScreenReferrals: {
            yourLink: 'TWÓJ LINK POLECAJACY',
            referredFriends: 'POLECENI ZNAJOMI',
            id: 'ID',
            name: 'Imie',
            registered: 'Zarejestrowany',
            level: 'Poziom',
            payout: 'Wypłatę',
            lastPayouts: 'OSTATNIE WYPLATY ZA POLECENIE',
            time: 'Czas',
            amount: 'Kwota',
            currency: 'Walut',
            info: 'Informacje'
        },
        orderTypes: ['Kupic', 'Sprzedac', 'Wykupic limit', 'Limit sprzedazy', 'Zakup Stop', 'Sprzedac Stop'],
        statuses: ['W trakcie realizacji', 'Zatwierdzony', 'Odrzucony', 'Obróbka','W trakcie przeglądu','In Process','Anulowano'],
        errors: {
            INVALID_FIELDS: 'Please check that the data you have entered is correct',
            NOT_FOUND: 'Blad zadania',
            FORBIDDEN: 'Odmowa dostepu. Prosimy o ponowne zalogowanie.',
            SERVER_ERROR: 'Akcja nie powiodla sie. Prosze spróbowac ponownie pózniej',
            INVALID_ACCOUNT: 'Akcja nie powiodla sie. Prosze spróbowac ponownie pózniej',
            INVALID_EMAIL: 'Nieprawidlowy adres e-mail',
            INVALID_PHONE: 'Nieprawidlowy numer telefonu',
            INVALID_COUNTRY: 'Nieprawidlowy kraj',
            INVALID_LOGIN: 'Nieprawidlowe poswiadczenia logowania',
            USER_BLOCKED: 'Konto jest zablokowane. Prosimy o kontakt z obsluga',
            USER_REGISTERED: 'Uzytkownik o podanym adresie e-mail lub numerze telefonu jest juz zarejestrowany',
            INVALID_USER: 'Uzytkownik nie zostal znaleziony',
            REJECTED: 'Dzialanie nie jest dozwolone z powodu ograniczen platformy',
            INVALID_OLD_PASSWORD: 'Stare haslo jest niewazne',
            INVALID_SYMBOL: 'Nieprawidlowy symbol handlowy',
            INVALID_SYMBOL_PRECISION: 'Nieprawidlowa precyzja symbolu',
            INVALID_FRAME: 'Nieprawidlowa ramka wykresu',
            INVALID_CURRENCY: 'Nieprawidlowa waluta',
            INVALID_PRODUCT: 'Nieprawidlowy typ handlowy konta',
            INSUFFICIENT_FUNDS: 'Niewystarczajace srodki finansowe',
            INVALID_WITHDRAWAL: 'Wycofanie nie zostalo odnalezione',
            INVALID_DEPOSIT: 'Tego depozytu nie można anulować - nie znaleziono go lub został już przetworzony',
            INVALID_STATUS: 'Nieprawidlowy status',
            INVALID_FILE: 'Nieprawidlowe rozszerzenie pliku lub plik jest zbyt duzy',
            INVALID_DOCUMENT: 'Dokument nie zostal znaleziony',
            INVALID_NAME: 'Nieprawidlowa nazwa',
            INVALID_LOT_SIZE: 'Nieprawidlowa wielkosc dzialki',
            INVALID_LOT_STEP: 'Nieprawidlowy krok partii',
            INVALID_MIN_VOLUME: 'Nieprawidlowa objetosc minimalna',
            INVALID_MAX_VOLUME: 'Nieprawidlowa objetosc maksymalna',
            INVALID_GROUP: 'Nieprawidlowa grupa',
            INVALID_SPREAD: 'Niewazny rozrzut',
            REQUEST_TIMEOUT: 'Zadanie zostalo przerwane. Prosze spróbowac ponownie pózniej',
            INVALID_TYPE: 'Nieprawidlowy typ zamówienia',
            INVALID_VOLUME: 'Nieprawidlowa wielkosc zamówienia',
            INVALID_SL: 'Nieprawidlowa wartosc stop loss',
            INVALID_TP: 'Nieprawidlowa wartosc take profit',
            INVALID_PRICE: 'Nieprawidlowa cena zamówienia',
            INVALID_EXPIRATION: 'Nieprawidlowy termin waznosci zamówienia',
            NOT_ENOUGH_MARGIN: 'Niewystarczajaca marza',
            INVALID_ORDER: 'Zamówienie nie zostalo znalezione',
            MARKET_CLOSED: 'Handel nie jest dostepny. Prosze spróbowac ponownie',
            INVALID_BALANCE_TYPE: 'Nieprawidlowy typ operacji bilansowej',
            INVALID_HASH: 'Nieprawidlowy hash',
            HASH_EXPIRED: 'Twój link do resetowania hasla wygasl. Popros o nowe haslo.',
            INVALID_CODE: 'Nieprawidlowy kod 2FA',
            CHAT_DISABLED: 'Dostep do czatu pomocy technicznej zostal zamkniety',
            WITHDRAWAL_NOT_ALLOWED: 'Dostep do wyplat zostal zamkniety',
            TRADING_DISABLED: 'Trading is disabled for current account',
            PENDING_DEPOSITS_LIMIT: 'Deposits limit exceeded',
            CLOSE_OPEN_ORDERS: 'Please close your open orders',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Only one pending withdrawal allowed',
            LOCAL_DEPOSIT_ONLY_REAL: 'Deposit is available only for real account',
            LOCAL_DEPOSIT_POSITIVE: 'Amount of deposit must be more than 0',
            LOCAL_INVALID_CARD_NUMBER: 'Invalid card number',
            LOCAL_INVALID_CARD_EXPIRATION: 'Invalid card expiration',
            LOCAL_INVALID_CVC: 'Invalid CVV/CVC code',
            LOCAL_PASSWORDS_NOT_MATCH: 'Passwords do not match, please re-enter',
            LOCAL_NO_TRADING_ACCOUNTS: 'You do not have trading accounts available. Please contact the support',
            LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
            LOCAL_MIN_WITHDRAWAL: 'Minimum withdrawal amount is $',
            LOCAL_INVALID_FILE_TYPE: 'File format not supported. Please attach only JPG, PNG or PDF',
            FLOOD_REJECTED: 'You are sending messages too often. Please try again later',
            LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',
            REGISTRATIONS_BLOCKED: "Dziękujemy za zapytanie, Jeden z naszych przedstawicieli skontaktuje się z Państwem najszybciej jak to możliwe",
        },
        countries: {
            AF: 'Afganistan',
            AX: 'Wyspy Alandzkie',
            AL: 'Albania',
            DZ: 'Algieria',
            AS: 'Samoa Amerykanskie',
            AD: 'Andora',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarktyda',
            AG: 'Antigua i Barbuda',
            AR: 'Argentyna',
            AM: 'Armenia',
            AW: 'Aruba',
            AU: 'Australia',
            AT: 'Austria',
            AZ: 'Azerbejdzan',
            BS: 'Bahamy',
            BH: 'Bahrajn',
            BD: 'Bangladesz',
            BB: 'Barbados',
            BY: 'Bialorus',
            BE: 'Belgia',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermudy',
            BT: 'Bhutan',
            BO: 'Boliwia',
            BA: 'Bosnia i Hercegowina',
            BW: 'Botswana',
            BV: 'Wyspa Bouveta',
            BR: 'Brazylia',
            IO: 'Brytyjskie Terytorium Oceanu Indyjskiego',
            BN: 'Panstwo Brunei Darussalam',
            BG: 'Bulgaria',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Kambodza',
            CM: 'Kamerun',
            CA: 'Kanada',
            CV: 'Republika Zielonego Przyladka',
            KY: 'Kajmany',
            CF: 'Republika Srodkowoafrykanska',
            TD: 'Chad',
            CL: 'Chile',
            CN: 'Chiny',
            CX: 'Wyspa Bozego Narodzenia',
            CC: 'Wyspy Kokosowe (Keelinga)',
            CO: 'Kolumbia',
            KM: 'Komory',
            CG: 'Kongo',
            CD: 'Kongo, Republika Demokratyczna',
            CK: 'Wyspy Cooka',
            CR: 'Kostaryka',
            CI: 'Wybrzeze Kosci Sloniowej',
            HR: 'Chorwacja',
            CU: 'Kuba',
            CY: 'Cypr',
            CZ: 'Republika Czeska',
            DK: 'Dania',
            DJ: 'Dzibuti',
            DM: 'Dominika',
            DO: 'Republika Dominikanska',
            EC: 'Ekwador',
            EG: 'Egipt',
            SV: 'Salwador',
            GQ: 'Gwinea Równikowa',
            ER: 'Erytrea',
            EE: 'Estonia',
            ET: 'Etiopia',
            FK: 'Wyspy Falklandzkie (Malwiny)',
            FO: 'Wyspy Owcze',
            FJ: 'Fidzi',
            FI: 'Finlandia',
            FR: 'Francja',
            GF: 'Gujana Francuska',
            PF: 'Polinezja Francuska',
            TF: 'Francuskie Terytoria Poludniowe',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgia',
            DE: 'Niemcy',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Grecja',
            GL: 'Grenlandia',
            GD: 'Grenada',
            GP: 'Gwadelupa',
            GU: 'Guam',
            GT: 'Gwatemala',
            GG: 'Guernsey',
            GN: 'Gwinea',
            GW: 'Gwinea Bissau',
            GY: 'Gujana',
            HT: 'Haiti',
            HM: 'Wyspa Heard i Wyspy Mcdonalda',
            VA: 'Stolica Apostolska (Panstwo Watykanskie)',
            HN: 'Honduras',
            HK: 'Hongkong',
            HU: 'Wegry',
            IS: 'Islandia',
            IN: 'Indie',
            ID: 'Indonezja',
            IR: 'Iran',
            IQ: 'Irak',
            IE: 'Irlandia',
            IM: 'Wyspa Man',
            IL: 'Izrael',
            IT: 'Wlochy',
            JM: 'Jamajka',
            JP: 'Japonia',
            JE: 'Jersey',
            JO: 'Jordan',
            KZ: 'Kazachstan',
            KE: 'Kenia',
            KI: 'Kiribati',
            KR: 'Korea',
            KW: 'Kuwejt',
            KG: 'Kirgistan',
            LA: 'Laotanska Republika Ludowo-Demokratyczna',
            LV: 'Lotwa',
            LB: 'Liban',
            LS: 'Lesotho',
            LR: 'Liberia',
            LY: 'Libijska Arabska Dzamahirija',
            LI: 'Liechtenstein',
            LT: 'Litwa',
            LU: 'Luksemburg',
            MO: 'Macao',
            MK: 'Macedonia',
            MG: 'Madagaskar',
            MW: 'Malawi',
            MY: 'Malezja',
            MV: 'Malediwy',
            ML: 'Mali',
            MT: 'Malta',
            MH: 'Wyspy Marshalla',
            MQ: 'Martynika',
            MR: 'Mauretania',
            MU: 'Mauritius',
            YT: 'Majotta',
            MX: 'Meksyk',
            FM: 'Mikronezja',
            MD: 'Moldawia',
            MC: 'Monako',
            MN: 'Mongolia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MA: 'Maroko',
            MZ: 'Mozambik',
            MM: 'Myanmar',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NL: 'Niderlandy',
            AN: 'Antyle Holenderskie',
            NC: 'Nowa Kaledonia',
            NZ: 'Nowa Zelandia',
            NI: 'Nikaragua',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            NF: 'Wyspa Norfolk',
            MP: 'Mariany Pólnocne',
            NO: 'Norwegia',
            OM: 'Oman',
            PK: 'Pakistan',
            PW: 'Palau',
            PS: 'Terytorium Palestynskie, Okupowane',
            PA: 'Panama',
            PG: 'Papua Nowa Gwinea',
            PY: 'Paragwaj',
            PE: 'Peru',
            PH: 'Filipiny',
            PN: 'Pitcairn',
            PL: 'Polska',
            PT: 'Portugalia',
            PR: 'Puerto Rico',
            QA: 'Katar',
            RE: 'Zjazd',
            RO: 'Rumunia',
            RU: 'Rosja',
            RW: 'Rwanda',
            BL: 'Swiety Bartymeusz',
            SH: 'Swieta Helena',
            KN: 'Saint Kitts i Nevis',
            LC: 'Saint Lucia (Lucja Pólnocna)',
            MF: 'Swiety Marcin',
            PM: 'Saint Pierre i Miquelon',
            VC: 'Saint Vincent i Grenadyny',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Wyspy Swietego Tomasza i Ksiazeca',
            SA: 'Arabia Saudyjska',
            SN: 'Senegal',
            RS: 'Serbia',
            SC: 'Seszele',
            SL: 'Sierra Leone',
            SG: 'Singapur',
            SK: 'Slowacja',
            SI: 'Slowenia',
            SB: 'Wyspy Salomona',
            SO: 'Somalia',
            ZA: 'Republika Poludniowej Afryki',
            GS: 'Poludniowa Georgia i Sandwich Isl.',
            ES: 'Hiszpania',
            LK: 'Sri Lanka',
            SD: 'Sudan',
            SR: 'Surinam',
            SJ: 'Svalbard i Jan Mayen',
            SZ: 'Suazi',
            SE: 'Szwecja',
            CH: 'Szwajcaria',
            SY: 'Syryjska Republika Arabska',
            TW: 'Taiwan',
            TJ: 'Tadzykistan',
            TZ: 'Tanzania',
            TH: 'Tajlandia',
            TL: 'Timor Wschodni',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trynidad i Tobago',
            TN: 'Tunezja',
            TR: 'Turcja',
            TM: 'Turkmenistan',
            TC: 'Wyspy Turks i Caicos',
            TV: 'Tuvalu',
            UG: 'Uganda',
            UA: 'Ukraina',
            AE: 'Zjednoczone Emiraty Arabskie',
            GB: 'Zjednoczone Królestwo',
            US: 'Stany Zjednoczone',
            UM: 'Wyspy Zewnetrzne Stanów Zjednoczonych',
            UY: 'Urugwaj',
            UZ: 'Uzbekistan',
            VU: 'Vanuatu',
            VE: 'Wenezuela',
            VN: 'Wietnam',
            VG: 'Brytyjskie Wyspy Dziewicze',
            VI: 'Wyspy Dziewicze, U.S.',
            WF: 'Wallis i Futuna',
            EH: 'Sahara Zachodnia',
            YE: 'Jemen',
            ZM: 'Zambia',
            ZW: 'Zimbabwe'
        },
    },
    cz: {
        _name: 'Čeština',
        autoCloseModal: {
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            takeProfit: 'Přijmout zisk',
            stopLoss: 'Zastavení ztráty',
            updateOrder: 'Aktualizace objednávky',
        },
        balanceModal: {
            balance: 'Rozvaha',
            credit: 'Kredit',
            equity: 'Kapitál',
            practice: 'PRAKTIKA',
            real: 'REÁLNÉ',
            account: 'ÚČET',
            invested: 'Investováno',
            profit: 'Zisk',
            loss: 'Ztráty',
            margin: 'Marže',
            marginLevel: 'Úroveň marže',
            marginFree: 'Volná marže'
        },
        header: {
            cfd: 'CFD',
            platform: 'Platforma',
            deposit: 'Vklad',
            myAccount: 'Můj účet'
        },
        sideMenu: {
            marketWatch: 'Sledování trhu',
            activeOrders: 'Aktivní objednávky',
            tradingHistory: 'Historie obchodování',
            economicCalendar: 'Ekonomický kalendář',
            marketNews: 'Zprávy z trhu'
        },
        closePositionModal: {
            closeOrder: 'Zavřít pozici',
            areYouSure: 'Určitě chcete pozici uzavřít',
            buy: 'Koupit',
            sell: 'Prodej',
            yes: 'Ano',
            no: 'Ne',
        },
        chart: {
            addNewChart: 'Přidat nový graf',
        },
        symbolsModal: {
            watchlist: 'Seznam sledování',
            asset: 'Majetek',
            price: 'Cena',
            changePct: 'Změna 24h'
        },
        pendingModal: {
            pending: 'Čekající',
            assetPrice: 'Cena aktiv',
            current: 'Aktuální',
            revert: 'Návrat k tržní ceně',
            automatically: 'Pozice se otevře automaticky, jakmile cena dosáhne této úrovně.'
        },
        orderMenu: {
            volume: 'Svazek',
            lots: 'šarže',
            units: 'jednotky',
            currency: 'měna',
            contractSize: 'Velikost smlouvy',
            position: 'Pozice',
            margin: 'Marže',
            freeMargin: 'Volná marže',
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            pending: 'Čekající',
            market: 'Trh',
            leverage: 'Pákový efekt',
            spread: 'Rozšíření',
            notSet: 'Není nastaveno',
            at: 'na',
            buy: 'Koupit',
            sell: 'Prodej',
        },
        footer: {
            supportBanner: 'KAŽDÝ DEN, NEPŘETRŽITĚ',
            currentTime: 'BĚŽNÝ ČAS',
            liveChat: 'Živý chat'
        },
        statusBar: {
            balance: 'Bilance',
            credit: 'Kredit',
            equity: 'Kapitál',
            margin: 'Marže',
            marginLevel: 'Úroveň marže',
            freeMargin: 'Volná marže',
            pnl: 'PnL',
            profitTotal: 'Lifetime PnL'
        },
        accountModal: {
            dateRegistered: 'Datum registrace',
            userId: 'ID uživatele',
            dashboard: 'Dashboard',
            personalData: 'Osobní údaje',
            deposit: 'Vklad',
            withdrawFunds: 'Výběr finančních prostředků',
            savings: 'Úspory',
            settings: 'Nastavení',
            logout: 'Odhlášení'
        },
        depositModal: {
            BT_INVOICE: 'Enter amount and generate invoice',
            BT_TITLE: 'Our banking details',
            PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
            BT_ACCOUNT: 'Account',
            BT_BANK_NAME: 'Bank Name',
            BT_BENEFICIARY: 'Beneficiary',
            BT_ADDRESS: 'Beneficiary Address',
            BT_SWIFT: 'Swift',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Bankovní referenční kód',
            BT_INN: 'INN',
            BT_KPP: 'Correspondent account',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: 'Amount',
            TOKEN_SUBTOTAL: 'Subtotal',
            TOKEN_TOTAL: 'Total',
            TOKEN_DESCRIPTION: 'Description',
            TOKEN_PAYMENT_DETAILS: 'Payment Details',
            makeDeposit: 'Provést vklad',
            practiceAccount: 'Účet pro praxi',
            realAccount: 'Skutečný účet',
            noWithdrawals: 'Žádné výběry',
            easyWithdrawals: 'Snadné výběry',
            allAssets: 'Všechna dostupná aktiva',
            fullFledged: 'Plnohodnotná platforma',
            fillUpTo: 'Naplnit do',
            freeReplenishment: 'Bezplatné doplňování',
            topUp: 'Dobití účtu',
            minimumAmount: 'Minimální částka',
            canSwitch: 'Mezi účty můžete kdykoli přepínat'
        },
        gridsModal: {
            chartGrids: 'GRAFICKÉ MŘÍŽKY',
            chart1: '1 diagram',
            chart2: '2 diagram',
            chart3: '3 diagram',
            chart4: '4 diagram',
        },
        noConnectionModal: {
            connectionLost: 'Spojení se serverem je ztraceno',
            retryNow: 'Zkusit to znovu',
        },
        loginModal: {
            loginToTradeRoom: 'Přihlášení do Traderoom',
            email: 'E-mailová adresa',
            emailAndId: 'Emailová adresa / Číslo ID',
            enterEmail: 'Zadejte svůj e-mail',
            twoFactor: 'Kód 2FA (je-li povolen)',
            twoFactorAuth: 'Dvoufaktorové ověřování',
            password: 'Heslo',
            yourPassword: 'Vaše heslo',
            signIn: 'Přihlásit se',
            dontHaveAccount: 'Don’t have an account?',
            restore: 'Restore',
            fullName: 'Full Name',
            havePromo: 'I have a promo-code',
            promo: 'Promo code',
            login: 'Login',
            haveAccount: 'Already have an account?',
            hide: 'Hide',
            goTo: 'Back to'
        },
        newPasswordModal: {
            setNewPassword: 'Nastavení nového hesla',
            newPassword: 'Nové heslo',
            confirmNewPassword: 'Potvrzení nového hesla',
            setButton: 'Sada'
        },
        registerModal: {
            createNewAccount: 'Vytvořit nový účet',
            email: 'E-mailová adresa',
            firstName: 'Křestní jméno',
            lastName: 'Příjmení',
            country: 'Stát',
            phone: 'Telefon',
            password: 'Heslo',
            createAccount: 'Vytvořit účet',
            currency: 'Měna'
        },
        forgotPasswordModal: {
            forgotPassword: 'Zapomenuté heslo?',
            submitEmail: 'Odešlete e-mail použitý k registraci, zkontrolujte si doručenou poštu a postupujte podle uvedených pokynů.',
            submit: 'Odeslat'
        },
        notifications: {
            error: 'Chyba',
            success: 'Úspěch',
            deposit: 'Vklad',
            withdrawal: 'Stažení',
            depositApproved: 'Vklad byl schválen',
            depositDeclined: 'Vklad byl odmítnut',
            withdrawalApproved: 'Stažení bylo schváleno',
            withdrawalDeclined: 'Stažení bylo zamítnuto',
            withdrawalCancelled: 'Výběr byl zrušen',
            orderRejected: 'Objednávka odmítnuta',
            insufficientMargin: 'Čekající objednávku nebylo možné otevřít: nedostatečná volná marže',
            marginCall: 'Margin call',
            marginCallText: 'Proveďte prosím vklad, abyste splnili požadavky na marži'
        },
        markets: {
            forex: 'Forex',
            stocks: 'Stocks',
            commodities: 'Komodity',
            indices: 'Indexy',
            crypto: 'Crypto',
            metals: 'Kovy',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            buy: 'BUY',
            profitCalculator: 'Profit Calculator',
            sell: 'SELL',
            volume: 'Volume',
            entryPrice: 'Entry Price',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            maxPosition: 'Max Position',
            calculate: 'Calculate',
            calculationsFor: 'Calculations for',
            leverage: 'Leverage',
            requiredMargin: 'Required Margin',
            profitFromTP: 'Profit from TP',
            lossFromSL: 'Loss from SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Deposit successful',
            text: 'Your deposit has been processed successfully!',
        },
        depositFailModal: {
            title: 'Deposit failed',
            text: 'Your deposit has not been processed.',
        },
        widgetMarketWatch: {
            marketWatch: 'Sledování trhu',
            search: 'Vyhledávání...',
        },
        widgetOrders: {
            commission: 'Commission',
            volume: 'Svazek',
            margin: 'Marže',
            active: 'Aktivní',
            pending: 'Čekající',
            activeOrders: 'Aktivní objednávky',
            portfolio: 'Portfolio',
            allPositions: 'Všechny pozice',
            noPositionsLine1: 'Nemáte žádné otevřené',
            noPositionsLine2: 'pozice zatím',
            show: 'Zobrazit',
            more: 'více',
            less: 'méně',
            purchaseTime: 'Čas nákupu',
            closePosition: 'Zavřít pozici',
            priceOpen: 'Nákupní cena',
            priceSl: 'Cena Stop Loss',
            priceTp: 'Cena Take Profit',
            type: 'Pozice Směr',
            pnl: 'Zisk/ztráta',
            cancelOrder: 'Zrušit objednávku',
            orderType: 'Typ objednávky',
            cancelled: 'Zrušeno',
            tradingHistory: 'Historie obchodování',
            noHistoryLine1: 'Nemáte žádné',
            noHistoryLine2: 'dosud uzavřené obchody',
            sortByTime: 'Řadit podle času',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Ekonomický kalendář'
        },
        widgetMarketNews: {
            marketNews: 'Zprávy z trhu'
        },
        ordersPane: {
            ordersActive: 'Objednávky Aktivní',
            ordersHistory: 'Historie objednávek',
            id: 'ID',
            symbol: 'Symbol',
            type: 'Typ',
            volume: 'Svazek',
            openPrice: 'Otevřená cena',
            openTime: 'Otevřený čas',
            closePrice: 'Zavřít Cena',
            closeTime: 'Čas uzavření',
            sl: 'SL',
            tp: 'TP',
            price: 'Cena',
            pnl: 'PnL',
            actions: 'Akce',
            edit: 'Upravit',
            close: 'Zavřít',
            commission: 'Commission',
            swap: 'Swap',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short'
        },
        assetInfoModal: {
            assetInfo: 'Asset Info',
            tradingConditions: 'Trading Conditions',
            information: 'Information',
            bid: 'Bid',
            ask: 'Ask',
            sessionChange: 'Session Change',
            tradeNow: 'Trade Now',
            opens: 'Opens',
            closes: 'Closes',
            at: 'at',
            open247: 'Open 24/7',
            today: 'today',
            tomorrow: 'tomorrow',
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            contractSpecification: 'Contract Specification',
            symbol: 'Symbol',
            name: 'Name',
            market: 'Market',
            baseCurrency: 'Base Currency',
            digits: 'Digits',
            lotSize: 'Lot Size',
            lotStep: 'Lot Step',
            minVolume: 'Min Volume',
            maxVolume: 'Max Volume',
            leverage: 'Leverage',
            commission: 'Commission',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short',
            schedule: 'Schedule',
            weekday: 'Weekday',
            tradingTime: 'Trading Time',
            closed: 'closed',
            sell: 'Sell',
            buy: 'Buy',
            low: 'Low',
            high: 'High',
            oneHourChange: '1 hour change',
            oneDayChange: '1 day change',
            oneWeekChange: '1 week change',
            oneMonthChange: '1 month change',
            threeMonthsChange: '3 months change',
            oneYearChange: '1 year change',
            loading: 'Loading...',
        },
        fullScreen: {
            startTrading: 'Start Trading',
            deposit: 'Provést vklad',
            dashboard: 'Dashboard',
            personalInfo: 'Aktualizace osobních údajů',
            withdrawal: 'Žádost o stažení',
            verification: 'Ověřování totožnosti',
            accounts: 'Správa účtů',
            liveChat: 'Živý chat',
            savings: 'Spoření',
            settings: 'Nastavení platformy',
            logOut: 'Odhlášení',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            name: 'Cardholder\'s name',
            address: 'Address',
            DOB: 'DOB',
            bankName: 'Bank name',
            additionalInfo: 'Chcete-li na svůj účet vložit více peněz, kontaktujte přímo svého účetního manažera',
            additionalInfoOnlyBTCpsp: 'Pro otevření jiných platebních metod, prosím, poskytněte KYC nebo kontaktujte svého správce účtu',
            sofortPspMessage: 'Náš finanční tým vás bude kontaktovat, aby vám pomohl provést vklad',
            addWalletAddress: 'Wallet for this deposit method is not set. Please contact your agent or support team.',
            addressReceipt: 'Please wait for the address to load',
            makeDeposit: 'UPLATNIT ZÁLOHU',
            instant: 'Instantní',
            minutes: 'minuty',
            hours: 'hodin',
            days: 'dny',
            amount: 'Částka',
            continue: 'Pokračovat',
            qrCode: 'QR KÓD',
            depositAddress: 'ADRESA VKLADU',
            copy: 'Kopírovat',
            last: 'POSLEDNÍ',
            deposits: 'DEPOSITY',
            time: 'Čas',
            currency: 'Měna',
            status: 'Status',
            info: 'Informace',
        },
        fullScreenCcExt: {
            pleaseWait: 'Počkejte prosím. Připojení k poskytovateli platebních služeb...',
            cardPayment: 'Platba kartou',
            inOrder: 'Za účelem odeslání částky',
            pleaseProvide: 'uveďte prosím údaje o kartě:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Total Taxes',
            totalBalance: 'Finální Balance',
            totalPnl: 'Totální Pnl',
            profitableOrders: 'Výdělečné Objednávky',
            roi: 'ROI',
            activityLog: 'Aktivační Log',
            loginFromIp: 'Login from IP',
            tradingResults: 'Tržní Výsledky ',
            week: 'Týden',
            month: 'Měsíc',
            year: 'Rok',
            successRate: 'Úspěšná Hodnota',
            closedWithProfit: 'Zavřeno s Výdělkem',
            closedWithLoss: 'Zavřeno s Prodělkem',
            account: 'Profil',
            balance: 'Balance',
            leverage: 'Obchodní Rameno',
            credit: 'Úvěr',
            tradeNow: 'Obchod Nyní',
            usingCurrentRate: 'using current exchange rate',
            totalDeposits: 'Total Deposits'
        },
        fullScreenPersonal: {
            personalDetails: 'Osobní údaje',
            profilePhoto: 'Profilová fotografie',
            firstName: 'Jméno',
            country: 'Stát',
            lastName: 'Příjmení',
            address: 'Adresa',
            email: 'E-mail',
            phone: 'Telefonní číslo',
            saveChanges: 'Uložit změny'
        },
        fullScreenAvatar: {
            dropFile: 'Nahrajte soubor do výše uvedeného kroužku.',
            notAllowed: 'Není povoleno zveřejňovat',
            notAllowedLine1: 'Fotografie vysloveně sexuální nebo pornografické povahy',
            notAllowedLine2: 'Snímky podněcující etnickou nebo rasovou nenávist nebo agresi.',
            notAllowedLine3: 'Fotografie osob mladších 18 let',
            notAllowedLine4: 'Fotografie třetích stran chráněné autorskými právy',
            notAllowedLine5: 'Obrázky větší než 5 MB a v jiném formátu než JPG, GIF nebo PNG.',
            requirements: 'Na fotografii musí být jasně vidět váš obličej. Všechny vámi nahrané fotografie a videa musí splňovat tyto požadavky, jinak mohou být odstraněny.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Withdrawal',
            requestNewWithdrawal: 'POŽÁDAT O NOVÝ VÝBĚR',
            amount: 'Částka',
            currentBalance: 'Zůstatek na vašem běžném účtu je',
            withdrawAll: 'Stáhněte všechny',
            requestWithdrawal: 'Žádost o stažení',
            last: 'POSLEDNÍ',
            withdrawalRequests: 'ŽÁDOSTI O STAŽENÍ',
            time: 'Čas',
            currency: 'Měna',
            info: 'Informace',
            status: 'Status',
            bank: 'Bank',
            bitcoin: 'Bitcoin',
            card: 'Karta',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Podrobnosti o stažení',
            address: 'Adresa peněženky',
            bankAccount: 'Číslo účtu',
            bankHolder: 'Jméno držitele účtu',
            bankIban: 'IBAN',
            bankSwift: 'Bankovní SWIFT kód',
            sortCode: 'Kód řazení',
            ifscCode: 'IFSC kód',
            bankCode: "Kód banky (BSB)",
            bankName: 'Název Banky',
            bankBranch: 'Pobočka Banky',
            cardNumber: 'Číslo karty',
            cardHolder: 'Jméno držitele karty',
            incorrectAmountByFreeMargin: 'The amount is incorrect you can withdraw the amount of free margin',
            closeOrders: 'before close all orders'
        },
        fullScreenVerification: {
            dragAndDrop: 'přetáhněte dokument do této oblasti',
            documentsList: 'SEZNAM NAHRANÝCH DOKUMENTŮ',
            document: 'Dokument',
            timeUploaded: 'Čas nahrání',
            timeProcessed: 'Zpracovaný čas',
            status: 'Status',
            types: ['Doklad totožnosti', 'Doklad o bydlišti', 'Přední strana kreditní karty', 'Kreditní karta zpět', 'Doklad o totožnosti zpět', 'Selfie','Other'],
            types2: ['Proof of Id (ID CARD, PASSPORT, DRIVER LICENCE)', 'Proof of Residence (Utility bill or Bank statement)', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back (ID CARD BACK, DRIVER LICENCE BACK)', 'Selfie','Other'],
            upload: 'Nahrát',
            isConfirmed: 'je potvrzeno',
            uploadAnotherDocument: 'Nahrát další dokument',
            isUnderReview: 'je předmětem přezkumu',
            questionnaire: 'Dotazník',
            sendAnswers: 'Odeslat odpovědi',
            progressBarOf: 'of',
            progressBarText: 'of your documents have been uploaded and confirmed'
        },
        fullScreenAccounts: {
            manageAccounts: 'Převádění prostředků mezi účty',
            transferFrom: 'Z účtu',
            transferTo: 'Na účet',
            amount: 'Částka',
            makeTransfer: 'Proveďte přenos',
            yourAccounts: 'Vaše účty',
            account: 'Účet',
            currency: 'Měna',
            balance: 'Bilance',
            credit: 'Kredit',
            makeActive: 'Udělat aktivní',
            active: 'Aktivní'
        },
        fullScreenSupport: {
            chatOff: 'Chat will be available on working days',
            sendMessage: 'Odeslat zprávu',
            responseTime: 'Průměrná doba odezvy: 1-24 h',
        },
        fullScreenSavings: {
            pct_0: 'Flexibilní',
            pct_30: 'Uzamčeno na 1 měsíc',
            pct_90: 'Uzamčeno 1 čtvrtletí',
            pct_180: 'Uzamčeno na 6 měsíců',
            pct_365: 'Uzamčeno na 1 rok',
            pct_730: 'Uzamčeno na 2 rok',
            savings: 'Úspory',
            detailedInformation: 'Podrobné informace',
            pleaseSelect: 'Vyberte měnu a období',
            openSavings: 'Otevřené spoření',
            currentTime: 'Aktuální čas',
            releaseTime: 'Čas vydání',
            currencyChosen: 'Vybraná měna',
            periodChosen: 'Vybrané období',
            yourRate: 'Vaše sazba',
            yourAnnualRate: 'Váš roční sazba',
            yourEarnings: 'Vaše příjmy',
            accountFrom: 'Účet, ze kterého se mají převádět prostředky',
            enterAmount: 'Zadejte částku',
            in: 'V',
            openAndInvest: 'Otevřete si spořicí účet a investujte',
            investment: 'Investice',
            period: 'Období',
            daysTotal: 'Dny celkem',
            finalEarnings: 'Konečné příjmy',
            created: 'Vytvořeno',
            daysElapsed: 'Uplynulé dny',
            days: 'dny',
            earnings: 'Výdělky',
            fundsReleasedIn: 'Uvolněné prostředky v',
            claim: 'Reklamace',
        },
        fullScreenSettings: {
            updatePassword: 'AKTUALIZOVAT HESLO',
            currentPassword: 'Aktuální heslo',
            newPassword: 'Nové heslo',
            changePassword: 'Změna hesla',
            activationForGoogle: 'Aktivační kód pro Google Authenticator',
            activateAndEnter: 'Aktivujte Authenticator a zadejte vygenerovaný kód do pole níže.',
            qrCode: 'QR kód',
            activateProtection: 'Aktivace ochrany 2FA',
            protectionActive: 'Ochrana 2FA je aktivní',
            twoFactorCode: '2FA Kód',
            disableProtection: 'Vypnutí ochrany 2FA',
            language: 'Jazyk',
            dashboardCurrency: 'Dashboard Currency',
            confirmNewPassword: 'Potvrzení nového hesla',
        },
        fullScreenReferrals: {
            yourLink: 'VÁŠ DOPORUČUJÍCÍ ODKAZ',
            referredFriends: 'DOPORUČENÉ PŘÁTELE',
            id: 'ID',
            name: 'Jméno',
            registered: 'Registrováný',
            level: 'Úroveň',
            payout: 'Výplata',
            lastPayouts: 'POSLEDNÍ VÝPLATY ZA DOPORUČENÍ',
            time: 'Čas',
            amount: 'Částka',
            currency: 'Měna',
            info: 'Informace'
        },
        months: {
            Jan: 'Leden',
            Feb: 'Únor',
            Mar: 'Březen',
            Apr: 'Duben',
            May: 'Květen',
            Jun: 'Červen',
            Jul: 'Červenec',
            Aug: 'Srpen',
            Sep: 'Září',
            Oct: 'Říjen',
            Nov: 'Listopad',
            Dec: 'Prosinec'
        },
        orderTypes: ['Koupit', 'Prodej', 'Nákupní limit', 'Prodejní limit', 'Koupit Stop', 'Prodejní zastávka'],
        statuses: ['Čekající', 'Schváleno', 'Odmítnuto', 'Zpracování','V přezkumu','In Process','Zrušeno'],
        errors: {
            INVALID_FIELDS: 'Please check that the data you have entered is correct',
            NOT_FOUND: 'Chyba požadavku',
            FORBIDDEN: 'Přístup odepřen. Přihlaste se znovu',
            SERVER_ERROR: 'Akce se nezdařila. Zkuste to prosím později',
            INVALID_ACCOUNT: 'Zasedání skončilo. Znovu se přihlaste',
            INVALID_EMAIL: 'Neplatná e-mailová adresa',
            INVALID_PHONE: 'Neplatné telefonní číslo',
            INVALID_COUNTRY: 'Neplatný stát',
            INVALID_LOGIN: 'Neplatné přihlašovací údaje',
            USER_BLOCKED: 'Účet je zablokován. Kontaktujte prosím podpor',
            USER_REGISTERED: 'Uživatel se zadaným e-mailem nebo telefonním číslem je již registrován',
            INVALID_USER: 'Uživatel nebyl nalezen',
            REJECTED: 'Provoz není povolen z důvodu omezení platformy',
            INVALID_OLD_PASSWORD: 'Staré heslo je neplatné',
            INVALID_SYMBOL: 'Neplatný obchodní symbol',
            INVALID_SYMBOL_PRECISION: 'Nesprávná přesnost symbolu',
            INVALID_FRAME: 'Neplatný rámec grafu',
            INVALID_CURRENCY: 'Neplatná měna',
            INVALID_PRODUCT: 'Neplatný typ obchodního účtu',
            INSUFFICIENT_FUNDS: 'Nedostatek finančních prostředků',
            INVALID_WITHDRAWAL: 'Stažení není nalezeno',
            INVALID_DEPOSIT: 'Tento vklad již nelze zrušit - nebyl nalezen nebo již byl zpracován',
            INVALID_STATUS: 'Neplatný stav',
            INVALID_FILE: 'Nesprávná přípona souboru nebo příliš velký soubor',
            INVALID_DOCUMENT: 'Dokument nebyl nalezen',
            INVALID_NAME: 'Nesprávné jméno',
            INVALID_LOT_SIZE: 'Nesprávná velikost pozemku',
            INVALID_LOT_STEP: 'Neplatný krok šarže',
            INVALID_MIN_VOLUME: 'Neplatný minimální objem',
            INVALID_MAX_VOLUME: 'Neplatný maximální objem',
            INVALID_GROUP: 'Neplatná skupina',
            INVALID_SPREAD: 'Neplatné rozpětí',
            REQUEST_TIMEOUT: 'Požadavek vypršel. Zkuste to prosím později',
            INVALID_TYPE: 'Nesprávný typ objednávky',
            INVALID_VOLUME: 'Neplatný objem objednávky',
            INVALID_SL: 'Neplatná hodnota stop loss',
            INVALID_TP: 'Neplatná hodnota take profit',
            INVALID_PRICE: 'Neplatná cena objednávky',
            INVALID_EXPIRATION: 'Neplatné vypršení platnosti objednávky',
            NOT_ENOUGH_MARGIN: 'Nedostatečná marže',
            INVALID_ORDER: 'Objednávka nebyla nalezena',
            MARKET_CLOSED: 'Obchodování není k dispozici. Zkuste to prosím znovu',
            INVALID_BALANCE_TYPE: 'Nesprávný typ operace vyvážení',
            INVALID_HASH: 'Neplatný hash',
            HASH_EXPIRED: 'Platnost odkazu pro obnovení hesla vypršela. Vyžádejte si prosím nové',
            INVALID_CODE: 'Neplatný kód 2FA',
            CHAT_DISABLED: 'Přístup k chatu podpory byl uzavřen',
            WITHDRAWAL_NOT_ALLOWED: 'Přístup k výběrům byl uzavřen',
            TRADING_DISABLED: 'Trading is disabled for current account',
            PENDING_DEPOSITS_LIMIT: 'Deposits limit exceeded',
            CLOSE_OPEN_ORDERS: 'Please close your open orders',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Only one pending withdrawal allowed',
            LOCAL_DEPOSIT_ONLY_REAL: 'Deposit is available only for real account',
            LOCAL_DEPOSIT_POSITIVE: 'Amount of deposit must be more than 0',
            LOCAL_INVALID_CARD_NUMBER: 'Invalid card number',
            LOCAL_INVALID_CARD_EXPIRATION: 'Invalid card expiration',
            LOCAL_INVALID_CVC: 'Invalid CVV/CVC code',
            LOCAL_PASSWORDS_NOT_MATCH: 'Passwords do not match, please re-enter',
            LOCAL_NO_TRADING_ACCOUNTS: 'You do not have trading accounts available. Please contact the support',
            LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
            LOCAL_MIN_WITHDRAWAL: 'Minimum withdrawal amount is $',
            LOCAL_INVALID_FILE_TYPE: 'File format not supported. Please attach only JPG, PNG or PDF',
            FLOOD_REJECTED: 'You are sending messages too often. Please try again later',
            LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',
            REGISTRATIONS_BLOCKED: "Děkujeme za váš dotaz, Někdo z našich zástupců vás bude kontaktovat co nejdříve",
        },
        countries: {
            AF: 'Afghánistán',
            AX: 'Alandské ostrovy',
            AL: 'Albánie',
            DZ: 'Alžírsko',
            AS: 'Americká Samoa',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarktida',
            AG: 'Antigua a Barbuda',
            AR: 'Argentina',
            AM: 'Arménie',
            AW: 'Aruba',
            AU: 'Austrálie',
            AT: 'Austria',
            AZ: 'Ázerbájdžán',
            BS: 'Bahamy',
            BH: 'Bahrajn',
            BD: 'Bangladéš',
            BB: 'Barbados',
            BY: 'Bělorusko',
            BE: 'Belgie',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermudy',
            BT: 'Bhútán',
            BO: 'Bolívie',
            BA: 'Bosna a Hercegovina',
            BW: 'Botswana',
            BV: 'Bouvetův ostrov',
            BR: 'Brazílie',
            IO: 'Britské území v Indickém oceánu',
            BN: 'Brunej Darussalam',
            BG: 'Bulharsko',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Kambodža',
            CM: 'Kamerun',
            CA: 'Kanada',
            CV: 'Kapverdy',
            KY: 'Kajmanské ostrovy',
            CF: 'Středoafrická republika',
            TD: 'Chad',
            CL: 'Chile',
            CN: 'Čína',
            CX: 'Vánoční ostrov',
            CC: 'Kokosové (Keelingovy) ostrovy',
            CO: 'Kolumbie',
            KM: 'Komory',
            CG: 'Kongo',
            CD: 'Kongo, Demokratická republika',
            CK: 'Cookovy ostrovy',
            CR: 'Kostarika',
            CI: 'Pobřeží slonoviny ',
            HR: 'Chorvatsko',
            CU: 'Kuba',
            CY: 'Kypr',
            CZ: 'Česká republika',
            DK: 'Dánsko',
            DJ: 'Džibutsko',
            DM: 'Dominika',
            DO: 'Dominikánská republika',
            EC: 'Ekvádor',
            EG: 'Egypt',
            SV: 'Salvador',
            GQ: 'Rovníková Guinea',
            ER: 'Eritrea',
            EE: 'Estonsko',
            ET: 'Etiopie',
            FK: 'Falklandy (Malvíny)',
            FO: 'Faerské ostrovy',
            FJ: 'Fidži',
            FI: 'Finsko',
            FR: 'Francie',
            GF: 'Francouzská Guyana',
            PF: 'Francouzská Polynésie',
            TF: 'Francouzská jižní území',
            GA: 'Gabon',
            GM: 'Gambie',
            GE: 'Georgia',
            DE: 'Německo',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Řecko',
            GL: 'Grónsko',
            GD: 'Grenada',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HM: 'Heardův ostrov a Mcdonaldovy ostrovy',
            VA: 'Svatý stolec (Vatikánský městský stát)',
            HN: 'Honduras',
            HK: 'Hongkong',
            HU: 'Maďarsko',
            IS: 'Island',
            IN: 'Indie',
            ID: 'Indonésie',
            IR: 'Írán',
            IQ: 'Irák',
            IE: 'Irsko',
            IM: 'Ostrov Man',
            IL: 'Izrael',
            IT: 'Itálie',
            JM: 'Jamajka',
            JP: 'Japonsko',
            JE: 'Jersey',
            JO: 'Jordan',
            KZ: 'Kazachstán',
            KE: 'Keňa',
            KI: 'Kiribati',
            KR: 'Korea',
            KW: 'Kuvajt',
            KG: 'Kyrgyzstán',
            LA: 'Laoská lidově demokratická republika',
            LV: 'Lotyšsko',
            LB: 'Libanon',
            LS: 'Lesotho',
            LR: 'Libérie',
            LY: 'Libyjská arabská džamáhíríja',
            LI: 'Lichtenštejnsko',
            LT: 'Litva',
            LU: 'Lucembursko',
            MO: 'Macao',
            MK: 'Makedonie',
            MG: 'Madagaskar',
            MW: 'Malawi',
            MY: 'Malajsie',
            MV: 'Maledivy',
            ML: 'Mali',
            MT: 'Malta',
            MH: 'Marshallovy ostrovy',
            MQ: 'Martinik',
            MR: 'Mauritánie',
            MU: 'Mauricius',
            YT: 'Mayotte',
            MX: 'Mexiko',
            FM: 'Mikronésie',
            MD: 'Moldavsko',
            MC: 'Monako',
            MN: 'Mongolsko',
            ME: 'Černá Hora',
            MS: 'Montserrat',
            MA: 'Maroko',
            MZ: 'Mosambik',
            MM: 'Myanmar',
            NA: 'Namibie',
            NR: 'Nauru',
            NP: 'Nepál',
            NL: 'Nizozemsko',
            AN: 'Nizozemské Antily',
            NC: 'Nová Kaledonie',
            NZ: 'Nový Zéland',
            NI: 'Nikaragua',
            NE: 'Niger',
            NG: 'Nigérie',
            NU: 'Niue',
            NF: 'Ostrov Norfolk',
            MP: 'Severní Mariany',
            NO: 'Norsko',
            OM: 'Omán',
            PK: 'Pákistán',
            PW: 'Palau',
            PS: 'Palestinské území, okupované území',
            PA: 'Panama',
            PG: 'Papua-Nová Guinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PH: 'Filipíny',
            PN: 'Pitcairn',
            PL: 'Polsko',
            PT: 'Portugalsko',
            PR: 'Portoriko',
            QA: 'Katar',
            RE: 'Sraz',
            RO: 'Rumunsko',
            RU: 'Rusko',
            RW: 'Rwanda',
            BL: 'Svatý Barthelemy',
            SH: 'Svatá Helena',
            KN: 'Svatý Kryštof a Nevis',
            LC: 'Svatá Lucie',
            MF: 'Svatý Martin',
            PM: 'Svatý Pierre a Miquelon',
            VC: 'Svatý Vincenc a Grenadiny',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Svatý Tomáš a Princův',
            SA: 'Saúdská Arábie',
            SN: 'Senegal',
            RS: 'Srbsko',
            SC: 'Seychely',
            SL: 'Sierra Leone',
            SG: 'Singapur',
            SK: 'Slovensko',
            SI: 'Slovinsko',
            SB: 'Šalamounovy ostrovy',
            SO: 'Somálsko',
            ZA: 'Jižní Afrika',
            GS: 'Jižní Georgie a Sandwichovy ostrovy',
            ES: 'Španělsko',
            LK: 'Srí Lanka',
            SD: 'Súdán',
            SR: 'Surinam',
            SJ: 'Špicberky a Jan Mayen',
            SZ: 'Svazijsko',
            SE: 'Švédsko',
            CH: 'Švýcarsko',
            SY: 'Syrská arabská republika',
            TW: 'Tchaj-wan',
            TJ: 'Tádžikistán',
            TZ: 'Tanzanie',
            TH: 'Thajsko',
            TL: 'Východní Timor',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad a Tobago',
            TN: 'Tunisko',
            TR: 'Krocan',
            TM: 'Turkmenistán',
            TC: 'Ostrovy Turks a Caicos',
            TV: 'Tuvalu',
            UG: 'Uganda',
            UA: 'Ukrajina',
            AE: 'Arabské emiráty',
            GB: 'Velká Británie',
            US: 'Spojené státy americké',
            UM: 'Odlehlé ostrovy Spojených států',
            UY: 'Uruguay',
            UZ: 'Uzbekistán',
            VU: 'Vanuatu',
            VE: 'Venezuela',
            VN: 'Vietnam',
            VG: 'Britské Panenské ostrovy',
            VI: 'Panenské ostrovy, USA',
            WF: 'Wallis a Futuna',
            EH: 'Západní Sahara',
            YE: 'Jemen',
            ZM: 'Zambie',
            ZW: 'Zimbabwe'
        }
    },
    de: {
        _name: 'Deutsch',
        autoCloseModal: {
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            updateOrder: 'Order aktualisieren',
        },
        balanceModal: {
            balance: 'Kontostand',
            credit: 'Kredit',
            equity: 'Eigenkapital',
            practice: 'DEMO',
            real: 'ECHTES',
            account: 'KONTO',
            invested: 'Investiert',
            profit: 'Gewinn',
            loss: 'Verlust',
            margin: 'Margin',
            marginLevel: 'Margin-Level',
            marginFree: 'Freie Margin'
        },
        header: {
            cfd: 'CFD',
            platform: 'Plattform',
            deposit: 'Einzahlung',
            myAccount: 'Mein Konto'
        },
        sideMenu: {
            marketWatch: 'Marktübersicht',
            activeOrders: 'Aktive Orders',
            tradingHistory: 'Handelshistorie',
            economicCalendar: 'Wirtschaftskalender',
            marketNews: 'Marktnachrichten'
        },
        closePositionModal: {
            closeOrder: 'Position schließen',
            areYouSure: 'Möchten Sie die Position wirklich schließen?',
            buy: 'Kaufen',
            sell: 'Verkaufen',
            yes: 'Ja',
            no: 'Nein',
        },
        chart: {
            addNewChart: 'Neuen Chart hinzufügen',
        },
        symbolsModal: {
            watchlist: 'Watchlist',
            asset: 'Asset',
            price: 'Preis',
            changePct: 'Änderung 24h'
        },
        pendingModal: {
            pending: 'Ausstehend',
            assetPrice: 'Asset-Preis',
            current: 'Aktuell',
            revert: 'Zurück zum Marktpreis',
            automatically: 'Die Position wird automatisch eröffnet, wenn der Preis dieses Niveau erreicht'
        },
        orderMenu: {
            volume: 'Volumen',
            lots: 'Lots',
            units: 'Einheiten',
            currency: 'Währung',
            contractSize: 'Kontraktgröße',
            position: 'Position',
            margin: 'Margin',
            freeMargin: 'Freie Margin',
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            pending: 'Ausstehend',
            market: 'Markt',
            leverage: 'Hebel',
            spread: 'Spread',
            notSet: 'Nicht gesetzt',
            at: 'bei',
            buy: 'Kaufen',
            sell: 'Verkaufen',
        },
        footer: {
            supportBanner: 'JEDEN TAG, RUND UM DIE UHR',
            currentTime: 'AKTUELLE UHRZEIT',
            liveChat: 'Live Chat'
        },
        statusBar: {
            balance: 'Kontostand',
            credit: 'Kredit',
            equity: 'Eigenkapital',
            margin: 'Margin',
            marginLevel: 'Margin-Level',
            freeMargin: 'Freie Margin',
            pnl: 'PnL',
            profitTotal: 'Gesamt-PnL'
        },
        accountModal: {
            dateRegistered: 'Registrierungsdatum',
            userId: 'Benutzer-ID',
            dashboard: 'Dashboard',
            personalData: 'Persönliche Daten',
            deposit: 'Einzahlung',
            withdrawFunds: 'Auszahlung',
            savings: 'Sparen',
            settings: 'Einstellungen',
            logout: 'Abmelden'
        },
        depositModal: {
            BT_INVOICE: 'Betrag eingeben und Rechnung erstellen',
            BT_TITLE: 'Unsere Bankverbindung',
            PENDING_DEPOSITS_LIMIT: 'Einzahlungslimit',
            BT_ACCOUNT: 'Konto',
            BT_BANK_NAME: 'Name der Bank',
            BT_BENEFICIARY: 'Begünstigter',
            BT_ADDRESS: 'Adresse des Begünstigten',
            BT_SWIFT: 'SWIFT',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Bankreferenzcode',
            BT_INN: 'INN',
            BT_KPP: 'Korrespondentenkonto',
            BT_CORRESPONDING: 'Korrespondentenkonto',
            TOKEN_AMOUNT: 'Betrag',
            TOKEN_SUBTOTAL: 'Zwischensumme',
            TOKEN_TOTAL: 'Gesamt',
            TOKEN_DESCRIPTION: 'Beschreibung',
            TOKEN_PAYMENT_DETAILS: 'Zahlungsdetails',
            makeDeposit: 'Einzahlung tätigen',
            practiceAccount: 'Demokonto',
            realAccount: 'Echtkonto',
            noWithdrawals: 'Keine Auszahlungen',
            easyWithdrawals: 'Einfache Auszahlungen',
            allAssets: 'Alle Assets verfügbar',
            fullFledged: 'Vollwertige Plattform',
            fillUpTo: 'Auffüllen bis',
            freeReplenishment: 'Kostenlose Einzahlung',
            topUp: 'Laden Sie Ihr Konto auf',
            minimumAmount: 'Mindestbetrag',
            canSwitch: 'Sie können jederzeit zwischen Ihren Konten wechseln'
        },
        gridsModal: {
            chartGrids: 'CHART-ANORDNUNG',
            chart1: '1 Chart',
            chart2: '2 Charts',
            chart3: '3 Charts',
            chart4: '4 Charts',
        },
        noConnectionModal: {
            connectionLost: 'Die Verbindung mit dem Server wurde unterbrochen',
            retryNow: 'Jetzt erneut versuchen',
        },
        loginModal: {
            loginToTradeRoom: 'Anmeldung im Traderoom',
            email: 'E-Mail-Adresse',
            emailAndId: 'E-Mail-Adresse / ID-Nummer',
            enterEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
            twoFactor: '2FA-Code (falls aktiviert)',
            twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
            password: 'Passwort',
            yourPassword: 'Ihr Passwort',
            signIn: 'Anmelden',
            dontHaveAccount: 'Noch kein Konto?',
            restore: 'Wiederherstellen',
            fullName: 'Vollständiger Name',
            havePromo: 'Ich habe einen Promo-Code',
            promo: 'Promo-Code',
            login: 'Login',
            haveAccount: 'Sie haben bereits ein Konto?',
            hide: 'Ausblenden',
            goTo: 'Zurück zum '
        },
        newPasswordModal: {
            setNewPassword: 'Neues Passwort festlegen',
            newPassword: 'Neues Passwort',
            confirmNewPassword: 'Neues Passwort bestätigen',
            setButton: 'Festlegen'
        },
        registerModal: {
            createNewAccount: 'Ein neues Konto erstellen',
            email: 'E-Mail-Adresse',
            firstName: 'Vorname',
            lastName: 'Nachname',
            country: 'Land',
            phone: 'Telefon',
            password: 'Passwort',
            createAccount: 'Konto erstellen',
            currency: 'Währung'
        },
        forgotPasswordModal: {
            forgotPassword: 'Passwort vergessen?',
            submitEmail: 'Bitte senden Sie eine für die Registrierung verwendete E-Mail-Adresse, überprüfen Sie Ihren Posteingang und befolgen Sie die bereitgestellten Anweisungen',
            submit: 'Absenden'
        },
        notifications: {
            error: 'Fehler',
            success: 'Erfolg',
            deposit: 'Einzahlung',
            withdrawal: 'Auszahlung',
            depositApproved: 'Einzahlung wurde genehmigt',
            depositDeclined: 'Einzahlung wurde abgelehnt',
            withdrawalApproved: 'Auszahlung wurde genehmigt',
            withdrawalDeclined: 'Auszahlung wurde abgelehnt',
            withdrawalCancelled: 'Die Auszahlung wurde storniert',
            orderRejected: 'Order abgelehnt',
            insufficientMargin: 'Ihre ausstehende Order konnte nicht eröffnet werden: nicht genügend freie Margin',
            marginCall: 'Margin Call',
            marginCallText: 'Bitte zahlen Sie ein, um Ihre Margin zu decken'
        },
        markets: {
            forex: 'Forex',
            stocks: 'Aktien',
            commodities: 'Rohstoffe',
            indices: 'Indizes',
            crypto: 'Krypto',
            metals: 'Metalle',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            buy: 'BUY',
            profitCalculator: 'Gewinnrechner',
            sell: 'SELL',
            volume: 'Volumen',
            entryPrice: 'Einstiegspreis',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            maxPosition: 'Max. Position',
            calculate: 'Berechnen',
            calculationsFor: 'Berechnungen für',
            leverage: 'Hebel',
            requiredMargin: 'Erforderliche Margin',
            profitFromTP: 'Gewinn aus TP',
            lossFromSL: 'Verlust aus SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Einzahlung erfolgreich',
            text: 'Ihre Einzahlung wurde erfolgreich verarbeitet!',
        },
        depositFailModal: {
            title: 'Einzahlung fehlgeschlagen',
            text: 'Ihre Einzahlung wurde nicht verarbeitet.',
        },
        widgetMarketWatch: {
            marketWatch: 'Marktübersicht',
            search: 'Suche...',
        },
        widgetOrders: {
            commission: 'Kommission',
            volume: 'Volumen',
            margin: 'Margin',
            active: 'Aktiv',
            pending: 'Ausstehend',
            activeOrders: 'Aktive Orders',
            portfolio: 'Portfolio',
            allPositions: 'Alle Positionen',
            noPositionsLine1: 'Sie haben noch keine',
            noPositionsLine2: 'geöffneten Positionen',
            show: 'Anzeigen',
            more: 'mehr',
            less: 'weniger',
            purchaseTime: 'Eröffnungszeit',
            closePosition: 'Position schließen',
            priceOpen: 'Eröffnungskurs',
            priceSl: 'Stop-Loss-Kurs',
            priceTp: 'Take-Profit-Kurs',
            type: 'Positionsrichtung',
            pnl: 'Gewinn/Verlust',
            cancelOrder: 'Order stornieren',
            orderType: 'Ordertyp',
            cancelled: 'Storniert',
            tradingHistory: 'Handelshistorie',
            noHistoryLine1: 'Sie haben noch keine',
            noHistoryLine2: 'geschlossenen Positionen',
            sortByTime: 'Nach Zeit sortieren',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Wirtschaftskalender'
        },
        widgetMarketNews: {
            marketNews: 'Marktnachrichten'
        },
        ordersPane: {
            ordersActive: 'Aktive Orders',
            ordersHistory: 'Orderhistorie',
            id: 'ID',
            symbol: 'Symbol',
            type: 'Typ',
            volume: 'Volumen',
            openPrice: 'Eröffnungskurs',
            openTime: 'Eröffnungszeit',
            closePrice: 'Schlusskurs',
            closeTime: 'Schlusszeit',
            sl: 'SL',
            tp: 'TP',
            price: 'Preis',
            pnl: 'PnL',
            actions: 'Aktionen',
            edit: 'Bearbeiten',
            close: 'Schließen',
            commission: 'Kommission',
            swap: 'Swap',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short'
        },
        assetInfoModal: {
            assetInfo: 'Asset-Info',
            tradingConditions: 'Handelskonditionen',
            information: 'Informationen',
            bid: 'Bid',
            ask: 'Ask',
            sessionChange: 'Session-Änderung',
            tradeNow: 'Jetzt handeln',
            opens: 'Öffnet',
            closes: 'Schließt',
            at: 'um',
            open247: '24/7 geöffnet',
            today: 'heute',
            tomorrow: 'morgen',
            sunday: 'Sonntag',
            monday: 'Montag',
            tuesday: 'Dienstag',
            wednesday: 'Mittwoch',
            thursday: 'Donnerstag',
            friday: 'Freitag',
            saturday: 'Samstag',
            contractSpecification: 'Kontraktspezifikation',
            symbol: 'Symbol',
            name: 'Name',
            market: 'Markt',
            baseCurrency: 'Basiswährung',
            digits: 'Dezimalstellen',
            lotSize: 'Lotgröße',
            lotStep: 'Lotschritt',
            minVolume: 'Min. Volumen',
            maxVolume: 'Max. Volumen',
            leverage: 'Hebel',
            commission: 'Kommission',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short',
            schedule: 'Zeitplan',
            weekday: 'Wochentag',
            tradingTime: 'Handelszeit',
            closed: 'geschlossen',
            sell: 'Verkauf',
            buy: 'Kauf',
            low: 'Tief',
            high: 'Hoch',
            oneHourChange: 'Änderung 1 Std.',
            oneDayChange: 'Änderung 1 Tag',
            oneWeekChange: 'Änderung 1 Woche',
            oneMonthChange: 'Änderung 1 Monat',
            threeMonthsChange: 'Änderung 3 Monate',
            oneYearChange: 'Änderung 1 Jahr',
            loading: 'Lädt...',
        },
        fullScreen: {
            startTrading: 'Handel starten',
            deposit: 'Einzahlung',
            dashboard: 'Dashboard',
            personalInfo: 'Persönliche Daten',
            withdrawal: 'Auszahlung',
            verification: 'Verifizierung',
            accounts: 'Konten',
            liveChat: 'Live Chat',
            savings: 'Sparen',
            settings: 'Einstellungen',
            logOut: 'Abmelden',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'KRYPTOWÄHRUNG WÄHLEN',
            name: 'Name des Karteninhabers',
            address: 'Adresse',
            DOB: 'Geburtsdatum',
            bankName: 'Bankname',
            additionalInfo: 'Um mehr auf Ihr Konto einzuzahlen, wenden Sie sich bitte direkt an Ihren Kontomanager',
            additionalInfoOnlyBTCpsp: 'Um andere Zahlungsmethoden zu öffnen, bitte KYC bereitstellen oder sich an Ihren Kontomanager wenden',
            sofortPspMessage: 'Unser Finanzteam wird sich mit Ihnen in Verbindung setzen, um Ihnen bei der Einzahlung zu helfen',
            addWalletAddress: 'Die Wallet für diese Zahlungsmethode ist nicht eingerichtet. Bitte wenden Sie sich an Ihren Agenten oder den Kundensupport.',
            addressReceipt: 'Bitte warten Sie, bis die Adresse geladen ist',
            makeDeposit: 'EINZAHLUNG TÄTIGEN',
            instant: 'Sofort',
            minutes: 'Minuten',
            hours: 'Stunden',
            days: 'Tage',
            amount: 'Betrag',
            continue: 'Weiter',
            qrCode: 'QR-CODE',
            depositAddress: 'EINZAHLUNGSADRESSE',
            copy: 'Kopieren',
            last: 'LETZTE',
            deposits: 'EINZAHLUNGEN',
            time: 'Zeit',
            currency: 'Währung',
            status: 'Status',
            info: 'Info',
        },
        fullScreenCcExt: {
            pleaseWait: 'Bitte warten. Verbindung zum Zahlungsdienstleister wird hergestellt...',
            cardPayment: 'Kartenzahlung',
            inOrder: 'Um den Betrag zu senden',
            pleaseProvide: 'Bitte geben Sie die Kartendaten an:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Steuern insgesamt',
            totalBalance: 'Gesamtkontostand',
            totalPnl: 'PnL insgesamt',
            profitableOrders: 'Erfolgreiche Orders',
            roi: 'ROI',
            activityLog: 'Aktivitätsprotokoll',
            loginFromIp: 'Login von IP',
            tradingResults: 'Handelsergebnisse',
            week: 'Woche',
            month: 'Monat',
            year: 'Jahr',
            successRate: 'Erfolgsquote',
            closedWithProfit: 'Geschlossen mit Gewinn',
            closedWithLoss: 'Geschlossen mit Verlust',
            account: 'Konto',
            balance: 'Kontostand',
            leverage: 'Hebel',
            credit: 'Kredit',
            tradeNow: 'Jetzt handeln',
            usingCurrentRate: 'zum aktuellen Wechselkurs',
            totalDeposits: 'Einzahlungen insgesamt'
        },
        fullScreenPersonal: {
            personalDetails: 'Persönliche Daten',
            profilePhoto: 'Profilfoto',
            firstName: 'Vorname',
            country: 'Land',
            lastName: 'Nachname',
            address: 'Adresse',
            email: 'E-Mail',
            phone: 'Telefonnummer',
            saveChanges: 'Änderungen speichern'
        },
        fullScreenAvatar: {
            dropFile: 'Legen Sie eine Datei zum Hochladen auf dem Kreis oben ab',
            notAllowed: 'Nicht erlaubt sind',
            notAllowedLine1: 'Fotos explizit sexueller oder pornografischer Natur',
            notAllowedLine2: 'Bilder, die darauf abzielen, zu ethnischem oder rassistischem Hass oder Aggression aufzustacheln',
            notAllowedLine3: 'Fotos mit Personen unter 18 Jahren',
            notAllowedLine4: 'Urheberrechtlich geschützte Fotos Dritter',
            notAllowedLine5: 'Bilder größer als 5 MB und in einem anderen Format als JPG, GIF oder PNG',
            requirements: 'Auf dem Foto muss Ihr Gesicht gut zu erkennen sein. Alle von Ihnen hochgeladenen Fotos und Videos müssen diese Anforderungen erfüllen, andernfalls können sie entfernt werden.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Auszahlung',
            requestNewWithdrawal: 'NEUE AUSZAHLUNG ANFORDERN',
            amount: 'Betrag',
            currentBalance: 'Ihr aktueller Kontostand ist',
            withdrawAll: 'Alles auszahlen',
            requestWithdrawal: 'Auszahlung anfordern',
            last: 'LETZTE',
            withdrawalRequests: 'AUSZAHLUNGSANTRÄGE',
            time: 'Zeit',
            currency: 'Währung',
            info: 'Info',
            status: 'Status',
            bank: 'Bank',
            bitcoin: 'Bitcoin',
            card: 'Karte',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Auszahlungsdetails',
            address: 'Wallet-Adresse',
            bankAccount: 'Kontonummer',
            bankHolder: 'Name des Kontoinhabers',
            bankIban: 'IBAN',
            bankSwift: 'SWIFT-Code der Bank',
            sortCode: 'Sort Code',
            ifscCode: 'IFSC-Code',
            bankCode: "Bankleitzahl (BSB)",
            bankName: 'Bankname',
            bankBranch: 'Bankfiliale',
            cardNumber: 'Kartennummer',
            cardHolder: 'Name des Karteninhabers',
            incorrectAmountByFreeMargin: 'Der Betrag ist nicht korrekt. Sie können höchstens die freie Margin auszahlen',
            closeOrders: 'Schließen Sie zuvor alle Orders'
        },
        fullScreenVerification: {
            dragAndDrop: 'Ziehen Sie das Dokument per Drag & Drop in diesen Bereich',
            documentsList: 'LISTE DER HOCHGELADENEN DOKUMENTE',
            document: 'Dokument',
            timeUploaded: 'Hochgeladen am',
            timeProcessed: 'Bearbeitet am',
            status: 'Status',
            types: ['Ausweisnachweis', 'Wohnsitznachweis', 'Kreditkartenvorderseite', 'Kreditkartenrückseite', 'Ausweisrückseite', 'Selfie','Sonstiges'],
            types2: ['Ausweisnachweis (PERSONALAUSWEIS, REISEPASS, FÜHRERSCHEIN)', 'Wohnsitznachweis (Nebenkostenrechnung oder Kontoauszug)', 'Kreditkartenvorderseite', 'Kreditkartenrückseite', 'Ausweisrückseite (PERSONALAUSWEIS RÜCKSEITE, FÜHRERSCHEIN RÜCKSEITE)', 'Selfie','Sonstiges'],
            upload: 'Hochladen',
            isConfirmed: 'bestätigt',
            uploadAnotherDocument: 'Anderes Dokument hochladen',
            isUnderReview: 'wird überprüft',
            questionnaire: 'Fragebogen',
            sendAnswers: 'Antworten senden',
            progressBarOf: 'von',
            progressBarText: 'Ihrer Dokumente sind hochgeladen und bestätigt'
        },
        fullScreenAccounts: {
            manageAccounts: 'Überweisen Sie Gelder zwischen Ihren Konten',
            transferFrom: 'Vom Konto',
            transferTo: 'Auf Konto',
            amount: 'Betrag',
            makeTransfer: 'Überweisung vornehmen',
            yourAccounts: 'Ihre Konten',
            account: 'Konto',
            currency: 'Währung',
            balance: 'Kontostand',
            credit: 'Kredit',
            makeActive: 'Aktivieren',
            active: 'Aktiv'
        },
        fullScreenSupport: {
            chatOff: 'Der Chat ist an Werktagen verfügbar',
            sendMessage: 'Nachricht senden',
            responseTime: 'Durchschnittliche Antwortzeit: 1-24 Stunden',
        },
        fullScreenSavings: {
            pct_0: 'Flexibel',
            pct_30: '1 Monat gebunden',
            pct_90: '1 Quartal gebunden',
            pct_180: '6 Monate gebunden',
            pct_365: '1 Jahr gebunden',
            pct_730: '2 Jahre gebunden',
            savings: 'Sparen',
            detailedInformation: 'Detaillierte Informationen',
            pleaseSelect: 'Bitte wählen Sie eine Währung und einen Zeitraum',
            openSavings: 'Sparkonto eröffnen',
            currentTime: 'Aktuelle Uhrzeit',
            releaseTime: 'Freigabezeit',
            currencyChosen: 'Gewählte Währung',
            periodChosen: 'Gewählter Zeitraum',
            yourRate: 'Ihr Zinssatz',
            yourAnnualRate: 'Ihr Jahreszinssatz',
            yourEarnings: 'Ihre Erträge',
            accountFrom: 'Konto, von dem Geld überwiesen werden soll',
            enterAmount: 'Betrag eingeben',
            in: 'in',
            openAndInvest: 'Sparkonto eröffnen und anlegen',
            investment: 'Anlage',
            period: 'Zeitraum',
            daysTotal: 'Tage insgesamt',
            finalEarnings: 'Erträge insgesamt',
            created: 'Erstellt',
            daysElapsed: 'Verstrichene Tage',
            days: 'Tage',
            earnings: 'Laufende Erträge',
            fundsReleasedIn: 'Freigabe der Mittel in',
            claim: 'Auflösen',
        },
        fullScreenSettings: {
            updatePassword: 'PASSWORT AKTUALISIEREN',
            currentPassword: 'Aktuelles Passwort',
            newPassword: 'Neues Passwort',
            changePassword: 'Passwort ändern',
            activationForGoogle: 'Aktivierungscode für Google Authenticator',
            activateAndEnter: 'Aktivieren Sie Authenticator und geben Sie einen generierten Code in das Feld unten ein',
            qrCode: 'QR-Code',
            activateProtection: '2FA-Schutz aktivieren',
            protectionActive: '2FA-Schutz ist aktiv',
            twoFactorCode: '2FA-Code',
            disableProtection: '2FA-Schutz deaktivieren',
            language: 'Sprache',
            dashboardCurrency: 'Dashboard-Währung',
            confirmNewPassword: 'Neues Passwort bestätigen',
        },
        fullScreenReferrals: {
            yourLink: 'IHR EMPFEHLUNGSLINK',
            referredFriends: 'GEWORBENE FREUNDE',
            id: 'ID',
            name: 'Name',
            registered: 'Registriert',
            level: 'Level',
            payout: 'Auszahlung',
            lastPayouts: 'LETZTE EMPFEHLUNGSAUSZAHLUNGEN',
            time: 'Zeit',
            amount: 'Betrag',
            currency: 'Währung',
            info: 'Info'
        },
        months: {
            Jan: 'Jan',
            Feb: 'Feb',
            Mar: 'Mär',
            Apr: 'Apr',
            May: 'Mai',
            Jun: 'Jun',
            Jul: 'Jul',
            Aug: 'Aug',
            Sep: 'Sep',
            Oct: 'Okt',
            Nov: 'Nov',
            Dec: 'Dez'
        },
        orderTypes: ['Buy', 'Sell', 'Buy Limit', 'Sell Limit', 'Buy Stop', 'Sell Stop'],
        statuses: ['Ausstehend', 'Genehmigt', 'Abgelehnt', 'Wird bearbeitet','In Überprüfung','In Bearbeitung','Storniert'],
        errors: {
            INVALID_FIELDS: 'Bitte prüfen Sie, ob die eingegebenen Daten korrekt sind',
            NOT_FOUND: 'Anforderungsfehler',
            FORBIDDEN: 'Zugriff verweigert. Bitte melden Sie sich erneut an',
            SERVER_ERROR: 'Aktion fehlgeschlagen. Bitte versuchen Sie es später noch einmal',
            INVALID_ACCOUNT: 'Sitzung abgelaufen. Bitte melden Sie sich erneut an',
            INVALID_EMAIL: 'Ungültige E-Mail-Adresse',
            INVALID_PHONE: 'Ungültige Telefonnummer',
            INVALID_COUNTRY: 'Ungültiges Land',
            INVALID_LOGIN: 'Ungültige Anmeldedaten',
            USER_BLOCKED: 'Konto ist gesperrt. Bitte wenden Sie sich an den Support',
            USER_REGISTERED: 'Benutzer mit eingegebener E-Mail oder Telefonnummer ist bereits registriert',
            INVALID_USER: 'Benutzer wurde nicht gefunden',
            REJECTED: 'Der Vorgang ist aufgrund von Plattformbeschränkungen nicht erlaubt',
            INVALID_OLD_PASSWORD: 'Altes Passwort ist ungültig',
            INVALID_SYMBOL: 'Ungültiges Handelssymbol',
            INVALID_SYMBOL_PRECISION: 'Ungültige Symbolpräzision',
            INVALID_FRAME: 'Ungültiger Chart-Zeitrahmen',
            INVALID_CURRENCY: 'Ungültige Währung',
            INVALID_PRODUCT: 'Ungültiger Typ des Handelskontos',
            INSUFFICIENT_FUNDS: 'Nicht genügend Geld auf dem Konto',
            INVALID_WITHDRAWAL: 'Auszahlung nicht gefunden',
            INVALID_DEPOSIT: 'Diese Einzahlung kann nicht mehr storniert werden - sie wurde nicht gefunden oder bereits bearbeitet',
            INVALID_STATUS: 'Ungültiger Status',
            INVALID_FILE: 'Ungültige Dateierweiterung oder Datei ist zu groß',
            INVALID_DOCUMENT: 'Dokument wurde nicht gefunden',
            INVALID_NAME: 'Ungültiger Name',
            INVALID_LOT_SIZE: 'Ungültige Lotgröße',
            INVALID_LOT_STEP: 'Ungültiger Lotschritt',
            INVALID_MIN_VOLUME: 'Ungültiges Mindestvolumen',
            INVALID_MAX_VOLUME: 'Ungültiges maximales Volumen',
            INVALID_GROUP: 'Ungültige Gruppe',
            INVALID_SPREAD: 'Ungültiger Spread',
            REQUEST_TIMEOUT: 'Zeitüberschreitung der Anforderung. Bitte versuchen Sie es später noch einmal',
            INVALID_TYPE: 'Ungültiger Ordertyp',
            INVALID_VOLUME: 'Ungültiges Ordervolumen',
            INVALID_SL: 'Ungültiger Stop-Loss-Wert',
            INVALID_TP: 'Ungültiger Take-Profit-Wert',
            INVALID_PRICE: 'Ungültiger Orderpreis',
            INVALID_EXPIRATION: 'Ungültige Gültigkeitsdauer der Order',
            NOT_ENOUGH_MARGIN: 'Nicht genügend Margin',
            INVALID_ORDER: 'Order nicht gefunden',
            MARKET_CLOSED: 'Handel ist nicht verfügbar. Bitte versuchen Sie es erneut',
            INVALID_BALANCE_TYPE: 'Ungültiger Typ der Kontobewegung',
            INVALID_HASH: 'Ungültiger Hash',
            HASH_EXPIRED: 'Ihr Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte fordern Sie einen neuen an',
            INVALID_CODE: 'Ungültiger 2FA-Code',
            CHAT_DISABLED: 'Zugriff auf den Support-Chat wurde gesperrt',
            WITHDRAWAL_NOT_ALLOWED: 'Zugriff auf die Auszahlungen wurde gesperrt',
            TRADING_DISABLED: 'Der Handel ist für dieses Konto deaktiviert',
            PENDING_DEPOSITS_LIMIT: 'Einzahlungslimit überschritten',
            CLOSE_OPEN_ORDERS: 'Bitte schließen Sie Ihre offenen Orders',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Es ist nur eine offene Auszahlung zulässig',
            LOCAL_DEPOSIT_ONLY_REAL: 'Einzahlungen sind nur auf Echtkonten möglich',
            LOCAL_DEPOSIT_POSITIVE: 'Der Einzahlungsbetrag muss größer als 0 sein',
            LOCAL_INVALID_CARD_NUMBER: 'Ungültige Kartennummer',
            LOCAL_INVALID_CARD_EXPIRATION: 'Ungültiges Ablaufdatum der Karte',
            LOCAL_INVALID_CVC: 'Ungültiger CVV/CVC-Code',
            LOCAL_PASSWORDS_NOT_MATCH: 'Die Passwörter stimmen nicht überein, bitte erneut eingeben',
            LOCAL_NO_TRADING_ACCOUNTS: 'Ihnen stehen keine Handelskonten zur Verfügung. Bitte wenden Sie sich an den Support',
            LOCAL_MIN_DEPOSIT: 'Mindesteinzahlung ist $',
            LOCAL_MIN_WITHDRAWAL: 'Mindestauszahlungsbetrag ist $',
            LOCAL_INVALID_FILE_TYPE: 'Dateiformat nicht unterstützt. Bitte nur JPG, PNG oder PDF anhängen',
            LOCAL_MIN_STAKING: 'Mindesteinzahlung für diese Währung ist ',
            FLOOD_REJECTED: 'Sie senden zu oft Nachrichten. Bitte versuchen Sie es später noch einmal',
            REGISTRATIONS_BLOCKED: "Vielen Dank für Ihre Anfrage, Einer unserer Vertreter wird sich so schnell wie möglich mit Ihnen in Verbindung setzen",
        },
        countries: {
            AF: 'Afghanistan',
            AX: 'Ålandinseln',
            AL: 'Albanien',
            DZ: 'Algerien',
            AS: 'Amerikanisch-Samoa',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarktis',
            AG: 'Antigua und Barbuda',
            AR: 'Argentinien',
            AM: 'Armenien',
            AW: 'Aruba',
            AU: 'Australien',
            AT: 'Österreich',
            AZ: 'Aserbaidschan',
            BS: 'Bahamas',
            BH: 'Bahrain',
            BD: 'Bangladesch',
            BB: 'Barbados',
            BY: 'Weißrussland',
            BE: 'Belgien',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivien',
            BA: 'Bosnien und Herzegowina',
            BW: 'Botswana',
            BV: 'Bouvetinsel',
            BR: 'Brasilien',
            IO: 'Britisches Territorium im Indischen Ozean',
            BN: 'Brunei Darussalam',
            BG: 'Bulgarien',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Kambodscha',
            CM: 'Kamerun',
            CA: 'Kanada',
            CV: 'Kap Verde',
            KY: 'Kaimaninseln',
            CF: 'Zentralafrikanische Republik',
            TD: 'Tschad',
            CL: 'Chile',
            CN: 'China',
            CX: 'Weihnachtsinsel',
            CC: 'Kokosinseln (Keeling)',
            CO: 'Kolumbien',
            KM: 'Komoren',
            CG: 'Kongo',
            CD: 'Kongo, Demokratische Republik',
            CK: 'Cookinseln',
            CR: 'Costa Rica',
            CI: 'Elfenbeinküste',
            HR: 'Kroatien',
            CU: 'Kuba',
            CY: 'Zypern',
            CZ: 'Tschechische Republik',
            DK: 'Dänemark',
            DJ: 'Dschibuti',
            DM: 'Dominica',
            DO: 'Dominikanische Republik',
            EC: 'Ecuador',
            EG: 'Ägypten',
            SV: 'El Salvador',
            GQ: 'Äquatorialguinea',
            ER: 'Eritrea',
            EE: 'Estland',
            ET: 'Äthiopien',
            FK: 'Falklandinseln (Malwinen)',
            FO: 'Färöer',
            FJ: 'Fidschi',
            FI: 'Finnland',
            FR: 'Frankreich',
            GF: 'Französisch-Guayana',
            PF: 'Französisch-Polynesien',
            TF: 'Französische Südgebiete',
            GA: 'Gabun',
            GM: 'Gambia',
            GE: 'Georgien',
            DE: 'Deutschland',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Griechenland',
            GL: 'Grönland',
            GD: 'Grenada',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HM: 'Heard und McDonaldinseln',
            VA: 'Heiliger Stuhl (Staat Vatikanstadt)',
            HN: 'Honduras',
            HK: 'Hongkong',
            HU: 'Ungarn',
            IS: 'Island',
            IN: 'Indien',
            ID: 'Indonesien',
            IR: 'Iran',
            IQ: 'Irak',
            IE: 'Irland',
            IM: 'Isle of Man',
            IL: 'Israel',
            IT: 'Italien',
            JM: 'Jamaika',
            JP: 'Japan',
            JE: 'Jersey',
            JO: 'Jordanien',
            KZ: 'Kasachstan',
            KE: 'Kenia',
            KI: 'Kiribati',
            KR: 'Korea',
            KW: 'Kuwait',
            KG: 'Kirgisistan',
            LA: 'Demokratische Volksrepublik Laos',
            LV: 'Lettland',
            LB: 'Libanon',
            LS: 'Lesotho',
            LR: 'Liberia',
            LY: 'Libysch-Arabische Dschamahirija',
            LI: 'Liechtenstein',
            LT: 'Litauen',
            LU: 'Luxemburg',
            MO: 'Macau',
            MK: 'Mazedonien',
            MG: 'Madagaskar',
            MW: 'Malawi',
            MY: 'Malaysia',
            MV: 'Malediven',
            ML: 'Mali',
            MT: 'Malta',
            MH: 'Marshallinseln',
            MQ: 'Martinique',
            MR: 'Mauretanien',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Mexiko',
            FM: 'Mikronesien',
            MD: 'Moldawien',
            MC: 'Monaco',
            MN: 'Mongolei',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MA: 'Marokko',
            MZ: 'Mosambik',
            MM: 'Myanmar',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NL: 'Niederlande',
            AN: 'Niederländische Antillen',
            NC: 'Neukaledonien',
            NZ: 'Neuseeland',
            NI: 'Nicaragua',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            NF: 'Norfolkinsel',
            MP: 'Nördliche Marianen',
            NO: 'Norwegen',
            OM: 'Oman',
            PK: 'Pakistan',
            PW: 'Palau',
            PS: 'Palästinensische Gebiete, Besetzt',
            PA: 'Panama',
            PG: 'Papua-Neuguinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PH: 'Philippinen',
            PN: 'Pitcairn',
            PL: 'Polen',
            PT: 'Portugal',
            PR: 'Puerto Rico',
            QA: 'Katar',
            RE: 'Réunion',
            RO: 'Rumänien',
            RU: 'Russland',
            RW: 'Ruanda',
            BL: 'St. Barthelemy',
            SH: 'Sankt Helena',
            KN: 'St. Kitts und Nevis',
            LC: 'St. Lucia',
            MF: 'Sankt Martin',
            PM: 'St. Pierre und Miquelon',
            VC: 'St. Vincent und Grenadinen',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Sao Tome und Principe',
            SA: 'Saudi-Arabien',
            SN: 'Senegal',
            RS: 'Serbien',
            SC: 'Seychellen',
            SL: 'Sierra Leone',
            SG: 'Singapur',
            SK: 'Slowakei',
            SI: 'Slowenien',
            SB: 'Salomoninseln',
            SO: 'Somalia',
            ZA: 'Südafrika',
            GS: 'Südgeorgien und Sandwichinseln',
            ES: 'Spanien',
            LK: 'Sri Lanka',
            SD: 'Sudan',
            SR: 'Suriname',
            SJ: 'Spitzbergen und Jan Mayen',
            SZ: 'Swasiland',
            SE: 'Schweden',
            CH: 'Schweiz',
            SY: 'Arabische Republik Syrien',
            TW: 'Taiwan',
            TJ: 'Tadschikistan',
            TZ: 'Tansania',
            TH: 'Thailand',
            TL: 'Timor-Leste',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad und Tobago',
            TN: 'Tunesien',
            TR: 'Türkei',
            TM: 'Turkmenistan',
            TC: 'Turks- und Caicosinseln',
            TV: 'Tuvalu',
            UG: 'Uganda',
            UA: 'Ukraine',
            AE: 'Vereinigte Arabische Emirate',
            GB: 'Vereinigtes Königreich',
            US: 'Vereinigte Staaten',
            UM: 'Überseeische Inseln der Vereinigten Staaten',
            UY: 'Uruguay',
            UZ: 'Usbekistan',
            VU: 'Vanuatu',
            VE: 'Venezuela',
            VN: 'Vietnam',
            VG: 'Jungferninseln, Britisch',
            VI: 'Jungferninseln, U.S.A.',
            WF: 'Wallis und Futuna',
            EH: 'Westsahara',
            YE: 'Jemen',
            ZM: 'Sambia',
            ZW: 'Simbabwe'
        },
    },
    fr: {
        _name: 'Française',
        autoCloseModal: {
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            updateOrder: 'Modifier l\'ordre',
        },
        balanceModal: {
            balance: 'Solde',
            credit: 'Crédit',
            equity: 'Capital',
            practice: 'DÉMO',
            real: 'RÉEL',
            account: 'COMPTE',
            invested: 'Investi',
            profit: 'Profit',
            loss: 'Perte',
            margin: 'Marge',
            marginLevel: 'Niveau de marge',
            marginFree: 'Marge libre'
        },
        header: {
            cfd: 'CFD',
            platform: 'Plateforme',
            deposit: 'Dépôt',
            myAccount: 'Mon compte'
        },
        sideMenu: {
            marketWatch: 'Surveillance du marché',
            activeOrders: 'Ordres actifs',
            tradingHistory: 'Historique des transactions',
            economicCalendar: 'Calendrier économique',
            marketNews: 'Nouvelles du marché'
        },
        closePositionModal: {
            closeOrder: 'Clôturer la position',
            areYouSure: 'Êtes-vous sûr de vouloir clôturer la position',
            buy: 'Achat',
            sell: 'Vente',
            yes: 'Oui',
            no: 'Non',
        },
        chart: {
            addNewChart: 'Ajouter un nouveau graphique',
        },
        symbolsModal: {
            watchlist: 'Liste de surveillance',
            asset: 'Actif',
            price: 'Prix',
            changePct: 'Changement 24h'
        },
        pendingModal: {
            pending: 'En attente',
            assetPrice: 'Prix de l\'actif',
            current: 'Actuel',
            revert: 'Retour au prix du marché',
            automatically: 'La position sera ouverte automatiquement lorsque le prix atteindra ce niveau'
        },
        orderMenu: {
            volume: 'Volume',
            lots: 'lots',
            units: 'unités',
            currency: 'devise',
            contractSize: 'Taille du contrat',
            position: 'Position',
            margin: 'Marge',
            freeMargin: 'Marge libre',
            takeProfitStopLoss: 'Take Profit & Stop Loss',
            pending: 'En attente',
            market: 'Marché',
            leverage: 'Effet de levier',
            spread: 'Spread',
            notSet: 'Non défini',
            at: 'à',
            buy: 'achat',
            sell: 'vente',
        },
        footer: {
            supportBanner: 'TOUS LES JOURS, 24 HEURES SUR 24',
            currentTime: 'HEURE ACTUELLE',
            liveChat: 'Chat en direct'
        },
        statusBar: {
            balance: 'Solde',
            credit: 'Crédit',
            equity: 'Capital',
            margin: 'Marge',
            marginLevel: 'Niveau de marge',
            freeMargin: 'Marge libre',
            pnl: 'PnL',
            profitTotal: 'PnL total'
        },
        accountModal: {
            dateRegistered: 'Date d\'inscription',
            userId: 'ID utilisateur',
            dashboard: 'Tableau de bord',
            personalData: 'Données personnelles',
            deposit: 'Dépôt',
            withdrawFunds: 'Retirer des fonds',
            savings: 'Épargne',
            settings: 'Paramètres',
            logout: 'Déconnexion'
        },
        depositModal: {
            BT_INVOICE: 'Saisissez le montant et générez la facture',
            BT_TITLE: 'Nos coordonnées bancaires',
            PENDING_DEPOSITS_LIMIT: 'Limite de dépôt',
            BT_ACCOUNT: 'Compte',
            BT_BANK_NAME: 'Nom de la banque',
            BT_BENEFICIARY: 'Bénéficiaire',
            BT_ADDRESS: 'Adresse du bénéficiaire',
            BT_SWIFT: 'SWIFT',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Code de référence bancaire',
            BT_INN: 'INN',
            BT_KPP: 'Compte correspondant',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: 'Montant',
            TOKEN_SUBTOTAL: 'Sous-total',
            TOKEN_TOTAL: 'Total',
            TOKEN_DESCRIPTION: 'Description',
            TOKEN_PAYMENT_DETAILS: 'Détails du paiement',
            makeDeposit: 'Effectuer un dépôt',
            practiceAccount: 'Compte démo',
            realAccount: 'Compte réel',
            noWithdrawals: 'Pas de retraits',
            easyWithdrawals: 'Retraits faciles',
            allAssets: 'Tous les actifs disponibles',
            fullFledged: 'Une plateforme complète',
            fillUpTo: 'Remplir jusqu\'à',
            freeReplenishment: 'Réapprovisionnement gratuit',
            topUp: 'Rechargez votre compte',
            minimumAmount: 'Montant minimum',
            canSwitch: 'Vous pouvez passer d\'un compte à l\'autre à tout moment'
        },
        gridsModal: {
            chartGrids: 'GRILLES DE GRAPHIQUES',
            chart1: '1 graphique',
            chart2: '2 graphiques',
            chart3: '3 graphiques',
            chart4: '4 graphiques',
        },
        noConnectionModal: {
            connectionLost: 'La connexion avec le serveur est perdue',
            retryNow: 'Réessayer maintenant',
        },
        loginModal: {
            loginToTradeRoom: 'Connexion à la Traderoom',
            email: 'Adresse e-mail',
            emailAndId: `Adresse e-mail / Numéro d'ID`,
            enterEmail: 'Entrez votre e-mail',
            twoFactor: 'Code 2FA (si activé)',
            twoFactorAuth: 'Authentification à deux facteurs',
            password: 'Mot de passe',
            yourPassword: 'Votre mot de passe',
            signIn: 'Se connecter',
            dontHaveAccount: 'Vous n\'avez pas de compte?',
            restore: 'Restaurer',
            fullName: 'Nom complet',
            havePromo: 'J\'ai un code promo',
            promo: 'Code promo',
            login: 'Connexion',
            haveAccount: 'Vous avez déjà un compte?',
            hide: 'Masquer',
            goTo: 'Retour'
        },
        newPasswordModal: {
            setNewPassword: 'Définir un nouveau mot de passe',
            newPassword: 'Nouveau mot de passe',
            confirmNewPassword: 'Confirmer le nouveau mot de passe',
            setButton: 'Définir'
        },
        registerModal: {
            createNewAccount: 'Créer un nouveau compte',
            email: 'Adresse e-mail',
            firstName: 'Prénom',
            lastName: 'Nom de famille',
            country: 'Pays',
            phone: 'Téléphone',
            password: 'Mot de passe',
            createAccount: 'Créer un compte',
            currency: 'Devise'
        },
        forgotPasswordModal: {
            forgotPassword: 'Mot de passe oublié?',
            submitEmail: 'Veuillez indiquer l\'e-mail utilisé lors de l\'inscription, vérifiez votre boîte de réception et suivez les instructions fournies.',
            submit: 'Soumettre'
        },
        notifications: {
            error: 'Erreur',
            success: 'Succès',
            deposit: 'Dépôt',
            withdrawal: 'Retrait',
            depositApproved: 'Le dépôt a été approuvé',
            depositDeclined: 'Le dépôt a été refusé',
            withdrawalApproved: 'Le retrait a été approuvé',
            withdrawalDeclined: 'Le retrait a été refusé',
            withdrawalCancelled: 'Le retrait a été annulé',
            orderRejected: 'Ordre rejeté',
            insufficientMargin: 'Votre ordre en attente n\'a pas pu être ouvert : marge libre insuffisante',
            marginCall: 'Appel de marge',
            marginCallText: 'Veuillez effectuer un dépôt pour couvrir la marge requise'
        },
        markets: {
            forex: 'Forex',
            stocks: 'Actions',
            commodities: 'Matières premières',
            indices: 'Indices',
            crypto: 'Crypto',
            metals: 'Métaux',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            buy: 'ACHAT',
            profitCalculator: 'Calculateur de profit',
            sell: 'VENTE',
            volume: 'Volume',
            entryPrice: 'Prix d\'entrée',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            maxPosition: 'Position max',
            calculate: 'Calculer',
            calculationsFor: 'Calculs pour',
            leverage: 'Effet de levier',
            requiredMargin: 'Marge requise',
            profitFromTP: 'Profit au TP',
            lossFromSL: 'Perte au SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Dépôt réussi',
            text: 'Votre dépôt a été traité avec succès !',
        },
        depositFailModal: {
            title: 'Dépôt échoué',
            text: 'Votre dépôt n\'a pas été traité.',
        },
        widgetMarketWatch: {
            marketWatch: 'Surveillance du marché',
            search: 'Recherche...',
        },
        widgetOrders: {
            commission: 'Commission',
            volume: 'Volume',
            margin: 'Marge',
            active: 'Actifs',
            pending: 'En attente',
            activeOrders: 'Ordres actifs',
            portfolio: 'Portefeuille',
            allPositions: 'Toutes les positions',
            noPositionsLine1: 'Vous n\'avez aucune',
            noPositionsLine2: 'position ouverte',
            show: 'Afficher',
            more: 'plus',
            less: 'moins',
            purchaseTime: 'Date d\'achat',
            closePosition: 'Clôturer la position',
            priceOpen: 'Prix d\'achat',
            priceSl: 'Prix du Stop Loss',
            priceTp: 'Prix du Take Profit',
            type: 'Sens',
            pnl: 'Profit/Perte',
            cancelOrder: 'Annuler l\'ordre',
            orderType: 'Type d\'ordre',
            cancelled: 'Annulé',
            tradingHistory: 'Historique des transactions',
            noHistoryLine1: 'Vous n\'avez encore aucune',
            noHistoryLine2: 'position clôturée',
            sortByTime: 'Trier par date',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Calendrier économique'
        },
        widgetMarketNews: {
            marketNews: 'Nouvelles du marché'
        },
        ordersPane: {
            ordersActive: 'Ordres actifs',
            ordersHistory: 'Historique des ordres',
            id: 'ID',
            symbol: 'Symbole',
            type: 'Type',
            volume: 'Volume',
            openPrice: "Prix d'ouverture",
            openTime: "Heure d'ouverture",
            closePrice: 'Prix de clôture',
            closeTime: 'Heure de clôture',
            sl: 'SL',
            tp: 'TP',
            price: 'Prix',
            pnl: 'PnL',
            actions: 'Actions',
            edit: 'Modifier',
            close: 'Clôturer',
            commission: 'Commission',
            swap: 'Swap',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short'
        },
        assetInfoModal: {
            assetInfo: 'Infos sur l\'actif',
            tradingConditions: 'Conditions de trading',
            information: 'Informations',
            bid: 'Bid',
            ask: 'Ask',
            sessionChange: 'Variation de la séance',
            tradeNow: 'Trader maintenant',
            opens: 'Ouvre',
            closes: 'Ferme',
            at: 'à',
            open247: 'Ouvert 24h/24 7j/7',
            today: 'aujourd\'hui',
            tomorrow: 'demain',
            sunday: 'Dimanche',
            monday: 'Lundi',
            tuesday: 'Mardi',
            wednesday: 'Mercredi',
            thursday: 'Jeudi',
            friday: 'Vendredi',
            saturday: 'Samedi',
            contractSpecification: 'Spécifications du contrat',
            symbol: 'Symbole',
            name: 'Nom',
            market: 'Marché',
            baseCurrency: 'Devise de base',
            digits: 'Décimales',
            lotSize: 'Taille du lot',
            lotStep: 'Pas du lot',
            minVolume: 'Volume min',
            maxVolume: 'Volume max',
            leverage: 'Effet de levier',
            commission: 'Commission',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short',
            schedule: 'Horaires',
            weekday: 'Jour',
            tradingTime: 'Heures de trading',
            closed: 'fermé',
            sell: 'Vente',
            buy: 'Achat',
            low: 'Plus bas',
            high: 'Plus haut',
            oneHourChange: 'Variation 1 heure',
            oneDayChange: 'Variation 1 jour',
            oneWeekChange: 'Variation 1 semaine',
            oneMonthChange: 'Variation 1 mois',
            threeMonthsChange: 'Variation 3 mois',
            oneYearChange: 'Variation 1 an',
            loading: 'Chargement...',
        },
        fullScreen: {
            startTrading: 'Commencer à trader',
            deposit: 'Dépôt',
            dashboard: 'Tableau de bord',
            personalInfo: 'Infos personnelles',
            withdrawal: 'Retrait',
            verification: 'Vérification',
            accounts: 'Comptes',
            liveChat: 'Chat en direct',
            savings: 'Épargne',
            settings: 'Paramètres',
            logOut: 'Déconnexion',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOISISSEZ UNE CRYPTOMONNAIE',
            name: 'Nom du titulaire de la carte',
            address: 'Adresse',
            DOB: 'Date de naissance',
            bankName: 'Nom de la banque',
            additionalInfo: 'Pour déposer plus sur votre compte, veuillez contacter directement votre gestionnaire de compte',
            additionalInfoOnlyBTCpsp: "Pour ouvrir d'autres modes de paiement, veuillez fournir le KYC ou contacter votre gestionnaire de compte",
            sofortPspMessage: 'Notre équipe financière vous contactera pour vous aider à effectuer un dépôt',
            addWalletAddress: 'Le portefeuille pour ce mode de paiement n\'est pas configuré. Veuillez contacter votre agent ou le service client.',
            addressReceipt: 'Veuillez patienter pendant le chargement de l\'adresse',
            makeDeposit: 'FAIRE UN DÉPÔT',
            instant: 'Instantané',
            minutes: 'minutes',
            hours: 'heures',
            days: 'jours',
            amount: 'Montant',
            continue: 'Continuer',
            qrCode: 'QR CODE',
            depositAddress: 'ADRESSE DE DÉPÔT',
            copy: 'Copier',
            last: 'LES',
            deposits: 'DERNIERS DÉPÔTS',
            time: 'Date',
            currency: 'Devise',
            status: 'Statut',
            info: 'Info',
        },
        fullScreenCcExt: {
            pleaseWait: 'Veuillez patienter. Connexion au fournisseur de services de paiement...',
            cardPayment: 'Paiement par carte',
            inOrder: 'Afin d\'envoyer le montant',
            pleaseProvide: 'veuillez fournir les détails de la carte :'
        },
        fullScreenDashboard: {
            totalTaxes: 'Total des taxes',
            totalBalance: 'Solde total',
            totalPnl: 'PnL total',
            profitableOrders: 'Ordres rentables',
            roi: 'ROI',
            activityLog: "Journal d'activité",
            loginFromIp: 'Connexion depuis IP',
            tradingResults: 'Résultats de trading',
            week: 'Semaine',
            month: 'Mois',
            year: 'Année',
            successRate: 'Taux de réussite',
            closedWithProfit: 'Clôturé avec profit',
            closedWithLoss: 'Clôturé avec perte',
            account: 'Compte',
            balance: 'Solde',
            leverage: 'Effet de levier',
            credit: 'Crédit',
            tradeNow: 'Trader maintenant',
            usingCurrentRate: 'au taux de change actuel',
            totalDeposits: 'Total des dépôts'
        },
        fullScreenPersonal: {
            personalDetails: 'Détails personnels',
            profilePhoto: 'Photo de profil',
            firstName: 'Prénom',
            country: 'Pays',
            lastName: 'Nom de famille',
            address: 'Adresse',
            email: 'E-mail',
            phone: 'Numéro de téléphone',
            saveChanges: 'Enregistrer les modifications'
        },
        fullScreenAvatar: {
            dropFile: 'Déposez un fichier sur le cercle ci-dessus pour l\'envoyer',
            notAllowed: 'Il n\'est pas permis de publier',
            notAllowedLine1: 'Photos à caractère explicitement sexuel ou pornographique',
            notAllowedLine2: 'Images visant à inciter à la haine ou à l\'agression ethnique ou raciale',
            notAllowedLine3: 'Photos impliquant des personnes de moins de 18 ans',
            notAllowedLine4: 'Photos protégées par le droit d\'auteur de tiers',
            notAllowedLine5: 'Images de plus de 5 MB et dans un format autre que JPG, GIF ou PNG',
            requirements: 'Votre visage doit être clairement visible sur la photo. Toutes les photos et vidéos que vous mettez en ligne doivent respecter ces exigences, faute de quoi elles peuvent être supprimées.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Retrait',
            requestNewWithdrawal: 'DEMANDER UN NOUVEAU RETRAIT',
            amount: 'Montant',
            currentBalance: 'Le solde actuel de votre compte est de',
            withdrawAll: 'Tout retirer',
            requestWithdrawal: 'Demander un retrait',
            last: 'DERNIÈRES',
            withdrawalRequests: 'DEMANDES DE RETRAIT',
            time: 'Date',
            currency: 'Devise',
            info: 'Info',
            status: 'Statut',
            bank: 'Banque',
            bitcoin: 'Bitcoin',
            card: 'Carte',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Détails du retrait',
            address: 'Adresse du portefeuille',
            bankAccount: 'Numéro de compte',
            bankHolder: 'Nom du titulaire du compte',
            bankIban: 'IBAN',
            bankSwift: 'Code SWIFT de la banque',
            sortCode: 'Sort Code',
            ifscCode: 'Code IFSC',
            bankCode: "Code bancaire (BSB)",
            bankName: 'Nom de la banque',
            bankBranch: 'Agence bancaire',
            cardNumber: 'Numéro de la carte',
            cardHolder: 'Nom du titulaire de la carte',
            incorrectAmountByFreeMargin: 'Le montant est incorrect, vous pouvez retirer au maximum le montant de la marge libre',
            closeOrders: 'avant de clôturer tous les ordres'
        },
        fullScreenVerification: {
            dragAndDrop: 'glissez et déposez le document dans cette zone',
            documentsList: 'LISTE DES DOCUMENTS ENVOYÉS',
            document: 'Document',
            timeUploaded: 'Date d\'envoi',
            timeProcessed: 'Date de traitement',
            status: 'Statut',
            types: ['Pièce d\'identité', 'Justificatif de domicile', 'Recto de la carte de crédit', 'Verso de la carte de crédit', 'Verso de la pièce d\'identité', 'Selfie','Autre'],
            types2: ['Pièce d\'identité (CARTE D\'IDENTITÉ, PASSEPORT, PERMIS DE CONDUIRE)', 'Justificatif de domicile (facture de services ou relevé bancaire)', 'Recto de la carte de crédit', 'Verso de la carte de crédit', 'Verso de la pièce d\'identité (VERSO DE LA CARTE D\'IDENTITÉ, VERSO DU PERMIS DE CONDUIRE)', 'Selfie','Autre'],
            upload: 'Envoyer',
            isConfirmed: 'est confirmé',
            uploadAnotherDocument: 'Envoyer un autre document',
            isUnderReview: 'est en cours d\'examen',
            questionnaire: 'Questionnaire',
            sendAnswers: 'Envoyer les réponses',
            progressBarOf: 'sur',
            progressBarText: 'de vos documents ont été envoyés et confirmés'
        },
        fullScreenAccounts: {
            manageAccounts: 'Transférer des fonds entre vos comptes',
            transferFrom: 'Depuis le compte',
            transferTo: 'Vers le compte',
            amount: 'Montant',
            makeTransfer: 'Effectuer un transfert',
            yourAccounts: 'Vos comptes',
            account: 'Compte',
            currency: 'Devise',
            balance: 'Solde',
            credit: 'Crédit',
            makeActive: 'Rendre actif',
            active: 'Actif'
        },
        fullScreenSupport: {
            chatOff: 'Le chat sera disponible les jours ouvrables',
            sendMessage: 'Envoyer un message',
            responseTime: 'Temps de réponse moyen : 1-24h',
        },
        fullScreenSavings: {
            pct_0: 'Flexible',
            pct_30: 'Verrouillé 1 mois',
            pct_90: 'Verrouillé 1 trimestre',
            pct_180: 'Verrouillé 6 mois',
            pct_365: 'Verrouillé 1 an',
            pct_730: 'Verrouillé 2 ans',
            savings: 'Épargne',
            detailedInformation: 'Informations détaillées',
            pleaseSelect: 'Veuillez sélectionner une devise et une période',
            openSavings: 'Ouvrir une épargne',
            currentTime: 'Heure actuelle',
            releaseTime: 'Date de déblocage',
            currencyChosen: 'Devise choisie',
            periodChosen: 'Période choisie',
            yourRate: 'Votre taux',
            yourAnnualRate: 'Votre taux annuel',
            yourEarnings: 'Vos revenus',
            accountFrom: 'Compte à débiter',
            enterAmount: 'Entrez le montant',
            in: 'En',
            openAndInvest: 'Ouvrir un compte d\'épargne et investir',
            investment: 'Investissement',
            period: 'Période',
            daysTotal: 'Nombre total de jours',
            finalEarnings: 'Revenus finaux',
            created: 'Créé',
            daysElapsed: 'Jours écoulés',
            days: 'jours',
            earnings: 'Revenus',
            fundsReleasedIn: 'Fonds débloqués dans',
            claim: 'Réclamer',
        },
        fullScreenSettings: {
            updatePassword: 'METTRE À JOUR LE MOT DE PASSE',
            currentPassword: 'Mot de passe actuel',
            newPassword: 'Nouveau mot de passe',
            changePassword: 'Changer le mot de passe',
            activationForGoogle: 'Code d\'activation pour Google Authenticator',
            activateAndEnter: 'Activez l\'Authenticator et entrez un code généré dans le champ ci-dessous.',
            qrCode: 'QR Code',
            activateProtection: 'Activer la protection 2FA',
            protectionActive: 'La protection 2FA est active',
            twoFactorCode: 'Code 2FA',
            disableProtection: 'Désactiver la protection 2FA',
            language: 'Langue',
            dashboardCurrency: 'Devise du tableau de bord',
            confirmNewPassword: 'Confirmer le nouveau mot de passe',
        },
        fullScreenReferrals: {
            yourLink: 'VOTRE LIEN DE PARRAINAGE',
            referredFriends: 'AMIS PARRAINÉS',
            id: 'ID',
            name: 'Nom',
            registered: 'Inscription',
            level: 'Niveau',
            payout: 'Paiement',
            lastPayouts: 'DERNIERS PAIEMENTS DE PARRAINAGE',
            time: 'Date',
            amount: 'Montant',
            currency: 'Devise',
            info: 'Info'
        },
        months: {
            Jan: 'Jan',
            Feb: 'Fév',
            Mar: 'Mar',
            Apr: 'Avr',
            May: 'Mai',
            Jun: 'Juin',
            Jul: 'Juil',
            Aug: 'Aoû',
            Sep: 'Sep',
            Oct: 'Oct',
            Nov: 'Nov',
            Dec: 'Déc'
        },
        orderTypes: ['Achat', 'Vente', 'Buy Limit', 'Sell Limit', 'Buy Stop', 'Sell Stop'],
        statuses: ['En attente', 'Approuvé', 'Refusé', 'En traitement',`En cours d'examen`,'En cours','Annulé'],
        errors: {
            INVALID_FIELDS: 'Veuillez vérifier que les données saisies sont correctes',
            NOT_FOUND: 'Erreur de demande',
            FORBIDDEN: 'Accès refusé. Veuillez vous reconnecter',
            SERVER_ERROR: 'L\'action a échoué. Veuillez réessayer plus tard',
            INVALID_ACCOUNT: 'La session a expiré. Veuillez vous reconnecter',
            INVALID_EMAIL: 'Adresse e-mail non valide',
            INVALID_PHONE: 'Numéro de téléphone non valide',
            INVALID_COUNTRY: 'Pays non valide',
            INVALID_LOGIN: 'Identifiants de connexion non valides',
            USER_BLOCKED: 'Le compte est bloqué. Veuillez contacter le support',
            USER_REGISTERED: 'Un utilisateur avec cette adresse e-mail ou ce numéro de téléphone est déjà inscrit',
            INVALID_USER: 'Utilisateur introuvable',
            REJECTED: 'L\'opération n\'est pas autorisée en raison des restrictions de la plateforme',
            INVALID_OLD_PASSWORD: 'L\'ancien mot de passe n\'est pas valide',
            INVALID_SYMBOL: 'Symbole de trading non valide',
            INVALID_SYMBOL_PRECISION: 'Précision du symbole non valide',
            INVALID_FRAME: 'Cadre graphique non valide',
            INVALID_CURRENCY: 'Devise non valide',
            INVALID_PRODUCT: 'Type de trading du compte non valide',
            INSUFFICIENT_FUNDS: 'Fonds insuffisants',
            INVALID_WITHDRAWAL: 'Retrait introuvable',
            INVALID_DEPOSIT: 'Ce dépôt ne peut plus être annulé : il est introuvable ou a déjà été traité',
            INVALID_STATUS: 'Statut non valide',
            INVALID_FILE: 'Extension de fichier non valide ou fichier trop volumineux',
            INVALID_DOCUMENT: 'Document introuvable',
            INVALID_NAME: 'Nom non valide',
            INVALID_LOT_SIZE: 'Taille de lot non valide',
            INVALID_LOT_STEP: 'Pas du lot non valide',
            INVALID_MIN_VOLUME: 'Volume minimal non valide',
            INVALID_MAX_VOLUME: 'Volume maximal non valide',
            INVALID_GROUP: 'Groupe non valide',
            INVALID_SPREAD: 'Spread non valide',
            REQUEST_TIMEOUT: 'La demande a expiré. Veuillez réessayer plus tard',
            INVALID_TYPE: 'Type d\'ordre non valide',
            INVALID_VOLUME: 'Volume de l\'ordre non valide',
            INVALID_SL: 'Valeur de Stop Loss non valide',
            INVALID_TP: 'Valeur de Take Profit non valide',
            INVALID_PRICE: 'Prix de l\'ordre non valide',
            INVALID_EXPIRATION: 'Échéance de l\'ordre non valide',
            NOT_ENOUGH_MARGIN: 'Marge insuffisante',
            INVALID_ORDER: 'Ordre introuvable',
            MARKET_CLOSED: 'Le trading n\'est pas disponible. Veuillez réessayer',
            INVALID_BALANCE_TYPE: 'Type d\'opération de solde non valide',
            INVALID_HASH: 'Hachage non valide',
            HASH_EXPIRED: 'Le lien de réinitialisation de votre mot de passe a expiré. Veuillez en demander un nouveau',
            INVALID_CODE: 'Code 2FA non valide',
            CHAT_DISABLED: 'L\'accès au chat d\'assistance a été fermé',
            WITHDRAWAL_NOT_ALLOWED: 'L\'accès aux retraits a été fermé',
            TRADING_DISABLED: 'Le trading est désactivé pour ce compte',
            PENDING_DEPOSITS_LIMIT: 'Limite de dépôts dépassée',
            CLOSE_OPEN_ORDERS: 'Veuillez clôturer vos ordres ouverts',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Une seule demande de retrait en attente est autorisée',
            LOCAL_DEPOSIT_ONLY_REAL: 'Le dépôt est disponible uniquement sur un compte réel',
            LOCAL_DEPOSIT_POSITIVE: 'Le montant du dépôt doit être supérieur à 0',
            LOCAL_INVALID_CARD_NUMBER: 'Numéro de carte non valide',
            LOCAL_INVALID_CARD_EXPIRATION: 'Date d\'expiration de la carte non valide',
            LOCAL_INVALID_CVC: 'Code CVV/CVC non valide',
            LOCAL_PASSWORDS_NOT_MATCH: 'Les mots de passe ne correspondent pas, veuillez les saisir à nouveau',
            LOCAL_NO_TRADING_ACCOUNTS: 'Vous n\'avez aucun compte de trading disponible. Veuillez contacter le support',
            LOCAL_MIN_DEPOSIT: 'Le dépôt minimum est de $',
            LOCAL_MIN_WITHDRAWAL: 'Le montant minimum de retrait est de $',
            LOCAL_INVALID_FILE_TYPE: 'Format de fichier non pris en charge. Veuillez joindre uniquement des fichiers JPG, PNG ou PDF',
            FLOOD_REJECTED: 'Vous envoyez des messages trop souvent. Veuillez réessayer plus tard',
            LOCAL_MIN_STAKING: 'Le dépôt minimum pour cette devise est de ',
            REGISTRATIONS_BLOCKED: "Merci pour votre demande, Un de nos représentants vous contactera dès que possible",
        },
        countries: {
            AF: 'Afghanistan',
            AX: 'Îles Åland',
            AL: 'Albanie',
            DZ: 'Algérie',
            AS: 'Samoa américaines',
            AD: 'Andorre',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarctique',
            AG: 'Antigua-et-Barbuda',
            AR: 'Argentine',
            AM: 'Arménie',
            AW: 'Aruba',
            AU: 'Australie',
            AT: 'Autriche',
            AZ: 'Azerbaïdjan',
            BS: 'Bahamas',
            BH: 'Bahreïn',
            BD: 'Bangladesh',
            BB: 'Barbade',
            BY: 'Biélorussie',
            BE: 'Belgique',
            BZ: 'Belize',
            BJ: 'Bénin',
            BM: 'Bermudes',
            BT: 'Bhoutan',
            BO: 'Bolivie',
            BA: 'Bosnie-Herzégovine',
            BW: 'Botswana',
            BV: 'Île Bouvet',
            BR: 'Brésil',
            IO: 'Territoire britannique de l\'océan Indien',
            BN: 'Brunéi Darussalam',
            BG: 'Bulgarie',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambodge',
            CM: 'Cameroun',
            CA: 'Canada',
            CV: 'Cap-Vert',
            KY: 'Îles Caïmans',
            CF: 'République centrafricaine',
            TD: 'Tchad',
            CL: 'Chili',
            CN: 'Chine',
            CX: 'Île Christmas',
            CC: 'Îles Cocos (Keeling)',
            CO: 'Colombie',
            KM: 'Comores',
            CG: 'Congo',
            CD: 'Congo, République démocratique',
            CK: 'Îles Cook',
            CR: 'Costa Rica',
            CI: 'Côte d\'Ivoire',
            HR: 'Croatie',
            CU: 'Cuba',
            CY: 'Chypre',
            CZ: 'République tchèque',
            DK: 'Danemark',
            DJ: 'Djibouti',
            DM: 'Dominique',
            DO: 'République dominicaine',
            EC: 'Équateur',
            EG: 'Égypte',
            SV: 'Salvador',
            GQ: 'Guinée équatoriale',
            ER: 'Érythrée',
            EE: 'Estonie',
            ET: 'Éthiopie',
            FK: 'Îles Falkland (Malouines)',
            FO: 'Îles Féroé',
            FJ: 'Fidji',
            FI: 'Finlande',
            FR: 'France',
            GF: 'Guyane française',
            PF: 'Polynésie française',
            TF: 'Terres australes françaises',
            GA: 'Gabon',
            GM: 'Gambie',
            GE: 'Géorgie',
            DE: 'Allemagne',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Grèce',
            GL: 'Groenland',
            GD: 'Grenade',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernesey',
            GN: 'Guinée',
            GW: 'Guinée-Bissau',
            GY: 'Guyana',
            HT: 'Haïti',
            HM: 'Îles Heard-et-MacDonald',
            VA: 'Saint-Siège (État de la Cité du Vatican)',
            HN: 'Honduras',
            HK: 'Hong Kong',
            HU: 'Hongrie',
            IS: 'Islande',
            IN: 'Inde',
            ID: 'Indonésie',
            IR: 'Iran',
            IQ: 'Irak',
            IE: 'Irlande',
            IM: 'Île de Man',
            IL: 'Israël',
            IT: 'Italie',
            JM: 'Jamaïque',
            JP: 'Japon',
            JE: 'Jersey',
            JO: 'Jordanie',
            KZ: 'Kazakhstan',
            KE: 'Kenya',
            KI: 'Kiribati',
            KR: 'Corée',
            KW: 'Koweït',
            KG: 'Kirghizistan',
            LA: 'République démocratique populaire lao',
            LV: 'Lettonie',
            LB: 'Liban',
            LS: 'Lesotho',
            LR: 'Libéria',
            LY: 'Jamahiriya arabe libyenne',
            LI: 'Liechtenstein',
            LT: 'Lituanie',
            LU: 'Luxembourg',
            MO: 'Macao',
            MK: 'Macédoine',
            MG: 'Madagascar',
            MW: 'Malawi',
            MY: 'Malaisie',
            MV: 'Maldives',
            ML: 'Mali',
            MT: 'Malte',
            MH: 'Îles Marshall',
            MQ: 'Martinique',
            MR: 'Mauritanie',
            MU: 'Maurice',
            YT: 'Mayotte',
            MX: 'Mexique',
            FM: 'Micronésie',
            MD: 'Moldavie',
            MC: 'Monaco',
            MN: 'Mongolie',
            ME: 'Monténégro',
            MS: 'Montserrat',
            MA: 'Maroc',
            MZ: 'Mozambique',
            MM: 'Myanmar',
            NA: 'Namibie',
            NR: 'Nauru',
            NP: 'Népal',
            NL: 'Pays-Bas',
            AN: 'Antilles néerlandaises',
            NC: 'Nouvelle-Calédonie',
            NZ: 'Nouvelle-Zélande',
            NI: 'Nicaragua',
            NE: 'Niger',
            NG: 'Nigéria',
            NU: 'Niue',
            NF: 'Île Norfolk',
            MP: 'Îles Mariannes du Nord',
            NO: 'Norvège',
            OM: 'Oman',
            PK: 'Pakistan',
            PW: 'Palaos',
            PS: 'Territoire palestinien occupé',
            PA: 'Panama',
            PG: 'Papouasie-Nouvelle-Guinée',
            PY: 'Paraguay',
            PE: 'Pérou',
            PH: 'Philippines',
            PN: 'Pitcairn',
            PL: 'Pologne',
            PT: 'Portugal',
            PR: 'Porto Rico',
            QA: 'Qatar',
            RE: 'Réunion',
            RO: 'Roumanie',
            RU: 'Russie',
            RW: 'Rwanda',
            BL: 'Saint-Barthélemy',
            SH: 'Sainte-Hélène',
            KN: 'Saint-Kitts-et-Nevis',
            LC: 'Sainte-Lucie',
            MF: 'Saint-Martin',
            PM: 'Saint-Pierre-et-Miquelon',
            VC: 'Saint-Vincent-et-les-Grenadines',
            WS: 'Samoa',
            SM: 'Saint-Marin',
            ST: 'Sao Tomé-et-Principe',
            SA: 'Arabie saoudite',
            SN: 'Sénégal',
            RS: 'Serbie',
            SC: 'Seychelles',
            SL: 'Sierra Leone',
            SG: 'Singapour',
            SK: 'Slovaquie',
            SI: 'Slovénie',
            SB: 'Îles Salomon',
            SO: 'Somalie',
            ZA: 'Afrique du Sud',
            GS: 'Géorgie du Sud et îles Sandwich',
            ES: 'Espagne',
            LK: 'Sri Lanka',
            SD: 'Soudan',
            SR: 'Suriname',
            SJ: 'Svalbard et Jan Mayen',
            SZ: 'Swaziland',
            SE: 'Suède',
            CH: 'Suisse',
            SY: 'République arabe syrienne',
            TW: 'Taïwan',
            TJ: 'Tadjikistan',
            TZ: 'Tanzanie',
            TH: 'Thaïlande',
            TL: 'Timor-Leste',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinité-et-Tobago',
            TN: 'Tunisie',
            TR: 'Turquie',
            TM: 'Turkménistan',
            TC: 'Îles Turques-et-Caïques',
            TV: 'Tuvalu',
            UG: 'Ouganda',
            UA: 'Ukraine',
            AE: 'Émirats arabes unis',
            GB: 'Royaume-Uni',
            US: 'États-Unis',
            UM: 'Îles mineures éloignées des États-Unis',
            UY: 'Uruguay',
            UZ: 'Ouzbékistan',
            VU: 'Vanuatu',
            VE: 'Venezuela',
            VN: 'Viêt Nam',
            VG: 'Îles Vierges britanniques',
            VI: 'Îles Vierges américaines',
            WF: 'Wallis-et-Futuna',
            EH: 'Sahara occidental',
            YE: 'Yémen',
            ZM: 'Zambie',
            ZW: 'Zimbabwe'
        },
    },
    es: {
        _name: 'Español',
        autoCloseModal: {
            takeProfitStopLoss: 'Take Profit y Stop Loss',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            updateOrder: 'Actualizar orden',
        },
        balanceModal: {
            balance: 'Saldo',
            credit: 'Crédito',
            equity: 'Capital',
            practice: 'PRÁCTICA',
            real: 'REAL',
            account: 'CUENTA',
            invested: 'Invertido',
            profit: 'Beneficio',
            loss: 'Pérdida',
            margin: 'Margen',
            marginLevel: 'Nivel de margen',
            marginFree: 'Margen libre'
        },
        header: {
            cfd: 'CFD',
            platform: 'Plataforma',
            deposit: 'Depositar',
            myAccount: 'Mi cuenta'
        },
        sideMenu: {
            marketWatch: 'Observación del mercado',
            activeOrders: 'Órdenes activas',
            tradingHistory: 'Historial de operaciones',
            economicCalendar: 'Calendario económico',
            marketNews: 'Noticias del mercado'
        },
        closePositionModal: {
            closeOrder: 'Cerrar Posición',
            areYouSure: '¿Está seguro de cerrar la posición?',
            buy: 'Comprar',
            sell: 'Vender',
            yes: 'Sí',
            no: 'No',
        },
        chart: {
            addNewChart: 'Agregar nuevo gráfico',
        },
        symbolsModal: {
            watchlist: 'Lista de seguimiento',
            asset: 'Activo',
            price: 'Precio',
            changePct: 'Cambio 24h'
        },
        pendingModal: {
            pending: 'Pendiente',
            assetPrice: 'Precio del activo',
            current: 'Actual',
            revert: 'Volver al precio de mercado',
            automatically: 'La posición se abrirá automáticamente cuando el precio alcance este nivel'
        },
        orderMenu: {
            volume: 'Volumen',
            lots: 'lotes',
            units: 'unidades',
            currency: 'divisa',
            contractSize: 'Tamaño del contrato',
            position: 'Posición',
            margin: 'Margen',
            freeMargin: 'Margen libre',
            takeProfitStopLoss: 'Take Profit y Stop Loss',
            pending: 'Pendiente',
            market: 'Mercado',
            leverage: 'Apalancamiento',
            spread: 'Spread',
            notSet: 'No establecido',
            at: 'a',
            buy: 'comprar',
            sell: 'vender',
        },
        footer: {
            supportBanner: 'TODOS LOS DÍAS, LAS 24 HORAS',
            currentTime: 'HORA ACTUAL',
            liveChat: 'Chat en vivo'
        },
        statusBar: {
            balance: 'Saldo',
            credit: 'Crédito',
            equity: 'Capital',
            margin: 'Margen',
            marginLevel: 'Nivel de margen',
            freeMargin: 'Margen libre',
            pnl: 'PnL',
            profitTotal: 'PnL total'
        },
        accountModal: {
            dateRegistered: 'Fecha de registro',
            userId: 'ID de usuario',
            dashboard: 'Panel',
            personalData: 'Datos personales',
            deposit: 'Depositar',
            withdrawFunds: 'Retirar fondos',
            savings: 'Ahorros',
            settings: 'Ajustes',
            logout: 'Cerrar sesión'
        },
        depositModal: {
            BT_INVOICE: 'Introduzca el monto y genere la factura',
            BT_TITLE: 'Nuestros datos bancarios',
            PENDING_DEPOSITS_LIMIT: 'Límite de depósito',
            BT_ACCOUNT: 'Cuenta',
            BT_BANK_NAME: 'Nombre del banco',
            BT_BENEFICIARY: 'Beneficiario',
            BT_ADDRESS: 'Dirección del beneficiario',
            BT_SWIFT: 'SWIFT',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Código de referencia bancaria',
            BT_INN: 'INN',
            BT_KPP: 'Cuenta corresponsal',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: 'Monto',
            TOKEN_SUBTOTAL: 'Subtotal',
            TOKEN_TOTAL: 'Total',
            TOKEN_DESCRIPTION: 'Descripción',
            TOKEN_PAYMENT_DETAILS: 'Detalles del pago',
            makeDeposit: 'Hacer un depósito',
            practiceAccount: 'Cuenta de práctica',
            realAccount: 'Cuenta real',
            noWithdrawals: 'Sin retiros',
            easyWithdrawals: 'Retiros fáciles',
            allAssets: 'Todos los activos disponibles',
            fullFledged: 'Plataforma completa',
            fillUpTo: 'Recargar hasta',
            freeReplenishment: 'Reposición gratuita',
            topUp: 'Recargue su cuenta',
            minimumAmount: 'Monto mínimo',
            canSwitch: 'Puede cambiar entre sus cuentas en cualquier momento'
        },
        gridsModal: {
            chartGrids: 'CUADRÍCULAS DE GRÁFICOS',
            chart1: '1 gráfico',
            chart2: '2 gráficos',
            chart3: '3 gráficos',
            chart4: '4 gráficos',
        },
        noConnectionModal: {
            connectionLost: 'Se perdió la conexión con el servidor',
            retryNow: 'Reintentar ahora',
        },
        loginModal: {
            loginToTradeRoom: 'Iniciar sesión en Traderoom',
            email: 'Dirección de correo electrónico',
            emailAndId: 'Dirección de correo electrónico / Número de ID',
            enterEmail: 'Introduzca su correo electrónico',
            twoFactor: 'Código 2FA (si está activado)',
            twoFactorAuth: 'Verificación en dos pasos',
            password: 'Contraseña',
            yourPassword: 'Su contraseña',
            signIn: 'Iniciar sesión',
            dontHaveAccount: '¿No tiene una cuenta?',
            restore: 'Restaurar',
            fullName: 'Nombre completo',
            havePromo: 'Tengo un código promocional',
            promo: 'Código promocional',
            login: 'Iniciar sesión',
            haveAccount: '¿Ya tiene una cuenta?',
            hide: 'Ocultar',
            goTo: 'Volver'
        },
        newPasswordModal: {
            setNewPassword: 'Establecer nueva contraseña',
            newPassword: 'Nueva contraseña',
            confirmNewPassword: 'Confirmar nueva contraseña',
            setButton: 'Establecer'
        },
        registerModal: {
            createNewAccount: 'Crear una cuenta nueva',
            email: 'Dirección de correo electrónico',
            firstName: 'Nombre',
            lastName: 'Apellido',
            country: 'País',
            phone: 'Teléfono',
            password: 'Contraseña',
            createAccount: 'Crear una cuenta',
            currency: 'Divisa'
        },
        forgotPasswordModal: {
            forgotPassword: '¿Ha olvidado su contraseña?',
            submitEmail: 'Introduzca el correo electrónico utilizado en el registro, revise su bandeja de entrada y siga las instrucciones.',
            submit: 'Enviar'
        },
        notifications: {
            error: 'Error',
            success: 'Éxito',
            deposit: 'Depósito',
            withdrawal: 'Retiro',
            depositApproved: 'El depósito ha sido aprobado',
            depositDeclined: 'El depósito ha sido rechazado',
            withdrawalApproved: 'El retiro ha sido aprobado',
            withdrawalDeclined: 'El retiro ha sido rechazado',
            withdrawalCancelled: 'El retiro ha sido cancelado',
            orderRejected: 'Orden rechazada',
            insufficientMargin: 'No se pudo abrir su orden pendiente: no hay suficiente margen libre',
            marginCall: 'Llamada de margen',
            marginCallText: 'Realice un depósito para cumplir con los requisitos de margen'
        },
        markets: {
            forex: 'Forex',
            stocks: 'Acciones',
            commodities: 'Materias primas',
            indices: 'Índices',
            crypto: 'Cripto',
            metals: 'Metales',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            buy: 'COMPRA',
            profitCalculator: 'Calculadora de beneficios',
            sell: 'VENTA',
            volume: 'Volumen',
            entryPrice: 'Precio de entrada',
            takeProfit: 'Take Profit',
            stopLoss: 'Stop Loss',
            maxPosition: 'Posición máxima',
            calculate: 'Calcular',
            calculationsFor: 'Cálculos para',
            leverage: 'Apalancamiento',
            requiredMargin: 'Margen requerido',
            profitFromTP: 'Beneficio del TP',
            lossFromSL: 'Pérdida del SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Depósito realizado',
            text: '¡Su depósito se ha procesado correctamente!',
        },
        depositFailModal: {
            title: 'Depósito fallido',
            text: 'Su depósito no se ha procesado.',
        },
        widgetMarketWatch: {
            marketWatch: 'Observación del mercado',
            search: 'Buscar...',
        },
        widgetOrders: {
            commission: 'Comisión',
            volume: 'Volumen',
            margin: 'Margen',
            active: 'Activo',
            pending: 'Pendiente',
            activeOrders: 'Órdenes activas',
            portfolio: 'Cartera',
            allPositions: 'Todas las posiciones',
            noPositionsLine1: 'Todavía no tiene',
            noPositionsLine2: 'posiciones abiertas',
            show: 'Mostrar',
            more: 'más',
            less: 'menos',
            purchaseTime: 'Hora de compra',
            closePosition: 'Cerrar posición',
            priceOpen: 'Precio de compra',
            priceSl: 'Precio de Stop Loss',
            priceTp: 'Precio de Take Profit',
            type: 'Dirección de la posición',
            pnl: 'Beneficio/Pérdida',
            cancelOrder: 'Cancelar orden',
            orderType: 'Tipo de orden',
            cancelled: 'Cancelado',
            tradingHistory: 'Historial de operaciones',
            noHistoryLine1: 'Todavía no tiene',
            noHistoryLine2: 'operaciones cerradas',
            sortByTime: 'Ordenar por hora',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Calendario económico'
        },
        widgetMarketNews: {
            marketNews: 'Noticias de mercado'
        },
        ordersPane: {
            ordersActive: 'Órdenes activas',
            ordersHistory: 'Historial de órdenes',
            id: 'ID',
            symbol: 'Símbolo',
            type: 'Tipo',
            volume: 'Volumen',
            openPrice: 'Precio de apertura',
            openTime: 'Hora de apertura',
            closePrice: 'Precio de cierre',
            closeTime: 'Hora de cierre',
            sl: 'SL',
            tp: 'TP',
            price: 'Precio',
            pnl: 'PnL',
            actions: 'Acciones',
            edit: 'Editar',
            close: 'Cerrar',
            commission: 'Comisión',
            swap: 'Swap',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short'
        },
        assetInfoModal: {
            assetInfo: 'Información del activo',
            tradingConditions: 'Condiciones de trading',
            information: 'Información',
            bid: 'Bid',
            ask: 'Ask',
            sessionChange: 'Cambio de la sesión',
            tradeNow: 'Operar ahora',
            opens: 'Abre',
            closes: 'Cierra',
            at: 'a las',
            open247: 'Abierto 24/7',
            today: 'hoy',
            tomorrow: 'mañana',
            sunday: 'Domingo',
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes',
            saturday: 'Sábado',
            contractSpecification: 'Especificación del contrato',
            symbol: 'Símbolo',
            name: 'Nombre',
            market: 'Mercado',
            baseCurrency: 'Divisa base',
            digits: 'Decimales',
            lotSize: 'Tamaño del lote',
            lotStep: 'Paso del lote',
            minVolume: 'Volumen mín.',
            maxVolume: 'Volumen máx.',
            leverage: 'Apalancamiento',
            commission: 'Comisión',
            swapLong: 'Swap Long',
            swapShort: 'Swap Short',
            schedule: 'Horario',
            weekday: 'Día',
            tradingTime: 'Horario de trading',
            closed: 'cerrado',
            sell: 'Venta',
            buy: 'Compra',
            low: 'Mínimo',
            high: 'Máximo',
            oneHourChange: 'Cambio 1 hora',
            oneDayChange: 'Cambio 1 día',
            oneWeekChange: 'Cambio 1 semana',
            oneMonthChange: 'Cambio 1 mes',
            threeMonthsChange: 'Cambio 3 meses',
            oneYearChange: 'Cambio 1 año',
            loading: 'Cargando...',
        },
        fullScreen: {
            startTrading: 'Empezar a operar',
            deposit: 'Depositar',
            dashboard: 'Panel',
            personalInfo: 'Datos personales',
            withdrawal: 'Retiro',
            verification: 'Verificación',
            accounts: 'Cuentas',
            liveChat: 'Chat en vivo',
            savings: 'Ahorros',
            settings: 'Ajustes',
            logOut: 'Cerrar sesión',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'ELIJA UNA CRIPTOMONEDA',
            name: 'Nombre del titular de la tarjeta',
            address: 'Dirección',
            DOB: 'Fecha de nacimiento',
            bankName: 'Nombre del banco',
            additionalInfo: 'Para depositar más en su cuenta, póngase en contacto directamente con su gestor de cuenta',
            additionalInfoOnlyBTCpsp: 'Para habilitar otros métodos de pago, complete la verificación KYC o contacte con su gestor de cuenta',
            sofortPspMessage: 'Nuestro equipo financiero se pondrá en contacto con usted para ayudarle a realizar un depósito',
            addWalletAddress: 'La cartera para este método no está configurada. Póngase en contacto con su agente o con atención al cliente.',
            addressReceipt: 'Espere a que se cargue la dirección',
            makeDeposit: 'HACER UN DEPÓSITO',
            instant: 'Instantáneo',
            minutes: 'minutos',
            hours: 'horas',
            days: 'días',
            amount: 'Monto',
            continue: 'Continuar',
            qrCode: 'CÓDIGO QR',
            depositAddress: 'DIRECCIÓN DE DEPÓSITO',
            copy: 'Copiar',
            last: 'ÚLTIMOS',
            deposits: 'DEPÓSITOS',
            time: 'Hora',
            currency: 'Divisa',
            status: 'Estado',
            info: 'Información',
        },
        fullScreenCcExt: {
            pleaseWait: 'Espere, por favor. Conectando con el proveedor de servicios de pago...',
            cardPayment: 'Pago con tarjeta',
            inOrder: 'Para enviar el importe',
            pleaseProvide: 'proporcione los datos de la tarjeta:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Impuestos totales',
            totalBalance: 'Saldo total',
            totalPnl: 'PnL total',
            profitableOrders: 'Órdenes rentables',
            roi: 'ROI',
            activityLog: 'Registro de actividad',
            loginFromIp: 'Inicio de sesión desde IP',
            tradingResults: 'Resultados de trading',
            week: 'Semana',
            month: 'Mes',
            year: 'Año',
            successRate: 'Tasa de éxito',
            closedWithProfit: 'Cerrado con beneficio',
            closedWithLoss: 'Cerrado con pérdida',
            account: 'Cuenta',
            balance: 'Saldo',
            leverage: 'Apalancamiento',
            credit: 'Crédito',
            tradeNow: 'Operar ahora',
            usingCurrentRate: 'usando el tipo de cambio actual',
            totalDeposits: 'Depósitos totales'
        },
        fullScreenPersonal: {
            personalDetails: 'Detalles personales',
            profilePhoto: 'Foto de perfil',
            firstName: 'Nombre',
            country: 'País',
            lastName: 'Apellido',
            address: 'Dirección',
            email: 'Correo electrónico',
            phone: 'Número de teléfono',
            saveChanges: 'Guardar cambios'
        },
        fullScreenAvatar: {
            dropFile: 'Soltar un archivo en el círculo de arriba para subirlo',
            notAllowed: 'No está permitido publicar',
            notAllowedLine1: 'Fotos de carácter explícitamente sexual o pornográfico',
            notAllowedLine2: 'Imágenes destinadas a incitar al odio o la agresión étnica o racial',
            notAllowedLine3: 'Fotos de personas menores de 18 años',
            notAllowedLine4: 'Fotos protegidas por derechos de autor de terceros',
            notAllowedLine5: 'Imágenes de más de 5 MB y en un formato que no sea JPG, GIF o PNG',
            requirements: 'Su cara debe ser claramente visible en la foto. Todas las fotos y videos subidos por usted deben cumplir con estos requisitos, de lo contrario, pueden ser eliminados.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Retiro',
            requestNewWithdrawal: 'SOLICITAR UN NUEVO RETIRO',
            amount: 'Monto',
            currentBalance: 'El saldo actual de su cuenta es',
            withdrawAll: 'Retirar todo',
            requestWithdrawal: 'Solicitar retiro',
            last: 'ÚLTIMAS',
            withdrawalRequests: 'SOLICITUDES DE RETIRO',
            time: 'Hora',
            currency: 'Divisa',
            info: 'Información',
            status: 'Estado',
            bank: 'Banco',
            bitcoin: 'Bitcoin',
            card: 'Tarjeta',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Detalles del retiro',
            address: 'Dirección de la billetera',
            bankAccount: 'Número de cuenta',
            bankHolder: 'Nombre del titular de la cuenta',
            bankIban: 'IBAN',
            bankSwift: 'Código SWIFT del banco',
            sortCode: 'Sort Code',
            ifscCode: 'Código IFSC',
            bankCode: "Código bancario (BSB)",
            bankName: 'Nombre del banco',
            bankBranch: 'Sucursal bancaria',
            cardNumber: 'Número de tarjeta',
            cardHolder: 'Nombre del titular de la tarjeta',
            incorrectAmountByFreeMargin: 'El monto no es correcto: puede retirar el importe del margen libre',
            closeOrders: 'antes cierre todas las órdenes'
        },
        fullScreenVerification: {
            dragAndDrop: 'arrastre y suelte el documento en esta área',
            documentsList: 'LISTA DE DOCUMENTOS SUBIDOS',
            document: 'Documento',
            timeUploaded: 'Fecha de subida',
            timeProcessed: 'Fecha de procesamiento',
            status: 'Estado',
            types: ['Documento de identidad', 'Comprobante de domicilio', 'Anverso de la tarjeta de crédito', 'Reverso de la tarjeta de crédito', 'Reverso del documento de identidad', 'Selfie','Otro'],
            types2: ['Documento de identidad (DNI, PASAPORTE, CARNÉ DE CONDUCIR)', 'Comprobante de domicilio (factura de suministro o extracto bancario)', 'Anverso de la tarjeta de crédito', 'Reverso de la tarjeta de crédito', 'Reverso del documento de identidad (DORSO DEL DNI O DEL CARNÉ DE CONDUCIR)', 'Selfie','Otro'],
            upload: 'Subir',
            isConfirmed: 'está confirmado',
            uploadAnotherDocument: 'Subir otro documento',
            isUnderReview: 'está en revisión',
            questionnaire: 'Cuestionario',
            sendAnswers: 'Enviar respuestas',
            progressBarOf: 'de',
            progressBarText: 'de sus documentos se han subido y confirmado'
        },
        fullScreenAccounts: {
            manageAccounts: 'Transferir fondos entre sus cuentas',
            transferFrom: 'De la cuenta',
            transferTo: 'A la cuenta',
            amount: 'Monto',
            makeTransfer: 'Hacer transferencia',
            yourAccounts: 'Sus cuentas',
            account: 'Cuenta',
            currency: 'Divisa',
            balance: 'Saldo',
            credit: 'Crédito',
            makeActive: 'Activar',
            active: 'Activo'
        },
        fullScreenSupport: {
            chatOff: 'El chat estará disponible en días laborables',
            sendMessage: 'Enviar mensaje',
            responseTime: 'Tiempo de respuesta promedio: 1-24h',
        },
        fullScreenSavings: {
            pct_0: 'Flexible',
            pct_30: 'Bloqueado 1 mes',
            pct_90: 'Bloqueado 1 trimestre',
            pct_180: 'Bloqueado 6 meses',
            pct_365: 'Bloqueado 1 año',
            pct_730: 'Bloqueado 2 años',
            savings: 'Ahorros',
            detailedInformation: 'Información detallada',
            pleaseSelect: 'Seleccione una divisa y un período',
            openSavings: 'Abrir ahorro',
            currentTime: 'Hora actual',
            releaseTime: 'Fecha de liberación',
            currencyChosen: 'Divisa elegida',
            periodChosen: 'Período elegido',
            yourRate: 'Su tasa',
            yourAnnualRate: 'Su tasa anual',
            yourEarnings: 'Sus ganancias',
            accountFrom: 'Cuenta desde la que transferir los fondos',
            enterAmount: 'Introduzca el monto',
            in: 'En',
            openAndInvest: 'Abra una cuenta de ahorro e invierta',
            investment: 'Inversión',
            period: 'Período',
            daysTotal: 'Días totales',
            finalEarnings: 'Ganancias finales',
            created: 'Creado',
            daysElapsed: 'Días transcurridos',
            days: 'días',
            earnings: 'Ganancias',
            fundsReleasedIn: 'Fondos liberados en',
            claim: 'Reclamar',
        },
        fullScreenSettings: {
            updatePassword: 'ACTUALIZAR CONTRASEÑA',
            currentPassword: 'Contraseña actual',
            newPassword: 'Nueva contraseña',
            changePassword: 'Cambiar contraseña',
            activationForGoogle: 'Código de activación para Google Authenticator',
            activateAndEnter: 'Active Authenticator e introduzca el código generado en el campo de abajo',
            qrCode: 'Código QR',
            activateProtection: 'Activar protección 2FA',
            protectionActive: 'La protección 2FA está activada',
            twoFactorCode: 'Código 2FA',
            disableProtection: 'Desactivar protección 2FA',
            language: 'Idioma',
            dashboardCurrency: 'Divisa del panel',
            confirmNewPassword: 'Confirmar nueva contraseña',
        },
        fullScreenReferrals: {
            yourLink: 'SU ENLACE DE REFERIDO',
            referredFriends: 'AMIGOS REFERIDOS',
            id: 'ID',
            name: 'Nombre',
            registered: 'Registro',
            level: 'Nivel',
            payout: 'Pago',
            lastPayouts: 'ÚLTIMOS PAGOS POR REFERIDOS',
            time: 'Hora',
            amount: 'Monto',
            currency: 'Divisa',
            info: 'Información'
        },
        months: {
            Jan: 'Ene',
            Feb: 'Feb',
            Mar: 'Mar',
            Apr: 'Abr',
            May: 'May',
            Jun: 'Jun',
            Jul: 'Jul',
            Aug: 'Ago',
            Sep: 'Sep',
            Oct: 'Oct',
            Nov: 'Nov',
            Dec: 'Dic'
        },
        orderTypes: ['Compra', 'Venta', 'Buy Limit', 'Sell Limit', 'Buy Stop', 'Sell Stop'],
        statuses: ['Pendiente', 'Aprobado', 'Rechazado', 'Procesando','En revisión','En proceso','Cancelado'],
        errors: {
            INVALID_FIELDS: 'Compruebe que los datos introducidos son correctos',
            NOT_FOUND: 'Error en la solicitud',
            FORBIDDEN: 'Acceso denegado. Vuelva a iniciar sesión',
            SERVER_ERROR: 'La acción ha fallado. Inténtelo de nuevo más tarde',
            INVALID_ACCOUNT: 'La sesión ha expirado. Vuelva a iniciar sesión',
            INVALID_EMAIL: 'Dirección de correo electrónico no válida',
            INVALID_PHONE: 'Número de teléfono no válido',
            INVALID_COUNTRY: 'País no válido',
            INVALID_LOGIN: 'Credenciales de acceso no válidas',
            USER_BLOCKED: 'La cuenta está bloqueada. Póngase en contacto con el soporte',
            USER_REGISTERED: 'El usuario con ese correo electrónico o número de teléfono ya está registrado',
            INVALID_USER: 'No se encuentra al usuario',
            REJECTED: 'La operación no está permitida debido a las restricciones de la plataforma',
            INVALID_OLD_PASSWORD: 'La contraseña antigua no es válida',
            INVALID_SYMBOL: 'Símbolo de trading no válido',
            INVALID_SYMBOL_PRECISION: 'Precisión del símbolo no válida',
            INVALID_FRAME: 'Marco de gráfico no válido',
            INVALID_CURRENCY: 'Divisa no válida',
            INVALID_PRODUCT: 'Tipo de cuenta de trading no válido',
            INSUFFICIENT_FUNDS: 'Fondos insuficientes',
            INVALID_WITHDRAWAL: 'No se encuentra el retiro',
            INVALID_DEPOSIT: 'Este depósito ya no se puede cancelar: no se encontró o ya fue procesado',
            INVALID_STATUS: 'Estado no válido',
            INVALID_FILE: 'Extensión de archivo no válida o archivo demasiado grande',
            INVALID_DOCUMENT: 'No se encuentra el documento',
            INVALID_NAME: 'Nombre no válido',
            INVALID_LOT_SIZE: 'Tamaño de lote no válido',
            INVALID_LOT_STEP: 'Paso de lote no válido',
            INVALID_MIN_VOLUME: 'Volumen mínimo no válido',
            INVALID_MAX_VOLUME: 'Volumen máximo no válido',
            INVALID_GROUP: 'Grupo no válido',
            INVALID_SPREAD: 'Spread no válido',
            REQUEST_TIMEOUT: 'La solicitud ha agotado el tiempo de espera. Inténtelo de nuevo más tarde',
            INVALID_TYPE: 'Tipo de orden no válido',
            INVALID_VOLUME: 'Volumen de la orden no válido',
            INVALID_SL: 'Valor de Stop Loss no válido',
            INVALID_TP: 'Valor de Take Profit no válido',
            INVALID_PRICE: 'Precio de la orden no válido',
            INVALID_EXPIRATION: 'Caducidad de la orden no válida',
            NOT_ENOUGH_MARGIN: 'No hay suficiente margen',
            INVALID_ORDER: 'No se encuentra la orden',
            MARKET_CLOSED: 'La negociación no está disponible. Inténtelo de nuevo',
            INVALID_BALANCE_TYPE: 'Tipo de operación de saldo no válido',
            INVALID_HASH: 'Hash no válido',
            HASH_EXPIRED: 'El enlace de restablecimiento de contraseña ha caducado. Solicite uno nuevo',
            INVALID_CODE: 'Código 2FA no válido',
            CHAT_DISABLED: 'Se ha cerrado el acceso al chat de soporte',
            WITHDRAWAL_NOT_ALLOWED: 'Se ha cerrado el acceso a los retiros',
            TRADING_DISABLED: 'El trading está desactivado para esta cuenta',
            PENDING_DEPOSITS_LIMIT: 'Límite de depósitos superado',
            CLOSE_OPEN_ORDERS: 'Cierre sus órdenes abiertas',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Solo se permite un retiro pendiente',
            LOCAL_DEPOSIT_ONLY_REAL: 'El depósito solo está disponible para cuentas reales',
            LOCAL_DEPOSIT_POSITIVE: 'El monto del depósito debe ser mayor que 0',
            LOCAL_INVALID_CARD_NUMBER: 'Número de tarjeta no válido',
            LOCAL_INVALID_CARD_EXPIRATION: 'Fecha de caducidad de la tarjeta no válida',
            LOCAL_INVALID_CVC: 'Código CVV/CVC no válido',
            LOCAL_PASSWORDS_NOT_MATCH: 'Las contraseñas no coinciden, vuelva a introducirlas',
            LOCAL_NO_TRADING_ACCOUNTS: 'No tiene cuentas de trading disponibles. Póngase en contacto con el soporte',
            LOCAL_MIN_DEPOSIT: 'El depósito mínimo es $',
            LOCAL_MIN_WITHDRAWAL: 'El monto mínimo de retiro es $',
            LOCAL_INVALID_FILE_TYPE: 'Formato de archivo no admitido. Adjunte solo JPG, PNG o PDF',
            LOCAL_MIN_STAKING: 'El depósito mínimo para esta divisa es ',
            FLOOD_REJECTED: 'Está enviando mensajes con demasiada frecuencia. Inténtelo de nuevo más tarde',
            REGISTRATIONS_BLOCKED: "Gracias por su consulta. Uno de nuestros representantes se pondrá en contacto con usted lo antes posible",
        },
        countries: {
            AF: 'Afganistán',
            AX: 'Islas Aland',
            AL: 'Albania',
            DZ: 'Argelia',
            AS: 'Samoa Americana',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguila',
            AQ: 'Antártida',
            AG: 'Antigua y Barbuda',
            AR: 'Argentina',
            AM: 'Armenia',
            AW: 'Aruba',
            AU: 'Australia',
            AT: 'Austria',
            AZ: 'Azerbaiyán',
            BS: 'Bahamas',
            BH: 'Baréin',
            BD: 'Bangladés',
            BB: 'Barbados',
            BY: 'Bielorrusia',
            BE: 'Bélgica',
            BZ: 'Belice',
            BJ: 'Benín',
            BM: 'Bermudas',
            BT: 'Bután',
            BO: 'Bolivia',
            BA: 'Bosnia y Herzegovina',
            BW: 'Botsuana',
            BV: 'Isla Bouvet',
            BR: 'Brasil',
            IO: 'Territorio Británico del Océano Índico',
            BN: 'Brunéi Darussalam',
            BG: 'Bulgaria',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Camboya',
            CM: 'Camerún',
            CA: 'Canadá',
            CV: 'Cabo Verde',
            KY: 'Islas Caimán',
            CF: 'República Centroafricana',
            TD: 'Chad',
            CL: 'Chile',
            CN: 'China',
            CX: 'Isla de Navidad',
            CC: 'Islas Cocos',
            CO: 'Colombia',
            KM: 'Comoras',
            CG: 'Congo',
            CD: 'Congo, República Democrática del',
            CK: 'Islas Cook',
            CR: 'Costa Rica',
            CI: 'Costa de Marfil',
            HR: 'Croacia',
            CU: 'Cuba',
            CY: 'Chipre',
            CZ: 'República Checa',
            DK: 'Dinamarca',
            DJ: 'Yibuti',
            DM: 'Dominica',
            DO: 'República Dominicana',
            EC: 'Ecuador',
            EG: 'Egipto',
            SV: 'El Salvador',
            GQ: 'Guinea Ecuatorial',
            ER: 'Eritrea',
            EE: 'Estonia',
            ET: 'Etiopía',
            FK: 'Islas Malvinas',
            FO: 'Islas Feroe',
            FJ: 'Fiyi',
            FI: 'Finlandia',
            FR: 'Francia',
            GF: 'Guayana Francesa',
            PF: 'Polinesia Francesa',
            TF: 'Territorios Australes Franceses',
            GA: 'Gabón',
            GM: 'Gambia',
            GE: 'Georgia',
            DE: 'Alemania',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Grecia',
            GL: 'Groenlandia',
            GD: 'Granada',
            GP: 'Guadalupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernesey',
            GN: 'Guinea',
            GW: 'Guinea-Bisáu',
            GY: 'Guyana',
            HT: 'Haití',
            HM: 'Islas Heard y McDonald',
            VA: 'Ciudad del Vaticano',
            HN: 'Honduras',
            HK: 'Hong Kong',
            HU: 'Hungría',
            IS: 'Islandia',
            IN: 'India',
            ID: 'Indonesia',
            IR: 'Irán',
            IQ: 'Irak',
            IE: 'Irlanda',
            IM: 'Isla de Man',
            IL: 'Israel',
            IT: 'Italia',
            JM: 'Jamaica',
            JP: 'Japón',
            JE: 'Jersey',
            JO: 'Jordania',
            KZ: 'Kazajistán',
            KE: 'Kenia',
            KI: 'Kiribati',
            KR: 'Corea',
            KW: 'Kuwait',
            KG: 'Kirguistán',
            LA: 'República Democrática Popular Lao',
            LV: 'Letonia',
            LB: 'Líbano',
            LS: 'Lesoto',
            LR: 'Liberia',
            LY: 'Libia',
            LI: 'Liechtenstein',
            LT: 'Lituania',
            LU: 'Luxemburgo',
            MO: 'Macao',
            MK: 'Macedonia',
            MG: 'Madagascar',
            MW: 'Malauí',
            MY: 'Malasia',
            MV: 'Maldivas',
            ML: 'Malí',
            MT: 'Malta',
            MH: 'Islas Marshall',
            MQ: 'Martinica',
            MR: 'Mauritania',
            MU: 'Mauricio',
            YT: 'Mayotte',
            MX: 'México',
            FM: 'Micronesia',
            MD: 'Moldavia',
            MC: 'Mónaco',
            MN: 'Mongolia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MA: 'Marruecos',
            MZ: 'Mozambique',
            MM: 'Birmania',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NL: 'Países Bajos',
            AN: 'Antillas Holandesas',
            NC: 'Nueva Caledonia',
            NZ: 'Nueva Zelanda',
            NI: 'Nicaragua',
            NE: 'Níger',
            NG: 'Nigeria',
            NU: 'Niue',
            NF: 'Isla Norfolk',
            MP: 'Islas Marianas del Norte',
            NO: 'Noruega',
            OM: 'Omán',
            PK: 'Pakistán',
            PW: 'Palaos',
            PS: 'Territorio Palestino Ocupado',
            PA: 'Panamá',
            PG: 'Papúa Nueva Guinea',
            PY: 'Paraguay',
            PE: 'Perú',
            PH: 'Filipinas',
            PN: 'Pitcairn',
            PL: 'Polonia',
            PT: 'Portugal',
            PR: 'Puerto Rico',
            QA: 'Catar',
            RE: 'Reunión',
            RO: 'Rumanía',
            RU: 'Rusia',
            RW: 'Ruanda',
            BL: 'San Bartolomé',
            SH: 'Santa Elena',
            KN: 'San Cristóbal y Nieves',
            LC: 'Santa Lucía',
            MF: 'San Martín',
            PM: 'San Pedro y Miquelón',
            VC: 'San Vicente y las Granadinas',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Santo Tomé y Príncipe',
            SA: 'Arabia Saudita',
            SN: 'Senegal',
            RS: 'Serbia',
            SC: 'Seychelles',
            SL: 'Sierra Leona',
            SG: 'Singapur',
            SK: 'Eslovaquia',
            SI: 'Eslovenia',
            SB: 'Islas Salomón',
            SO: 'Somalia',
            ZA: 'Sudáfrica',
            GS: 'Islas Georgias del Sur y Sandwich del Sur',
            ES: 'España',
            LK: 'Sri Lanka',
            SD: 'Sudán',
            SR: 'Surinam',
            SJ: 'Svalbard y Jan Mayen',
            SZ: 'Suazilandia',
            SE: 'Suecia',
            CH: 'Suiza',
            SY: 'República Árabe Siria',
            TW: 'Taiwán',
            TJ: 'Tayikistán',
            TZ: 'Tanzania',
            TH: 'Tailandia',
            TL: 'Timor Oriental',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad y Tobago',
            TN: 'Túnez',
            TR: 'Turquía',
            TM: 'Turkmenistán',
            TC: 'Islas Turcas y Caicos',
            TV: 'Tuvalu',
            UG: 'Uganda',
            UA: 'Ucrania',
            AE: 'Emiratos Árabes Unidos',
            GB: 'Reino Unido',
            US: 'Estados Unidos',
            UM: 'Islas Ultramarinas de Estados Unidos',
            UY: 'Uruguay',
            UZ: 'Uzbekistán',
            VU: 'Vanuatu',
            VE: 'Venezuela',
            VN: 'Vietnam',
            VG: 'Islas Vírgenes Británicas',
            VI: 'Islas Vírgenes de EE. UU.',
            WF: 'Wallis y Futuna',
            EH: 'Sáhara Occidental',
            YE: 'Yemen',
            ZM: 'Zambia',
            ZW: 'Zimbabue'
        },
    },
    dk: {
        _name: 'Dansk',
        autoCloseModal: {
            takeProfitStopLoss: 'Tag overskud  & Stop Tab',
            takeProfit: 'Tag overskud',
            stopLoss: 'Stop Tab',
            updateOrder: 'Opdatering af ordre',
        },
        balanceModal: {
            balance: 'Balance',
            credit: 'Kredit',
            equity: 'Egenkapital',
            practice: 'PRAKTIK',
            real: 'REAL',
            account: 'KONTO',
            invested: 'Investeret',
            profit: 'Overskud',
            loss: 'Tab',
            margin: 'Margen',
            marginLevel: 'Margin-niveau',
            marginFree: 'Fri margen'
        },
        header: {
            cfd: 'CFD',
            platform: 'Platform',
            deposit: 'Depositum',
            myAccount: 'Min konto'
        },
        sideMenu: {
            marketWatch: 'Markedsovervågning',
            activeOrders: 'Aktive ordrer',
            tradingHistory: 'Handelshistorie',
            economicCalendar: 'Økonomisk kalender',
            marketNews: 'Nyheder om markedet'
        },
        closePositionModal: {
            closeOrder: 'Luk position',
            areYouSure: 'Er du sikker på, at du vil lukke stillingen',
            buy: 'Køb',
            sell: 'Sælg',
            yes: 'Ja',
            no: 'Nej',
        },
        chart: {
            addNewChart: 'Tilføj nyt diagram',
        },
        symbolsModal: {
            watchlist: 'Overvågningsliste',
            asset: 'Formue',
            price: 'Pris',
            changePct: 'Ændring 24 timer'
        },
        pendingModal: {
            pending: 'I vente',
            assetPrice: 'Aktivpris',
            current: 'Nuværende',
            revert: 'Tilbage til markedsprisen',
            automatically: 'Positionen vil blive åbnet automatisk, når prisen når dette niveau'
        },
        orderMenu: {
            volume: 'Volumen',
            lots: 'partier',
            units: 'enheder',
            currency: 'valuta',
            contractSize: 'Kontraktens størrelse',
            position: 'Position',
            margin: 'Margen',
            freeMargin: 'Fri margen',
            takeProfitStopLoss: 'Tag overskud  & Stop Tab',
            pending: 'I vente',
            market: 'Marked',
            leverage: 'Løftestang',
            spread: 'Spred',
            notSet: 'Ikke indstillet',
            at: 'på',
            buy: 'Køb',
            sell: 'Sælg',
        },
        footer: {
            supportBanner: 'HVER DAG, DØGNET RUNDT',
            currentTime: 'AKTUEL TID',
            liveChat: 'Live Chat'
        },
        statusBar: {
            balance: 'Balance',
            credit: 'Kredit',
            equity: 'Egenkapital',
            margin: 'Margen',
            marginLevel: 'Margen-niveau',
            freeMargin: 'Fri margen',
            pnl: 'PnL',
            profitTotal: 'Livstid PnL'
        },
        accountModal: {
            dateRegistered: 'Dato for registrering',
            userId: 'Bruger ID',
            dashboard: 'Instrumentbræt',
            personalData: 'Personlige data',
            deposit: 'Depositum',
            withdrawFunds: 'Trække penge ud',
            savings: 'Opsparing',
            settings: 'Indstillinger',
            logout: 'Logout'
        },
        depositModal: {
            BT_INVOICE: 'Enter amount and generate invoice',
            BT_TITLE: 'Our banking details',
            PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
            BT_ACCOUNT: 'Account',
            BT_BANK_NAME: 'Bank Name',
            BT_BENEFICIARY: 'Beneficiary',
            BT_ADDRESS: 'Beneficiary Address',
            BT_SWIFT: 'Swift',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Bankreferencekode',
            BT_INN: 'INN',
            BT_KPP: 'Correspondent account',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: 'Amount',
            TOKEN_SUBTOTAL: 'Subtotal',
            TOKEN_TOTAL: 'Total',
            TOKEN_DESCRIPTION: 'Description',
            TOKEN_PAYMENT_DETAILS: 'Payment Details',
            makeDeposit: 'Foretag en indbetaling',
            practiceAccount: 'Praksiskonto',
            realAccount: 'Rigtig konto',
            noWithdrawals: 'No Withdrawals',
            easyWithdrawals: 'Nemme udbetalinger',
            allAssets: 'Alle disponible aktiver',
            fullFledged: 'En fuldgyldig platform',
            fillUpTo: 'Fyld op til',
            freeReplenishment: 'Gratis genopfyldning',
            topUp: 'Opfyld din konto',
            minimumAmount: 'Mindste beløb',
            canSwitch: 'Du kan skifte mellem dine konti når som helst'
        },
        gridsModal: {
            chartGrids: 'DIAGRAMMER',
            chart1: '1 diagram',
            chart2: '2 diagrammer',
            chart3: '3 diagrammer',
            chart4: '4 diagrammer',
        },
        noConnectionModal: {
            connectionLost: 'Forbindelsen med serveren er mistet',
            retryNow: 'Prøv igen nu',
        },
        loginModal: {
            loginToTradeRoom: 'Log ind på Traderoom',
            email: 'E-mail-adresse',
            emailAndId: 'E-mail adresse / ID-nummer',
            enterEmail: 'Indtast din e-mail',
            twoFactor: '2FA-kode (hvis aktiveret)',
            twoFactorAuth: 'To-faktor-autentifikation',
            password: 'Adgangskode',
            yourPassword: 'Your password',
            signIn: 'Log ind',
            dontHaveAccount: 'Har du ikke en konto?',
            restore: 'Gendan',
            fullName: 'Fuldt navn',
            havePromo: 'Jeg har en promo-kode',
            promo: 'Promo-kode',
            login: 'Login',
            haveAccount: 'Har du allerede en konto?',
            hide: 'Skjul',
            goTo: 'Gå tilbage'
        },
        newPasswordModal: {
            setNewPassword: 'Indstil nyt kodeord',
            newPassword: 'Ny adgangskode',
            confirmNewPassword: 'Bekræft ny adgangskode',
            setButton: 'Indstil'
        },
        registerModal: {
            createNewAccount: 'Opret en ny konto',
            email: 'E-mail-adresse',
            firstName: 'Fornavn',
            lastName: 'Efternavn',
            country: 'Land',
            phone: 'Telefon',
            password: 'Adgangskode',
            createAccount: 'Opret konto',
            currency: 'Valuta'
        },
        forgotPasswordModal: {
            forgotPassword: 'Har du glemt din adgangskode?',
            submitEmail: 'Send venligst en e-mail, der anvendes til registrering, tjek din indbakke og følg instruktionerne',
            submit: 'Indsend'
        },
        notifications: {
            error: 'Fejl',
            success: 'Succes',
            deposit: 'Depositum',
            withdrawal: 'Tilbagetrækning',
            depositApproved: 'Depositum er blevet godkendt',
            depositDeclined: 'Depositum er blevet afvist',
            withdrawalApproved: 'Tilbagetrækningen er blevet godkendt',
            withdrawalDeclined: 'Tilbagetrækning er blevet afvist',
            withdrawalCancelled: 'Udbetalingen er blevet annulleret',
            orderRejected: 'Ordre afvist',
            insufficientMargin: 'Din afventende ordre kunne ikke åbnes: ikke tilstrækkelig fri margen',
            marginCall: 'Margin call',
            marginCallText: 'Foretag venligst en indbetaling for at opfylde margenkravene'
        },
        markets: {
            forex: 'Forex',
            stocks: 'Aktier',
            commodities: 'Råvarer',
            indices: 'Indekser',
            crypto: 'Crypto',
            metals: 'Metals',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            profitCalculator: 'Profitberegner',
            buy: 'KØB',
            sell: 'SÆLG',
            volume: 'Volumen',
            entryPrice: 'Indgangspris',
            takeProfit: 'Tag overskud',
            stopLoss: 'Stop Tab',
            maxPosition: 'Max Position',
            calculate: 'Beregn',
            calculationsFor: 'Beregninger for',
            leverage: 'Løftestang',
            requiredMargin: 'Nødvendig margen',
            profitFromTP: 'Overskud fra TP',
            lossFromSL: 'Tab fra SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Depositum lykkedes',
            text: 'Din indbetaling er blevet behandlet med succes!',
        },
        depositFailModal: {
            title: 'Depositum mislykkedes',
            text: 'Din indbetaling er ikke blevet behandlet.',
        },
        widgetMarketWatch: {
            marketWatch: 'Markedsovervågning',
            search: 'Søg på...',
        },
        widgetOrders: {
            commission: 'Commission',
            volume: 'Volumen',
            margin: 'Margen',
            active: 'Aktiv',
            pending: 'I vente',
            activeOrders: 'Aktive ordrer',
            portfolio: 'Portefølje',
            allPositions: 'Alle stillinger',
            noPositionsLine1: 'Du har ingen åbne',
            noPositionsLine2: 'stillinger endnu',
            show: 'Vis',
            more: 'mere',
            less: 'mindre',
            purchaseTime: 'Tidspunkt for køb',
            closePosition: 'Luk position',
            priceOpen: 'Købspris',
            priceSl: 'Stop Loss-pris',
            priceTp: 'Take Profit Pris',
            type: 'Position Retning',
            pnl: 'Overskud/tab',
            cancelOrder: 'Annuller bestilling',
            orderType: 'Bestillingstype',
            cancelled: 'Annulleret',
            tradingHistory: 'Handelshistorie',
            noHistoryLine1: 'Du har ikke nogen',
            noHistoryLine2: 'endnu ikke indgået aftaler',
            sortByTime: 'Sorter efter tid',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Økonomisk kalender'
        },
        widgetMarketNews: {
            marketNews: 'Nyheder om markedet'
        },
        ordersPane: {
            ordersActive: 'Aktive ordrer',
            ordersHistory: 'Ordrehistorik',
            id: 'ID',
            symbol: 'Symbol',
            type: 'Type',
            volume: 'Volumen',
            openPrice: 'Åben pris',
            openTime: 'Åben tid',
            closePrice: 'Luk pris',
            closeTime: 'Luk tid',
            sl: 'SL',
            tp: 'TP',
            price: 'Pris',
            pnl: 'PnL',
            actions: 'Foranstaltninger',
            edit: 'Rediger',
            close: 'Luk',
            commission: 'Kommissionen',
            swap: 'Byt',
            swapLong: 'Bytte lang',
            swapShort: 'Bytte kort'
        },
        assetInfoModal: {
            assetInfo: 'Oplysninger om aktiver',
            tradingConditions: 'Handelsbetingelser',
            information: 'Oplysninger',
            bid: 'Bud',
            ask: 'Spørg',
            sessionChange: 'Ændring af session',
            tradeNow: 'Handel nu',
            opens: 'Åbner',
            closes: 'Lukker',
            at: 'på',
            open247: 'Åben 24/7',
            today: 'i dag',
            tomorrow: 'i morgen',
            sunday: 'Søndag',
            monday: 'Mandag',
            tuesday: 'Tirsdag',
            wednesday: 'Onsdag',
            thursday: 'Torsdag',
            friday: 'Fredag',
            saturday: 'Lørdag',
            contractSpecification: 'Kontraktspecifikation',
            symbol: 'Symbol',
            name: 'Navn',
            market: 'Marked',
            baseCurrency: 'Basisvaluta',
            digits: 'Cifre',
            lotSize: 'Størrelse af parti',
            lotStep: 'Parti trin',
            minVolume: 'Min Volumen',
            maxVolume: 'Max Volumen',
            leverage: 'Løftestang',
            commission: 'Kommissionen',
            swapLong: 'Bytte lang',
            swapShort: 'Bytte kort',
            schedule: 'Tidsplan',
            weekday: 'Hverdag',
            tradingTime: 'Handelstid',
            closed: 'lukket',
            sell: 'Sælg',
            buy: 'Køb',
            low: 'Lav',
            high: 'Høj',
            oneHourChange: '1 times ændring',
            oneDayChange: '1 dags ændring',
            oneWeekChange: '1 uges ændring',
            oneMonthChange: '1 måneds ændring',
            threeMonthsChange: '3 måneders ændring',
            oneYearChange: '1 års ændring',
            loading: 'Indlæsning...',
        },
        fullScreen: {
            startTrading: 'Start handel',
            deposit: 'Depositum',
            dashboard: 'Instrumentbræt',
            personalInfo: 'Personlig information',
            withdrawal: 'Tilbagetrækning',
            verification: 'Verifikation',
            accounts: 'Regnskaber',
            liveChat: 'Live Chat',
            savings: 'Opsparing',
            settings: 'Indstillinger',
            logOut: 'Log ud',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            name: 'Cardholder\'s name',
            address: 'Address',
            DOB: 'DOB',
            bankName: 'Bank name',
            additionalInfo: 'For at indsætte mere på din konto, bedes du kontakte din kontoleder direkte',
            additionalInfoOnlyBTCpsp: 'For at åbne andre betalingsmetoder, skal du venligst give KYC eller kontakte din kontomanager',
            sofortPspMessage: 'Vores finansteam vil kontakte dig for at hjælpe dig med at foretage en indbetaling',
            addWalletAddress: 'Wallet for this deposit method is not set. Please contact your agent or support team.',
            addressReceipt: 'Please wait for the address to load',
            makeDeposit: 'GØR ET INDBETALING',
            instant: 'Øjeblikkelig',
            minutes: 'minutter',
            hours: 'timer',
            days: 'dage',
            amount: 'Beløb',
            continue: 'Fortsæt',
            qrCode: 'QR CODE',
            depositAddress: 'INDBETALINGSADRESSE',
            copy: 'Kopier',
            last: 'SIDSTE',
            deposits: 'INDBETALINGER',
            time: 'Tid',
            currency: 'Valuta',
            status: 'Status',
            info: 'Info',
        },
        fullScreenCcExt: {
            pleaseWait: 'Vent venligst. Oprettelse af forbindelse til udbyder af betalingstjenester...',
            cardPayment: 'Card payment',
            inOrder: 'For at sende beløbet',
            pleaseProvide: 'Angiv venligst kortoplysninger:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Total Taxes',
            totalBalance: 'Samlet saldo',
            totalPnl: 'Samlet PNL',
            profitableOrders: 'Rentable ordrer',
            roi: 'ROI',
            activityLog: 'Aktivitetslogbog',
            loginFromIp: 'Login fra IP',
            tradingResults: 'Handelsresultater',
            week: 'Uge',
            month: 'Måned',
            year: 'År',
            successRate: 'Succesrate',
            closedWithProfit: 'Lukket med overskud',
            closedWithLoss: 'Lukket med tab',
            account: 'Konto',
            balance: 'Balance',
            leverage: 'Løftestang',
            credit: 'Kredit',
            tradeNow: 'Handel nu',
            usingCurrentRate: 'ved anvendelse af den aktuelle valutakurs',
            totalDeposits: 'Total Deposits'
        },
        fullScreenPersonal: {
            personalDetails: 'Personlige oplysninger',
            profilePhoto: 'Profilbillede',
            firstName: 'Fornavn',
            country: 'Land',
            lastName: 'Efternavn',
            address: 'Adresse',
            email: 'E-mail',
            phone: 'Telefon nummer',
            saveChanges: 'Gem ændringer',
        },
        fullScreenAvatar: {
            dropFile: 'Smid en fil på cirklen ovenfor for at uploade',
            notAllowed: 'Det er ikke tilladt at offentliggøre',
            notAllowedLine1: 'Billeder af eksplicit seksuel eller pornografisk karakter',
            notAllowedLine2: 'Billeder, der har til formål at tilskynde til etnisk eller racemæssigt had eller aggression',
            notAllowedLine3: 'Billeder, der involverer personer under 18 år',
            notAllowedLine4: 'Ophavsretligt beskyttede fotos fra tredjeparter',
            notAllowedLine5: 'Billeder, der er større end 5 MB og i et andet format end JPG, GIF eller PNG',
            requirements: 'Dit ansigt skal være tydeligt synligt på billedet. Alle billeder og videoer, som du uploader, skal opfylde disse krav, ellers kan de blive fjernet.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Tilbagetrækning',
            requestNewWithdrawal: 'ANMODE OM EN NY UDBETALING',
            amount: 'Beløb',
            currentBalance: 'Din nuværende kontosaldo er',
            withdrawAll: 'Tilbagetrækning af alle',
            requestWithdrawal: 'Anmodning om tilbagetrækning',
            last: 'SIDSTE',
            withdrawalRequests: 'ANMODNINGER OM TILBAGETRÆKNING',
            time: 'Tid',
            currency: 'Valuta',
            info: 'Info',
            status: 'Status',
            bank: 'Bank',
            bitcoin: 'Bitcoin',
            card: 'Kort',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Oplysninger om tilbagetrækning',
            address: 'Tegnebogens adresse',
            bankAccount: 'Kontonummer',
            bankHolder: 'Kontohaverens navn',
            bankIban: 'IBAN',
            bankSwift: 'Bankens SWIFT-kode',
            sortCode: 'Sorteringskode',
            ifscCode: 'IFSC-kode',
            bankCode: "Bankkode (BSB)",
            bankName: 'Banknavn',
            bankBranch: 'Bankfilial',
            cardNumber: 'Kortnummer',
            cardHolder: 'Kortindehaverens navn',
            incorrectAmountByFreeMargin: 'The amount is incorrect you can withdraw the amount of free margin',
            closeOrders: 'before close all orders'
        },
        fullScreenVerification: {
            dragAndDrop: 'træk og slip dokumentet til dette område',
            documentsList: 'LISTE OVER UPLOADEDE DOKUMENTER',
            document: 'Dokument',
            timeUploaded: 'Tidspunkt uploadet',
            timeProcessed: 'Behandlet tid',
            status: 'Status',
            types: ['Bevis for id', 'Bevis for bopæl', 'Kreditkort forside', 'Kreditkort tilbage', 'Bevis for id tilbage', 'Selfie','Other'],
            types2: ['Proof of Id (ID CARD, PASSPORT, DRIVER LICENCE)', 'Proof of Residence (Utility bill or Bank statement)', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back (ID CARD BACK, DRIVER LICENCE BACK)', 'Selfie','Other'],
            upload: 'Overfør',
            isConfirmed: 'er bekræftet',
            uploadAnotherDocument: 'Upload et andet dokument',
            isUnderReview: 'er under revision',
            questionnaire: 'Spørgeskema',
            sendAnswers: 'Send svar',
            progressBarOf: 'på',
            progressBarText: 'alle dine dokumenter er blevet uploadet og bekræftet'
        },
        fullScreenAccounts: {
            manageAccounts: 'Overfør penge mellem dine konti',
            transferFrom: 'Fra konto',
            transferTo: 'Til regnskab',
            amount: 'Beløb',
            makeTransfer: 'Foretag overførsel',
            yourAccounts: 'Dine konti',
            account: 'Konto',
            currency: 'Valuta',
            balance: 'Balance',
            credit: 'Kredit',
            makeActive: 'Gør aktiv',
            active: 'Aktiv'
        },
        fullScreenSupport: {
            chatOff: 'Chat will be available on working days',
            sendMessage: 'Send besked',
            responseTime: 'Gennemsnitlig svartid: 1-24 timer',
        },
        fullScreenSavings: {
            pct_0: 'Fleksibel',
            pct_30: 'Låst 1 måned',
            pct_90: 'Låst 1 kvartal',
            pct_180: 'Låst 6 måneder',
            pct_365: 'Låst 1 år',
            pct_730: 'Låst 2 år',
            savings: 'Opsparing',
            detailedInformation: 'Detaljerede oplysninger',
            pleaseSelect: 'Vælg venligst en valuta og en periode',
            openSavings: 'Åben opsparing',
            currentTime: 'Nuværende tid',
            releaseTime: 'Udgivelsestidspunkt',
            currencyChosen: 'Valgt valuta',
            periodChosen: 'Valgt periode',
            yourRate: 'Din pris',
            yourAnnualRate: 'Din årlige sats',
            yourEarnings: 'Din indtjening',
            accountFrom: 'Konto til overførsel af midler fra',
            enterAmount: 'Indtast beløbet',
            in: 'På',
            openAndInvest: 'Åbn en opsparingskonto og invester',
            investment: 'Investering',
            period: 'Periode',
            daysTotal: 'Antal dage i alt',
            finalEarnings: 'Endelig indtjening',
            created: 'Oprettet',
            daysElapsed: 'Forløbne dage',
            days: 'dage',
            earnings: 'Indtjening',
            fundsReleasedIn: 'Midler frigivet i',
            claim: 'Krav',
        },
        fullScreenSettings: {
            updatePassword: 'OPDATERE ADGANGSKODE',
            currentPassword: 'Nuværende adgangskode',
            newPassword: 'Nyt kodeord',
            changePassword: 'Ændre adgangskode',
            activationForGoogle: 'Aktiveringskode til Google Authenticator',
            activateAndEnter: 'Aktivér Authenticator, og indtast en genereret kode i feltet nedenfor',
            qrCode: 'QR-kode',
            activateProtection: 'Aktiver 2FA-beskyttelse',
            protectionActive: '2FA-beskyttelse er aktiv',
            twoFactorCode: '2FA-kode',
            disableProtection: 'Deaktivere 2FA-beskyttelse',
            language: 'Sprog',
            dashboardCurrency: 'Dashboard Valuta',
            confirmNewPassword: 'Bekræft ny adgangskode',
        },
        fullScreenReferrals: {
            yourLink: 'DIT HENVISNINGSLINK',
            referredFriends: 'HENVISTE VENNER',
            id: 'ID',
            name: 'Navn',
            registered: 'Registreret',
            level: 'Niveau',
            payout: 'Udbetaling',
            lastPayouts: 'SENESTE UDBETALINGER VED HENVISNING',
            time: 'Tid',
            amount: 'Beløb',
            currency: 'Valuta',
            info: 'Info'
        },
        months: {
            Jan: 'Jan',
            Feb: 'Feb',
            Mar: 'Mar',
            Apr: 'Apr',
            May: 'Maj',
            Jun: 'Jun',
            Jul: 'Jul',
            Aug: 'Aug',
            Sep: 'Sep',
            Oct: 'Oct',
            Nov: 'Nov',
            Dec: 'Dec'
        },
        orderTypes: ['Køb', 'Salg', 'Køb Limit', 'Salg Limit', 'Køb Stop', 'Salg Stop'],
        statuses: ['Afventer', 'Godkendt', 'Afvist', 'Behandling','Under gennemgang','In Process','Annulleret'],
        errors: {
            INVALID_FIELDS: 'Please check that the data you have entered is correct',
            NOT_FOUND: 'Fejl i anmodningen',
            FORBIDDEN: 'Adgang nægtet. Log venligst ind igen',
            SERVER_ERROR: 'Indsatsen mislykkedes. Prøv venligst igen senere',
            INVALID_ACCOUNT: 'Sessionen udløb. Log venligst ind igen',
            INVALID_EMAIL: 'Ugyldig e-mail-adresse',
            INVALID_PHONE: 'Ugyldigt telefonnummer',
            INVALID_COUNTRY: 'Ugyldigt land',
            INVALID_LOGIN: 'Ugyldige loginoplysninger',
            USER_BLOCKED: 'Kontoen er spærret. Kontakt venligst support',
            USER_REGISTERED: 'Brugeren med det indtastede e-mail eller telefonnummer er allerede registreret',
            INVALID_USER: 'Brugeren er ikke fundet',
            REJECTED: 'Drift er ikke tilladt på grund af platformsrestriktioner',
            INVALID_OLD_PASSWORD: 'Det gamle password er ugyldigt',
            INVALID_SYMBOL: 'Ugyldigt handelssymbol',
            INVALID_SYMBOL_PRECISION: 'Ugyldig symbolpræcision',
            INVALID_FRAME: 'Ugyldig diagramramme',
            INVALID_CURRENCY: 'Ugyldig valuta',
            INVALID_PRODUCT: 'Ugyldig konto handelstype',
            INSUFFICIENT_FUNDS: 'Utilstrækkelige midler',
            INVALID_WITHDRAWAL: 'Tilbagetrækning er ikke fundet',
            INVALID_DEPOSIT: 'Denne indbetaling kan ikke længere annulleres - den blev ikke fundet eller er allerede behandlet',
            INVALID_STATUS: 'Ugyldig status',
            INVALID_FILE: 'Ugyldig filudvidelse eller filen er for stor',
            INVALID_DOCUMENT: 'Dokumentet er ikke fundet',
            INVALID_NAME: 'Ugyldigt navn',
            INVALID_LOT_SIZE: 'Ugyldig partistørrelse',
            INVALID_LOT_STEP: 'Ugyldigt partitrin',
            INVALID_MIN_VOLUME: 'Ugyldig minimumsvolumen',
            INVALID_MAX_VOLUME: 'Ugyldig maksimal volumen',
            INVALID_GROUP: 'Ugyldig gruppe',
            INVALID_SPREAD: 'Ugyldig spredning',
            REQUEST_TIMEOUT: 'Anmodningen er udløbet. Prøv venligst igen senere',
            INVALID_TYPE: 'Ugyldig bestillingstype',
            INVALID_VOLUME: 'Ugyldig ordremængde',
            INVALID_SL: 'Ugyldig stop loss-værdi',
            INVALID_TP: 'Ugyldig take profit-værdi',
            INVALID_PRICE: 'Ugyldig ordrepris',
            INVALID_EXPIRATION: 'Ugyldig ordreudløb',
            NOT_ENOUGH_MARGIN: 'Ikke tilstrækkelig margen',
            INVALID_ORDER: 'Ordren er ikke fundet',
            MARKET_CLOSED: 'Handel er ikke tilgængelig. Prøv venligst igen',
            INVALID_BALANCE_TYPE: 'Ugyldig type af balanceoperation',
            INVALID_HASH: 'Ugyldig hash',
            HASH_EXPIRED: 'Dit link til nulstilling af adgangskode er udløbet. Anmod venligst om et nyt',
            INVALID_CODE: 'Ugyldig 2FA-kode',
            CHAT_DISABLED: 'Adgang til supportchatten er blevet lukket',
            WITHDRAWAL_NOT_ALLOWED: 'Adgangen til tilbagekøb er blevet lukket',
            TRADING_DISABLED: 'Handel er deaktiveret for den løbende konto',
            PENDING_DEPOSITS_LIMIT: 'Kun én igangværende indbetaling er tilladt',
            CLOSE_OPEN_ORDERS: 'Luk venligst dine åbne ordrer',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Kun én igangværende udbetaling er tilladt',
            LOCAL_DEPOSIT_ONLY_REAL: 'Indbetaling er kun tilgængelig for rigtige konti',
            LOCAL_DEPOSIT_POSITIVE: 'Indbetalingsbeløbet skal være over 0',
            LOCAL_INVALID_CARD_NUMBER: 'Ugyldigt kortnummer',
            LOCAL_INVALID_CARD_EXPIRATION: 'Ugyldigt kortudløb',
            LOCAL_INVALID_CVC: 'Ugyldig CVV/CVC-kode',
            LOCAL_PASSWORDS_NOT_MATCH: 'Adgangskoderne stemmer ikke overens, indtast venligst igen',
            LOCAL_NO_TRADING_ACCOUNTS: 'Du har ingen handelskonti til rådighed. Kontakt venligst supporten',
            LOCAL_MIN_DEPOSIT: 'Mindste indbetaling er $',
            LOCAL_MIN_WITHDRAWAL: 'Mindste udbetalingsbeløb er $',
            LOCAL_INVALID_FILE_TYPE: 'Filformat ikke understøttet. Vedhæft venligst kun JPG, PNG eller PDF',
            LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',
            FLOOD_REJECTED: 'You are sending messages too often. Please try again later',
            REGISTRATIONS_BLOCKED: "Tak for din forespørgsel, En af vores repræsentanter vil kontakte dig så hurtigt som muligt",
        },
        countries: {
            AF: 'Afghanistan',
            AX: 'Aland-øerne',
            AL: 'Albanien',
            DZ: 'Algeriet',
            AS: 'Amerikanske Samoa',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarktis',
            AG: 'Antigua og Barbuda',
            AR: 'Argentina',
            AM: 'Armenien',
            AW: 'Aruba',
            AU: 'Australien',
            AT: 'Østrig',
            AZ: 'Aserbajdsjan',
            BS: 'Bahamas',
            BH: 'Bahrain',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BY: 'Hviderusland',
            BE: 'Belgien',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivia',
            BA: 'Bosnien og Hercegovina',
            BW: 'Botswana',
            BV: 'Bouvet-øen',
            BR: 'Brasilien',
            IO: 'Britisk territorium i Det Indiske Ocean',
            BN: 'Brunei Darussalam',
            BG: 'Bulgarien',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambodja',
            CM: 'Cameroun',
            CA: 'Canada',
            CV: 'Kap Verde',
            KY: 'Caymanøerne',
            CF: 'Den Centralafrikanske Republik',
            TD: 'Chad',
            CL: 'Chile',
            CN: 'Kina',
            CX: 'Juleøen',
            CC: 'Cocos- (Keeling) øerne',
            CO: 'Colombia',
            KM: 'Comorerne',
            CG: 'Congo',
            CD: 'Congo, Den Demokratiske Republik',
            CK: 'Cookøerne',
            CR: 'Costa Rica',
            CI: 'Elfenbenskysten',
            HR: 'Kroatien',
            CU: 'Cuba',
            CY: 'Cypern',
            CZ: 'Tjekkiet',
            DK: 'Danmark',
            DJ: 'Djibouti',
            DM: 'Dominica',
            DO: 'Den Dominikanske Republik',
            EC: 'Ecuador',
            EG: 'Egypten',
            SV: 'El Salvador',
            GQ: 'Ækvatorialguinea',
            ER: 'Eritrea',
            EE: 'Estland',
            ET: 'Etiopien',
            FK: 'Falklandsøerne (Malvinas)',
            FO: 'Færøerne',
            FJ: 'Fiji',
            FI: 'Finland',
            FR: 'Frankrig',
            GF: 'Fransk Guyana',
            PF: 'Fransk Polynesien',
            TF: 'Franske sydlige territorier',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgien',
            DE: 'Tyskland',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Grækenland',
            GL: 'Grønland',
            GD: 'Grenada',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HM: 'Heard Island og Mcdonald-øerne',
            VA: 'Den Hellige Stol (Vatikanstaten)',
            HN: 'Honduras',
            HK: 'Hong Kong',
            HU: 'Ungarn',
            IS: 'Island',
            IN: 'Indien',
            ID: 'Indonesien',
            IR: 'Iran',
            IQ: 'Irak',
            IE: 'Irland',
            IM: 'Man-øen',
            IL: 'Israel',
            IT: 'Italien',
            JM: 'Jamaica',
            JP: 'Japan',
            JE: 'Jersey',
            JO: 'Jordan',
            KZ: 'Kasakhstan',
            KE: 'Kenya',
            KI: 'Kiribati',
            KR: 'Korea',
            KW: 'Kuwait',
            KG: 'Kirgisistan',
            LA: 'Den Demokratiske Folkerepublik Laos',
            LV: 'Letland',
            LB: 'Libanon',
            LS: 'Lesotho',
            LR: 'Liberia',
            LY: 'Libysk-Arabisk Jamahiriya',
            LI: 'Liechtenstein',
            LT: 'Litauen',
            LU: 'Luxembourg',
            MO: 'Macao',
            MK: 'Makedonien',
            MG: 'Madagaskar',
            MW: 'Malawi',
            MY: 'Malaysia',
            MV: 'Maldiverne',
            ML: 'Mali',
            MT: 'Malta',
            MH: 'Marshalløerne',
            MQ: 'Martinique',
            MR: 'Mauritanien',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Mexico',
            FM: 'Mikronesien',
            MD: 'Moldova',
            MC: 'Monaco',
            MN: 'Mongoliet',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MA: 'Morokko',
            MZ: 'Mozambique',
            MM: 'Myanmar',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NL: 'Nederlandene',
            AN: 'De Nederlandske Antiller',
            NC: 'Ny Kaledonien',
            NZ: 'New Zealand',
            NI: 'Nicaragua',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            NF: 'Norfolk-øen',
            MP: 'Nordmarianerne',
            NO: 'Norge',
            OM: 'Oman',
            PK: 'Pakistan',
            PW: 'Palau',
            PS: 'Palæstinensisk område, besat',
            PA: 'Panama',
            PG: 'Papua Ny Guinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PH: 'Filippinerne',
            PN: 'Pitcairn',
            PL: 'Polen',
            PT: 'Portugal',
            PR: 'Puerto Rico',
            QA: 'Qatar',
            RE: 'Reunion',
            RO: 'Rumænien',
            RU: 'Rusland',
            RW: 'Rwanda',
            BL: 'Saint Barthelemy',
            SH: 'Saint Helena',
            KN: 'Saint Kitts And Nevis',
            LC: 'Saint Lucia',
            MF: 'Saint Martin',
            PM: 'Saint Pierre og Miquelon',
            VC: 'Saint Vincent og Grenadinerne',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Sao Tome Og Principe',
            SA: 'Saudi Arabien',
            SN: 'Senegal',
            RS: 'Serbien',
            SC: 'Seychellerne',
            SL: 'Sierra Leone',
            SG: 'Singapore',
            SK: 'Slovakiet',
            SI: 'Slovenien',
            SB: 'Salomonøerne',
            SO: 'Somalia',
            ZA: 'Sydafrika',
            GS: 'Sydgeorgien og Sandwichøerne',
            ES: 'Spanien',
            LK: 'Sri Lanka',
            SD: 'Sudan',
            SR: 'Surinam',
            SJ: 'Svalbard og Jan Mayen',
            SZ: 'Swaziland',
            SE: 'Sverige',
            CH: 'Schweiz',
            SY: 'Den Syriske Arabiske Republik',
            TW: 'Taiwan',
            TJ: 'Tadsjikistan',
            TZ: 'Tanzania',
            TH: 'Thailand',
            TL: 'Timor-Leste',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad Og Tobago',
            TN: 'Tunisien',
            TR: 'Turkiet',
            TM: 'Turkmenistan',
            TC: 'Turks- og Caicosøerne',
            TV: 'Tuvalu',
            UG: 'Uganda',
            UA: 'Ukraine',
            AE: 'Forenede Arabiske Emirater',
            GB: 'Det Forenede Kongerige',
            US: 'Forenede Stater',
            UM: 'United States Outlying Islands',
            UY: 'Uruguay',
            UZ: 'Uzbekistan',
            VU: 'Vanuatu',
            VE: 'Venezuela',
            VN: 'Viet Nam',
            VG: 'Jomfruøerne, Britiske',
            VI: 'Virgin Islands, U.S.',
            WF: 'Wallis Og Futuna',
            EH: 'Vestsahara',
            YE: 'Yemen',
            ZM: 'Zambia',
            ZW: 'Zimbabwe'
        },
    },
    nl: {
        _name: 'Nederlandse taal',
        autoCloseModal: {
            takeProfitStopLoss: 'Neem Winst & Stoppen Verlies',
            takeProfit: 'Neem Winst ',
            stopLoss: 'Stoppen Verlies',
            updateOrder: 'Bestelling Bijwerken',
        },
        balanceModal: {
            balance: 'Balans',
            credit: 'krediet',
            equity: 'Equity',
            practice: 'PRAKTIJK',
            real: 'ECHT',
            account: 'ACCOUNT',
            invested: 'Geïnvesteerd',
            profit: 'Winst',
            loss: 'Verlies',
            margin: 'marge',
            marginLevel: 'Onderhoudsmarge',
            marginFree: 'Vrij Marge'
        },
        header: {
            cfd: 'CFD',
            platform: 'Platform',
            deposit: 'Storting',
            myAccount: 'Mijn account'
        },
        sideMenu: {
            marketWatch: 'Markt bekijken',
            activeOrders: 'Open Posities',
            tradingHistory: 'Handel Geschiedenis',
            economicCalendar: 'Economisch Kalender',
            marketNews: 'Markt Nieuws'
        },
        closePositionModal: {
            closeOrder: 'Gesloten positie ',
            areYouSure: 'Weet je zeker dat je de positie sluit?',
            buy: 'Kopen',
            sell: 'Verkopen',
            yes: 'Ja',
            no: 'Nee',
        },
        chart: {
            addNewChart: 'Nieuwe grafiek toevoegen',
        },
        symbolsModal: {
            watchlist: 'Volglijst',
            asset: 'Bedrijfsmiddel',
            price: 'Prijs',
            changePct: 'verandering 24u'
        },
        pendingModal: {
            pending: 'Laden',
            assetPrice: 'Bedrijfsmiddel Prijs',
            current: 'Actueel',
            revert: 'Terug naar Markt Prijs',
            automatically: 'Positie wordt automatisch geopend wanneer de prijs dit niveau bereikt'
        },
        orderMenu: {
            volume: 'Volume',
            lots: 'lots',
            units: 'units',
            currency: 'valuta',
            contractSize: 'Contractgrootte',
            position: 'Positie',
            margin: 'Marge',
            freeMargin: 'Vrij Marge',
            takeProfitStopLoss: 'Neem Winst & Stoppen Verlies',
            pending: 'Laden',
            market: 'Markt',
            leverage: 'Hefboom',
            spread: 'Verspreiding',
            notSet: 'Niet ingesteld',
            at: 'Bij',
            buy: 'kopen',
            sell: 'verkopen',
        },
        footer: {
            supportBanner: 'ELKE DAG, DE KLOK ROND',
            currentTime: 'ACTUEEL TIJD',
            liveChat: 'Live chatten'
        },
        statusBar: {
            balance: 'Balans',
            credit: 'Credit',
            equity: 'Eigen vermogen',
            margin: 'Marge',
            marginLevel: 'Onderhoudsmarge',
            freeMargin: 'Vrij Marge',
            pnl: 'PNL',
            profitTotal: 'Winst totaal'
        },
        accountModal: {
            dateRegistered: 'Datum Geregistreerd',
            userId: 'Gebruiker ID',
            dashboard: 'Dashboard',
            personalData: 'Persoonlijke gegevens',
            deposit: 'Storting',
            withdrawFunds: 'Geld opnemen',
            savings: 'Spaargeld',
            settings: 'Instellingen',
            logout: 'Uitloggen'
        },
        depositModal: {
            BT_INVOICE: 'Enter amount and generate invoice',
            BT_TITLE: 'Our banking details',
            PENDING_DEPOSITS_LIMIT: 'Deposit Limit',
            BT_ACCOUNT: 'Account',
            BT_BANK_NAME: 'Bank Name',
            BT_BENEFICIARY: 'Beneficiary',
            BT_ADDRESS: 'Beneficiary Address',
            BT_SWIFT: 'Swift',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE : 'Bankreferentiecode',
            BT_INN: 'INN',
            BT_KPP: 'Correspondent account',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: 'Amount',
            TOKEN_SUBTOTAL: 'Subtotal',
            TOKEN_TOTAL: 'Total',
            TOKEN_DESCRIPTION: 'Description',
            TOKEN_PAYMENT_DETAILS: 'Payment Details',
            makeDeposit: 'Storting doen',
            practiceAccount: 'praktijk account',
            realAccount: 'Echte account',
            noWithdrawals: 'Geen opnames',
            easyWithdrawals: 'Gemakkelijke opnames',
            allAssets: 'Alle middelen beschikbaar',
            fullFledged: 'Full-ledged platform',
            fillUpTo: 'Fill Up To',
            freeReplenishment: 'Gratis aanvulling',
            topUp: 'Waardeer je account op',
            minimumAmount: 'Minimale bedrag',
            canSwitch: 'U kunt op elk moment tussen uw accounts schakelen'
        },
        gridsModal: {
            chartGrids: 'GRAFIEKRASTERS',
            chart1: '1 grafiek',
            chart2: '2 grafieken',
            chart3: '3 grafieken',
            chart4: '4 grafieken',
        },
        noConnectionModal: {
            connectionLost: 'Verbinding met de server is verbroken',
            retryNow: 'Probeer het nu opnieuw',
        },
        loginModal: {
            loginToTradeRoom: 'Inloggen op Traderoom',
            email: 'E-mailadres',
            emailAndId: 'E-mailadres / ID-nummer',
            enterEmail: 'Vul je e-mailadres in',
            twoFactor: '2FA-code (indien ingeschakeld)',
            twoFactorAuth: 'Tweefactorauthenticatie',
            password: 'Wachtwoord',
            yourPassword: 'Uw wachtwoord',
            signIn: 'Log in',
            dontHaveAccount: 'Heb je geen account?',
            restore: 'Herstellen',
            fullName: 'Voor-en achternaam',
            havePromo: 'Ik heb een promotiecode',
            promo: 'Promotiecode',
            login: 'Login',
            haveAccount: 'Heb je al een account?',
            hide: 'Zich verstoppen',
            goTo: 'Terug naar'
        },
        newPasswordModal: {
            setNewPassword: 'Nieuw wachtwoord instellen',
            newPassword: 'Nieuw wachtwoord',
            confirmNewPassword: 'Bevestig nieuw wachtwoord',
            setButton: 'Set'
        },
        registerModal: {
            createNewAccount: 'Maak een nieuw account aan',
            email: 'E-mailadres',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            country: 'Land',
            phone: 'Telefoon',
            password: 'Wachtwoord',
            createAccount: 'Maak account',
            currency: 'Valuta'
        },
        forgotPasswordModal: {
            forgotPassword: 'Wachtwoord vergeten?',
            submitEmail: 'Dien een e-mail in die is gebruikt voor registratie, controleer uw inbox en volg de instructies',
            submit: 'Indienen'
        },
        notifications: {
            error: 'Fout',
            success: 'Succes',
            deposit: 'Storting',
            withdrawal: 'Opname',
            depositApproved: 'Aanbetaling is goedgekeurd',
            depositDeclined: 'Aanbetaling is geweigerd',
            withdrawalApproved: 'Opname goedgekeurd',
            withdrawalDeclined: 'Opname geweigerd',
            withdrawalCancelled: 'De opname is geannuleerd',
            orderRejected: 'Order afgewezen',
            insufficientMargin: 'Uw openstaande order kon niet worden geopend: niet genoeg vrije marge',
            marginCall: 'Margin call',
            marginCallText: 'Doe een storting om aan de margevereisten te voldoen'
        },
        markets: {
            forex: 'Valuta',
            stocks: 'Aandelen',
            commodities: 'Grondstoffen',
            indices: 'Indexen',
            crypto: 'Crypto',
            metals: 'Metalen',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            profitCalculator: 'Winstcalculator',
            buy: 'Kopen',
            sell: 'Verkopen',
            volume: 'Volume',
            entryPrice: 'Toegangs prijs',
            takeProfit: 'Winst nemen',
            stopLoss: 'Stop-Loss',
            maxPosition: 'Maximale positie',
            calculate: 'Berekenen',
            calculationsFor: 'Berekeningen voor',
            leverage: 'Hefboom',
            requiredMargin: 'Vereiste marge',
            profitFromTP: 'Profiteer van TP',
            lossFromSL: 'Verlies van SL',
            roe: 'ROI',
        },
        depositSuccessModal: {
            title: 'Storting succesvol',
            text: 'Your deposit has been processed successfully!',
        },
        depositFailModal: {
            title: 'Storting mislukt',
            text: 'Uw storting is niet verwerkt.',
        },
        widgetMarketWatch: {
            marketWatch: 'Markt bekijken',
            search: 'Zoeken...',
        },
        widgetOrders: {
            commission: 'Commission',
            volume: 'Volume',
            margin: 'Margen',
            active: 'Actief',
            pending: 'Laden',
            activeOrders: 'Open posities',
            portfolio: 'Portefeuille',
            allPositions: 'Alle posities',
            noPositionsLine1: 'Je hebt geen open',
            noPositionsLine2: 'posities nog',
            show: 'Tonen',
            more: 'meer',
            less: 'minder',
            purchaseTime: 'Aankooptijd',
            closePosition: 'Positie sluiten',
            priceOpen: 'Aankoopprijs',
            priceSl: 'Stop Loss-prijs',
            priceTp: 'Winstprijs nemen',
            type: 'Positie Richting',
            pnl: 'Winst/verlies',
            cancelOrder: 'Annuleer bestelling',
            orderType: 'Order Type',
            cancelled: 'Geannuleerd',
            tradingHistory: 'Geschiedenis',
            noHistoryLine1: 'Je hebt er geen',
            noHistoryLine2: 'nog gesloten deals',
            sortByTime: 'Sorteer op tijd',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'Economische kalender'
        },
        widgetMarketNews: {
            marketNews: 'Marktnieuws'
        },
        ordersPane: {
            ordersActive: 'Open posities',
            ordersHistory: 'Handel geschiedenis',
            id: 'ID',
            symbol: 'Symbool',
            type: 'Type',
            volume: 'Volume',
            openPrice: 'Open prijs',
            openTime: 'Open tijd',
            closePrice: 'Sluit prijs',
            closeTime: 'Sluitingstijd',
            sl: 'SL',
            tp: 'TP',
            price: 'Prijs',
            pnl: 'PnL',
            actions: 'Acties',
            edit: 'Bewerken',
            close: 'Sluiten',
            commission: 'Commissie',
            swap: 'Swap',
            swapLong: 'Ruil lang',
            swapShort: 'Wissel kort'
        },
        assetInfoModal: {
            assetInfo: 'Activa-info',
            tradingConditions: 'Handelsvoorwaarden',
            information: 'Informatie',
            bid: 'Bod',
            ask: 'Vragen',
            sessionChange: 'Sessie wijzigen',
            tradeNow: 'Nu handelen',
            opens: 'Opent',
            closes: 'Sluit',
            at: 'bij',
            open247: 'Open 24/7',
            today: 'Vandaag',
            tomorrow: 'Morgen',
            sunday: 'Zondag',
            monday: 'Maandag',
            tuesday: 'Dinsdag',
            wednesday: 'Woensdag',
            thursday: 'Donderdag',
            friday: 'Vrijdag',
            saturday: 'Zaterdag',
            contractSpecification: 'Contractspecificatie',
            symbol: 'Symbool',
            name: 'Naam',
            market: 'Markt',
            baseCurrency: 'Basisvaluta',
            digits: 'Cijfers',
            lotSize: 'Kavelgrootte',
            lotStep: 'Lot stap',
            minVolume: 'Min Volume',
            maxVolume: 'Max Volume',
            leverage: 'Hefboom',
            commission: 'Commissie',
            swapLong: 'Ruil lang',
            swapShort: 'Wissel kort',
            schedule: 'Schema',
            weekday: 'Weekdag',
            tradingTime: 'Handelstijd',
            closed: 'gesloten',
            sell: 'Verkopen',
            buy: 'Kopen',
            low: 'Laag',
            high: 'Hoog',
            oneHourChange: '1 uur wissel',
            oneDayChange: '1 dag verandering',
            oneWeekChange: '1 week wissel',
            oneMonthChange: '1 maand verandering',
            threeMonthsChange: '3 maanden verandering',
            oneYearChange: '1 jaar verandering',
            loading: 'Bezig met laden...',
        },
        fullScreen: {
            startTrading: 'Begin met handelen',
            deposit: 'Storting',
            dashboard: 'Dashboard',
            personalInfo: 'Persoonlijke informatie',
            withdrawal: 'Opname',
            verification: 'Verificatie',
            accounts: 'Rekeningen',
            liveChat: 'Live chatten',
            savings: 'Spaargeld',
            settings: 'Instellingen',
            logOut: 'Uitloggen',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            name: 'Cardholder\'s name',
            address: 'Address',
            DOB: 'DOB',
            bankName: 'Bank name',
            additionalInfo: 'Om meer op uw account te storten, neem rechtstreeks contact op met uw accountmanager',
            additionalInfoOnlyBTCpsp: 'Om andere betaalmethoden te openen, gelieve KYC te verstrekken of contact op te nemen met uw accountmanager',
            sofortPspMessage: 'Ons financiële team zal contact met u opnemen om u te helpen een storting te doen',
            addWalletAddress: 'Wallet for this deposit method is not set. Please contact your agent or support team.',
            addressReceipt: 'Please wait for the address to load',
            makeDeposit: 'STORTING DOEN',
            instant: 'Instant',
            minutes: 'minuten',
            hours: 'uur',
            days: 'dagen',
            amount: 'Bedrag',
            continue: 'Doorgaan met',
            qrCode: 'QR CODE',
            depositAddress: 'BETALINGS ADRES',
            copy: 'Kopiëren',
            last: 'LAATSTE',
            deposits: 'DEPOSITO\'S',
            time: 'Tijd',
            currency: 'Valuta',
            status: 'Toestand',
            info: 'Info',
        },
        fullScreenCcExt: {
            pleaseWait: 'Even geduld aub. Verbinding maken met betalingsdienstaanbieder...',
            cardPayment: 'Kaart betaling',
            inOrder: 'Om het bedrag te verzenden',
            pleaseProvide: 'geef kaartgegevens op:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Total Taxes',
            totalBalance: 'Eigen Vermogen',
            totalPnl: 'Totaal PNL',
            profitableOrders: 'Winstgevende posties',
            roi: 'ROI',
            activityLog: 'Activiteiten logboek',
            loginFromIp: 'Inloggen vanaf IP',
            tradingResults: 'Handelsresultaten',
            week: 'Week',
            month: 'Maand',
            year: 'Jaar',
            successRate: 'Slaagkans',
            closedWithProfit: 'Gesloten met winst',
            closedWithLoss: 'Gesloten met verlies',
            account: 'Account',
            balance: 'Balans',
            leverage: 'Hefboom',
            credit: 'Credit',
            tradeNow: 'Nu handelen',
            usingCurrentRate: 'met huidige wisselkoers',
            totalDeposits: 'Total Deposits'
        },
        fullScreenPersonal: {
            personalDetails: 'Persoonlijke gegevens',
            profilePhoto: 'Profielfoto',
            firstName: 'Voornaam',
            country: 'Land',
            lastName: 'Achternaam',
            address: 'Adres',
            email: 'E-mail',
            phone: 'Telefoonnummer',
            saveChanges: 'Wijzigingen opslaan',
        },
        fullScreenAvatar: {
            dropFile: 'Zet een bestand in de cirkel hierboven om te uploaden',
            notAllowed: 'Het is niet toegestaan ​​om te publiceren',
            notAllowedLine1: 'Foto\'s van expliciet seksuele of pornografische aard',
            notAllowedLine2: 'Afbeeldingen gericht op het aanzetten tot etnische of rassenhaat of agressie',
            notAllowedLine3: 'Foto\'s met personen jonger dan 18 jaar',
            notAllowedLine4: 'Auteursrechtelijk beschermde foto\'s van derden',
            notAllowedLine5: 'Afbeeldingen groter dan 5 MB en in een ander formaat dan JPG, GIF of PNG',
            requirements: 'Je gezicht moet duidelijk zichtbaar zijn op de foto. Alle door jou geüploade foto\'s en video\'s moeten aan deze eisen voldoen, anders kunnen ze worden verwijderd.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'Opname',
            requestNewWithdrawal: 'EEN NIEUWE OPNAME AANVRAGEN',
            amount: 'Bedrag',
            currentBalance: 'Uw huidige rekeningsaldo is',
            withdrawAll: 'Alles uitlaten betalen',
            requestWithdrawal: 'Uitbetaling aanvragen',
            last: 'LAATSTE',
            withdrawalRequests: 'INTREKKING VERZOEKEN',
            time: 'Tijd',
            currency: 'Valuta',
            info: 'Info',
            status: 'Toestand',
            bank: 'Bank',
            bitcoin: 'Bitcoin',
            card: 'Kaart',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'Uitbetalingsdetails',
            address: 'Portemonnee-adres',
            bankAccount: 'Rekeningnummer',
            bankHolder: 'Naam rekeninghouder',
            bankIban: 'IBAN',
            bankSwift: 'Bank SWIFT code',
            sortCode: 'Sorteercode',
            ifscCode: 'IFSC-code',
            bankCode: "Bankcode (BSB)",
            bankName: 'Banknaam',
            bankBranch: 'Bankfiliaal',
            cardNumber: 'Kaartnummer',
            cardHolder: 'Naam pashouder',
            incorrectAmountByFreeMargin: 'The amount is incorrect you can withdraw the amount of free margin',
            closeOrders: 'before close all orders'
        },

        fullScreenVerification: {
            dragAndDrop: 'slepen en neerzetten van het document naar dit gebied',
            documentsList: 'LIJST MET GEUPLOAD DOCUMENTEN',
            document: 'Document',
            timeUploaded: 'Tijd geüpload',
            timeProcessed: 'Tijd verwerkt',
            status: 'Toestand',
            types: ['Bewijs van Id', 'Bewijs van Residentie', 'Creditcard voorzijde', 'Creditcard achterzijde', 'Bewijs van identiteitsbewijs achterzijde', 'Selfie','Other'],
            types2: ['Proof of Id (ID CARD, PASSPORT, DRIVER LICENCE)', 'Proof of Residence (Utility bill or Bank statement)', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back (ID CARD BACK, DRIVER LICENCE BACK)', 'Selfie','Other'],
            upload: 'Uploaden',
            isConfirmed: 'bevestigd',
            uploadAnotherDocument: 'Nog een document uploaden',
            isUnderReview: 'wordt beoordeeld',
            questionnaire: 'Vragenlijst',
            sendAnswers: 'Send Answers',
            progressBarOf: 'van',
            progressBarText: 'Van uw documenten zijn geüpload en bevestigd'
        },
        fullScreenAccounts: {
            manageAccounts: 'Geld overboeken tussen uw rekeningen',
            transferFrom: 'Van account',
            transferTo: 'Verklaren',
            amount: 'Bedrag',
            makeTransfer: 'Overboeking maken',
            yourAccounts: 'Uw rekeningen',
            account: 'Account',
            currency: 'Valuta',
            balance: 'Balans',
            credit: 'Credit',
            makeActive: 'Maak actief',
            active: 'Actief'
        },
        fullScreenSupport: {
            chatOff: 'Chat will be available on working days',
            sendMessage: 'Bericht versturen',
            responseTime: 'Gemiddelde reactietijd: 1-24 uur',
        },
        fullScreenSavings: {
            pct_0: 'Flexibel',
            pct_30: '1 maand vergrendeld',
            pct_90: '1 Kwart vergrendeld',
            pct_180: '6 maanden vergrendeld',
            pct_365: '1 jaar vergrendeld',
            pct_730: '2 jaar vergrendeld',
            savings: 'Besparingen',
            detailedInformation: 'Gedetailleerde informatie',
            pleaseSelect: 'Selecteer een valuta en een periode',
            openSavings: 'Spaargeld openen',
            currentTime: 'Huidige tijd',
            releaseTime: 'Vrijgavetijd',
            currencyChosen: 'Valuta gekozen',
            periodChosen: 'Periode gekozen',
            yourRate: 'Uw tarief',
            yourAnnualRate: 'Uw jaarlijkse tarief',
            yourEarnings: 'Uw verdiensten',
            accountFrom: 'Rekening om geld van over te boeken',
            enterAmount: 'Voer een bedrag in',
            in: 'In',
            openAndInvest: 'Spaarrekening openen en beleggen',
            investment: 'Investering',
            period: 'Periode',
            daysTotal: 'Dagen totaal',
            finalEarnings: 'Eindinkomsten',
            created: 'gemaakt',
            daysElapsed: 'Verstreken dagen',
            days: 'dagen',
            earnings: 'Verdiensten',
            fundsReleasedIn: 'Fondsen vrijgegeven in',
            claim: 'Beweren',
        },
        fullScreenSettings: {
            updatePassword: 'VERNIEUW WACHTWOORD',
            currentPassword: 'Huidig ​​wachtwoord',
            newPassword: 'Nieuw wachtwoord',
            changePassword: 'Verander wachtwoord',
            activationForGoogle: 'Activation code for Google Authenticator',
            activateAndEnter: 'Activeer Authenticator en voer een gegenereerde code in het onderstaande veld in',
            qrCode: 'QR Code',
            activateProtection: 'Activeer 2FA-beveiliging',
            protectionActive: '2FA-beveiliging is actief',
            twoFactorCode: '2FA-Code',
            disableProtection: 'Schakel 2FA-beveiliging uit',
            language: 'Taal',
            dashboardCurrency: 'Dashboardvaluta',
            confirmNewPassword: 'Bevestig nieuw wachtwoord',
        },
        fullScreenReferrals: {
            yourLink: 'JOUW VERWIJSLINK',
            referredFriends: 'VERWEZEN VRIENDEN',
            id: 'ID',
            name: 'Naam',
            registered: 'geregistreerd',
            level: 'Niveau',
            payout: 'Uitbetaling',
            lastPayouts: 'LAATSTE VERWIJZINGSUITBETALINGEN',
            time: 'Tijd',
            amount: 'Bedrag',
            currency: 'Valuta',
            info: 'Info'
        },
        months: {
            Jan: 'Jan',
            Feb: 'Feb',
            Mar: 'Mar',
            Apr: 'Apr',
            May: 'Mei',
            Jun: 'Jun',
            Jul: 'Jul',
            Aug: 'Aug',
            Sep: 'Sep',
            Oct: 'Okt',
            Nov: 'Nov',
            Dec: 'Dec'
        },
        orderTypes: ['Kopen', 'Verkopen', 'Kooplimiet', 'Verkooplimiet', 'Koopstop', 'Verkoopstop'],
        statuses: ['In behandeling', 'Goedgekeurd', 'Geweigerd', 'Bezig met verwerken','In beoordeling','In Process','Geannuleerd'],
        errors: {
            INVALID_FIELDS: 'Please check that the data you have entered is correct',
            NOT_FOUND: 'Verzoek fout',
            FORBIDDEN: 'Toegang geweigerd. Gelieve opnieuw in te loggen',
            SERVER_ERROR: 'Actie: mislukt. Probeer het later opnieuw',
            INVALID_ACCOUNT: 'Sessie verlopen. Gelieve opnieuw in te loggen',
            INVALID_EMAIL: 'Ongeldig e-mailadres',
            INVALID_PHONE: 'Ongeldig telefoonnummer',
            INVALID_COUNTRY: 'Ongeldig land',
            INVALID_LOGIN: 'Ongeldige inloggegevens',
            USER_BLOCKED: 'Account is geblokkeerd. Neem contact op met ondersteuning',
            USER_REGISTERED: 'Gebruiker met ingevoerd e-mailadres of telefoonnummer is al geregistreerd',
            INVALID_USER: 'Gebruiker is niet gevonden',
            REJECTED: 'Bediening is niet toegestaan ​​vanwege platformbeperkingen',
            INVALID_OLD_PASSWORD: 'Oud wachtwoord is ongeldig',
            INVALID_SYMBOL: 'Ongeldig handelssymbool',
            INVALID_SYMBOL_PRECISION: 'Invalid symbol precision',
            INVALID_FRAME: 'Ongeldig kaartframe',
            INVALID_CURRENCY: 'Ongeldige valuta',
            INVALID_PRODUCT: 'Ongeldig handelstype account',
            INSUFFICIENT_FUNDS: 'Onvoldoende middelen',
            INVALID_WITHDRAWAL: 'Opname niet gevonden',
            INVALID_DEPOSIT: 'Deze storting kan niet meer worden geannuleerd - niet gevonden of al verwerkt',
            INVALID_STATUS: 'Ongeldige status',
            INVALID_FILE: 'Ongeldige bestandsextensie of bestand is te groot',
            INVALID_DOCUMENT: 'Document niet gevonden',
            INVALID_NAME: 'Ongeldige naam',
            INVALID_LOT_SIZE: 'Ongeldige partijgrootte',
            INVALID_LOT_STEP: 'Ongeldige partijstap',
            INVALID_MIN_VOLUME: 'Ongeldig minimaal volume',
            INVALID_MAX_VOLUME: 'Ongeldig maximaal volume',
            INVALID_GROUP: 'Ongeldige groep',
            INVALID_SPREAD: 'Ongeldige spreiding',
            REQUEST_TIMEOUT: 'Verzoek time-out. Probeer het later opnieuw',
            INVALID_TYPE: 'Ongeldig ordertype',
            INVALID_VOLUME: 'Ongeldig bestelvolume',
            INVALID_SL: 'Ongeldige stop loss-waarde',
            INVALID_TP: 'Ongeldige winstwaarde',
            INVALID_PRICE: 'Ongeldige bestelprijs',
            INVALID_EXPIRATION: 'Ongeldige vervaldatum van bestelling',
            NOT_ENOUGH_MARGIN: 'Niet genoeg marge',
            INVALID_ORDER: 'Bestelling niet gevonden',
            MARKET_CLOSED: 'Handelen is niet mogelijk. Probeer het opnieuw',
            INVALID_BALANCE_TYPE: 'Ongeldig type saldobewerking',
            INVALID_HASH: 'Ongeldige hash',
            HASH_EXPIRED: 'De link voor het opnieuw instellen van uw wachtwoord is verlopen. Vraag een nieuwe aan',
            INVALID_CODE: 'Ongeldige 2FA-code',
            CHAT_DISABLED: 'Toegang tot de supportchat is gesloten',
            WITHDRAWAL_NOT_ALLOWED: 'Toegang tot de opnames is gesloten',
            TRADING_DISABLED: 'Handelen is uitgeschakeld voor lopende rekening',
            PENDING_DEPOSITS_LIMIT: 'Slechts één lopende storting toegestaan',
            CLOSE_OPEN_ORDERS: 'Sluit alstublieft uw open orders',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'Slechts één lopende opname toegestaan',
            LOCAL_DEPOSIT_ONLY_REAL: 'Storting is alleen beschikbaar voor een echt account',
            LOCAL_DEPOSIT_POSITIVE: 'Het aanbetalingsbedrag moet meer dan 0 zijn',
            LOCAL_INVALID_CARD_NUMBER: 'Ongeldig kaart nummer',
            LOCAL_INVALID_CARD_EXPIRATION: 'Ongeldige kaart vervalt',
            LOCAL_INVALID_CVC: 'Ongeldige CVV/CVC code',
            LOCAL_PASSWORDS_NOT_MATCH: 'Wachtwoorden komen niet overeen, gelieve opnieuw in te voeren',
            LOCAL_NO_TRADING_ACCOUNTS: 'U heeft geen handelsaccounts beschikbaar. Neem contact op met de ondersteuning',
            LOCAL_MIN_DEPOSIT: 'Minimum deposit is $',
            LOCAL_MIN_WITHDRAWAL: 'Minimum opnamebedrag is $',
            LOCAL_INVALID_FILE_TYPE: 'Bestands formaat niet ondersteund. Gelieve alleen JPG, PNG of PDF bij te voegen',
            LOCAL_MIN_STAKING: 'Minimum deposit for this currency is ',
            FLOOD_REJECTED: 'You are sending messages too often. Please try again later',
            REGISTRATIONS_BLOCKED: "Bedankt voor uw aanvraag, Een van onze vertegenwoordigers neemt zo snel mogelijk contact met u op",
        },
        countries: {
            AF: 'Afghanistan',
            AX: 'Aland-eilanden',
            AL: 'Albanië',
            DZ: 'Algerije',
            AS: 'Amerikaans Samoa',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarctica',
            AG: 'Antigua En Barbuda',
            AR: 'Argentinië',
            AM: 'Armenië',
            AW: 'Aruba',
            AU: 'Australië',
            AT: 'Oostenrijk',
            AZ: 'Azerbeidzjan',
            BS: 'Bahamas',
            BH: 'Bahrein',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BY: 'Wit-Rusland',
            BE: 'België',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivia',
            BA: 'Bosnië en Herzegovina',
            BW: 'Botswana',
            BV: 'Bouvet-eiland',
            BR: 'Brazilië',
            IO: 'Brits Territorium in de Indische Oceaan',
            BN: 'Brunei Darussalam',
            BG: 'Bulgarije',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambodja',
            CM: 'Kameroen',
            CA: 'Canada',
            CV: 'Kaapverdië',
            KY: 'Kaaimaneilanden',
            CF: 'Centraal-Afrikaanse Republiek',
            TD: 'Tsjaad',
            CL: 'Chili',
            CN: 'China',
            CX: 'Christmas Island',
            CC: 'Cocos (Keeling) Islands',
            CO: 'Colombia',
            KM: 'Comoren',
            CG: 'Congo',
            CD: 'Congo, Democratische Republiek',
            CK: 'Cook Islands',
            CR: 'Costa Rica',
            CI: 'Ivoorkust',
            HR: 'Kroatië',
            CU: 'Cuba',
            CY: 'Cyprus',
            CZ: 'Tsjechië',
            DK: 'Denemarken',
            DJ: 'Djibouti',
            DM: 'Dominica',
            DO: 'Dominicaanse Republiek',
            EC: 'Ecuador',
            EG: 'Egypte',
            SV: 'El Salvador',
            GQ: 'Equatoriaal-Guinea',
            ER: 'Eritrea',
            EE: 'Estland',
            ET: 'Ethiopië',
            FK: 'Falklandeilanden (Malvinas)',
            FO: 'Faeröer Eilanden',
            FJ: 'Fiji',
            FI: 'Finland',
            FR: 'Frankrijk',
            GF: 'Frans-Guyana',
            PF: 'Frans-Polynesië',
            TF: 'Franse zuidelijke gebieden',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgië',
            DE: 'Duitsland',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GR: 'Griekenland',
            GL: 'Groenland',
            GD: 'Grenada',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haïti',
            HM: 'Heard Island & Mcdonald Islands',
            VA: 'Heilige Stoel (Vaticaanstad)',
            HN: 'Honduras',
            HK: 'Hong Kong',
            HU: 'Hongarije',
            IS: 'IJsland',
            IN: 'India',
            ID: 'Indonesië',
            IR: 'Iran',
            IQ: 'Irak',
            IE: 'Ierland',
            IM: 'Isle Of Man',
            IL: 'Israëll',
            IT: 'Italië',
            JM: 'Jamaica',
            JP: 'Japan',
            JE: 'Jersey',
            JO: 'Jordanië',
            KZ: 'Kazachstan',
            KE: 'Kenia',
            KI: 'Kiribati',
            KR: 'Korea',
            KW: 'Koeweit',
            KG: 'Kirgizië',
            LA: 'Lao Democratische Volksrepubliek',
            LV: 'Letland',
            LB: 'Libanon',
            LS: 'Lesotho',
            LR: 'Liberia',
            LY: 'Libische Arabische Jamahiriya',
            LI: 'Liechtenstein',
            LT: 'Litouwen',
            LU: 'Luxembourg',
            MO: 'Macao',
            MK: 'Macedonië',
            MG: 'Madagascar',
            MW: 'Malawi',
            MY: 'Maleisië',
            MV: 'Malediven',
            ML: 'Mali',
            MT: 'Malta',
            MH: 'Marshalleilanden',
            MQ: 'Martinique',
            MR: 'Mauritanië',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Mexico',
            FM: 'Micronesië',
            MD: 'Moldavië',
            MC: 'Monaco',
            MN: 'Mongolië',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MA: 'Morokko',
            MZ: 'Mozambique',
            MM: 'Myanmar',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NL: 'Nederland',
            AN: 'Nederlandse Antillen',
            NC: 'Nieuw-Caledonië',
            NZ: 'Nieuw-Zeeland',
            NI: 'Nicaragua',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            NF: 'Norfolkeiland',
            MP: 'Noordelijke Marianen',
            NO: 'Noorwegen',
            OM: 'Oman',
            PK: 'Pakistan',
            PW: 'Palau',
            PS: 'Palestijns grondgebied, bezet',
            PA: 'Panama',
            PG: 'Papoea-Nieuw-Guinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PH: 'Filipijnen',
            PN: 'Pitcairn',
            PL: 'Polen',
            PT: 'Portugal',
            PR: 'Puerto Rico',
            QA: 'Qatar',
            RE: 'Reunion',
            RO: 'Roemenië',
            RU: 'Rusland',
            RW: 'Rwanda',
            BL: 'Saint Barthelemy',
            SH: 'Saint Helena',
            KN: 'Saint Kitts En Nevis',
            LC: 'Saint Lucia',
            MF: 'Saint Martin',
            PM: 'Saint Pierre En Miquelon',
            VC: 'Saint Vincent En Grenadines',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Sao Tomé en Principe',
            SA: 'Saoedi-Arabië',
            SN: 'Senegal',
            RS: 'Servië',
            SC: 'Seychellen',
            SL: 'Sierra Leone',
            SG: 'Singapore',
            SK: 'Slovakije',
            SI: 'Slovenië',
            SB: 'Salomonseilanden',
            SO: 'Somalië',
            ZA: 'Zuid-Afrika',
            GS: 'Zuid-Georgië en Sandwich-eilanden',
            ES: 'Spanje',
            LK: 'Sri Lanka',
            SD: 'Soedan',
            SR: 'Suriname',
            SJ: 'Svalbard En Jan Mayen',
            SZ: 'Swaziland',
            SE: 'Zweden',
            CH: 'Zwitserland',
            SY: 'Syrische Arabische Republiek',
            TW: 'Taiwan',
            TJ: 'Tadzjikistan',
            TZ: 'Tanzania',
            TH: 'Thailand',
            TL: 'Timor Leste',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad En Tobago',
            TN: 'Tuvalu',
            TR: 'Turkije',
            TM: 'Turkmenistan',
            TC: 'Turks- en Caicoseilanden',
            TV: 'Tuvalu',
            UG: 'Oeganda',
            UA: 'Oekraïne',
            AE: 'Verenigde Arabische Emiraten',
            GB: 'Verenigd Koninkrijk',
            US: 'Verenigde Staten',
            UM: 'Verenigde Staten perifere eilanden',
            UY: 'Uruguay',
            UZ: 'Oezbekistan',
            VU: 'Vanuatu',
            VE: 'Venezuela',
            VN: 'Vietnam',
            VG: 'Maagdeneilanden, Brits',
            VI: 'Maagdeneilanden, VS',
            WF: 'Wallis En Futuna',
            EH: 'Westelijke Sahara',
            YE: 'Jemen',
            ZM: 'Zambia',
            ZW: 'Zimbabwe'
        },
    },
    sa: {
        _name: 'Arabic',
        autoCloseModal: {
            takeProfitStopLoss: 'جني الأرباح وإيقاف الخسارة',
            takeProfit: 'جني الأرباح',
            stopLoss: 'وقف الخسارة',
            updateOrder: 'تحديث الطلب',
        },
        balanceModal: {
            balance: 'تحسين',
            credit: 'حيوي',
            equity: 'صافي الرصيد',
            practice: 'الممارسة',
            real: 'حقيقي',
            account: 'الحساب',
            invested: 'استثمر',
            profit: 'ربح',
            loss: 'خسارة',
            margin: 'الهامش',
            marginLevel: 'مستوى الهامش',
            marginFree: 'الهامش الحر'
        },
        header: {
            cfd: 'العقود مقابل الفروقات (CFD)',
            platform: 'المنصة',
            deposit: 'إيداع',
            myAccount: 'حسابي'
        },
        sideMenu: {
            marketWatch: 'مراقبة السوق',
            activeOrders: 'أوامر مخصصة',
            tradingHistory: 'تاريخ التداول',
            economicCalendar: 'التقويم الاقتصادي',
            marketNews: 'أخبار السوق'
        },
        closePositionModal: {
            closeOrder: 'إغلاق الصفقة',
            areYouSure: 'هل أنت متأكد من إغلاق الصفقة',
            buy: 'اشترى',
            sell: 'بيع',
            yes: 'نعم',
            no: 'لا',
        },
        chart: {
            addNewChart: 'إضافة رسم بياني جديد',
        },
        symbolsModal: {
            watchlist: 'قائمة المراقبة',
            asset: 'الأصل',

            price: 'السعر',
            changePct: 'تغيير 24 ساعة'
        },
        pendingModal: {
            pending: 'معلق',
            assetPrice: 'سعر الأصول',
            current: 'الحالي',
            revert: 'العودة إلى سعر السوق',
            automatically: 'فتح الصفقة تلقائيًا عندما يصل السعر إلى هذا المستوى'
        },
        orderMenu: {
            volume: 'الحجم',
            lots: 'اللوتات',
            units: 'الوحدات',
            currency: 'في المقابل',
            contractSize: 'حجم العقد',
            position: 'الصفقة ',
            margin: 'الهامش',
            freeMargin: 'الهامش الحر',
            takeProfitStopLoss: 'جني الأرباح وإيقاف الخسارة',
            pending: 'معلق',
            market: 'السوق',
            leverage: 'الرافعة المالية',
            spread: 'هامش السعر',
            notSet: 'غير محدد',
            at: 'عند',
            buy: 'اشترى',
            sell: 'بيع',
        },
        footer: {
            supportBanner: 'كل يوم ، على مدار الساعة',
            currentTime: 'الوقت الحالي',
            liveChat: 'الدردشة الحية'
        },
        statusBar: {
            balance: 'تحسين',
            credit: 'حيوي',
            equity: 'صافي الرصيد',
            margin: 'الهامش',
            marginLevel: 'مستوى الهامش',
            freeMargin: 'الهامش الحر',
            pnl: 'الأرباح والخسائر (PnL)',
            profitTotal: 'PNL مدى الحياة'
        },
        accountModal: {
            dateRegistered: 'تاريخ التسجيل',
            userId: 'معرف المستخدم',
            dashboard: 'المنصة',

            personalData: 'البيانات الشخصية',
            deposit: 'إيداع',
            withdrawFunds: 'سحب الأموال',
            savings: 'مدخرات',
            settings: 'الإعدادات',
            logout: 'تسجيل الخروج'
        },
        depositModal: {
            BT_INN: 'INN',
            BT_KPP: 'حساب المراسل',
            BT_CORRESPONDING: '',
            BT_INVOICE: 'أدخل مبلغ وإنشاء الفاتورة',
            BT_TITLE: 'تفاصيلنا المصرفية',
            BT_ACCOUNT: 'الحساب',
            BT_BANK_NAME: 'اسم البنك',
            BT_BENEFICIARY: 'المستفيد',
            BT_ADDRESS: 'عنوان المستفيد',
            BT_SWIFT: 'سويفت',
            BT_IBAN: 'رقم الحساب بصيغة IBAN',
            BT_REFERENCE_CODE : 'رمز المرجع البنكي',
            TOKEN_AMOUNT: 'المبلغ',
            TOKEN_SUBTOTAL: 'المجموع الفرعي',
            TOKEN_TOTAL: 'الإجمالي',
            TOKEN_DESCRIPTION: 'الوصف',
            TOKEN_PAYMENT_DETAILS: 'تفاصيل الدفع',
            PENDING_DEPOSITS_LIMIT: 'حد الإيداع',
            makeDeposit: 'قم بإيداع',
            practiceAccount: 'الحساب التجريبي',
            realAccount: 'حساب حقيقي',
            noWithdrawals: 'لا توجد عمليات سحب',
            easyWithdrawals: 'عمليات سحب سهلة',
            allAssets: 'جميع الأصول المتاحة',
            fullFledged: 'منصة ذات أركان كاملة',
            fillUpTo: 'التعبئة حتى',
            freeReplenishment: 'تجديد مجاني',
            topUp: 'اشحن حسابك',
            minimumAmount: 'الحد الأقصى',
            canSwitch: 'يمكنك إجراء عمليات بين حساباتك في أي لحظة'
        },
        gridsModal: {
            chartGrids: 'شبكات الرسم البياني',
            chart1: '1 رسم بياني',
            chart2: '2 رسومات بيانية',
            chart3: '3 رسومات بيانية',
            chart4: '4 رسومات بيانية',
        },
        noConnectionModal: {
            connectionLost: 'تم فقد الاتصال بالخادم',
            retryNow: 'إعادة المحاولة الآن',
        },
        loginModal: {
            loginToTradeRoom: 'تسجيل الدخول إلى غرفة التداول',

            email: 'عنوان البريد الإلكتروني',
            emailAndId: 'عنوان البريد الإلكتروني / رقم الهوية',
            enterEmail: 'أدخل البريد الإلكتروني',
            twoFactor: 'رمز المصادقة ذات العاملين 2FA (إذا تم تمكينه)',
            twoFactorAuth: 'المصادقة ذات العاملين',
            password: 'كلمة المرور',
            yourPassword: 'كلمة مرورك',
            signIn: 'تسجيل الدخول',
            dontHaveAccount: 'ليس لديك حساب؟',
            restore: 'استعادة',
            fullName: 'الاسم الكامل',
            havePromo: 'لدي رمز ترويجي',
            promo: 'الرمز الشعيبي',
            login: 'تسجيل الدخول',
            haveAccount: 'هل لديك حساب بالفعل؟',
            hide: 'إخفاء',
            goTo: 'العودة إلى الخلف'
        },
        newPasswordModal: {
            setNewPassword: 'تعيين كلمة مرور جديدة',
            newPassword: 'كلمة مرور جديدة',
            confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
            setButton: 'تعيين'
        },
        registerModal: {
            createNewAccount: 'إنشاء حساب جديد',
            email: 'عنوان البريد الإلكتروني',
            firstName: 'الاسم الأول',
            lastName: 'اسم العائلة',
            country: 'الدولة',
            phone: 'الهاتف',
            password: 'كلمة المرور',
            createAccount: 'إنشاء حساب',
            currency: 'في المقابل'
        },
        forgotPasswordModal: {
            forgotPassword: 'هل نسيت كلمة المرور؟',
            submitEmail: 'الرجاء إدخال بريد إلكتروني مستخدم للتسجيل ، وتحقق من صندوق الوارد الخاص بك واتبع التعليمات',
            submit: 'إرسال'
        },
        notifications: {
            error: 'خطأ',
            success: 'النجاح',
            deposit: 'إيداع',
            withdrawal: 'سحب الاموال',
            depositApproved: 'الموافقة على الإيداع',
            depositDeclined: 'تم رفض الإيداع',
            withdrawalApproved: 'الموافقة على عملية سحب الاموال',
            withdrawalDeclined: 'تم رفض عملية سحب الاموال',
            withdrawalCancelled: 'تم إلغاء السحب',
            orderRejected: 'تم رفض الأمر',
            insufficientMargin: 'تعذر فتح أمرك المعلق: الهامش الحر غير كافٍ',
            marginCall: 'نداء الهامش',
            marginCallText: 'يرجى إجراء إيداع لتلبية متطلبات الهامش'
        },
        markets: {
            forex: 'فوركس',
            stocks: 'الأسهم',
            commodities: 'السلع',
            indices: 'المؤشرات',
            crypto: 'العملات المشفرة',
            metals: 'المعادن',
            nft: 'NFT'
        },
        profitCalculatorModal: {
            buy: 'اشترى',
            profitCalculator: 'حاسبة الربح',
            sell: 'بيع',
            volume: 'الحجم',
            entryPrice: 'سعر الدخول',
            takeProfit: 'جني الأرباح',
            stopLoss: 'وقف الخسارة',
            maxPosition: 'أقصى حد للصفقة',
            calculate: 'احسب',
            calculationsFor: 'حسابات تخص',
            leverage: 'الرافعة المالية',
            requiredMargin: 'الهامش المطلوب',
            profitFromTP: 'الربح من جني الأرباح',
            lossFromSL: 'خسارة من إيقاف الخسارة',
            roe: 'العائد على الاستثمار',
        },
        depositSuccessModal: {
            title: 'تم الايداع بنجاح',
            text: 'تمت بنجاح عملية الايداع!',
        },
        depositFailModal: {
            title: 'فشل الإيداع',
            text: 'لم تتم عملية الايداع.',
        },
        widgetMarketWatch: {
            marketWatch: 'مراقبة السوق',
            search: 'بحث ...',
        },
        widgetOrders: {
            commission: 'العمولة',
            volume: 'الحجم',
            margin: 'الهامش',
            active: 'نشط',
            pending: 'معلق',
            activeOrders: 'أوامر مخصصة',
            portfolio: 'محفظة',

            allPositions: 'جميع الصفقات',
            noPositionsLine1: 'ليس لديك',
            noPositionsLine2: 'الصفقات حتى الآن',
            show: 'عرض',
            more: 'اكثر',
            less: 'أقل',
            purchaseTime: 'وقت الشراء',
            closePosition: 'إغلاق الصفقة',
            priceOpen: 'سعر الشراء',
            priceSl: 'سعر إيقاف الخسارة',
            priceTp: 'سعر جني الأرباح',
            type: 'إات الصفقة',
            pnl: 'ربح / خسارة',
            cancelOrder: 'إلغاء الصفقة',
            orderType: 'نوع الطلب',
            cancelled: 'ملغاة',
            tradingHistory: 'تاريخ التداول',
            noHistoryLine1: 'أنت لم',
            noHistoryLine2: 'الصفقات المغلقة حتى الآن',
            sortByTime: 'فرز حسب الوقت',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'التقويم الاقتصادي'
        },
        widgetMarketNews: {
            marketNews: 'أخبار السوق'
        },
        ordersPane: {
            ordersActive: 'أوامر مخصصة',
            ordersHistory: 'سجل الأوامر',
            id: 'المعرف',
            symbol: 'الرمز',
            type: 'النوع',
            volume: 'الحجم',
            openPrice: 'سعر الفتح',
            openTime: 'وقت الفتح ',
            closePrice: 'سعر الإغلاق',
            closeTime: 'وقت الإغلاق',
            sl: 'إيقاف الخسارة',
            tp: 'جني الأرباح',
            price: 'السعر',
            pnl: 'الأرباح والخسائر (PnL)',
            actions: 'الإجراءات',
            edit: 'تحرير',
            close: 'إغلاق',
            commission: 'العمولة',
            swap: 'مبادلة',
            swapLong: 'مبادلة شراء',
            swapShort: 'مبادلة بيع'

        },
        assetInfoModal: {
            assetInfo: 'معلومات حول الأصول',
            tradingConditions: 'شروط التداول',
            information: 'المعلومات',
            bid: 'عرض',
            ask: 'طلب',
            sessionChange: 'تغيير الجلسة',
            tradeNow: 'تداول الآن',
            opens: 'يفتح',
            closes: 'يغلق',
            at: 'في',
            open247: 'مفتوح 24/7',
            today: 'اليوم',
            tomorrow: 'غدا',
            sunday: 'الأحد',
            monday: 'الاثنين',
            tuesday: 'الثلاثاء',
            wednesday: 'الأربعاء',
            thursday: 'الخميس',
            friday: 'الجمعة',
            saturday: 'السبت',
            contractSpecification: 'مواصفات العقد',
            symbol: 'الرمز',
            name: 'اسم',
            market: 'السوق',
            baseCurrency: 'الأساسي',
            digits: 'الأرقام',
            lotSize: 'حجم اللوت',
            lotStep: 'خطوة نحو اللوت',
            minVolume: 'الحجم الأدنى',
            maxVolume: 'الحجم الأقصى',
            leverage: 'الرافعة المالية',
            commission: 'العمولة',
            swapLong: 'مبادلة شراء',
            swapShort: 'مبادلة بيع',
            schedule: 'جدول',
            weekday: 'يوم من أيام الأسبوع',
            tradingTime: 'وقت التداول',
            closed: 'مغلق',
            sell: 'بيع',
            buy: 'شراء',
            low: 'منخفض',
            high: 'عالي',
            oneHourChange: 'تغيير ساعة لمدة',
            oneDayChange: 'تغيير يوم واحد',
            oneWeekChange: 'تغيير أسبوع واحد',
            oneMonthChange: 'تغيير شهر واحد',

            threeMonthsChange: 'تغيير 3 أشهر',
            oneYearChange: 'تغيير سنة لمدة واحدة',
            loading: 'جارى التحميل ...',
        },
        fullScreen: {
            startTrading: 'ابدأ التداول',
            deposit: 'إيداع',
            dashboard: 'منصة التداول',
            personalInfo: 'المعلومات الشخصية',
            withdrawal: 'السحب',
            verification: 'التحقق',
            accounts: 'الحسابات',
            liveChat: 'الدردشة الحية',
            savings: 'مدخرات',
            settings: 'الإعدادات',
            logOut: 'تسجيل الخروج',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            name: 'Cardholder\'s name',
            address: 'Address',
            DOB: 'DOB',
            bankName: 'Bank name',
            additionalInfo: 'لإيداع المزيد في حسابك، يرجى الاتصال بمدير حسابك مباشرةً',
            additionalInfoOnlyBTCpsp: 'لفتح طرق الدفع الأخرى، يرجى تقديم KYC أو الاتصال بمدير الحساب الخاص بك',
            sofortPspMessage: 'فريقنا المالي سيتصل بك لمساعدتك في إيداع المبلغ',
            addWalletAddress: 'لم يتم تعيين المحفظة لطريقة الإيداع هذه. يرجى الاتصال بوكيلك أو فريق الدعم.',
            addressReceipt: 'الرجاء الانتظار حتى يتم تحميل العنوان',
            makeDeposit: 'قم بإيداع',
            instant: 'فوري',
            minutes: 'دقائق',
            hours: 'ساعات',
            days: 'أيام',
            amount: 'المبلغ',
            continue: 'متابعة',
            qrCode: 'كود QR',
            depositAddress: 'عنوان الإيداع',
            copy: 'نسخ',
            last: 'آخر',
            deposits: 'الايداعات',
            time: 'التوقيت',
            currency: 'في المقابل',
            status: 'الحالة',
            info: 'معلومات',
        },
        fullScreenCcExt: {
            pleaseWait: 'يرجى الانتظار. جاري الاتصال بمزود خدمة الدفع ...',
            cardPayment: 'بطاقة الدفع',
            inOrder: 'من أجل إرسال المبلغ',
            pleaseProvide: 'يرجى ادخال تفاصيل البطاقة:'
        },
        fullScreenDashboard: {
            totalTaxes: 'Total Taxes',
            totalBalance: 'ارتفاع إجمالي',
            totalPnl: 'إجمالي الأرباح والخسائر',
            profitableOrders: 'أوامر مربحة',
            roi: 'عائد الاستثمار',

            activityLog: 'سجل النشاط',
            loginFromIp: 'تسجيل الدخول من IP',
            tradingResults: 'نتائج التداول',
            week: 'اسبوع',
            month: 'شهر',
            year: 'سنة',
            successRate: 'معدل النجاح',
            closedWithProfit: 'مغلق بالربح',
            closedWithLoss: 'مغلق بالخسارة',
            account: 'الحساب',
            balance: 'تحسين',
            leverage: 'الرافعة المالية',
            credit: 'حيوي',
            tradeNow: 'تداول الآن',
            usingCurrentRate: 'استخدام سعر الصرف الحالي',
            totalDeposits: 'إجمالي الودائع'
        },
        fullScreenPersonal: {
            personalDetails: 'التفاصيل الشخصية',
            profilePhoto: 'صورة الملف الشخصي',
            firstName: 'الاسم الأول',
            country: 'الدولة',
            lastName: 'اسم العائلة',
            address: 'العنوان',
            email: 'البريد الإلكتروني',
            phone: 'رقم الهاتف',
            saveChanges: 'حفظ التغييرات',
        },
        fullScreenAvatar: {
            dropFile: 'أسقط ملف',
            notAllowed: 'ممنوع النشر',
            notAllowedLine1: 'صور ذات جنسية أو إباحية صريحة',
            notAllowedLine2: 'المضايقة أو العدوان أو الإثني أو العرقي',
            notAllowedLine3: 'صور لأكبر عدد من الأعضاء',
            notAllowedLine4: 'الصور المحمية الطبع والنشر من جهات خارجية',
            notAllowedLine5: 'الصور التي يزيد حجمها عن 5 ميغابايت وبتنسيق غير JPG أو GIF أو PNG',
            requirements: 'يجب أن يكون وجهك ظاهرًا بوضوح في الصورة. يجب أن تتوافق جميع الصور ومقاطع الفيديو التي تحمّلها مع هذه المتطلبات، وإلا فقد تتم إزالتها.'
        },
        fullScreenWithdrawal: {
            withdrawal: 'سحب',
            requestNewWithdrawal: 'طلب سحب جديد',
            amount: 'المبلغ',
            currentBalance: 'رصيد حسابك الجاري هو',
            withdrawAll: 'سحب كل المبلغ',
            requestWithdrawal: 'طلب سحب',
            last: 'آخر',
            withdrawalRequests: 'طلبات السحب',

            time: 'التوقيت',
            currency: 'في المقابل',
            info: 'معلومات',
            status: 'الحالة',
            bank: 'البنك',
            bitcoin: 'Bitcoin',
            card: 'بطاقة',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: 'تفاصيل السحب',
            address: 'عنوان المحفظة',
            bankAccount: 'رقم الحساب',
            bankHolder: 'اسم صاحب الحساب',
            bankIban: 'رقم الحساب بصيغة IBAN',
            bankSwift: 'رمز SWIFT للمصرف',
            sortCode: 'كود التصنيف',
            ifscCode: 'كود ال IFSC',
            bankCode: "رمز البنك (BSB)",
            bankName: 'اسم البنك',
            bankBranch: 'فرع البنك',
            cardNumber: 'رقم البطاقة',
            cardHolder: 'اسم حامل البطاقة',
            incorrectAmountByFreeMargin: 'The amount is incorrect you can withdraw the amount of free margin',
            closeOrders: 'before close all orders'
        },
        fullScreenVerification: {
            dragAndDrop: 'قم بسحب المستند وإفلاته في هذه المنطقة',
            documentsList: 'قائمة المستندات المحملة',
            document: 'المستند',
            timeUploaded: 'وقت التحميل',
            timeProcessed: 'معالجة الوقت',
            status: 'الحالة',
            types: ['إثبات بطاقة الهوية', 'دليل الإقامة', 'واجهة بطاقة الائتمان', 'ظهر بطاقة الائتمان', 'إثبات ظهر بطاقة الهوية',
                'سيلفي','Other'],
            types2: ['Proof of Id (ID CARD, PASSPORT, DRIVER LICENCE)', 'Proof of Residence (Utility bill or Bank statement)', 'Credit Card Front', 'Credit Card Back', 'Proof of Id Back (ID CARD BACK, DRIVER LICENCE BACK)', 'Selfie','Other'],
            upload: 'تحميل',
            isConfirmed: 'تم التأكيد',
            uploadAnotherDocument: 'تحميل وثيقة أخرى',
            isUnderReview: 'قيد المراجعة',
            questionnaire: 'استبيان',
            sendAnswers: 'إرسال الإرسال',
            progressBarOf: 'من',
            progressBarText: 'تم تحميل مستنداتك وتأكيدها'
        },
        fullScreenAccounts: {
            manageAccounts: 'تحويل الأموال بين حساباتك',
            transferFrom: 'من الحساب',
            transferTo: 'إلى الحساب',
            amount: 'المبلغ',
            makeTransfer: 'إجراء التحويل',
            yourAccounts: 'حساباتك',
            account: 'الحساب',
            currency: 'في المقابل',
            balance: 'تحسين',
            credit: 'حيوي',
            makeActive: 'تنشيط',

            active: 'نشط'
        },
        fullScreenSupport: {
            sendMessage: 'أرسل رسالة',
            responseTime: 'متوسط ​​وقت الاستجابة: 1-24 ساعة',
            chatOff: 'ستكون الدردشة متاحة في أيام العمل',
        },
        fullScreenSavings: {
            pct_0: 'مرنة',
            pct_30: 'مغلق لمدة شهر',
            pct_90: 'مغلق لمدة ٣ أشهر',
            pct_180: 'مغلق لمدة 6 أشهر',
            pct_365: 'مغلق لمدة عام',
            pct_730: 'مغلق لمدة عام',
            savings: 'مدخرات',
            detailedInformation: 'معلومات مفصلة',
            pleaseSelect: 'الرجاء تحديد عملة وعلاقة',
            openSavings: 'فتح المدخرات',
            currentTime: 'الوقت الحالي',
            releaseTime: 'وقت الإصدار',
            currencyChosen: 'من أجل المختارة',
            periodChosen: 'الفترة المختارة',
            yourRate: 'تقييمك',
            yourAnnualRate: 'معدل سنويك',
            yourEarnings: 'أرباحك',
            accountFrom: 'حساب لتحويل الأموال منه',
            enterAmount: 'أدخل المبلغ',
            in: 'في',
            openAndInvest: 'افتح حساب التوفير واستثمر',
            investment: 'الاستثمار',
            period: 'الفترة',
            daysTotal: 'مجموع الأيام',
            finalEarnings: 'الأرباح النهائية',
            created: 'تم الإنشاء',
            daysElapsed: 'الأيام المنقضية',
            days: 'أيام',
            earnings: 'الأرباح',
            fundsReleasedIn: 'تم إصدار الأموال في',
            claim: 'مطالبة',
        },
        fullScreenSettings: {
            updatePassword: 'تحديث كلمة المرور',
            currentPassword: 'كلمة المرور الحالية',
            newPassword: 'كلمة مرور جديدة',
            changePassword: 'تغيير كلمة المرور',
            activationForGoogle: 'رمز التنشيط لـ Google Authenticator',
            activateAndEnter: 'قم بتنشيط Authenticator وأدخل رمزًا تم إنشاؤه في الحقل أدناه',
            qrCode: 'رمز الاستجابة السريعة',
            activateProtection: 'تنشيط حماية 2FA',
            protectionActive: 'حماية 2FA نشطة',
            twoFactorCode: 'رمز 2FA',
            disableProtection: 'تعطيل حماية 2FA',

            language: 'اللغة',
            dashboardCurrency: 'عملة لوحة المعلومات',
            confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
        },
        fullScreenReferrals: {
            yourLink: 'رابط الإحالة الخاص بك',
            referredFriends: 'الأصدقاء المُحالين',
            id: 'رقم الهوية',
            name: 'اسم',
            registered: 'سجل',
            level: 'المستوى',
            payout: 'الدفع',
            lastPayouts: 'مدفوعات الإحالة الأخيرة',
            time: 'التوقيت',
            amount: 'المبلغ',
            currency: 'في المقابل',
            info: 'معلومات'
        },
        months: {
            Jan: 'يناير',
            Feb: 'فبراير',
            Mar: 'مارس',
            Apr: 'أبريل',
            May: 'مايو',
            Jun: 'يونيو',
            Jul: 'يوليو',
            Aug: 'أغسطس',
            Sep: 'سبتمبر',
            Oct: 'أكتوبر',
            Nov: 'نوفمبر',
            Dec: 'ديسمبر'
        },
        orderTypes: ['شراء', 'بيع', 'حد الشراء', 'حد البيع', 'إيقاف الشراء', 'إيقاف البيع'],
        statuses: ['معلق', 'موافق عليه', 'مرفوض', 'قيد المعالجة', 'قيد المراجعة', 'In Process', 'تم الإلغاء'],
        errors: {
            INVALID_FIELDS: 'Please check that the data you have entered is correct',
            NOT_FOUND: 'خطأ في الطلب',
            FORBIDDEN: 'الدخول مرفوض. الرجاء إعادة تسجيل الدخول',
            SERVER_ERROR: 'فشل الإجراء. الرجاء المحاولة في وقت لاحق',
            INVALID_ACCOUNT: 'انتهت الجلسة. الرجاء إعادة تسجيل الدخول',
            INVALID_EMAIL: 'عنوان بريد إلكتروني غير صالح',
            INVALID_PHONE: 'رقم الهاتف غير صالح',
            INVALID_COUNTRY: 'دولة غير صحيحة',
            INVALID_LOGIN: 'بيانات اعتماد تسجيل الدخول غير صالحة',
            USER_BLOCKED: 'الحساب محظور. الرجاء الاتصال بالدعم',
            USER_REGISTERED: 'المستخدم الذي لديه بريد إلكتروني أو رقم هاتف مسجل بالفعل',
            INVALID_USER: 'المستخدم غير موجود',
            REJECTED: 'التشغيل غير مسموح به بسبب قيود المنصة',
            INVALID_OLD_PASSWORD: 'كلمة المرور القديمة غير صالحة',

            INVALID_SYMBOL: 'رمز تداول غير صالح',
            INVALID_SYMBOL_PRECISION: 'دقة رمز غير صالحة',
            INVALID_FRAME: 'إطار الرسم البياني غير صالح',
            INVALID_CURRENCY: 'عملة غير صالحة',
            INVALID_PRODUCT: 'نوع تداول الحساب غير صالح',
            INSUFFICIENT_FUNDS: 'أموال غير كافية',
            INVALID_WITHDRAWAL: 'السحب غير موجود',
            INVALID_DEPOSIT: 'لا يمكن إلغاء هذا الإيداع - غير موجود أو تمت معالجته بالفعل',
            INVALID_STATUS: 'حالة غير صالحة',
            INVALID_FILE: 'امتداد الملف غير صالح أو الملف كبير جدًا',
            INVALID_DOCUMENT: 'لم يتم العثور على المستند',
            INVALID_NAME: 'اسم غير صالح',
            INVALID_LOT_SIZE: 'حجم اللوت غير صالح',
            INVALID_LOT_STEP: 'خطوة غير صالحة نحو اللوت',
            INVALID_MIN_VOLUME: 'حجم أدنى غير صالح',
            INVALID_MAX_VOLUME: 'حجم الأقصى غير صالح',
            INVALID_GROUP: 'مجموعة غير صالحة',
            INVALID_SPREAD: 'هامش سعر غير صالح',
            REQUEST_TIMEOUT: 'انتهت مهلة الطلب. يرجى المحاولة مرة أخرى في وقت لاحق',
            INVALID_TYPE: 'نوع الطلب غير صالح',
            INVALID_VOLUME: 'حجم الطلب غير صالح',
            INVALID_SL: 'قيمة الخسارة غير صالحة',
            INVALID_TP: 'قيمة جني الأرباح غير صالحة',
            INVALID_PRICE: 'سعر الطلب غير صالح',
            INVALID_EXPIRATION: 'انتهاء صلاحية أمر غير صالح',
            NOT_ENOUGH_MARGIN: 'هامش غير كافٍ',
            INVALID_ORDER: 'يتم العثور على الطلب',
            MARKET_CLOSED: 'التداول غير متاح. حاول مرة أخرى',
            INVALID_BALANCE_TYPE: 'نوع غير صالح لعملية الرصيد',
            INVALID_HASH: 'تجزئة غير صالحة',
            HASH_EXPIRED: 'رابط إعادة تعيين كلمة المرور انتهت صلاحيته. الرجاء طلب واحد جديد',
            INVALID_CODE: 'رمز 2FA غير صالح ',
            CHAT_DISABLED: 'تم إغلاق الوصول إلى دردشة الدعم',
            WITHDRAWAL_NOT_ALLOWED: 'تم إغلاق الوصول إلى عمليات السحب',
            TRADING_DISABLED: 'التداول معطل للحساب الجاري',
            PENDING_DEPOSITS_LIMIT: 'تجاوز حد الإيداعات',
            CLOSE_OPEN_ORDERS: 'يرجى إغلاق صفقاتك المفتوحة',
            LOCAL_ONE_PENDING_WITHDRAWAL: 'يسمح بطلب سحب معلق واحد فقط',
            LOCAL_DEPOSIT_ONLY_REAL: 'الإيداع متاح فقط للحساب الحقيقي',
            LOCAL_DEPOSIT_POSITIVE: 'يجب أن يكون مبلغ الإيداع أكثر من 0',
            LOCAL_INVALID_CARD_NUMBER: 'رقم البطاقة غير صالح',
            LOCAL_INVALID_CARD_EXPIRATION: 'انتهاء صلاحية البطاقة غير صالحة',
            LOCAL_INVALID_CVC: 'غير صالح CVV / CVC رمز',
            LOCAL_PASSWORDS_NOT_MATCH: 'كلمات المرور غير متطابقة ، الرجاء إعادة',
            LOCAL_NO_TRADING_ACCOUNTS: 'ليس لديك حسابات متاحة. يرجى الاتصال بالدعم',
            LOCAL_MIN_DEPOSIT: ' $ الحد الأدنى للإيداع هو ',
            LOCAL_MIN_WITHDRAWAL: '$ الحد للسحب هو ',
            LOCAL_INVALID_FILE_TYPE: 'فقط JPG أو PNG أو PDF نوع الملف غير مدعوم. يرجى إرفاق ملفات ',
            LOCAL_MIN_STAKING: 'الحد الأقصى للإيداع للإيداع ',

            FLOOD_REJECTED: ' أنت ترسل الرسائل. الرجاء المحاولة في وقت لاحق',
            REGISTRATIONS_BLOCKED: "شكرًا لاستفسارك, سيتواصل معك أحد ممثلينا في أقرب وقت ممكن",
        },
        countries: {
            AF: 'أفغانستان',
            AX: 'جزر آلاند',
            AL: 'ألبانيا',
            DZ: 'الجزائر',
            AS: 'ساموا الأمريكية',
            AD: 'أندورا',
            AO: 'أنغولا',
            AI: 'أنغيلا',
            AQ: 'أنتاركتيكا',
            AG: 'أنتيغوا وبربودا',
            AR: 'الأرجنتين',
            AM: 'أرمينيا',
            AW: 'أروبا',
            AU: 'فيكتوريا',
            AT: 'النمسا',
            AZ: 'أذربيجان',
            BS: 'جزر البهاما',
            BH: 'البحرين',
            BD: 'بنغلاديش',
            BB: 'بربادوس',
            BY: 'بيلاروسيا',
            BE: 'بلجيكا',
            BZ: 'بليز',
            BJ: 'بنين',
            BM: 'برمودا',
            BT: 'بوتان',
            BO: 'بوليفيا',
            BA: 'البوسنة والهرسك',
            BW: 'بوتسوانا',
            BV: 'جزيرة بوفيت',
            BR: 'البرازيل',
            IO: 'إقليم المحيط الهندي البريطاني',
            BN: 'بروناي دار السلام',
            BG: 'بلغاريا',
            BF: 'بوركينا فاسو',
            BI: 'بوروندي',
            KH: 'كمبوديا',
            CM: 'الكاميرون',
            CA: 'كندا',
            CV: 'الرأس الأخضر',
            KY: 'جزر كايمان',
            CF: 'جمهورية أفريقيا الوسطى',
            TD: 'تشاد',
            CL: 'تشيلي',
            CN: 'الصين',

            CX: 'جزيرة الكريسماس',
            CC: 'جزر كوكوس (كيلينغ)',
            CO: 'كولومبيا',
            KM: 'جزر القمر',
            CG: 'الكونغو',
            CD: 'جمهورية الكونغو الديمقراطية',
            CK: 'جزر كوك',
            CR: 'كوستاريكا',
            CI: 'كوت دي إيفوار',
            HR: 'كرواتيا',
            CU: 'كوبا',
            CY: 'قبرص',
            CZ: 'جمهورية التشيك',
            DK: 'الدنمارك',
            DJ: 'جيبوتي',
            DM: 'دومينيكا',
            DO: 'جمهورية الدومينيكان',
            EC: 'الإكوادور',
            EG: 'مصر',
            SV: 'السلفادور',
            GQ: 'غينيا الاستوائية',
            ER: 'إريتريا',
            EE: 'إستونيا',
            ET: 'إثيوبيا',
            FK: '(مالفيناس)',
            FO: 'جزر فارو',
            FJ: 'فيجي',
            FI: 'فنلندا',
            FR: 'فرنسا',
            GF: 'جويانا الفرنسية',
            PF: 'بولينيزيا الفرنسية',
            TF: 'الأقاليم الجنوبية الفرنسية',
            GA: 'الجابون',
            GM: 'غامبيا',
            GE: 'جورجيا',
            DE: 'ألمانيا',
            GH: 'غانا',
            GI: 'جبل طارق',
            GR: 'اليونان',
            GL: 'بالألمانية',
            GD: 'غرينادا',
            GP: 'جوادلوب',
            GU: 'غوام',
            GT: 'غواتيمالا',
            GG: 'غيرنسي',
            GN: 'غينيا',
            GW: 'غينيا بيساو',
            GY: 'غيانا',

            HT: 'هايتي',
            HM: 'جزيرة هيرد وجزر ماكدونالد',
            VA: 'الكرسي الرسولي (دولة الفاتيكان)',
            HN: 'هندوراس',
            HK: 'المزيد من اللغات',
            HU: 'المجر',
            IS: 'آيسلندا',
            IN: 'الهند',
            ID: 'إندونيسيا',
            IR: 'إيران',
            IQ: 'العراق',
            IE: 'أيرلندا',
            IM: 'جزيرة مان',
            IL: 'إسرائيل',
            IT: 'إيطاليا',
            JM: 'جامايكا',
            JP: 'اليابان',
            JE: 'صغير',
            JO: 'الأردن',
            KZ: 'كازاخستان',
            KE: 'كينيا',
            KI: 'كيريباتي',
            KR: 'كوريا',
            KW: 'الكويت',
            KG: 'قيرغيزستان',
            LA: 'جمهورية لاو الديمقراطية الشعبية',
            LV: 'لاتفيا',
            LB: 'لبنان',
            LS: 'ليسوتو',
            LR: 'ليبيريا',
            LY: 'الجماهيرية العربية الليبية',
            LI: 'ليختنشتاين',
            LT: 'ليتوانيا',
            LU: 'لوكسمبورغ',
            MO: 'ماكاو',
            MK: 'مقدونيا',
            MG: 'مدغشقر',
            MW: 'ملاوي',
            MY: 'ماليزيا',
            MV: 'جزر المالديف',
            ML: 'مالي',
            MT: 'مالطا',
            MH: 'جزر مارشال',
            MQ: 'مارتينيك',
            MR: 'موريتانيا',
            MU: 'موريشيوس',
            YT: 'مايوت',
            MX: 'المكسيك',

            FM: 'ميكرونيزيا',
            MD: 'مولدوفا',
            MC: 'موناكو',
            MN: 'منغوليا',
            ME: 'الجبل الأسود',
            MS: 'مونتسيرات',
            MA: 'المغرب',
            MZ: 'موزمبيق',
            MM: 'ميانمار',
            NA: 'ناميبيا',
            NR: 'ناورو',
            NP: 'نيبال',
            NL: 'هولندا',
            AN: 'جزر الأنتيل دول',
            NC: 'كاليدونيا الجديدة',
            NZ: 'نيوزيلندا',
            NI: 'نيكاراغوا',
            NE: 'النيجر',
            NG: 'نيجيريا',
            NU: 'نيوي',
            NF: 'جزيرة نورفولك',
            MP: 'جزر ماريانا الشمالية',
            NO: 'النرويج',
            OM: 'عمان',
            PK: 'باكستان',
            PW: 'بالاو',
            PS: 'الأراضي الفلسطينية المحتلة',
            PA: 'بنما',
            PG: 'بابوا غينيا الجديدة',
            PY: 'باراغواي',
            PE: 'بيرو',
            PH: 'الفلبين',
            PN: 'بيتكيرن',
            PL: 'بولندا',
            PT: 'البرتغال',
            PR: 'بورتوريكو',
            QA: 'قطر',
            RE: 'ريونيون',
            RO: 'رومانيا',
            RU: 'روسيا',
            RW: 'رواندا',
            BL: 'سانت بارتيليمي',
            SH: 'سانت هيلانة',
            KN: 'سانت كيتس ونيفيس',
            LC: 'سانت لوسيا',
            MF: 'سانت مارتن',
            PM: 'سان بيير وميكلون',
            VC: 'سانت فنسنت وجزر غرينادين',

            WS: 'ساموا',
            SM: 'سان مارينو',
            ST: 'ساو تومي وبرينسيبي',
            SA: 'المملكة العربية السعودية',
            SN: 'السنغال',
            RS: 'صربيا',
            SC: 'سيشل',
            SL: 'سيراليون',
            SG: 'سنغافورة',
            SK: 'سلوفاكيا',
            SI: 'سلوفينيا',
            SB: 'جزر سليمان',
            SO: 'الصومال',
            ZA: 'جنوب إفريقيا',
            GS: 'جورجيا الجنوبية وجزيرة ساندويتش.',
            ES: 'إسبانيا',
            LK: 'سريلانكا',
            SD: 'السودان',
            SR: 'سورينام',
            SJ: 'سفالبارد وجان ماين',
            SZ: 'سوازيلاند',
            SE: 'السويد',
            CH: 'سويسرا',
            SY: 'الجمهورية العربية السورية',
            TW: 'أنفه',
            TJ: 'طاجيكستان',
            TZ: 'تنزانيا',
            TH: 'تايلاند',
            TL: 'تيمور الشرقية',
            TG: 'توغو',
            TK: 'توكيلاو',
            TO: 'تونجا',
            TT: 'ترينيداد وتوباغو',
            TN: 'تونس',
            TR: 'تركيا',
            TM: 'تركمانستان',
            TC: 'جزر تركس وكايكوس',
            TV: 'توفالو',
            UG: 'أوغندا',
            UA: 'أوكرانيا',
            AE: 'الإمارات العربية المتحدة',
            GB: 'المملكة المتحدة',
            US: 'الولايات المتحدة',
            UM: 'جزر الولايات المتحدة النائية',
            UY: 'أوروغواي',
            UZ: 'أوزبكستان',
            VU: 'فانواتو',
            VE: 'فنزويلا',

            VN: 'فيتنام',
            VG: 'جزر فيرجن البريطانية',
            VI: 'جزر فيرجن الأمريكية',
            WF: 'واليس وفوتون',
            EH: 'الصحراء الغربية',
            YE: 'اليمن',
            ZM: 'زامبيا',
            ZW: 'زيمبابوي'
        },
    },
    it: {
        _name: "Italiano",
        autoCloseModal: {
            takeProfitStopLoss: "Take Profit e Stop Loss",
            takeProfit: "Take Profit",
            stopLoss: "Stop Loss",
            updateOrder: "Aggiorna ordine",
        },
        balanceModal: {
            balance: "Saldo",
            credit: "Credito",
            equity: "Equity",
            practice: "DEMO",
            real: "REALE",
            account: "CONTO",
            invested: "Investito",
            profit: "Profitto",
            loss: "Perdita",
            margin: "Margine",
            marginLevel: "Livello di margine",
            marginFree: "Margine libero",
        },
        header: {
            cfd: "CFD",
            platform: "Piattaforma",
            deposit: "Deposito",
            myAccount: "Il mio account",
        },
        sideMenu: {
            marketWatch: "Market Watch",
            activeOrders: "Ordini attivi",
            tradingHistory: "Cronologia di trading",
            economicCalendar: "Calendario economico",
            marketNews: "Notizie di mercato",
        },
        closePositionModal: {
            closeOrder: "Chiudi posizione",
            areYouSure: "Sei sicuro di voler chiudere la posizione?",
            buy: "Compra",
            sell: "Vendi",
            yes: "Sì",
            no: "No",
        },
        chart: {
            addNewChart: "Aggiungi nuovo grafico",
        },
        symbolsModal: {
            watchlist: "Watchlist",
            asset: "Strumento",
            price: "Prezzo",
            changePct: "Variazione 24h",
        },
        pendingModal: {
            pending: "In attesa",
            assetPrice: "Prezzo dello strumento",
            current: "Prezzo corrente",
            revert: "Torna al prezzo di mercato",
            automatically: "La posizione verrà aperta automaticamente quando il prezzo raggiungerà questo livello",
        },
        orderMenu: {
            volume: "Volume",
            lots: "lotti",
            units: "unità",
            currency: "valuta",
            contractSize: "Dimensione del contratto",
            position: "Posizione",
            margin: "Margine",
            freeMargin: "Margine libero",
            takeProfitStopLoss: "Take Profit e Stop Loss",
            pending: "In attesa",
            market: "Mercato",
            leverage: "Leva",
            spread: "Spread",
            notSet: "Non impostato",
            at: "a",
            buy: "Compra",
            sell: "Vendi",
        },
        footer: {
            supportBanner: "OGNI GIORNO, 24 ORE SU 24",
            currentTime: "ORA CORRENTE",
            liveChat: "Live Chat",
        },
        statusBar: {
            balance: "Saldo",
            credit: "Credito",
            equity: "Equity",
            margin: "Margine",
            marginLevel: "Livello di margine",
            freeMargin: "Margine libero",
            pnl: "PnL",
            profitTotal: "PnL totale",
        },
        accountModal: {
            dateRegistered: "Data di registrazione",
            userId: "ID utente",
            dashboard: "Dashboard",
            personalData: "Dati personali",
            deposit: "Deposito",
            withdrawFunds: "Prelievo fondi",
            savings: "Risparmi",
            settings: "Impostazioni",
            logout: "Disconnetti",
        },
        depositModal: {
            BT_INVOICE: "Inserisci l'importo e genera la fattura",
            BT_TITLE: "I nostri dati bancari",
            BT_ACCOUNT: "Conto",
            BT_BANK_NAME: "Nome della banca",
            BT_BENEFICIARY: "Beneficiario",
            BT_ADDRESS: "Indirizzo del beneficiario",
            BT_SWIFT: "Swift",
            BT_IBAN: "IBAN",
            BT_REFERENCE_CODE: "Codice di riferimento bancario",
            BT_INN: "INN",
            BT_KPP: "Conto corrispondente",
            BT_CORRESPONDING: "",
            TOKEN_AMOUNT: "Importo",
            TOKEN_SUBTOTAL: "Subtotale",
            TOKEN_TOTAL: "Totale",
            TOKEN_DESCRIPTION: "Descrizione",
            TOKEN_PAYMENT_DETAILS: "Dettagli del pagamento",
            PENDING_DEPOSITS_LIMIT: "Limite di deposito",
            makeDeposit: "Effettua un deposito",
            practiceAccount: "Conto demo",
            realAccount: "Conto reale",
            noWithdrawals: "Nessun prelievo",
            easyWithdrawals: "Prelievi facili",
            allAssets: "Tutti gli strumenti disponibili",
            fullFledged: "Piattaforma completa",
            fillUpTo: "Ricarica fino a",
            freeReplenishment: "Ricariche gratuite",
            topUp: "Ricarica il tuo conto",
            minimumAmount: "Importo minimo",
            canSwitch: "Puoi passare da un conto all'altro in qualsiasi momento",
        },
        gridsModal: {
            chartGrids: "GRIGLIE DEI GRAFICI",
            chart1: "1 grafico",
            chart2: "2 grafici",
            chart3: "3 grafici",
            chart4: "4 grafici",
        },
        noConnectionModal: {
            connectionLost: "La connessione con il server è stata persa",
            retryNow: "Riprova ora",
        },
        loginModal: {
            loginToTradeRoom: "Accedi a Traderoom",
            email: "Indirizzo email",
            emailAndId: "Indirizzo email / Numero ID",
            enterEmail: "Inserisci il tuo indirizzo e-mail",
            twoFactor: "Codice 2FA (se abilitato)",
            twoFactorAuth: "Autenticazione a due fattori",
            password: "Password",
            yourPassword: "La tua password",
            signIn: "Accedi",
            dontHaveAccount: "Non hai un account?",
            restore: "Recupera",
            fullName: "Nome completo",
            havePromo: "Ho un codice promozionale",
            promo: "Codice promozionale",
            login: "Accedi",
            haveAccount: "Hai già un account?",
            hide: "Nascondi",
            goTo: "Torna indietro",
        },
        newPasswordModal: {
            setNewPassword: "Imposta nuova password",
            newPassword: "Nuova password",
            confirmNewPassword: "Conferma la nuova password",
            setButton: "Imposta",
        },
        registerModal: {
            createNewAccount: "Crea un nuovo account",
            email: "Indirizzo e-mail",
            firstName: "Nome",
            lastName: "Cognome",
            country: "Paese",
            phone: "Telefono",
            password: "Password",
            createAccount: "Crea account",
            currency: "Valuta",
        },
        forgotPasswordModal: {
            forgotPassword: "Password dimenticata?",
            submitEmail: "Inserisci l'e-mail usata per la registrazione, controlla la tua casella di posta e segui le istruzioni ricevute",
            submit: "Invia",
        },
        notifications: {
            error: "Errore",
            success: "Successo",
            deposit: "Deposito",
            withdrawal: "Prelievo",
            depositApproved: "Il deposito è stato approvato",
            depositDeclined: "Il deposito è stato rifiutato",
            withdrawalApproved: "Il prelievo è stato approvato",
            withdrawalDeclined: "Il prelievo è stato rifiutato",
            withdrawalCancelled: "Il prelievo è stato annullato",
            orderRejected: "Ordine rifiutato",
            insufficientMargin: "Impossibile aprire il tuo ordine in attesa: margine libero insufficiente",
            marginCall: "Margin call",
            marginCallText: "Effettua un deposito per soddisfare i requisiti di margine",
        },
        markets: {
            forex: "Forex",
            stocks: "Azioni",
            commodities: "Materie prime",
            indices: "Indici",
            crypto: "Criptovalute",
            metals: "Metalli",
            nft: "NFT",
        },
        profitCalculatorModal: {
            buy: "COMPRA",
            profitCalculator: "Calcolatore di profitto",
            sell: "VENDI",
            volume: "Volume",
            entryPrice: "Prezzo di ingresso",
            takeProfit: "Take Profit",
            stopLoss: "Stop Loss",
            maxPosition: "Posizione massima",
            calculate: "Calcola",
            calculationsFor: "Calcoli per",
            leverage: "Leva",
            requiredMargin: "Margine richiesto",
            profitFromTP: "Profitto dal TP",
            lossFromSL: "Perdita dallo SL",
            roe: "ROI",
        },
        depositSuccessModal: {
            title: "Deposito riuscito",
            text: "Il tuo deposito è stato elaborato con successo!",
        },
        depositFailModal: {
            title: "Deposito non riuscito",
            text: "Il tuo deposito non è stato elaborato.",
        },
        widgetMarketWatch: {
            marketWatch: "Market Watch",
            search: "Cerca...",
        },
        widgetOrders: {
            commission: "Commissione",
            volume: "Volume",
            margin: "Margine",
            active: "Attivo",
            pending: "In attesa",
            activeOrders: "Ordini attivi",
            portfolio: "Portafoglio",
            allPositions: "Tutte le posizioni",
            noPositionsLine1: "Non hai ancora",
            noPositionsLine2: "posizioni aperte",
            show: "Mostra",
            more: "di più",
            less: "meno",
            purchaseTime: "Ora di acquisto",
            closePosition: "Chiudi posizione",
            priceOpen: "Prezzo di acquisto",
            priceSl: "Prezzo SL",
            priceTp: "Prezzo TP",
            type: "Direzione",
            pnl: "Profitto/Perdita",
            cancelOrder: "Annulla ordine",
            orderType: "Tipo di ordine",
            cancelled: "Annullato",
            tradingHistory: "Cronologia di trading",
            noHistoryLine1: "Non hai ancora",
            noHistoryLine2: "operazioni concluse",
            sortByTime: "Ordina per ora",
        },
        widgetEconomicCalendar: {
            economicCalendar: "Calendario economico",
        },
        widgetMarketNews: {
            marketNews: "Notizie di mercato",
        },
        ordersPane: {
            ordersActive: "Ordini attivi",
            ordersHistory: "Cronologia ordini",
            id: "ID",
            symbol: "Simbolo",
            type: "Tipo",
            volume: "Volume",
            openPrice: "Prezzo di apertura",
            openTime: "Ora di apertura",
            closePrice: "Prezzo di chiusura",
            closeTime: "Ora di chiusura",
            sl: "SL",
            tp: "TP",
            price: "Prezzo",
            pnl: "PnL",
            actions: "Azioni",
            edit: "Modifica",
            close: "Chiudi",
            commission: "Commissione",
            swap: "Swap",
            swapLong: "Swap Long",
            swapShort: "Swap Short",
        },
        assetInfoModal: {
            assetInfo: "Info strumento",
            tradingConditions: "Condizioni di trading",
            information: "Informazioni",
            bid: "Bid",
            ask: "Ask",
            sessionChange: "Variazione di sessione",
            tradeNow: "Fai trading ora",
            opens: "Apre",
            closes: "Chiude",
            at: "a",
            open247: "Aperto 24/7",
            today: "oggi",
            tomorrow: "domani",
            sunday: "Domenica",
            monday: "Lunedì",
            tuesday: "Martedì",
            wednesday: "Mercoledì",
            thursday: "Giovedì",
            friday: "Venerdì",
            saturday: "Sabato",
            contractSpecification: "Specifiche del contratto",
            symbol: "Simbolo",
            name: "Nome",
            market: "Mercato",
            baseCurrency: "Valuta di base",
            digits: "Decimali",
            lotSize: "Dimensione del lotto",
            lotStep: "Step del lotto",
            minVolume: "Volume minimo",
            maxVolume: "Volume massimo",
            leverage: "Leva",
            commission: "Commissione",
            swapLong: "Swap Long",
            swapShort: "Swap Short",
            schedule: "Orari",
            weekday: "Giorno della settimana",
            tradingTime: "Orario di trading",
            closed: "chiuso",
            sell: "Vendi",
            buy: "Compra",
            low: "Minimo",
            high: "Massimo",
            oneHourChange: "Variazione 1 ora",
            oneDayChange: "Variazione 1 giorno",
            oneWeekChange: "Variazione 1 settimana",
            oneMonthChange: "Variazione 1 mese",
            threeMonthsChange: "Variazione 3 mesi",
            oneYearChange: "Variazione 1 anno",
            loading: "Caricamento...",
        },
        fullScreen: {
            startTrading: "Inizia a fare trading",
            deposit: "Deposito",
            dashboard: "Dashboard",
            personalInfo: "Informazioni personali",
            withdrawal: "Prelievo",
            verification: "Verifica",
            accounts: "Conti",
            liveChat: "Live Chat",
            savings: "Risparmi",
            settings: "Impostazioni",
            logOut: "Esci",
        },
        fullScreenDeposit: {
            chooseCryptocurrency: "SCEGLI CRIPTOVALUTA",
            addressReceipt: "Attendi il caricamento dell'indirizzo",
            makeDeposit: "EFFETTUA UN DEPOSITO",
            instant: "Immediato",
            minutes: "minuti",
            hours: "ore",
            days: "giorni",
            amount: "Importo",
            continue: "Continua",
            qrCode: "CODICE QR",
            depositAddress: "INDIRIZZO DI DEPOSITO",
            addWalletAddress: "Il portafoglio per questo metodo non è configurato. Contatta il tuo agente o l'assistenza clienti.",
            copy: "Copia",
            last: "ULTIMO",
            deposits: "DEPOSITI",
            time: "Ora",
            currency: "Valuta",
            status: "Stato",
            info: "Info",
            name: "Nome del titolare della carta",
            address: "Indirizzo",
            DOB: "Data di nascita",
            bankName: "Nome della banca",
            additionalInfo: "Per depositare altri fondi sul tuo conto, contatta direttamente il tuo account manager",
            additionalInfoOnlyBTCpsp: "Per sbloccare altri metodi di pagamento, completa la verifica KYC o contatta il tuo account manager",
            sofortPspMessage: "Il nostro team finanziario ti contatterà per aiutarti a effettuare il deposito",
        },
        fullScreenCcExt: {
            pleaseWait: "Attendi. Connessione al fornitore di servizi di pagamento...",
            cardPayment: "Pagamento con carta",
            inOrder: "Per inviare l'importo",
            pleaseProvide: "inserisci i dati della carta:",
        },
        fullScreenDashboard: {
            totalTaxes: "Totale imposte",
            totalBalance: "Saldo totale",
            totalPnl: "PnL totale",
            profitableOrders: "Ordini in profitto",
            roi: "ROI",
            activityLog: "Registro attività",
            loginFromIp: "Accesso da IP",
            tradingResults: "Risultati di trading",
            week: "Settimana",
            month: "Mese",
            year: "Anno",
            successRate: "Tasso di successo",
            closedWithProfit: "Chiuso con profitto",
            closedWithLoss: "Chiuso con perdita",
            account: "Conto",
            balance: "Saldo",
            leverage: "Leva",
            credit: "Credito",
            tradeNow: "Fai trading ora",
            usingCurrentRate: "al tasso di cambio corrente",
            totalDeposits: "Totale depositi",
        },
        fullScreenPersonal: {
            personalDetails: "Dettagli personali",
            profilePhoto: "Foto del profilo",
            firstName: "Nome",
            country: "Paese",
            lastName: "Cognome",
            address: "Indirizzo",
            email: "E-mail",
            phone: "Numero di telefono",
            saveChanges: "Salva modifiche",
        },
        fullScreenAvatar: {
            dropFile: "Trascina un file sul cerchio qui sopra per caricarlo",
            notAllowed: "Non è consentito pubblicare",
            notAllowedLine1: "Foto di natura esplicitamente sessuale o pornografica",
            notAllowedLine2: "Immagini che incitano all'odio o all'aggressione etnica o razziale",
            notAllowedLine3: "Foto che coinvolgono persone di età inferiore ai 18 anni",
            notAllowedLine4: "Foto protette da copyright di terzi",
            notAllowedLine5: "Immagini di dimensioni superiori a 5 MB e in un formato diverso da JPG, GIF o PNG",
            requirements: "Il tuo volto deve essere chiaramente visibile nella foto. Tutte le foto e i video che carichi devono rispettare questi requisiti, altrimenti potranno essere rimossi.",
        },
        fullScreenWithdrawal: {
            withdrawal: "Prelievo",
            requestNewWithdrawal: "RICHIEDI UN NUOVO PRELIEVO",
            amount: "Importo",
            currentBalance: "Il saldo attuale del tuo conto è",
            withdrawAll: "Preleva tutto",
            requestWithdrawal: "Richiedi prelievo",
            last: "ULTIMO",
            withdrawalRequests: "RICHIESTE DI PRELIEVO",
            time: "Ora",
            currency: "Valuta",
            info: "Info",
            status: "Stato",
            bank: "Banca",
            bitcoin: "Bitcoin",
            card: "Carta",
            ethereum: "Ethereum",
            usdt: "USDT",
            usdt_erc20: "USDT ERC-20",
            matic: "Matic",
            etransfer: "Etransfer",
            interact: "Interact",
            withdrawalDetails: "Dettagli del prelievo",
            address: "Indirizzo del wallet",
            bankAccount: "Numero di conto",
            bankHolder: "Nome del titolare del conto",
            bankIban: "IBAN",
            bankSwift: "Codice SWIFT della banca",
            sortCode: "Sort Code",
            ifscCode: "Codice IFSC",
            bankCode: "Codice banca (BSB)",
            bankName: "Nome della banca",
            bankBranch: "Filiale della banca",
            cardNumber: "Numero di carta",
            cardHolder: "Nome del titolare della carta",
            incorrectAmountByFreeMargin: "L'importo non è corretto: puoi prelevare al massimo l'importo del margine libero",
            closeOrders: "prima di chiudere tutti gli ordini",
        },
        fullScreenVerification: {
            dragAndDrop: "trascina e rilascia il documento in quest'area",
            documentsList: "ELENCO DEI DOCUMENTI CARICATI",
            document: "Documento",
            timeUploaded: "Ora di caricamento",
            timeProcessed: "Ora di elaborazione",
            status: "Stato",
            types: ["Documento di identità", "Prova di residenza", "Fronte carta di credito", "Retro carta di credito", "Retro del documento di identità", "Selfie", "Altro"],
            types2: ["Documento di identità (CARTA DI IDENTITÀ, PASSAPORTO, PATENTE DI GUIDA)", "Prova di residenza (Bolletta o Estratto conto bancario)", "Fronte carta di credito", "Retro carta di credito", "Retro del documento di identità (RETRO DELLA CARTA DI IDENTITÀ, RETRO DELLA PATENTE DI GUIDA)", "Selfie", "Altro"],
            upload: "Carica",
            isConfirmed: "è confermato",
            uploadAnotherDocument: "Carica un altro documento",
            isUnderReview: "è in fase di revisione",
            questionnaire: "Questionario",
            sendAnswers: "Invia risposte",
            progressBarOf: "di",
            progressBarText: "dei tuoi documenti sono stati caricati e confermati",
        },
        fullScreenAccounts: {
            manageAccounts: "Trasferisci fondi tra i tuoi conti",
            transferFrom: "Dal conto",
            transferTo: "Al conto",
            amount: "Importo",
            makeTransfer: "Effettua trasferimento",
            yourAccounts: "I tuoi conti",
            account: "Conto",
            currency: "Valuta",
            balance: "Saldo",
            credit: "Credito",
            makeActive: "Rendi attivo",
            active: "Attivo",
        },
        fullScreenSupport: {
            chatOff: "La chat sarà disponibile nei giorni lavorativi",
            sendMessage: "Invia messaggio",
            responseTime: "Tempo medio di risposta: 1-24h",
        },
        fullScreenSavings: {
            pct_0: "Flessibile",
            pct_30: "Bloccato 1 mese",
            pct_90: "Bloccato 1 trimestre",
            pct_180: "Bloccato 6 mesi",
            pct_365: "Bloccato 1 anno",
            pct_730: "Bloccato 2 anni",
            savings: "Risparmi",
            detailedInformation: "Informazioni dettagliate",
            pleaseSelect: "Seleziona una valuta e un periodo",
            openSavings: "Apri conto di risparmio",
            currentTime: "Ora corrente",
            releaseTime: "Data di sblocco",
            currencyChosen: "Valuta scelta",
            periodChosen: "Periodo scelto",
            yourRate: "Il tuo tasso",
            yourAnnualRate: "Il tuo tasso annuale",
            yourEarnings: "I tuoi guadagni",
            accountFrom: "Conto da cui trasferire i fondi",
            enterAmount: "Inserisci l'importo",
            in: "In",
            openAndInvest: "Apri un conto di risparmio e investi",
            investment: "Investimento",
            period: "Periodo",
            daysTotal: "Totale giorni",
            finalEarnings: "Guadagni finali",
            created: "Creato",
            daysElapsed: "Giorni trascorsi",
            days: "giorni",
            earnings: "Guadagni",
            fundsReleasedIn: "Fondi sbloccati tra",
            claim: "Riscuoti",
        },
        fullScreenSettings: {
            updatePassword: "AGGIORNA LA PASSWORD",
            currentPassword: "Password attuale",
            newPassword: "Nuova password",
            changePassword: "Cambia password",
            activationForGoogle: "Codice di attivazione per Google Authenticator",
            activateAndEnter: "Attiva Authenticator e inserisci il codice generato nel campo sottostante",
            qrCode: "QR Code",
            activateProtection: "Attiva la protezione 2FA",
            protectionActive: "La protezione 2FA è attiva",
            twoFactorCode: "Codice 2FA",
            disableProtection: "Disattiva la protezione 2FA",
            language: "Lingua",
            dashboardCurrency: "Valuta della dashboard",
            confirmNewPassword: "Conferma la nuova password",
        },
        fullScreenReferrals: {
            yourLink: "IL TUO LINK DI REFERRAL",
            referredFriends: "AMICI INVITATI",
            id: "ID",
            name: "Nome",
            registered: "Registrato",
            level: "Livello",
            payout: "Pagamento",
            lastPayouts: "ULTIMI PAGAMENTI REFERRAL",
            time: "Ora",
            amount: "Importo",
            currency: "Valuta",
            info: "Info",
        },
        months: {
            Jan: "Gen",
            Feb: "Feb",
            Mar: "Mar",
            Apr: "Apr",
            May: "Mag",
            Jun: "Giu",
            Jul: "Lug",
            Aug: "Ago",
            Sep: "Set",
            Oct: "Ott",
            Nov: "Nov",
            Dec: "Dic",
        },
        orderTypes: ["Compra", "Vendi", "Buy Limit", "Sell Limit", "Buy Stop", "Sell Stop"],
        statuses: ["In attesa", "Approvato", "Rifiutato", "In elaborazione", "In revisione", "In corso", "Annullato"],
        errors: {
            INVALID_FIELDS: "Controlla che i dati inseriti siano corretti",
            NOT_FOUND: "Errore di richiesta",
            FORBIDDEN: "Accesso negato. Effettua di nuovo l'accesso",
            SERVER_ERROR: "Operazione non riuscita. Riprova più tardi",
            INVALID_ACCOUNT: "Sessione scaduta. Effettua di nuovo l'accesso",
            INVALID_EMAIL: "Indirizzo e-mail non valido",
            INVALID_PHONE: "Numero di telefono non valido",
            INVALID_COUNTRY: "Paese non valido",
            INVALID_LOGIN: "Credenziali di accesso non valide",
            USER_BLOCKED: "L'account è bloccato. Contatta l'assistenza",
            USER_REGISTERED: "Esiste già un utente registrato con questa e-mail o questo numero di telefono",
            INVALID_USER: "L'utente non è stato trovato",
            REJECTED: "Operazione non consentita a causa delle restrizioni della piattaforma",
            INVALID_OLD_PASSWORD: "La vecchia password non è valida",
            INVALID_SYMBOL: "Simbolo di trading non valido",
            INVALID_SYMBOL_PRECISION: "Precisione del simbolo non valida",
            INVALID_FRAME: "Timeframe del grafico non valido",
            INVALID_CURRENCY: "Valuta non valida",
            INVALID_PRODUCT: "Tipo di trading del conto non valido",
            INSUFFICIENT_FUNDS: "Fondi insufficienti",
            INVALID_WITHDRAWAL: "Il prelievo non è stato trovato",
            INVALID_DEPOSIT: "Questo deposito non può più essere annullato: non è stato trovato o è già stato elaborato",
            INVALID_STATUS: "Stato non valido",
            INVALID_FILE: "Estensione file non valida o file troppo grande",
            INVALID_DOCUMENT: "Il documento non è stato trovato",
            INVALID_NAME: "Nome non valido",
            INVALID_LOT_SIZE: "Dimensione del lotto non valida",
            INVALID_LOT_STEP: "Step del lotto non valido",
            INVALID_MIN_VOLUME: "Volume minimo non valido",
            INVALID_MAX_VOLUME: "Volume massimo non valido",
            INVALID_GROUP: "Gruppo non valido",
            INVALID_SPREAD: "Spread non valido",
            REQUEST_TIMEOUT: "La richiesta è scaduta. Riprova più tardi",
            INVALID_TYPE: "Tipo di ordine non valido",
            INVALID_VOLUME: "Volume dell'ordine non valido",
            INVALID_SL: "Valore dello Stop Loss non valido",
            INVALID_TP: "Valore del Take Profit non valido",
            INVALID_PRICE: "Prezzo dell'ordine non valido",
            INVALID_EXPIRATION: "Scadenza dell'ordine non valida",
            NOT_ENOUGH_MARGIN: "Margine insufficiente",
            INVALID_ORDER: "L'ordine non è stato trovato",
            MARKET_CLOSED: "Il trading non è disponibile. Riprova",
            INVALID_BALANCE_TYPE: "Tipo di operazione sul saldo non valido",
            INVALID_HASH: "Hash non valido",
            HASH_EXPIRED: "Il link per reimpostare la password è scaduto. Richiedine uno nuovo",
            INVALID_CODE: "Codice 2FA non valido",
            CHAT_DISABLED: "L'accesso alla chat di assistenza è stato chiuso",
            WITHDRAWAL_NOT_ALLOWED: "L'accesso ai prelievi è stato chiuso",
            TRADING_DISABLED: "Il trading è disabilitato per questo conto",
            PENDING_DEPOSITS_LIMIT: "Limite di depositi superato",
            CLOSE_OPEN_ORDERS: "Chiudi i tuoi ordini aperti",
            LOCAL_ONE_PENDING_WITHDRAWAL: "È consentito un solo prelievo in attesa",
            LOCAL_DEPOSIT_ONLY_REAL: "Il deposito è disponibile solo per il conto reale",
            LOCAL_DEPOSIT_POSITIVE: "L'importo del deposito deve essere superiore a 0",
            LOCAL_INVALID_CARD_NUMBER: "Numero di carta non valido",
            LOCAL_INVALID_CARD_EXPIRATION: "Scadenza della carta non valida",
            LOCAL_INVALID_CVC: "Codice CVV/CVC non valido",
            LOCAL_PASSWORDS_NOT_MATCH: "Le password non corrispondono, inseriscile di nuovo",
            LOCAL_NO_TRADING_ACCOUNTS: "Non hai conti di trading disponibili. Contatta l'assistenza",
            LOCAL_MIN_DEPOSIT: "Il deposito minimo è di $",
            LOCAL_MIN_WITHDRAWAL: "L'importo minimo di prelievo è di $",
            LOCAL_INVALID_FILE_TYPE: "Formato file non supportato. Allega solo JPG, PNG o PDF",
            LOCAL_MIN_STAKING: "Il deposito minimo per questa valuta è ",
            FLOOD_REJECTED: "Stai inviando messaggi troppo di frequente. Riprova più tardi",
            REGISTRATIONS_BLOCKED: "Grazie per la tua richiesta. Uno dei nostri rappresentanti ti contatterà al più presto",
        },
        countries: {
            AF: "Afghanistan",
            AX: "Isole Åland",
            AL: "Albania",
            DZ: "Algeria",
            AS: "Samoa Americane",
            AD: "Andorra",
            AO: "Angola",
            AI: "Anguilla",
            AQ: "Antartide",
            AG: "Antigua e Barbuda",
            AR: "Argentina",
            AM: "Armenia",
            AW: "Aruba",
            AU: "Australia",
            AT: "Austria",
            AZ: "Azerbaigian",
            BS: "Bahamas",
            BH: "Bahrein",
            BD: "Bangladesh",
            BB: "Barbados",
            BY: "Bielorussia",
            BE: "Belgio",
            BZ: "Belize",
            BJ: "Benin",
            BM: "Bermuda",
            BT: "Bhutan",
            BO: "Bolivia",
            BA: "Bosnia ed Erzegovina",
            BW: "Botswana",
            BV: "Isola Bouvet",
            BR: "Brasile",
            IO: "Territorio Britannico dell’Oceano Indiano",
            BN: "Brunei",
            BG: "Bulgaria",
            BF: "Burkina Faso",
            BI: "Burundi",
            KH: "Cambogia",
            CM: "Camerun",
            CA: "Canada",
            CV: "Capo Verde",
            KY: "Isole Cayman",
            CF: "Repubblica Centrafricana",
            TD: "Ciad",
            CL: "Cile",
            CN: "Cina",
            CX: "Isola Christmas",
            CC: "Isole Cocos (Keeling)",
            CO: "Colombia",
            KM: "Comore",
            CG: "Congo-Brazzaville",
            CD: "Congo - Kinshasa",
            CK: "Isole Cook",
            CR: "Costa Rica",
            CI: "Costa d’Avorio",
            HR: "Croazia",
            CU: "Cuba",
            CY: "Cipro",
            CZ: "Cechia",
            DK: "Danimarca",
            DJ: "Gibuti",
            DM: "Dominica",
            DO: "Repubblica Dominicana",
            EC: "Ecuador",
            EG: "Egitto",
            SV: "El Salvador",
            GQ: "Guinea Equatoriale",
            ER: "Eritrea",
            EE: "Estonia",
            ET: "Etiopia",
            FK: "Isole Falkland",
            FO: "Isole Fær Øer",
            FJ: "Figi",
            FI: "Finlandia",
            FR: "Francia",
            GF: "Guyana Francese",
            PF: "Polinesia Francese",
            TF: "Terre Australi Francesi",
            GA: "Gabon",
            GM: "Gambia",
            GE: "Georgia",
            DE: "Germania",
            GH: "Ghana",
            GI: "Gibilterra",
            GR: "Grecia",
            GL: "Groenlandia",
            GD: "Grenada",
            GP: "Guadalupa",
            GU: "Guam",
            GT: "Guatemala",
            GG: "Guernsey",
            GN: "Guinea",
            GW: "Guinea-Bissau",
            GY: "Guyana",
            HT: "Haiti",
            HM: "Isole Heard e McDonald",
            VA: "Città del Vaticano",
            HN: "Honduras",
            HK: "RAS di Hong Kong",
            HU: "Ungheria",
            IS: "Islanda",
            IN: "India",
            ID: "Indonesia",
            IR: "Iran",
            IQ: "Iraq",
            IE: "Irlanda",
            IM: "Isola di Man",
            IL: "Israele",
            IT: "Italia",
            JM: "Giamaica",
            JP: "Giappone",
            JE: "Jersey",
            JO: "Giordania",
            KZ: "Kazakistan",
            KE: "Kenya",
            KI: "Kiribati",
            KR: "Corea del Sud",
            KW: "Kuwait",
            KG: "Kirghizistan",
            LA: "Laos",
            LV: "Lettonia",
            LB: "Libano",
            LS: "Lesotho",
            LR: "Liberia",
            LY: "Libia",
            LI: "Liechtenstein",
            LT: "Lituania",
            LU: "Lussemburgo",
            MO: "RAS di Macao",
            MK: "Macedonia del Nord",
            MG: "Madagascar",
            MW: "Malawi",
            MY: "Malaysia",
            MV: "Maldive",
            ML: "Mali",
            MT: "Malta",
            MH: "Isole Marshall",
            MQ: "Martinica",
            MR: "Mauritania",
            MU: "Mauritius",
            YT: "Mayotte",
            MX: "Messico",
            FM: "Micronesia",
            MD: "Moldavia",
            MC: "Monaco",
            MN: "Mongolia",
            ME: "Montenegro",
            MS: "Montserrat",
            MA: "Marocco",
            MZ: "Mozambico",
            MM: "Myanmar (Birmania)",
            NA: "Namibia",
            NR: "Nauru",
            NP: "Nepal",
            NL: "Paesi Bassi",
            AN: "Antille Olandesi",
            NC: "Nuova Caledonia",
            NZ: "Nuova Zelanda",
            NI: "Nicaragua",
            NE: "Niger",
            NG: "Nigeria",
            NU: "Niue",
            NF: "Isola Norfolk",
            MP: "Isole Marianne Settentrionali",
            NO: "Norvegia",
            OM: "Oman",
            PK: "Pakistan",
            PW: "Palau",
            PS: "Territori Palestinesi",
            PA: "Panama",
            PG: "Papua Nuova Guinea",
            PY: "Paraguay",
            PE: "Perù",
            PH: "Filippine",
            PN: "Isole Pitcairn",
            PL: "Polonia",
            PT: "Portogallo",
            PR: "Portorico",
            QA: "Qatar",
            RE: "Riunione",
            RO: "Romania",
            RU: "Russia",
            RW: "Ruanda",
            BL: "Saint-Barthélemy",
            SH: "Sant’Elena",
            KN: "Saint Kitts e Nevis",
            LC: "Saint Lucia",
            MF: "Saint Martin",
            PM: "Saint-Pierre e Miquelon",
            VC: "Saint Vincent e Grenadine",
            WS: "Samoa",
            SM: "San Marino",
            ST: "São Tomé e Príncipe",
            SA: "Arabia Saudita",
            SN: "Senegal",
            RS: "Serbia",
            SC: "Seychelles",
            SL: "Sierra Leone",
            SG: "Singapore",
            SK: "Slovacchia",
            SI: "Slovenia",
            SB: "Isole Salomone",
            SO: "Somalia",
            ZA: "Sudafrica",
            GS: "Georgia del Sud e Sandwich Australi",
            ES: "Spagna",
            LK: "Sri Lanka",
            SD: "Sudan",
            SR: "Suriname",
            SJ: "Svalbard e Jan Mayen",
            SZ: "Eswatini",
            SE: "Svezia",
            CH: "Svizzera",
            SY: "Siria",
            TW: "Taiwan",
            TJ: "Tagikistan",
            TZ: "Tanzania",
            TH: "Thailandia",
            TL: "Timor Est",
            TG: "Togo",
            TK: "Tokelau",
            TO: "Tonga",
            TT: "Trinidad e Tobago",
            TN: "Tunisia",
            TR: "Turchia",
            TM: "Turkmenistan",
            TC: "Isole Turks e Caicos",
            TV: "Tuvalu",
            UG: "Uganda",
            UA: "Ucraina",
            AE: "Emirati Arabi Uniti",
            GB: "Regno Unito",
            US: "Stati Uniti",
            UM: "Isole Minori Esterne degli Stati Uniti",
            UY: "Uruguay",
            UZ: "Uzbekistan",
            VU: "Vanuatu",
            VE: "Venezuela",
            VN: "Vietnam",
            VG: "Isole Vergini Britanniche",
            VI: "Isole Vergini Americane",
            WF: "Wallis e Futuna",
            EH: "Sahara Occidentale",
            YE: "Yemen",
            ZM: "Zambia",
            ZW: "Zimbabwe",
        },
    },
    jp: {
        _name: '日本語',
        autoCloseModal: {
            takeProfitStopLoss: '利益確定とストップロス',
            takeProfit: '利益を得る',
            stopLoss: 'ストップ・ロス',
            updateOrder: '更新オーダー',
        },
        balanceModal: {
            balance: 'バランス',
            credit: 'クレジット',
            equity: 'エクイティ',
            practice: '実践',
            real: 'リアル',
            account: 'アカウント',
            invested: '投資済み',
            profit: '利益',
            loss: '損失',
            margin: 'マージン',
            marginLevel: 'マージンレベル',
            marginFree: 'フリー・マージン'
        },
        header: {
            cfd: 'CFD',
            platform: 'プラットフォーム',
            deposit: 'デポジット',
            myAccount: 'マイアカウント'
        },
        sideMenu: {
            marketWatch: 'マーケット・ウォッチ',
            activeOrders: 'アクティブオーダー',
            tradingHistory: '取引履歴',
            economicCalendar: 'カレンダー',
            marketNews: 'マーケットニュース'
        },
        closePositionModal: {
            closeOrder: 'クローズポジション',
            areYouSure: 'ポジションをクローズしてよろしいですか？',
            buy: '購入',
            sell: '売る',
            yes: 'はい',
            no: 'いいえ',
        },
        chart: {
            addNewChart: '新しいチャートを追加する',
        },
        symbolsModal: {
            watchlist: 'ウォッチリスト',
            asset: '資産',
            price: '価格',
            changePct: '24時間変更'
        },
        pendingModal: {
            pending: '申請中',
            assetPrice: '資産価格',
            current: '現在',
            revert: '市場価格に戻す',
            automatically: '価格がこのレベルに達すると自動的にポジションがオープンされます。'
        },
        orderMenu: {
            volume: 'ボリューム',
            lots: 'ロット',
            units: '単位',
            currency: '通貨',
            contractSize: '契約サイズ',
            position: 'ポジション',
            margin: 'マージン',
            freeMargin: 'フリーマージン',
            takeProfitStopLoss: 'テイクプロフィット & ストップロス',
            pending: '保留中',
            market: 'マーケット',
            leverage: 'レバレッジ',
            spread: 'スプレッド',
            notSet: '設定されていません',
            at: 'で',
            buy: '買い',
            sell: '売り',
        },
        footer: {
            supportBanner: '毎日、24時間対応',
            currentTime: '現在時刻',
            liveChat: 'ライブチャット'
        },
        statusBar: {
            balance: '残高',
            credit: 'クレジット',
            equity: '証拠金残高',
            margin: 'マージン',
            marginLevel: 'マージンレベル',
            freeMargin: 'フリーマージン',
            pnl: '損益',
            profitTotal: '累計損益'
        },
        accountModal: {
            dateRegistered: '登録日',
            userId: 'ユーザーID',
            dashboard: 'ダッシュボード',
            personalData: '個人情報',
            deposit: '入金',
            withdrawFunds: '出金',
            savings: '貯蓄',
            settings: '設定',
            logout: 'ログアウト'
        },
        depositModal: {
            BT_INVOICE: '金額を入力して請求書を作成',
            BT_TITLE: '当社の銀行情報',
            BT_ACCOUNT: '口座',
            BT_BANK_NAME: '銀行名',
            BT_BENEFICIARY: '受取人',
            BT_ADDRESS: '受取人住所',
            BT_SWIFT: 'SWIFT',
            BT_IBAN: 'IBAN',
            BT_REFERENCE_CODE: '銀行参照コード',
            BT_INN: 'INN',
            BT_KPP: 'コルレス口座',
            BT_CORRESPONDING: '',
            TOKEN_AMOUNT: '金額',
            TOKEN_SUBTOTAL: '小計',
            TOKEN_TOTAL: '合計',
            TOKEN_DESCRIPTION: '説明',
            TOKEN_PAYMENT_DETAILS: '支払い詳細',
            PENDING_DEPOSITS_LIMIT: '入金上限',
            makeDeposit: '入金する',
            practiceAccount: 'デモ口座',
            realAccount: 'リアル口座',
            noWithdrawals: '出金不可',
            easyWithdrawals: '簡単な出金',
            allAssets: 'すべての資産が利用可能',
            fullFledged: 'フル機能のプラットフォーム',
            fillUpTo: '最大まで入金',
            freeReplenishment: '無料入金',
            topUp: '口座に入金',
            minimumAmount: '最低金額',
            canSwitch: 'いつでも口座を切り替えできます'
        },
        gridsModal: {
            chartGrids: 'チャートグリッド',
            chart1: '1チャート',
            chart2: '2チャート',
            chart3: '3チャート',
            chart4: '4チャート',
        },
        noConnectionModal: {
            connectionLost: 'サーバーとの接続が失われました',
            retryNow: '今すぐ再試行'
        },
        loginModal: {
            loginToTradeRoom: 'トレードルームにログイン',
            email: 'メールアドレス',
            emailAndId: 'メールアドレス / ID番号',
            enterEmail: 'メールアドレスを入力してください',
            twoFactor: '2FAコード（有効な場合）',
            twoFactorAuth: '二要素認証',
            password: 'パスワード',
            yourPassword: 'あなたのパスワード',
            signIn: 'サインイン',
            dontHaveAccount: 'アカウントをお持ちではありませんか？',
            restore: '復元',
            fullName: '氏名',
            havePromo: 'プロモコードをお持ちですか',
            promo: 'プロモコード',
            login: 'ログイン',
            haveAccount: 'すでにアカウントをお持ちですか？',
            hide: '隠す',
            goTo: '戻る'
        },
        newPasswordModal: {
            setNewPassword: '新しいパスワードを設定する',
            newPassword: '新しいパスワード',
            confirmNewPassword: '新しいパスワードを確認',
            setButton: '設定する'
        },
        registerModal: {
            createNewAccount: '新しいアカウントを作成する',
            email: 'メールアドレス',
            firstName: '名（ファーストネーム)',
            lastName: '姓（ラストネーム',
            country: '国',
            phone: '電話番号',
            password: 'パスワード',
            createAccount: 'アカウントを作成する',
            currency: '通貨',
        },
        forgotPasswordModal: {
            forgotPassword: 'パスワードをお忘れですか',
            submitEmail: '登録に使用したメールアドレスを送信してください。受信トレイを確認し、記載された指示に従ってください',
            submit: '送信',
        },
        notifications: {
            error: 'エラー',
            success: '成功',
            deposit: '入金',
            withdrawal: '出金',
            depositApproved: 'が承認されました',
            depositDeclined: '入金が拒否されました',
            withdrawalApproved: '出金が承認されました',
            withdrawalDeclined: '出金が拒否されました',
            withdrawalCancelled: '出金はキャンセルされました',
            orderRejected: '注文拒否',
            insufficientMargin: '保留中の注文を開けませんでした：フリーマージンが不足しています',
            marginCall: 'マージンコール',
            marginCallText: '必要証拠金を満たすために入金してください',
        },
        markets: {
            forex: '外国為替',
            stocks: '株式',
            commodities: '商品（コモディティ',
            indices: '株価指数 (インデックス)',
            crypto: '暗号通貨 (クリプト)',
            metals: '貴金属',
            nft: '（非代替性トークン'
        },
        profitCalculatorModal: {
            buy: '購入',
            profitCalculator: '利益計算機',
            sell: '売却',
            volume: '取引量',
            entryPrice: 'エントリープライス（開始価格）',
            takeProfit: '利益確定 (テイクプロフィット)',
            stopLoss: '損切り (ストップロス)',
            maxPosition: '最大ポジション',
            calculate: '計算する',
            calculationsFor: '計算対象',
            leverage: 'レバレッジ',
            requiredMargin: '必要証拠金',
            profitFromTP: '利益確定（TP）からの利益',
            lossFromSL: '損切り（SL）からの損失',
            roe: '自己資本利益率 (ROE)',
        },
        depositSuccessModal: {
            title: '入金が成功しました',
            text: 'あなたの入金は正常に処理されました！',
        },
        depositFailModal: {
            title: '入金に失敗しました',
            text: 'あなたの入金は処理されませんでした。',
        },
        widgetMarketWatch: {
            marketWatch: 'マーケットウォッチ',
            search: '検索...',
        },
        widgetOrders: {
            commission: '手数料',
            volume: '取引量',
            margin: '証拠金',
            active: 'アクティブ',
            pending: '保留中',
            activeOrders: 'アクティブ注文',
            portfolio: 'ポートフォリオ',
            allPositions: 'すべてのポジション',
            noPositionsLine1: '開いているものはありません',
            noPositionsLine2: 'まだポジションがありません',
            show: '表示',
            more: 'もっと表示する',
            less: '少なく表示する',
            purchaseTime: '購入時間',
            closePosition: 'ポジションをクローズする',
            priceOpen: '購入価格',
            priceSl: '損切り価格 (ストップロス価格)',
            priceTp: '利益確定価格 (テイクプロフィット価格)',
            type: 'ポジションの方向',
            pnl: '利益/損失',
            cancelOrder: '注文をキャンセルする',
            orderType: '注文タイプ',
            cancelled: 'キャンセルされました',
            tradingHistory: '取引履歴',
            noHistoryLine1: '取引履歴はありません。',
            noHistoryLine2: 'まだクローズした取引はありません。',
            sortByTime: '時間順に並び替え',
        },
        widgetEconomicCalendar: {
            economicCalendar: 'カレンダー'
        },
        widgetMarketNews: {
            marketNews: 'マーケットニュース'
        },
        ordersPane: {
            ordersActive: 'アクティブオーダー',
            ordersHistory: '注文履歴',
            id: 'ID',
            symbol: 'シンボル',
            type: 'タイプ',
            volume: 'ボリューム',
            openPrice: 'オープン価格',
            openTime: 'オープン時間',
            closePrice: 'クローズ価格',
            closeTime: 'クローズ時間',
            sl: '（ストップロス）',
            tp: '（テイクプロフィット）',
            price: '価格',
            pnl: '利益と損失',
            actions: 'アクション',
            edit: '編集',
            close: '閉じる',
            commission: '手数料',
            swap: 'スワップ',
            swapLong: 'ロングスワップ',
            swapShort: 'ショートスワップ'
        },
        assetInfoModal: {
            assetInfo: '資産情報',
            tradingConditions: '取引条件',
            information: 'セッション変更',
            bid: 'ビッド',
            ask: 'アスク',
            sessionChange: 'セッションの変更',
            tradeNow: '今すぐ取引する',
            opens: 'オープン',
            closes: 'クローズ',
            at: 'で',
            open247: '24時間営業',
            today: '今日',
            tomorrow: '明日',
            sunday: '日曜日',
            monday: '月曜日',
            tuesday: '火曜日',
            wednesday: '水曜日',
            thursday: '木曜日',
            friday: '金曜日',
            saturday: '土曜日',
            contractSpecification: '契約仕様',
            symbol: 'シンボル',
            name: '名前',
            market: 'マーケット',
            baseCurrency: '基軸通貨',
            digits: '桁数',
            lotSize: 'ロットサイズ',
            lotStep: 'ロットステップ',
            minVolume: '最小取引量',
            maxVolume: '最大取引量',
            leverage: 'レバレッジ',
            commission: '手数料',
            swapLong: 'ロングスワップ',
            swapShort: 'ショートスワップ',
            schedule: 'スケジュール',
            weekday: '平日',
            tradingTime: '取引時間',
            closed: 'クローズ済み',
            sell: '売却',
            buy: '購入',
            low: '安値',
            high: '高値',
            oneHourChange: '1時間の変化',
            oneDayChange: '1日の変化',
            oneWeekChange: '1週間の変化',
            oneMonthChange: '1ヶ月の変化',
            threeMonthsChange: '3ヶ月の変化',
            oneYearChange: '1年の変化',
            loading: '読み込み中...',
        },
      
        fullScreen: {
            startTrading: '取引を開始する',
            deposit: '入金',
            dashboard: 'ダッシュボード',
            personalInfo: '個人情報',
            withdrawal: '出金',
            verification: '本人確認',
            accounts: 'アカウント',
            liveChat: 'ライブチャット',
            savings: '貯蓄',
            settings: '設定',
            logOut: 'ログアウト',
        },
        fullScreenDeposit: {
            chooseCryptocurrency: 'CHOOSE CRYPTOCURRENCY',
            addressReceipt: 'アドレスを読み込み中です。しばらくお待ちください',
            makeDeposit: '入金する',
            instant: '即時',
            minutes: '分',
            hours: '時間',
            days: '日',
            amount: '金額',
            continue: '続行',
            qrCode: 'QRコード',
            depositAddress: '入金先アドレス',
            addWalletAddress: 'この方法のウォレットが設定されていません。担当者またはカスタマーサポートにご連絡ください。',
            copy: 'コピー',
            last: '最新',
            deposits: '入金履歴',
            time: '時間',
            currency: '通貨',
            status: 'ステータス',
            info: '情報',
            name: 'カード名義人',
            address: '住所',
            DOB: '生年月日',
            bankName: '銀行名',
            additionalInfo: 'さらに入金する場合は、担当のアカウントマネージャーまで直接ご連絡ください',
            additionalInfoOnlyBTCpsp: '他の支払い方法を開くには、KYCの提出またはアカウントマネージャーへの連絡が必要です',
            sofortPspMessage: '入金をサポートするため、弊社の財務チームよりご連絡いたします'
        },
        fullScreenCcExt: {
            pleaseWait: 'お待ちください。決済サービスプロバイダーに接続中です...',
            cardPayment: 'カード決済',
            inOrder: '金額を送信するためには、',
            pleaseProvide: 'カードの詳細を入力してください：'
        },
        fullScreenDashboard: {
            totalTaxes: '税額合計',
            totalBalance: '総残高',
            totalPnl: '総損益 ',
            profitableOrders: '利益のある注文',
            roi: '投資利益率',
            activityLog: 'アクティビティログ',
            loginFromIp: 'IPからのログイン',
            tradingResults: '取引結果',
            week: '週',
            month: '月',
            year: '年',
            successRate: '成功率',
            closedWithProfit: '利益でクローズしました',
            closedWithLoss: '損失でクローズしました',
            account: 'アカウント',
            balance: '残高',
            leverage: 'レバレッジ',
            credit: 'クレジット',
            tradeNow: '今すぐ取引する',
            usingCurrentRate: '現在の為替レートを使用して',
            totalDeposits: '総入金額',
        },
        fullScreenPersonal: {
            personalDetails: '個人情報',
            profilePhoto: 'プロフィール写真',
            firstName: '名（ファーストネーム）',
            country: '国',
            lastName: '姓（ラストネーム）',
            address: '住所',
            email: 'メールアドレス',
            phone: '電話番号',
            saveChanges: '変更を保存する',
        },
        fullScreenAvatar: {
            dropFile: '上の円にファイルをドラッグ＆ドロップしてアップロードしてください。',
            notAllowed: '公開することは許可されていません。',
            notAllowedLine1: '露骨な性的またはポルノ的な性質の写真',
            notAllowedLine2: '民族的または人種的憎悪や侵略を扇動することを目的とした画像',
            notAllowedLine3: '18歳未満が写っている写真',
            notAllowedLine4: '第三者の著作権保護された写真',
            notAllowedLine5: '5MBを超え、JPG、GIF、PNG以外の形式の画像',
            requirements: 'あなたの顔がはっきりと写っていること。あなたがアップロードしたすべての写真とビデオは、これらの要件に準拠している必要があります。'
        },
        fullScreenWithdrawal: {
            withdrawal: '退会',
            requestNewWithdrawal: '新規引き出しを申請する',
            amount: '金額',
            currentBalance: '現在の口座残高は',
            withdrawAll: 'すべて辞退する',
            requestWithdrawal: '退会申請',
            last: '最後',
            withdrawalRequests: '退会申請',
            time: '時間',
            currency: '通貨',
            info: 'インフォメーション',
            status: 'ステータス',
            bank: '銀行',
            bitcoin: 'Bitcoin',
            card: 'カード',
            ethereum: 'Ethereum',
            usdt: 'USDT',
            usdt_erc20: 'USDT ERC-20',
            matic: 'Matic',
            etransfer: 'Etransfer',
            interact: 'Interact',
            withdrawalDetails: '退会の詳細',
            address: '財布の住所',
            bankAccount: '口座番号',
            bankHolder: '口座名義人の名前',
            bankIban: 'IBAN',
            bankSwift: '銀行SWIFTコード',
            sortCode: 'ソートコード',
            ifscCode: 'IFSCコード',
            bankCode: "銀行コード（BSB）",
            bankName: '銀行名',
            bankBranch: '支店名',
            cardNumber: 'カード番号',
            cardHolder: 'カード名義人',
            incorrectAmountByFreeMargin: '金額が正しくありません。フリーマージンの金額まで出金できます。',
            closeOrders: 'すべての注文をクローズする前に'
        },
        fullScreenVerification: {
            dragAndDrop: 'ドキュメントをこのエリアにドラッグ＆ドロップする',
            documentsList: 'アップロードされたドキュメントのリスト',
            document: 'ドキュメント',
            timeUploaded: 'アップロード時間',
            timeProcessed: '処理時間',
            status: 'ステータス',
            types: ['身分証明', '居住証明', 'クレジットカード・フロント', 'クレジットカード・バック', '身分証明書', 'セルフィー', 'Other'],
            types2: [
                '身分証明書（IDカード、パスポート、運転免許証）', '住所証明書（公共料金の請求書または銀行明細書）', 'クレジットカード表面', 'クレジットカード裏面', '身分証明書裏面（IDカード裏面、運転免許証裏面）', '自撮り写真', 'その他' ],
            upload: 'アップロード',
            isConfirmed: 'が確認された',
            uploadAnotherDocument: '別の文書をアップロードする',
            isUnderReview: '検討中',
            questionnaire: 'アンケート',
            sendAnswers: '回答を送信',
            progressBarOf: 'の',
            progressBarText: '書類のアップロードと確認が完了しました。'
        },
        fullScreenAccounts: {
            manageAccounts: '口座間の資金移動',
            transferFrom: 'アカウントより',
            transferTo: '会計',
            amount: '金額',
            makeTransfer: '譲渡する',
            yourAccounts: 'アカウント',
            account: 'アカウント',
            currency: '通貨',
            balance: 'バランス',
            credit: 'クレジット',
            makeActive: 'アクティブにする',
            active: 'アクティブ'
        },
        fullScreenSupport: {
            chatOff: 'チャットは営業日のみご利用いただけます',
            sendMessage: 'メッセージを送信',
            responseTime: '平均応答時間：1～24時間',
        },
        fullScreenSavings: {
            pct_0: 'フレキシブル',
            pct_30: 'ロック1ヶ月',
            pct_90: 'ロック1クォーター',
            pct_180: 'ロック6ヶ月',
            pct_365: 'ロック1年',
            pct_730: '2年間ロック',
            savings: '貯蓄',
            detailedInformation: '詳細情報',
            pleaseSelect: '通貨と期間を選択してください。',
            openSavings: 'オープン・セービング',
            currentTime: '現在時刻',
            releaseTime: 'リリース時間',
            currencyChosen: '選択された通貨',
            periodChosen: '選ばれた期間',
            yourRate: 'レート',
            yourAnnualRate: '年間利率',
            yourEarnings: 'あなたの収入',
            accountFrom: '送金元口座',
            enterAmount: '金額を入力',
            in: 'で',
            openAndInvest: '普通預金口座の開設と投資',
            investment: '投資',
            period: '期間',
            daysTotal: '合計日数',
            finalEarnings: '最終利益',
            created: '作成',
            daysElapsed: '経過日数',
            days: '日',
            earnings: '収益',
            fundsReleasedIn: '資金放出',
            claim: 'クレーム',
        },
        fullScreenSettings: {
            updatePassword: 'パスワード更新',
            currentPassword: '現在のパスワード',
            newPassword: '新しいパスワード',
            changePassword: 'パスワードの変更',
            activationForGoogle: 'Google Authenticatorのアクティベーションコード',
            activateAndEnter: 'Authenticatorを起動し、以下のフィールドに生成されたコードを入力します。',
            qrCode: 'QRコード',
            activateProtection: '2FA保護を有効にする',
            protectionActive: '2FA保護が有効',
            twoFactorCode: '2FAコード',
            disableProtection: '2FA保護を無効にする',
            language: '言語',
            dashboardCurrency: 'ダッシュボードの通貨',
            confirmNewPassword: '新しいパスワードの確認',
        },
        fullScreenReferrals: {
            yourLink: 'あなたの紹介リンク',
            referredFriends: '友人紹介',
            id: '身分証明書',
            name: '名称',
            registered: '登録',
            level: 'レベル',
            payout: '支払い',
            lastPayouts: '最後の紹介料支払い',
            time: '時間',
            amount: '金額',
            currency: '通貨',
            info: 'インフォメーション',
        },
        months: {
            Jan: 'ヤン',
            Feb: '2月',
            Mar: 'マー',
            Apr: '4月',
            May: '月',
            Jun: 'ジュン',
            Jul: 'ジュル',
            Aug: 'オーグ',
            Sep: 'セプ',
            Oct: 'オクト',
            Nov: 'ノヴ',
            Dec: 'デック'
        },
        orderTypes: ['購入', '売る', 'リミット購入', '売り指値', 'ストップ高', '売りストップ'],
        statuses: ['保留中', '承認済み', '拒否されました', '処理中', '審査中', '処理中', 'キャンセル済み'],
        errors: {
            INVALID_FIELDS: '入力された内容が正しいかご確認ください',
            NOT_FOUND: 'リクエストエラー',
            FORBIDDEN: 'アクセスが拒否されました。再度ログインしてください',
            SERVER_ERROR: '操作に失敗しました。後ほど再試行してください',
            INVALID_ACCOUNT: 'セッションの有効期限が切れました。再度ログインしてください',
            INVALID_EMAIL: '無効なメールアドレスです',
            INVALID_PHONE: '無効な電話番号です',
            INVALID_COUNTRY: '無効な国です',
            INVALID_LOGIN: 'ログイン情報が正しくありません',
            USER_BLOCKED: 'アカウントはブロックされています。サポートにお問い合わせください',
            USER_REGISTERED: '入力されたメールアドレスまたは電話番号は既に登録されています',
            INVALID_USER: 'ユーザーが見つかりません',
            REJECTED: 'プラットフォームの制限により操作は許可されていません',
            INVALID_OLD_PASSWORD: '古いパスワードが正しくありません',
            INVALID_SYMBOL: '無効な取引シンボルです',
            INVALID_SYMBOL_PRECISION: 'シンボルの精度が無効です',
            INVALID_FRAME: '無効なチャートフレームです',
            INVALID_CURRENCY: '無効な通貨です',
            INVALID_PRODUCT: '無効なアカウント取引タイプです',
            INSUFFICIENT_FUNDS: '残高が不足しています',
            INVALID_WITHDRAWAL: '出金が見つかりません',
            INVALID_DEPOSIT: 'この入金はキャンセルできません。見つからないか、すでに処理されています',
            INVALID_STATUS: '無効なステータスです',
            INVALID_FILE: 'ファイルの拡張子が無効、またはファイルが大きすぎます',
            INVALID_DOCUMENT: 'ドキュメントが見つかりません',
            INVALID_NAME: '名前が無効です',
            INVALID_LOT_SIZE: 'ロットサイズが無効です',
            INVALID_LOT_STEP: 'ロットステップが無効です',
            INVALID_MIN_VOLUME: '最小取引量が無効です',
            INVALID_MAX_VOLUME: '最大取引量が無効です',
            INVALID_GROUP: '無効なグループです',
            INVALID_SPREAD: 'スプレッドが無効です',
            REQUEST_TIMEOUT: 'リクエストがタイムアウトしました。後ほど再試行してください',
            INVALID_TYPE: '無効な注文タイプです',
            INVALID_VOLUME: '注文量が無効です',
            INVALID_SL: 'ストップロスの値が無効です',
            INVALID_TP: 'テイクプロフィットの値が無効です',
            INVALID_PRICE: '注文価格が無効です',
            INVALID_EXPIRATION: '注文の有効期限が無効です',
            NOT_ENOUGH_MARGIN: 'マージンが不足しています',
            INVALID_ORDER: '注文が見つかりません',
            MARKET_CLOSED: '現在取引できません。後ほど再試行してください',
            INVALID_BALANCE_TYPE: '無効な残高操作タイプです',
            INVALID_HASH: 'ハッシュが無効です',
            HASH_EXPIRED: 'パスワードリセットリンクの有効期限が切れています。新しいリンクをリクエストしてください',
            INVALID_CODE: '2FAコードが無効です',
            CHAT_DISABLED: 'サポートチャットへのアクセスは閉鎖されています',
            WITHDRAWAL_NOT_ALLOWED: '出金へのアクセスは閉鎖されています',
            TRADING_DISABLED: '現在のアカウントでは取引が無効です',
            PENDING_DEPOSITS_LIMIT: '入金限度額を超えています',
            CLOSE_OPEN_ORDERS: 'オープン中の注文を閉じてください',
            LOCAL_ONE_PENDING_WITHDRAWAL: '保留中の出金は1件のみ許可されています',
            LOCAL_DEPOSIT_ONLY_REAL: '入金はリアルアカウントのみ可能です',
            LOCAL_DEPOSIT_POSITIVE: '入金額は0より大きくする必要があります',
            LOCAL_INVALID_CARD_NUMBER: 'カード番号が無効です',
            LOCAL_INVALID_CARD_EXPIRATION: 'カードの有効期限が無効です',
            LOCAL_INVALID_CVC: 'CVV/CVCコードが無効です',
            LOCAL_PASSWORDS_NOT_MATCH: 'パスワードが一致しません。再入力してください',
            LOCAL_NO_TRADING_ACCOUNTS: '取引可能なアカウントがありません。サポートにお問い合わせください',
            LOCAL_MIN_DEPOSIT: '最小入金額は $',
            LOCAL_MIN_WITHDRAWAL: '最小出金額は $',
            LOCAL_INVALID_FILE_TYPE: 'サポートされていないファイル形式です。JPG、PNG、PDFのみ添付してください',
            LOCAL_MIN_STAKING: 'この通貨の最小入金額は ',
            FLOOD_REJECTED: 'メッセージの送信が多すぎます。後ほど再試行してください',
            REGISTRATIONS_BLOCKED: 'お問い合わせありがとうございます。担当者ができるだけ早くご連絡いたします',
        },
        countries: {
            AF: 'アフガニスタン',
            AX: 'アランド諸島',
            AL: 'アルバニア',
            DZ: 'アルジェリア',
            AS: '米領サモア',
            AD: 'アンドラ',
            AO: 'アンゴラ',
            AI: 'アングィラ',
            AQ: '南極大陸',
            AG: 'アンティグア・バーブーダ',
            AR: 'アルゼンチン',
            AM: 'アルメニア',
            AW: 'アルバ',
            AU: 'オーストラリア',
            AT: 'オーストリア',
            AZ: 'アゼルバイジャン',
            BS: 'バハマ',
            BH: 'バーレーン',
            BD: 'バングラデシュ',
            BB: 'バルバドス',
            BY: 'ベラルーシ',
            BE: 'ベルギー',
            BZ: 'ベリーズ',
            BJ: 'ベナン',
            BM: 'バーミューダ',
            BT: 'ブータン',
            BO: 'ボリビア',
            BA: 'ボスニア・ヘルツェゴビナ',
            BW: 'ボツワナ',
            BV: 'ブーベ島',
            BR: 'ブラジル',
            IO: '英領インド洋地域',
            BN: 'ブルネイ',
            BG: 'ブルガリア',
            BF: 'ブルキナファソ',
            BI: 'ブルンジ',
            KH: 'カンボジア',
            CM: 'カメルーン',
            CA: 'カナダ',
            CV: 'カーボベルデ',
            KY: 'ケイマン諸島',
            CF: '中央アフリカ共和国',
            TD: 'チャド',
            CL: 'チリ',
            CN: '中国',
            CX: 'クリスマス島',
            CC: 'ココス（キーリング）諸島',
            CO: 'コロンビア',
            KM: 'コモロ',
            CG: 'コンゴ',
            CD: 'コンゴ民主共和国',
            CK: 'クック諸島',
            CR: 'コスタリカ',
            CI: 'コートジボワール',
            HR: 'クロアチア',
            CU: 'キューバ',
            CY: 'キプロス',
            CZ: 'チェコ共和国',
            DK: 'デンマーク',
            DJ: 'ジブチ',
            DM: 'ドミニカ',
            DO: 'ドミニカ共和国',
            EC: 'エクアドル',
            EG: 'エジプト',
            SV: 'エルサルバドル',
            GQ: '赤道ギニア',
            ER: 'エリトリア',
            EE: 'エストニア',
            ET: 'エチオピア',
            FK: 'フォークランド諸島（マルビナス）',
            FO: 'フェロー諸島',
            FJ: 'フィジー',
            FI: 'フィンランド',
            FR: 'フランス',
            GF: 'フランス領ギアナ',
            PF: 'フランス領ポリネシア',
            TF: 'フランス領南方領土',
            GA: 'ガボン',
            GM: 'ガンビア',
            GE: 'グルジア',
            DE: 'ドイツ',
            GH: 'ガーナ',
            GI: 'ジブラルタル',
            GR: 'ギリシャ',
            GL: 'グリーンランド',
            GD: 'グレナダ',
            GP: 'グアドループ',
            GU: 'グアム',
            GT: 'グアテマラ',
            GG: 'ガーンジー',
            GN: 'ギニア',
            GW: 'ギニアビサウ',
            GY: 'ガイアナ',
            HT: 'ハイチ',
            HM: 'ハード島＆マクドナルド諸島',
            VA: 'バチカン市国',
            HN: 'ホンジュラス',
            HK: '香港',
            HU: 'ハンガリー',
            IS: 'アイスランド',
            IN: 'インド',
            ID: 'インドネシア',
            IR: 'イラン',
            IQ: 'イラク',
            IE: 'アイルランド',
            IM: 'マン島',
            IL: 'イスラエル',
            IT: 'イタリア',
            JM: 'ジャマイカ',
            JP: '日本',
            JE: 'ジャージー',
            JO: 'ヨルダン',
            KZ: 'カザフスタン',
            KE: 'ケニア',
            KI: 'キリバス',
            KR: '韓国',
            KW: 'クウェート',
            KG: 'キルギス',
            LA: 'ラオス人民民主共和国',
            LV: 'ラトビア',
            LB: 'レバノン',
            LS: 'レソト',
            LR: 'リベリア',
            LY: 'リビア・アラブ・ジャマーヒリーヤ',
            LI: 'リヒテンシュタイン',
            LT: 'リトアニア',
            LU: 'ルクセンブルク',
            MO: 'マカオ',
            MK: 'マケドニア',
            MG: 'マダガスカル',
            MW: 'マラウイ',
            MY: 'マレーシア',
            MV: 'モルディブ',
            ML: 'マリ',
            MT: 'マルタ',
            MH: 'マーシャル諸島',
            MQ: 'マルティニーク',
            MR: 'モーリタニア',
            MU: 'モーリシャス',
            YT: 'マヨット',
            MX: 'メキシコ',
            FM: 'ミクロネシア',
            MD: 'モルドバ',
            MC: 'モナコ',
            MN: 'モンゴル',
            ME: 'モンテネグロ',
            MS: 'モンセラット',
            MA: 'モロッコ',
            MZ: 'モザンビーク',
            MM: 'ミャンマー',
            NA: 'ナミビア',
            NR: 'ナウル',
            NP: 'ネパール',
            NL: 'オランダ',
            AN: 'オランダ領アンティル',
            NC: 'ニューカレドニア',
            NZ: 'ニュージーランド',
            NI: 'ニカラグア',
            NE: 'ニジェール',
            NG: 'ナイジェリア',
            NU: 'ニウエ',
            NF: 'ノーフォーク島',
            MP: '北マリアナ諸島',
            NO: 'ノルウェー',
            OM: 'オマーン',
            PK: 'パキスタン',
            PW: 'パラオ',
            PS: 'パレスチナ占領地',
            PA: 'パナマ',
            PG: 'パプアニューギニア',
            PY: 'パラグアイ',
            PE: 'ペルー',
            PH: 'フィリピン',
            PN: 'ピトケアン',
            PL: 'ポーランド',
            PT: 'ポルトガル',
            PR: 'プエルトリコ',
            QA: 'カタール',
            RE: '再会',
            RO: 'ルーマニア',
            RU: 'ロシア',
            RW: 'ルワンダ',
            BL: 'サン・バルテルミー',
            SH: 'セントヘレナ',
            KN: 'セントクリストファー・ネイビス',
            LC: 'セントルシア',
            MF: 'セント・マーチン',
            PM: 'サンピエール島・ミクロン島',
            VC: 'セントビンセント・グレナディーン',
            WS: 'サモア',
            SM: 'サンマリノ',
            ST: 'サントメ・プリンシペ',
            SA: 'サウジアラビア',
            SN: 'セネガル',
            RS: 'セルビア',
            SC: 'セーシェル',
            SL: 'シエラレオネ',
            SG: 'シンガポール',
            SK: 'スロバキア',
            SI: 'スロベニア',
            SB: 'ソロモン諸島',
            SO: 'ソマリア',
            ZA: '南アフリカ',
            GS: 'サウス・ジョージア島とサンドイッチ島',
            ES: 'スペイン',
            LK: 'スリランカ',
            SD: 'スーダン',
            SR: 'スリナム',
            SJ: 'スバールバル諸島とヤンマイエン島',
            SZ: 'スワジランド',
            SE: 'スウェーデン',
            CH: 'スイス',
            SY: 'シリア・アラブ共和国',
            TW: '台湾',
            TJ: 'タジキスタン',
            TZ: 'タンザニア',
            TH: 'タイ',
            TL: '東ティモール',
            TG: 'トーゴ',
            TK: 'トケラウ',
            TO: 'トンガ',
            TT: 'トリニダード・トバゴ',
            TN: 'チュニジア',
            TR: 'トルコ',
            TM: 'トルクメニスタン',
            TC: 'タークス・カイコス諸島',
            TV: 'ツバル',
            UG: 'ウガンダ',
            UA: 'ウクライナ',
            AE: 'アラブ首長国連邦',
            GB: 'イギリス',
            US: '米国',
            UM: 'アメリカ離島',
            UY: 'ウルグアイ',
            UZ: 'ウズベキスタン',
            VU: 'バヌアツ',
            VE: 'ベネズエラ',
            VN: 'ベトナム',
            VG: '英領ヴァージン諸島',
            VI: '米バージン諸島',
            WF: 'ウォリス・フテュナ',
            EH: '西サハラ',
            YE: 'イエメン',
            ZM: 'ザンビア',
            ZW: 'ジンバブエ'
        },
    },
    pt: {
        "autoCloseModal": {
            "takeProfitStopLoss": "Take Profit e Stop Loss",
            "takeProfit": "Take Profit",
            "stopLoss": "Stop Loss",
            "updateOrder": "Atualizar Ordem"
        },
        "balanceModal": {
            "balance": "Saldo",
            "credit": "Crédito",
            "equity": "Capital Próprio",
            "practice": "DEMO",
            "real": "REAL",
            "account": "CONTA",
            "invested": "Investido",
            "profit": "Lucro",
            "loss": "Perda",
            "margin": "Margem",
            "marginLevel": "Nível de Margem",
            "marginFree": "Margem Livre"
        },
        "header": {
            "cfd": "CFD",
            "platform": "Plataforma",
            "deposit": "Depositar",
            "myAccount": "A minha conta"
        },
        "sideMenu": {
            "marketWatch": "Cotações",
            "activeOrders": "Ordens Ativas",
            "tradingHistory": "Histórico de Negociação",
            "economicCalendar": "Calendário Económico",
            "marketNews": "Notícias do Mercado"
        },
        "closePositionModal": {
            "closeOrder": "Fechar Posição",
            "areYouSure": "Tem a certeza de que pretende fechar a posição",
            "buy": "Comprar",
            "sell": "Vender",
            "yes": "Sim",
            "no": "Não"
        },
        "chart": {
            "addNewChart": "Adicionar Novo Gráfico"
        },
        "symbolsModal": {
            "watchlist": "Favoritos",
            "asset": "Ativo",
            "price": "Preço",
            "changePct": "Variação 24h"
        },
        "pendingModal": {
            "pending": "Pendente",
            "assetPrice": "Preço do Ativo",
            "current": "Atual",
            "revert": "Voltar ao Preço de Mercado",
            "automatically": "A posição será aberta automaticamente quando o preço atingir este nível"
        },
        "orderMenu": {
            "volume": "Volume",
            "lots": "lotes",
            "units": "unidades",
            "currency": "moeda",
            "contractSize": "Tamanho do contrato",
            "position": "Posição",
            "margin": "Margem",
            "freeMargin": "Margem Livre",
            "takeProfitStopLoss": "Take Profit e Stop Loss",
            "pending": "Pendente",
            "market": "Mercado",
            "leverage": "Alavancagem",
            "spread": "Spread",
            "notSet": "Não definido",
            "at": "a",
            "buy": "comprar",
            "sell": "vender"
        },
        "footer": {
            "supportBanner": "TODOS OS DIAS, 24 HORAS POR DIA",
            "currentTime": "HORA ATUAL",
            "liveChat": "Chat em Direto"
        },
        "statusBar": {
            "balance": "Saldo",
            "credit": "Crédito",
            "equity": "Capital Próprio",
            "margin": "Margem",
            "marginLevel": "Nível de margem",
            "freeMargin": "Margem Livre",
            "pnl": "PnL",
            "profitTotal": "PnL Total"
        },
        "accountModal": {
            "dateRegistered": "Data de Registo",
            "userId": "ID de Utilizador",
            "dashboard": "Painel",
            "personalData": "Dados Pessoais",
            "deposit": "Depositar",
            "withdrawFunds": "Levantar Fundos",
            "savings": "Poupanças",
            "settings": "Definições",
            "logout": "Terminar Sessão"
        },
        "depositModal": {
            "BT_INVOICE": "Introduza o montante e gere a fatura",
            "BT_TITLE": "Os nossos dados bancários",
            "BT_ACCOUNT": "Conta",
            "BT_BANK_NAME": "Nome do Banco",
            "BT_BENEFICIARY": "Beneficiário",
            "BT_ADDRESS": "Morada do Beneficiário",
            "BT_SWIFT": "Swift",
            "BT_IBAN": "IBAN",
            "BT_REFERENCE_CODE": "Código de Referência Bancária",
            "BT_INN": "INN",
            "BT_KPP": "Conta correspondente",
            "BT_CORRESPONDING": "",
            "TOKEN_AMOUNT": "Montante",
            "TOKEN_SUBTOTAL": "Subtotal",
            "TOKEN_TOTAL": "Total",
            "TOKEN_DESCRIPTION": "Descrição",
            "TOKEN_PAYMENT_DETAILS": "Detalhes do Pagamento",
            "PENDING_DEPOSITS_LIMIT": "Limite de Depósito",
            "makeDeposit": "Efetuar um Depósito",
            "practiceAccount": "Conta Demo",
            "realAccount": "Conta Real",
            "noWithdrawals": "Sem Levantamentos",
            "easyWithdrawals": "Levantamentos Fáceis",
            "allAssets": "Todos os ativos disponíveis",
            "fullFledged": "Plataforma completa",
            "fillUpTo": "Recarregar Até",
            "freeReplenishment": "Carregamento gratuito",
            "topUp": "Carregue a Sua Conta",
            "minimumAmount": "Montante mínimo",
            "canSwitch": "Pode alternar entre as suas contas a qualquer momento"
        },
        "gridsModal": {
            "chartGrids": "GRELHAS DE GRÁFICOS",
            "chart1": "1 gráfico",
            "chart2": "2 gráficos",
            "chart3": "3 gráficos",
            "chart4": "4 gráficos"
        },
        "noConnectionModal": {
            "connectionLost": "A ligação ao servidor foi perdida",
            "retryNow": "Tentar Novamente"
        },
        "loginModal": {
            "loginToTradeRoom": "Iniciar Sessão na Traderoom",
            "email": "Endereço de e-mail",
            "emailAndId": "Endereço de e-mail / Número de ID",
            "enterEmail": "Introduza o seu e-mail",
            "twoFactor": "Código 2FA (se ativado)",
            "twoFactorAuth": "Autenticação de dois fatores",
            "password": "Palavra-passe",
            "yourPassword": "A sua palavra-passe",
            "signIn": "Iniciar Sessão",
            "dontHaveAccount": "Não tem uma conta?",
            "restore": "Recuperar",
            "fullName": "Nome Completo",
            "havePromo": "Tenho um código promocional",
            "promo": "Código promocional",
            "login": "Iniciar sessão",
            "haveAccount": "Já tem uma conta?",
            "hide": "Ocultar",
            "goTo": "Voltar"
        },
        "newPasswordModal": {
            "setNewPassword": "Definir Nova Palavra-passe",
            "newPassword": "Nova palavra-passe",
            "confirmNewPassword": "Confirmar nova palavra-passe",
            "setButton": "Definir"
        },
        "registerModal": {
            "createNewAccount": "Criar Nova Conta",
            "email": "Endereço de email",
            "firstName": "Nome próprio",
            "lastName": "Apelido",
            "country": "País",
            "phone": "Telefone",
            "password": "Palavra-passe",
            "createAccount": "Criar Conta",
            "currency": "Moeda"
        },
        "forgotPasswordModal": {
            "forgotPassword": "Esqueceu-se da palavra-passe?",
            "submitEmail": "Introduza o email utilizado no registo, verifique a sua caixa de entrada e siga as instruções fornecidas",
            "submit": "Enviar"
        },
        "notifications": {
            "error": "Erro",
            "success": "Sucesso",
            "deposit": "Depósito",
            "withdrawal": "Levantamento",
            "depositApproved": "O depósito foi aprovado",
            "depositDeclined": "O depósito foi recusado",
            "withdrawalApproved": "O levantamento foi aprovado",
            "withdrawalDeclined": "O levantamento foi recusado",
            "withdrawalCancelled": "O levantamento foi cancelado",
            "orderRejected": "Ordem rejeitada",
            "insufficientMargin": "Não foi possível abrir a sua ordem pendente: margem livre insuficiente",
            "marginCall": "Chamada de margem",
            "marginCallText": "Efetue um depósito para cumprir os requisitos de margem"
        },
        "markets": {
            "forex": "Forex",
            "stocks": "Ações",
            "commodities": "Matérias-primas",
            "indices": "Índices",
            "crypto": "Cripto",
            "metals": "Metais",
            "nft": "NFT"
        },
        "profitCalculatorModal": {
            "buy": "COMPRAR",
            "profitCalculator": "Calculadora de Lucro",
            "sell": "VENDER",
            "volume": "Volume",
            "entryPrice": "Preço de Entrada",
            "takeProfit": "Take Profit",
            "stopLoss": "Stop Loss",
            "maxPosition": "Posição Máxima",
            "calculate": "Calcular",
            "calculationsFor": "Cálculos para",
            "leverage": "Alavancagem",
            "requiredMargin": "Margem Necessária",
            "profitFromTP": "Lucro do TP",
            "lossFromSL": "Perda do SL",
            "roe": "ROI"
        },
        "depositSuccessModal": {
            "title": "Depósito bem-sucedido",
            "text": "O seu depósito foi processado com sucesso!"
        },
        "depositFailModal": {
            "title": "Falha no depósito",
            "text": "O seu depósito não foi processado."
        },
        "widgetMarketWatch": {
            "marketWatch": "Market Watch",
            "search": "Pesquisar..."
        },
        "widgetOrders": {
            "commission": "Comissão",
            "volume": "Volume",
            "margin": "Margem",
            "active": "Ativas",
            "pending": "Pendentes",
            "activeOrders": "Ordens Ativas",
            "portfolio": "Portefólio",
            "allPositions": "Todas as Posições",
            "noPositionsLine1": "Ainda não tem posições",
            "noPositionsLine2": "abertas",
            "show": "Mostrar",
            "more": "mais",
            "less": "menos",
            "purchaseTime": "Hora da Compra",
            "closePosition": "Fechar Posição",
            "priceOpen": "Preço de Compra",
            "priceSl": "Preço Stop Loss",
            "priceTp": "Preço Take Profit",
            "type": "Direção da Posição",
            "pnl": "Lucro/Perda",
            "cancelOrder": "Cancelar Ordem",
            "orderType": "Tipo de Ordem",
            "cancelled": "Cancelada",
            "tradingHistory": "Histórico de Negociação",
            "noHistoryLine1": "Ainda não tem negociações",
            "noHistoryLine2": "fechadas",
            "sortByTime": "Ordenar por hora"
        },
        "widgetEconomicCalendar": {
            "economicCalendar": "Calendário Económico"
        },
        "widgetMarketNews": {
            "marketNews": "Notícias do Mercado"
        },
        "ordersPane": {
            "ordersActive": "Ordens Ativas",
            "ordersHistory": "Histórico de Ordens",
            "id": "ID",
            "symbol": "Símbolo",
            "type": "Tipo",
            "volume": "Volume",
            "openPrice": "Preço de Abertura",
            "openTime": "Hora de Abertura",
            "closePrice": "Preço de Fecho",
            "closeTime": "Hora de Fecho",
            "sl": "SL",
            "tp": "TP",
            "price": "Preço",
            "pnl": "L/P",
            "actions": "Ações",
            "edit": "Editar",
            "close": "Fechar",
            "commission": "Comissão",
            "swap": "Swap",
            "swapLong": "Swap Longo",
            "swapShort": "Swap Curto"
        },
        "assetInfoModal": {
            "assetInfo": "Info do Ativo",
            "tradingConditions": "Condições de Negociação",
            "information": "Informação",
            "bid": "Bid",
            "ask": "Ask",
            "sessionChange": "Variação da Sessão",
            "tradeNow": "Negociar Agora",
            "opens": "Abre",
            "closes": "Fecha",
            "at": "às",
            "open247": "Aberto 24/7",
            "today": "hoje",
            "tomorrow": "amanhã",
            "sunday": "Domingo",
            "monday": "Segunda-feira",
            "tuesday": "Terça-feira",
            "wednesday": "Quarta-feira",
            "thursday": "Quinta-feira",
            "friday": "Sexta-feira",
            "saturday": "Sábado",
            "contractSpecification": "Especificação do Contrato",
            "symbol": "Símbolo",
            "name": "Nome",
            "market": "Mercado",
            "baseCurrency": "Moeda Base",
            "digits": "Dígitos",
            "lotSize": "Tamanho do Lote",
            "lotStep": "Passo do Lote",
            "minVolume": "Volume Mín.",
            "maxVolume": "Volume Máx.",
            "leverage": "Alavancagem",
            "commission": "Comissão",
            "swapLong": "Swap Longo",
            "swapShort": "Swap Curto",
            "schedule": "Horário",
            "weekday": "Dia da Semana",
            "tradingTime": "Horário de Negociação",
            "closed": "fechado",
            "sell": "Vender",
            "buy": "Comprar",
            "low": "Mínimo",
            "high": "Máximo",
            "oneHourChange": "Variação 1 hora",
            "oneDayChange": "Variação 1 dia",
            "oneWeekChange": "Variação 1 semana",
            "oneMonthChange": "Variação 1 mês",
            "threeMonthsChange": "Variação 3 meses",
            "oneYearChange": "Variação 1 ano",
            "loading": "A carregar..."
        },
        "fullScreen": {
            "startTrading": "Começar a Negociar",
            "deposit": "Depósito",
            "dashboard": "Painel",
            "personalInfo": "Dados Pessoais",
            "withdrawal": "Levantamento",
            "verification": "Verificação",
            "accounts": "Contas",
            "liveChat": "Chat ao Vivo",
            "savings": "Poupanças",
            "settings": "Definições",
            "logOut": "Terminar Sessão"
        },
        "fullScreenDeposit": {
            "chooseCryptocurrency": "ESCOLHER CRIPTOMOEDA",
            "addressReceipt": "Aguarde o carregamento do endereço",
            "makeDeposit": "FAZER UM DEPÓSITO",
            "instant": "Instantâneo",
            "minutes": "minutos",
            "hours": "horas",
            "days": "dias",
            "amount": "Montante",
            "continue": "Continuar",
            "qrCode": "CÓDIGO QR",
            "depositAddress": "ENDEREÇO DE DEPÓSITO",
            "addWalletAddress": "A carteira para este método não está configurada. Contacte o seu agente ou o apoio ao cliente.",
            "copy": "Copiar",
            "last": "ÚLTIMOS",
            "deposits": "DEPÓSITOS",
            "time": "Hora",
            "currency": "Moeda",
            "status": "Estado",
            "info": "Info",
            "name": "Nome do titular do cartão",
            "address": "Morada",
            "DOB": "Data de Nasc.",
            "bankName": "Nome do banco",
            "additionalInfo": "Para depositar mais na sua conta, contacte diretamente o seu gestor de conta",
            "additionalInfoOnlyBTCpsp": "Para desbloquear outros métodos de pagamento, forneça o KYC ou contacte o seu gestor de conta",
            "sofortPspMessage": "A nossa equipa financeira entrará em contacto consigo para o ajudar a fazer um depósito"
        },
        "fullScreenCcExt": {
            "pleaseWait": "Aguarde. A ligar ao fornecedor de serviços de pagamento...",
            "cardPayment": "Pagamento com cartão",
            "inOrder": "Para enviar o montante",
            "pleaseProvide": "indique os dados do cartão:"
        },
        "fullScreenDashboard": {
            "totalTaxes": "Total de Taxas",
            "totalBalance": "Saldo Total",
            "totalPnl": "PNL Total",
            "profitableOrders": "Ordens Lucrativas",
            "roi": "ROI",
            "activityLog": "Registo de Atividade",
            "loginFromIp": "Início de sessão do IP",
            "tradingResults": "Resultados de Negociação",
            "week": "Semana",
            "month": "Mês",
            "year": "Ano",
            "successRate": "Taxa de sucesso",
            "closedWithProfit": "Fechadas Com Lucro",
            "closedWithLoss": "Fechadas Com Perda",
            "account": "Conta",
            "balance": "Saldo",
            "leverage": "Alavancagem",
            "credit": "Crédito",
            "tradeNow": "Negociar Agora",
            "usingCurrentRate": "com a taxa de câmbio atual",
            "totalDeposits": "Total de Depósitos"
        },
        "fullScreenPersonal": {
            "personalDetails": "Dados Pessoais",
            "profilePhoto": "Foto de Perfil",
            "firstName": "Nome",
            "country": "País",
            "lastName": "Apelido",
            "address": "Morada",
            "email": "E-mail",
            "phone": "Número de telefone",
            "saveChanges": "Guardar Alterações"
        },
        "fullScreenAvatar": {
            "dropFile": "Largue um ficheiro no círculo acima para carregar",
            "notAllowed": "Não é permitido publicar",
            "notAllowedLine1": "Fotografias de natureza explicitamente sexual ou pornográfica",
            "notAllowedLine2": "Imagens destinadas a incitar ao ódio ou à agressão étnica ou racial",
            "notAllowedLine3": "Fotografias com pessoas menores de 18 anos",
            "notAllowedLine4": "Fotografias protegidas por direitos de autor de terceiros",
            "notAllowedLine5": "Imagens com mais de 5 MB e num formato diferente de JPG, GIF ou PNG",
            "requirements": "O seu rosto deve estar claramente visível na fotografia. Todas as fotografias e vídeos que carregar devem cumprir estes requisitos, caso contrário poderão ser removidos."
        },
        "fullScreenWithdrawal": {
            "withdrawal": "Levantamento",
            "requestNewWithdrawal": "SOLICITAR UM NOVO LEVANTAMENTO",
            "amount": "Montante",
            "currentBalance": "O saldo atual da sua conta é",
            "withdrawAll": "Levantar tudo",
            "requestWithdrawal": "Solicitar Levantamento",
            "last": "ÚLTIMOS",
            "withdrawalRequests": "PEDIDOS DE LEVANTAMENTO",
            "time": "Hora",
            "currency": "Moeda",
            "info": "Info",
            "status": "Estado",
            "bank": "Banco",
            "bitcoin": "Bitcoin",
            "card": "Cartão",
            "ethereum": "Ethereum",
            "usdt": "USDT",
            "usdt_erc20": "USDT ERC-20",
            "matic": "Matic",
            "etransfer": "Etransfer",
            "interact": "Interact",
            "withdrawalDetails": "Detalhes do Levantamento",
            "address": "Endereço da Carteira",
            "bankAccount": "Número de Conta",
            "bankHolder": "Nome do Titular da Conta",
            "bankIban": "IBAN",
            "bankSwift": "Código SWIFT do banco",
            "sortCode": "Sort Code",
            "ifscCode": "Código IFSC",
            "bankCode": "Código do Banco (BSB)",
            "bankName": "Nome do Banco",
            "bankBranch": "Balcão do Banco",
            "cardNumber": "Número do Cartão",
            "cardHolder": "Nome do Titular do Cartão",
            "incorrectAmountByFreeMargin": "O montante está incorreto, pode levantar o valor da margem livre",
            "closeOrders": "antes feche todas as ordens"
        },
        "fullScreenVerification": {
            "dragAndDrop": "arraste e largue o documento para esta área",
            "documentsList": "LISTA DE DOCUMENTOS CARREGADOS",
            "document": "Documento",
            "timeUploaded": "Hora de Carregamento",
            "timeProcessed": "Hora de Processamento",
            "status": "Estado",
            "types": "Comprovativo de Identidade,Comprovativo de Morada,Frente do Cartão de Crédito,Verso do Cartão de Crédito,Verso do Comprovativo de Identidade,Selfie,Outro",
            "types2": "Comprovativo de Identidade (CARTÃO DE CIDADÃO, PASSAPORTE, CARTA DE CONDUÇÃO),Comprovativo de Morada (Fatura de serviços ou Extrato bancário),Frente do Cartão de Crédito,Verso do Cartão de Crédito,Verso do Comprovativo de Identidade (VERSO DO CARTÃO DE CIDADÃO, VERSO DA CARTA DE CONDUÇÃO),Selfie,Outro",
            "upload": "Carregar",
            "isConfirmed": "está confirmado",
            "uploadAnotherDocument": "Carregar outro documento",
            "isUnderReview": "está em análise",
            "questionnaire": "Questionário",
            "sendAnswers": "Enviar Respostas",
            "progressBarOf": "de",
            "progressBarText": "dos seus documentos foram carregados e confirmados"
        },
        "fullScreenAccounts": {
            "manageAccounts": "Transferir fundos entre as suas contas",
            "transferFrom": "Da conta",
            "transferTo": "Para a conta",
            "amount": "Montante",
            "makeTransfer": "Efetuar Transferência",
            "yourAccounts": "As Suas Contas",
            "account": "Conta",
            "currency": "Moeda",
            "balance": "Saldo",
            "credit": "Crédito",
            "makeActive": "Tornar Ativa",
            "active": "Ativa"
        },
        "fullScreenSupport": {
            "chatOff": "O chat estará disponível nos dias úteis",
            "sendMessage": "Enviar Mensagem",
            "responseTime": "Tempo médio de resposta: 1-24h"
        },
        "fullScreenSavings": {
            "pct_0": "Flexível",
            "pct_30": "Bloqueado 1 Mês",
            "pct_90": "Bloqueado 1 Trimestre",
            "pct_180": "Bloqueado 6 Meses",
            "pct_365": "Bloqueado 1 Ano",
            "pct_730": "Bloqueado 2 Anos",
            "savings": "Poupança",
            "detailedInformation": "Informação Detalhada",
            "pleaseSelect": "Selecione uma moeda e um período",
            "openSavings": "Abrir Poupança",
            "currentTime": "Hora Atual",
            "releaseTime": "Hora de Libertação",
            "currencyChosen": "Moeda Escolhida",
            "periodChosen": "Período Escolhido",
            "yourRate": "A Sua Taxa",
            "yourAnnualRate": "A Sua Taxa Anual",
            "yourEarnings": "Os seus ganhos",
            "accountFrom": "Conta de origem dos fundos",
            "enterAmount": "Introduzir Montante",
            "in": "Em",
            "openAndInvest": "Abrir Conta Poupança e investir",
            "investment": "Investimento",
            "period": "Período",
            "daysTotal": "Total de dias",
            "finalEarnings": "Ganhos finais",
            "created": "Criada",
            "daysElapsed": "Dias Decorridos",
            "days": "dias",
            "earnings": "Ganhos",
            "fundsReleasedIn": "Fundos Libertados Em",
            "claim": "Resgatar"
        },
        "fullScreenSettings": {
            "updatePassword": "ATUALIZAR PALAVRA-PASSE",
            "currentPassword": "Palavra-passe Atual",
            "newPassword": "Nova Palavra-passe",
            "changePassword": "Alterar Palavra-passe",
            "activationForGoogle": "Código de ativação para o Google Authenticator",
            "activateAndEnter": "Ative o Authenticator e introduza o código gerado no campo abaixo",
            "qrCode": "Código QR",
            "activateProtection": "Ativar Proteção 2FA",
            "protectionActive": "A proteção 2FA está ativa",
            "twoFactorCode": "Código 2FA",
            "disableProtection": "Desativar Proteção 2FA",
            "language": "Idioma",
            "dashboardCurrency": "Moeda do Painel",
            "confirmNewPassword": "Confirmar nova palavra-passe"
        },
        "fullScreenReferrals": {
            "yourLink": "O SEU LINK DE REFERÊNCIA",
            "referredFriends": "AMIGOS REFERENCIADOS",
            "id": "ID",
            "name": "Nome",
            "registered": "Registo",
            "level": "Nível",
            "payout": "Pagamento",
            "lastPayouts": "ÚLTIMOS PAGAMENTOS DE REFERÊNCIA",
            "time": "Hora",
            "amount": "Montante",
            "currency": "Moeda",
            "info": "Info"
        },
        "months": {
            "Jan": "Jan",
            "Feb": "Fev",
            "Mar": "Mar",
            "Apr": "Abr",
            "May": "Mai",
            "Jun": "Jun",
            "Jul": "Jul",
            "Aug": "Ago",
            "Sep": "Set",
            "Oct": "Out",
            "Nov": "Nov",
            "Dec": "Dez"
        },
        "orderTypes": ["Comprar", "Vender", "Buy Limit", "Sell Limit", "Buy Stop", "Sell Stop"],
        "statuses": ["Pendente", "Aprovado", "Recusado", "Em Processamento", "Em Análise", "Em Curso", "Cancelado"],
        "errors": {
            "INVALID_FIELDS": "Verifique se os dados introduzidos estão corretos",
            "NOT_FOUND": "Erro no pedido",
            "FORBIDDEN": "Acesso negado. Inicie sessão novamente",
            "SERVER_ERROR": "A ação falhou. Tente novamente mais tarde",
            "INVALID_ACCOUNT": "Sessão expirada. Inicie sessão novamente",
            "INVALID_EMAIL": "Endereço de e-mail inválido",
            "INVALID_PHONE": "Número de telefone inválido",
            "INVALID_COUNTRY": "País inválido",
            "INVALID_LOGIN": "Credenciais de acesso inválidas",
            "USER_BLOCKED": "Conta bloqueada. Contacte o apoio ao cliente",
            "USER_REGISTERED": "Já existe um utilizador registado com este e-mail ou número de telefone",
            "INVALID_USER": "Utilizador não encontrado",
            "REJECTED": "Operação não permitida devido a restrições da plataforma",
            "INVALID_OLD_PASSWORD": "A palavra-passe antiga é inválida",
            "INVALID_SYMBOL": "Símbolo de negociação inválido",
            "INVALID_SYMBOL_PRECISION": "Precisão do símbolo inválida",
            "INVALID_FRAME": "Intervalo do gráfico inválido",
            "INVALID_CURRENCY": "Moeda inválida",
            "INVALID_PRODUCT": "Tipo de negociação da conta inválido",
            "INSUFFICIENT_FUNDS": "Fundos insuficientes",
            "INVALID_WITHDRAWAL": "Levantamento não encontrado",
            "INVALID_DEPOSIT": "Este depósito já não pode ser cancelado: não foi encontrado ou já foi processado",
            "INVALID_STATUS": "Estado inválido",
            "INVALID_FILE": "Extensão de ficheiro inválida ou ficheiro demasiado grande",
            "INVALID_DOCUMENT": "Documento não encontrado",
            "INVALID_NAME": "Nome inválido",
            "INVALID_LOT_SIZE": "Tamanho do lote inválido",
            "INVALID_LOT_STEP": "Incremento do lote inválido",
            "INVALID_MIN_VOLUME": "Volume mínimo inválido",
            "INVALID_MAX_VOLUME": "Volume máximo inválido",
            "INVALID_GROUP": "Grupo inválido",
            "INVALID_SPREAD": "Spread inválido",
            "REQUEST_TIMEOUT": "O pedido expirou. Tente novamente mais tarde",
            "INVALID_TYPE": "Tipo de ordem inválido",
            "INVALID_VOLUME": "Volume da ordem inválido",
            "INVALID_SL": "Valor de Stop Loss inválido",
            "INVALID_TP": "Valor de Take Profit inválido",
            "INVALID_PRICE": "Preço da ordem inválido",
            "INVALID_EXPIRATION": "Validade da ordem inválida",
            "NOT_ENOUGH_MARGIN": "Margem insuficiente",
            "INVALID_ORDER": "Ordem não encontrada",
            "MARKET_CLOSED": "A negociação não está disponível. Tente novamente",
            "INVALID_BALANCE_TYPE": "Tipo de operação de saldo inválido",
            "INVALID_HASH": "Hash inválido",
            "HASH_EXPIRED": "O seu link de reposição de palavra-passe expirou. Solicite um novo",
            "INVALID_CODE": "Código 2FA inválido",
            "CHAT_DISABLED": "O acesso ao chat de apoio foi encerrado",
            "WITHDRAWAL_NOT_ALLOWED": "O acesso aos levantamentos foi encerrado",
            "TRADING_DISABLED": "A negociação está desativada para a conta atual",
            "PENDING_DEPOSITS_LIMIT": "Limite de depósitos excedido",
            "CLOSE_OPEN_ORDERS": "Feche as suas ordens abertas",
            "LOCAL_ONE_PENDING_WITHDRAWAL": "Só é permitido um levantamento pendente",
            "LOCAL_DEPOSIT_ONLY_REAL": "O depósito só está disponível para contas reais",
            "LOCAL_DEPOSIT_POSITIVE": "O valor do depósito deve ser superior a 0",
            "LOCAL_INVALID_CARD_NUMBER": "Número de cartão inválido",
            "LOCAL_INVALID_CARD_EXPIRATION": "Validade do cartão inválida",
            "LOCAL_INVALID_CVC": "Código CVV/CVC inválido",
            "LOCAL_PASSWORDS_NOT_MATCH": "As palavras-passe não coincidem, introduza novamente",
            "LOCAL_NO_TRADING_ACCOUNTS": "Não tem contas de negociação disponíveis. Contacte o apoio ao cliente",
            "LOCAL_MIN_DEPOSIT": "O depósito mínimo é $",
            "LOCAL_MIN_WITHDRAWAL": "O valor mínimo de levantamento é $",
            "LOCAL_INVALID_FILE_TYPE": "Formato de ficheiro não suportado. Anexe apenas JPG, PNG ou PDF",
            "LOCAL_MIN_STAKING": "O depósito mínimo para esta moeda é ",
            "FLOOD_REJECTED": "Está a enviar mensagens com demasiada frequência. Tente novamente mais tarde",
            "REGISTRATIONS_BLOCKED": "Obrigado pelo seu contacto. Um dos nossos representantes entrará em contacto consigo o mais brevemente possível"
        },
        "countries": {
            "AF": "Afeganistão",
            "AX": "Ilhas Åland",
            "AL": "Albânia",
            "DZ": "Argélia",
            "AS": "Samoa Americana",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguila",
            "AQ": "Antártida",
            "AG": "Antígua e Barbuda",
            "AR": "Argentina",
            "AM": "Arménia",
            "AW": "Aruba",
            "AU": "Austrália",
            "AT": "Áustria",
            "AZ": "Azerbaijão",
            "BS": "Bahamas",
            "BH": "Barém",
            "BD": "Bangladesh",
            "BB": "Barbados",
            "BY": "Bielorrússia",
            "BE": "Bélgica",
            "BZ": "Belize",
            "BJ": "Benim",
            "BM": "Bermudas",
            "BT": "Butão",
            "BO": "Bolívia",
            "BA": "Bósnia e Herzegovina",
            "BW": "Botsuana",
            "BV": "Ilha Bouvet",
            "BR": "Brasil",
            "IO": "Território Britânico do Oceano Índico",
            "BN": "Brunei Darussalam",
            "BG": "Bulgária",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Camboja",
            "CM": "Camarões",
            "CA": "Canadá",
            "CV": "Cabo Verde",
            "KY": "Ilhas Caimão",
            "CF": "República Centro-Africana",
            "TD": "Chade",
            "CL": "Chile",
            "CN": "China",
            "CX": "Ilha do Natal",
            "CC": "Ilhas Cocos (Keeling)",
            "CO": "Colômbia",
            "KM": "Comores",
            "CG": "Congo",
            "CD": "Congo, República Democrática",
            "CK": "Ilhas Cook",
            "CR": "Costa Rica",
            "CI": "Costa do Marfim",
            "HR": "Croácia",
            "CU": "Cuba",
            "CY": "Chipre",
            "CZ": "República Checa",
            "DK": "Dinamarca",
            "DJ": "Jibuti",
            "DM": "Domínica",
            "DO": "República Dominicana",
            "EC": "Equador",
            "EG": "Egito",
            "SV": "El Salvador",
            "GQ": "Guiné Equatorial",
            "ER": "Eritreia",
            "EE": "Estónia",
            "ET": "Etiópia",
            "FK": "Ilhas Falkland (Malvinas)",
            "FO": "Ilhas Faroé",
            "FJ": "Fiji",
            "FI": "Finlândia",
            "FR": "França",
            "GF": "Guiana Francesa",
            "PF": "Polinésia Francesa",
            "TF": "Territórios Franceses do Sul",
            "GA": "Gabão",
            "GM": "Gâmbia",
            "GE": "Geórgia",
            "DE": "Alemanha",
            "GH": "Gana",
            "GI": "Gibraltar",
            "GR": "Grécia",
            "GL": "Gronelândia",
            "GD": "Granada",
            "GP": "Guadalupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GG": "Guernsey",
            "GN": "Guiné",
            "GW": "Guiné-Bissau",
            "GY": "Guiana",
            "HT": "Haiti",
            "HM": "Ilha Heard e Ilhas McDonald",
            "VA": "Santa Sé (Estado da Cidade do Vaticano)",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Hungria",
            "IS": "Islândia",
            "IN": "Índia",
            "ID": "Indonésia",
            "IR": "Irão",
            "IQ": "Iraque",
            "IE": "Irlanda",
            "IM": "Ilha de Man",
            "IL": "Israel",
            "IT": "Itália",
            "JM": "Jamaica",
            "JP": "Japão",
            "JE": "Jersey",
            "JO": "Jordânia",
            "KZ": "Cazaquistão",
            "KE": "Quénia",
            "KI": "Kiribati",
            "KR": "Coreia do Sul",
            "KW": "Kuwait",
            "KG": "Quirguistão",
            "LA": "República Democrática Popular do Laos",
            "LV": "Letónia",
            "LB": "Líbano",
            "LS": "Lesoto",
            "LR": "Libéria",
            "LY": "Jamahiriya Árabe Líbia",
            "LI": "Liechtenstein",
            "LT": "Lituânia",
            "LU": "Luxemburgo",
            "MO": "Macau",
            "MK": "Macedónia",
            "MG": "Madagáscar",
            "MW": "Malawi",
            "MY": "Malásia",
            "MV": "Maldivas",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Ilhas Marshall",
            "MQ": "Martinica",
            "MR": "Mauritânia",
            "MU": "Maurícia",
            "YT": "Mayotte",
            "MX": "México",
            "FM": "Micronésia",
            "MD": "Moldávia",
            "MC": "Mónaco",
            "MN": "Mongólia",
            "ME": "Montenegro",
            "MS": "Montserrat",
            "MA": "Marrocos",
            "MZ": "Moçambique",
            "MM": "Myanmar",
            "NA": "Namíbia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Países Baixos",
            "AN": "Antilhas Neerlandesas",
            "NC": "Nova Caledónia",
            "NZ": "Nova Zelândia",
            "NI": "Nicarágua",
            "NE": "Níger",
            "NG": "Nigéria",
            "NU": "Niue",
            "NF": "Ilha Norfolk",
            "MP": "Ilhas Marianas do Norte",
            "NO": "Noruega",
            "OM": "Omã",
            "PK": "Paquistão",
            "PW": "Palau",
            "PS": "Território Palestiniano Ocupado",
            "PA": "Panamá",
            "PG": "Papua-Nova Guiné",
            "PY": "Paraguai",
            "PE": "Peru",
            "PH": "Filipinas",
            "PN": "Pitcairn",
            "PL": "Polónia",
            "PT": "Portugal",
            "PR": "Porto Rico",
            "QA": "Catar",
            "RE": "Reunião",
            "RO": "Roménia",
            "RU": "Rússia",
            "RW": "Ruanda",
            "BL": "São Bartolomeu",
            "SH": "Santa Helena",
            "KN": "São Cristóvão e Neves",
            "LC": "Santa Lúcia",
            "MF": "São Martinho",
            "PM": "São Pedro e Miquelon",
            "VC": "São Vicente e Granadinas",
            "WS": "Samoa",
            "SM": "São Marino",
            "ST": "São Tomé e Príncipe",
            "SA": "Arábia Saudita",
            "SN": "Senegal",
            "RS": "Sérvia",
            "SC": "Seicheles",
            "SL": "Serra Leoa",
            "SG": "Singapura",
            "SK": "Eslováquia",
            "SI": "Eslovénia",
            "SB": "Ilhas Salomão",
            "SO": "Somália",
            "ZA": "África do Sul",
            "GS": "Geórgia do Sul e Ilhas Sandwich",
            "ES": "Espanha",
            "LK": "Sri Lanka",
            "SD": "Sudão",
            "SR": "Suriname",
            "SJ": "Svalbard e Jan Mayen",
            "SZ": "Suazilândia",
            "SE": "Suécia",
            "CH": "Suíça",
            "SY": "República Árabe Síria",
            "TW": "Taiwan",
            "TJ": "Tajiquistão",
            "TZ": "Tanzânia",
            "TH": "Tailândia",
            "TL": "Timor-Leste",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trindade e Tobago",
            "TN": "Tunísia",
            "TR": "Turquia",
            "TM": "Turquemenistão",
            "TC": "Ilhas Turcas e Caicos",
            "TV": "Tuvalu",
            "UG": "Uganda",
            "UA": "Ucrânia",
            "AE": "Emirados Árabes Unidos",
            "GB": "Reino Unido",
            "US": "Estados Unidos",
            "UM": "Ilhas Menores Distantes dos EUA",
            "UY": "Uruguai",
            "UZ": "Usbequistão",
            "VU": "Vanuatu",
            "VE": "Venezuela",
            "VN": "Vietname",
            "VG": "Ilhas Virgens Britânicas",
            "VI": "Ilhas Virgens Americanas",
            "WF": "Wallis e Futuna",
            "EH": "Saara Ocidental",
            "YE": "Iémen",
            "ZM": "Zâmbia",
            "ZW": "Zimbabué"
        },
        "_name": "Português"
    },
}

export default langs